// Game SEO: patterns, gamesSlugMap, optional gameSeo per `/p/{provider}/{game}` (use `{brand}` in copy).
// Keep in sync with libs/content/src/lib/seo/en.json. Slug map names must match catalog API (GameInfo / ProviderInfo).
// Patterns - {game}, {provider}, {brand} substituted at runtime
export const gameSeoPatterns = {
    title: 'Play {game} by {provider} | {brand}',
    description: 'Play {game} by {provider} at {brand}. Crypto deposits, instant withdrawals, demo play, and fast payouts on this online slot.'
};
// slug → game info map - generated from catalog (pnpm sync:catalog-sitemap)
export { gamesSlugMap } from './games-slug-map.generated.js';
const gameSeoBase = {
    '/p/pgsoft/garuda_gems': {
        title: 'Garuda Gems: 96% RTP, 3,136x Max Win | {brand}',
        description: 'Garuda Gems runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/legendary_monkey_king': {
        title: 'Legendary Monkey King: 96% RTP, 6,030x Max Win | {brand}',
        description: 'Legendary Monkey King runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/shaolin_soccer': {
        title: 'Shaolin Soccer: 96% RTP, 1,662x Max Win | {brand}',
        description: 'Shaolin Soccer runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/destiny_of_sun_and_moon': {
        title: 'Destiny of Sun & Moon: 96% RTP, 3,913x Max Win | {brand}',
        description: 'Destiny of Sun & Moon runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mr_treasures_fortune': {
        title: "Mr Treasure\\'s Fortune: 96.71% RTP, 5,000x Max Win | {brand}",
        description: "Mr Treasure\\'s Fortune runs at 96.71% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/dreams_of_macau': {
        title: 'Dreams of Macau: 96% RTP, 6,160x Max Win | {brand}',
        description: 'Dreams of Macau runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/opera_dynasty': {
        title: 'Opera Dynasty: 96% RTP, 8,841x Max Win | {brand}',
        description: 'Opera Dynasty runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/hip_hop_panda': {
        title: 'Hip Hop Panda: 96% RTP, 572x Max Win | {brand}',
        description: 'Hip Hop Panda runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/wild_coaster': {
        title: 'Wild Coaster: 96% RTP, 16,465x Max Win | {brand}',
        description: 'Wild Coaster runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/win_win_won': {
        title: 'Win Win Won: 96% RTP, 2,600x Max Win | {brand}',
        description: 'Win Win Won runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/symbols_of_egypt': {
        title: 'Symbols of Egypt: 96% RTP, 1,080x Max Win | {brand}',
        description: 'Symbols of Egypt runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/museum_mystery': {
        title: 'Museum Mystery: 96.71% RTP, 5,000x Max Win | {brand}',
        description: 'Museum Mystery runs at 96.71% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mystic_potion': {
        title: 'Mystic Potion: 96.71% RTP, 10,000x Max Win | {brand}',
        description: 'Mystic Potion runs at 96.71% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/rio_fantasia': {
        title: 'Rio Fantasia: 96.76% RTP, 2,000x Max Win | {brand}',
        description: 'Rio Fantasia runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/midas_fortune': {
        title: 'Midas Fortune: 96% RTP, 2,138x Max Win | {brand}',
        description: 'Midas Fortune runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/flirting_scholar': {
        title: 'Flirting Scholar: 96% RTP, 1,407x Max Win | {brand}',
        description: 'Flirting Scholar runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/alibabas_cave_of_fortune': {
        title: "Alibaba's Cave of Fortune: 96.77% RTP | {brand}",
        description: "Alibaba's Cave of Fortune runs at 96.77% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/safari_wilds': {
        title: 'Safari Wilds: 96.75% RTP, 5,000x Max Win | {brand}',
        description: 'Safari Wilds runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/honey_trap_of_diao_chan': {
        title: 'Honey Trap of Diao Chan: 96% RTP, 20,230x Max Win | {brand}',
        description: 'Honey Trap of Diao Chan runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/piggy_gold': {
        title: 'Piggy Gold: 96% RTP, 2,990x Max Win | {brand}',
        description: 'Piggy Gold runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/wild_fireworks': {
        title: 'Wild Fireworks: 96% RTP, 1,356x Max Win | {brand}',
        description: 'Wild Fireworks runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mystical_spirits': {
        title: 'Mystical Spirits: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Mystical Spirits runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/totem_wonders': {
        title: 'Totem Wonders: 96% RTP, 2,500x Max Win | {brand}',
        description: 'Totem Wonders runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/lucky_neko': {
        title: 'Lucky Neko: 96% RTP, 5,527x Max Win | {brand}',
        description: 'Lucky Neko runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/bikini_paradise': {
        title: 'Bikini Paradise: 96% RTP, 5,482x Max Win | {brand}',
        description: 'Bikini Paradise runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/oishi_delights': {
        title: 'Oishi Delights: 96.75% RTP, 10,000x Max Win | {brand}',
        description: 'Oishi Delights runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/bali_vacation': {
        title: 'Bali Vacation: 96% RTP, 3,560x Max Win | {brand}',
        description: 'Bali Vacation runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/egypts_book_of_mystery': {
        title: "Egypt\\'s Book of Mystery: 96% RTP, 9,546x Max Win | {brand}",
        description: "Egypt\\'s Book of Mystery runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/songkran_splash': {
        title: 'Songkran Splash: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Songkran Splash runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/vampires_charm': {
        title: "Vampire\\'s Charm: 96% RTP, 1,696x Max Win | {brand}",
        description: "Vampire\\'s Charm runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/dragon_hatch': {
        title: 'Dragon Hatch: 96% RTP, 2,027x Max Win | {brand}',
        description: 'Dragon Hatch runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/fortune_ox': {
        title: 'Fortune Ox: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Fortune Ox runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/guardians_of_ice_and_fire': {
        title: 'Guardians of Ice and Fire: 96% RTP, 6,917x Max Win | {brand}',
        description: 'Guardians of Ice and Fire runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/pinata_wins': {
        title: 'Pinata Wins: 96.75% RTP, 5,000x Max Win | {brand}',
        description: 'Pinata Wins runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/galaxy_miner': {
        title: 'Galaxy Miner: 96.77% RTP, 1,000x Max Win | {brand}',
        description: 'Galaxy Miner runs at 96.77% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mahjong_ways': {
        title: 'Mahjong Ways: 96% RTP, 2,893x Max Win | {brand}',
        description: 'Mahjong Ways runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/fortune_snake': {
        title: 'Fortune Snake: 96.75% RTP, 5,000x Max Win | {brand}',
        description: 'Fortune Snake runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/pharaoh_royale': {
        title: 'Pharaoh Royale: 96.76% RTP, 2,000x Max Win | {brand}',
        description: 'Pharaoh Royale runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/wild_ape_3258': {
        title: 'Wild Ape #3258: 96.74% RTP, 10,000x Max Win | {brand}',
        description: 'Wild Ape #3258 runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/buffalo_win': {
        title: 'Buffalo Win: 96% RTP, 1,548x Max Win | {brand}',
        description: 'Buffalo Win runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/asgardian_rising': {
        title: 'Asgardian Rising: 96% RTP, 8,305x Max Win | {brand}',
        description: 'Asgardian Rising runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/reel_royale_showdown': {
        title: 'Reel Royale Showdown: 96.75% RTP, 5,000x Max Win | {brand}',
        description: 'Reel Royale Showdown runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/majestic_empire': {
        title: 'Majestic Empire: 96.74% RTP, 10,000x Max Win | {brand}',
        description: 'Majestic Empire runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/knockout_riches': {
        title: 'Knockout Riches: 96.75% RTP, 10,000x Max Win | {brand}',
        description: 'Knockout Riches runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/zombie_outbreak': {
        title: 'Zombie Outbreak: 96.76% RTP, 5,000x Max Win | {brand}',
        description: 'Zombie Outbreak runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/plushie_frenzy': {
        title: 'Plushie Frenzy: 96% RTP, 505x Max Win | {brand}',
        description: 'Plushie Frenzy runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/reel_love': {
        title: 'Reel Love: 96% RTP, 3,446x Max Win | {brand}',
        description: 'Reel Love runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/ganesha_fortune': {
        title: 'Ganesha Fortune: 96% RTP, 7,524x Max Win | {brand}',
        description: 'Ganesha Fortune runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/doomsday_rampage': {
        title: 'Doomsday Rampage: 96.75% RTP, 5,000x Max Win | {brand}',
        description: 'Doomsday Rampage runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/jewels_of_prosperity': {
        title: 'Jewels of Prosperity: 96% RTP, 5,952x Max Win | {brand}',
        description: 'Jewels of Prosperity runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/genies_3_wishes': {
        title: "Genie\\'s 3 Wishes: 96% RTP, 3,213x Max Win | {brand}",
        description: "Genie\\'s 3 Wishes runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/fortune_horse': {
        title: 'Fortune Horse: 96.76% RTP, 10,000x Max Win | {brand}',
        description: 'Fortune Horse runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/hotpot': {
        title: 'Hotpot: 96% RTP, 12,352x Max Win | {brand}',
        description: 'Hotpot runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/candy_burst': {
        title: 'Candy Burst: 96% RTP, 1,016x Max Win | {brand}',
        description: 'Candy Burst runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/candy_bonanza': {
        title: 'Candy Bonanza: 96% RTP, 2,563x Max Win | {brand}',
        description: 'Candy Bonanza runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/hood_vs_wolf': {
        title: 'Hood vs Wolf: 96% RTP, 360x Max Win | {brand}',
        description: 'Hood vs Wolf runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/speed_winner': {
        title: 'Speed Winner: 96% RTP, 8,345x Max Win | {brand}',
        description: 'Speed Winner runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/zombie_blasters': {
        title: 'Zombie Blasters: 96.75% RTP, 10,000x Max Win | {brand}',
        description: 'Zombie Blasters runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/captains_bounty': {
        title: "Captain\\'s Bounty: 96% RTP, 4,796x Max Win | {brand}",
        description: "Captain\\'s Bounty runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/jungle_delight': {
        title: 'Jungle Delight: 96% RTP, 2,669x Max Win | {brand}',
        description: 'Jungle Delight runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/ninja_vs_samurai': {
        title: 'Ninja vs Samurai: 96% RTP, 2,610x Max Win | {brand}',
        description: 'Ninja vs Samurai runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/jack_frosts_winter': {
        title: "Jack Frost\\'s Winter: 96% RTP, 3,500x Max Win | {brand}",
        description: "Jack Frost\\'s Winter runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/santas_gift_rush': {
        title: "Santa\\'s Gift Rush: 96% RTP, 689x Max Win | {brand}",
        description: "Santa\\'s Gift Rush runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/mayan_destiny': {
        title: 'Mayan Destiny: 96.74% RTP, 10,000x Max Win | {brand}',
        description: 'Mayan Destiny runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/the_queens_banquet': {
        title: "The Queen\\'s Banquet: 96% RTP, 9,071x Max Win | {brand}",
        description: "The Queen\\'s Banquet runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/bakery_bonanza': {
        title: 'Bakery Bonanza: 96% RTP, 12,190x Max Win | {brand}',
        description: 'Bakery Bonanza runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/perfect_strike': {
        title: 'Perfect Strike: 96.76% RTP, 4,000x Max Win | {brand}',
        description: 'Perfect Strike runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/fortune_rabbit': {
        title: 'Fortune Rabbit: 96.0% RTP | {brand}',
        description: 'Fortune Rabbit runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mermaid_riches': {
        title: 'Mermaid Riches: 96% RTP, 3,513x Max Win | {brand}',
        description: 'Mermaid Riches runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/fortune_mouse': {
        title: 'Fortune Mouse: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Fortune Mouse runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/prosperity_fortune_tree': {
        title: 'Prosperity Fortune Tree: 96% RTP, 1,513x Max Win | {brand}',
        description: 'Prosperity Fortune Tree runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/cash_mania': {
        title: 'Cash Mania: 96.75% RTP, 2,000x Max Win | {brand}',
        description: 'Cash Mania runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/fortune_gods': {
        title: 'Fortune Gods: 96% RTP, 1,024x Max Win | {brand}',
        description: 'Fortune Gods runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mighty_mania': {
        title: 'Mighty Mania: 96.76% RTP, 5,000x Max Win | {brand}',
        description: 'Mighty Mania runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/super_golf_drive': {
        title: 'Super Golf Drive: 96.78% RTP, 8,000x Max Win | {brand}',
        description: 'Super Golf Drive runs at 96.78% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/skylight_wonders': {
        title: 'Skylight Wonders: 96.74% RTP, 5,000x Max Win | {brand}',
        description: 'Skylight Wonders runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/jack_the_giant_hunter': {
        title: 'Jack the Giant Hunter: 96.8% RTP, 10,000x Max Win | {brand}',
        description: 'Jack the Giant Hunter runs at 96.8% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/rooster_rumble': {
        title: 'Rooster Rumble: 96% RTP, 3,158x Max Win | {brand}',
        description: 'Rooster Rumble runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/legend_of_perseus': {
        title: 'Legend of Perseus: 96% RTP, 7,524x Max Win | {brand}',
        description: 'Legend of Perseus runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/funky_fortunez': {
        title: 'Funky Fortunez: 96.74% RTP, 2,000x Max Win | {brand}',
        description: 'Funky Fortunez runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/poker_kingdom_win': {
        title: 'Poker Kingdom Win: 96.74% RTP, 5,000x Max Win | {brand}',
        description: 'Poker Kingdom Win runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/gemstones_gold': {
        title: 'Gemstones Gold: 96.71% RTP, 7,500x Max Win | {brand}',
        description: 'Gemstones Gold runs at 96.71% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/fortune_dragon': {
        title: 'Fortune Dragon: 96.74% RTP, 2,500x Max Win | {brand}',
        description: 'Fortune Dragon runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/forbidden_alchemy': {
        title: 'Forbidden Alchemy: 96.76% RTP, 8,000x Max Win | {brand}',
        description: 'Forbidden Alchemy runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/ultimate_striker': {
        title: 'Ultimate Striker: 96.77% RTP, 8,000x Max Win | {brand}',
        description: 'Ultimate Striker runs at 96.77% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/ways_of_the_qilin': {
        title: 'Ways of the Qilin: 96% RTP, 7,106x Max Win | {brand}',
        description: 'Ways of the Qilin runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/dragons_treasure_quest': {
        title: "Dragon\\'s Treasure Quest: 96.76% RTP, 10,000x Max Win | {brand}",
        description: "Dragon\\'s Treasure Quest runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/legend_of_hou_yi': {
        title: 'Legend of Hou Yi: 96% RTP, 900x Max Win | {brand}',
        description: 'Legend of Hou Yi runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/gem_saviour_conquest': {
        title: 'Gem Saviour Conquest: 96% RTP, 7,551x Max Win | {brand}',
        description: 'Gem Saviour Conquest runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/wings_of_iguazu': {
        title: 'Wings of Iguazu: 96.78% RTP, 2,000x Max Win | {brand}',
        description: 'Wings of Iguazu runs at 96.78% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/heist_stakes': {
        title: 'Heist Stakes: 96% RTP, 3,071x Max Win | {brand}',
        description: 'Heist Stakes runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/medusa_ii': {
        title: 'Medusa II: 96% RTP, 529x Max Win | {brand}',
        description: 'Medusa II runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/tornado_rampage': {
        title: 'Tornado Rampage: 96.75% RTP, 5,000x Max Win | {brand}',
        description: 'Tornado Rampage runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/queen_of_bounty': {
        title: 'Queen of Bounty: 96% RTP, 7,576x Max Win | {brand}',
        description: 'Queen of Bounty runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/cruise_royale': {
        title: 'Cruise Royale: 96% RTP, 2,500x Max Win | {brand}',
        description: 'Cruise Royale runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/yakuza_honor': {
        title: 'Yakuza Honor: 96.75% RTP, 2,500x Max Win | {brand}',
        description: 'Yakuza Honor runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/emoji_riches': {
        title: 'Emoji Riches: 96% RTP, 2,992x Max Win | {brand}',
        description: 'Emoji Riches runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/three_crazy_piggies': {
        title: 'Three Crazy Piggies: 96.72% RTP, 2,500x Max Win | {brand}',
        description: 'Three Crazy Piggies runs at 96.72% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/majestic_treasures': {
        title: 'Majestic Treasures: 96% RTP, 5,236x Max Win | {brand}',
        description: 'Majestic Treasures runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/diner_delights': {
        title: 'Diner Delights: 96% RTP, 2,989x Max Win | {brand}',
        description: 'Diner Delights runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/gladiators_glory': {
        title: "Gladiator\\'s Glory: 96.75% RTP, 5,000x Max Win | {brand}",
        description: "Gladiator\\'s Glory runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/galactic_gems': {
        title: 'Galactic Gems: 96% RTP, 2,658x Max Win | {brand}',
        description: 'Galactic Gems runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/gem_saviour': {
        title: 'Gem Saviour: 96% RTP, 74x Max Win | {brand}',
        description: 'Gem Saviour runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/butterfly_blossom': {
        title: 'Butterfly Blossom: 96% RTP, 7,125x Max Win | {brand}',
        description: 'Butterfly Blossom runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/diner_frenzy_spins': {
        title: 'Diner Frenzy Spins: 96.8% RTP, 2,105x Max Win | {brand}',
        description: 'Diner Frenzy Spins runs at 96.8% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/supermarket_spree': {
        title: 'Supermarket Spree: 96% RTP, 2,309x Max Win | {brand}',
        description: 'Supermarket Spree runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/leprechaun_riches': {
        title: 'Leprechaun Riches: 96% RTP, 9,893x Max Win | {brand}',
        description: 'Leprechaun Riches runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/chicky_run': {
        title: 'Chicky Run: 96% RTP, 30x Max Win | {brand}',
        description: 'Chicky Run runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/rise_of_apollo': {
        title: 'Rise of Apollo: 96% RTP, 6,171x Max Win | {brand}',
        description: 'Rise of Apollo runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/futebol_fever': {
        title: 'Futebol Fever: 96.73% RTP, 2,000x Max Win | {brand}',
        description: 'Futebol Fever runs at 96.73% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/dragon_legend': {
        title: 'Dragon Legend: 96% RTP, 1,672x Max Win | {brand}',
        description: 'Dragon Legend runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/secrets_of_cleopatra': {
        title: 'Secrets of Cleopatra: 96% RTP, 8,649x Max Win | {brand}',
        description: 'Secrets of Cleopatra runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/super_wildrix': {
        title: 'Super Wildrix: 96.75% RTP, 20,000x Max Win | {brand}',
        description: 'Super Wildrix runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/muay_thai_champion': {
        title: 'Muay Thai Champion: 96% RTP, 3,120x Max Win | {brand}',
        description: 'Muay Thai Champion runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/lucky_piggy': {
        title: 'Lucky Piggy: 96% RTP, 3,687x Max Win | {brand}',
        description: 'Lucky Piggy runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/tree_of_fortune': {
        title: 'Tree of Fortune: 96% RTP, 213x Max Win | {brand}',
        description: 'Tree of Fortune runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/thai_river_wonders': {
        title: 'Thai River Wonders: 96% RTP, 8,716x Max Win | {brand}',
        description: 'Thai River Wonders runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/lucky_clover_riches': {
        title: 'Lucky Clover Riches: 96.77% RTP, 7,500x Max Win | {brand}',
        description: 'Lucky Clover Riches runs at 96.77% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/journey_to_the_wealth': {
        title: 'Journey to the Wealth: 96% RTP, 1,268x Max Win | {brand}',
        description: 'Journey to the Wealth runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/circus_delight': {
        title: 'Circus Delight: 96% RTP, 5,467x Max Win | {brand}',
        description: 'Circus Delight runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mr_hallowwin': {
        title: 'Mr. Hallow-Win: 96% RTP, 1,964x Max Win | {brand}',
        description: 'Mr. Hallow-Win runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mythical_guardians': {
        title: 'Mythical Guardians: 96.76% RTP, 15,000x Max Win | {brand}',
        description: 'Mythical Guardians runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/treasures_of_aztec': {
        title: 'Treasures of Aztec: 96% RTP, 9,071x Max Win | {brand}',
        description: 'Treasures of Aztec runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/wild_bounty_showdown': {
        title: 'Wild Bounty Showdown: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Bounty Showdown runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/dead_mans_riches': {
        title: "Dead Man\\'s Riches: 96.75% RTP, 10,000x Max Win | {brand}",
        description: "Dead Man\\'s Riches runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/mahjong_ways_2': {
        title: 'Mahjong Ways 2: 96% RTP, 1,708x Max Win | {brand}',
        description: 'Mahjong Ways 2 runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/caishen_wins': {
        title: 'Caishen Wins: 96% RTP, 4,936x Max Win | {brand}',
        description: 'Caishen Wins runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/phoenix_rises': {
        title: 'Phoenix Rises: 96% RTP, 2,990x Max Win | {brand}',
        description: 'Phoenix Rises runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/graffiti_rush': {
        title: 'Graffiti Rush: 96.75% RTP, 5,000x Max Win | {brand}',
        description: 'Graffiti Rush runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/dragon_tiger_luck': {
        title: 'Dragon Tiger Luck: 96% RTP, 200x Max Win | {brand}',
        description: 'Dragon Tiger Luck runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/fruit_candy': {
        title: 'Fruit Candy: 96.75% RTP, 10,000x Max Win | {brand}',
        description: 'Fruit Candy runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/forge_of_wealth': {
        title: 'Forge of Wealth: 96.74% RTP, 5,000x Max Win | {brand}',
        description: 'Forge of Wealth runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/anubis_wrath': {
        title: 'Anubis Wrath: 96.75% RTP, 10,000x Max Win | {brand}',
        description: 'Anubis Wrath runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/inferno_mayhem': {
        title: 'Inferno Mayhem: 96.74% RTP, 25,000x Max Win | {brand}',
        description: 'Inferno Mayhem runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/gem_saviour_sword': {
        title: 'Gem Saviour Sword: 96% RTP, 300x Max Win | {brand}',
        description: 'Gem Saviour Sword runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/geishas_revenge': {
        title: "Geisha\\'s Revenge: 96.81% RTP, 5,000x Max Win | {brand}",
        description: "Geisha\\'s Revenge runs at 96.81% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/emperors_favour': {
        title: "Emperor\\'s Favour: 96% RTP, 639x Max Win | {brand}",
        description: "Emperor\\'s Favour runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/ninja_raccoon_frenzy': {
        title: 'Ninja Raccoon Frenzy: 96.81% RTP, 2,500x Max Win | {brand}',
        description: 'Ninja Raccoon Frenzy runs at 96.81% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/medusa': {
        title: 'Medusa: 96% RTP, 550x Max Win | {brand}',
        description: 'Medusa runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/cocktail_nights': {
        title: 'Cocktail Nights: 96% RTP, 5,173x Max Win | {brand}',
        description: 'Cocktail Nights runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/monkeys_wild_party': {
        title: 'Monkeys Wild Party: 96.75% RTP, 10,000x Max Win | {brand}',
        description: 'Monkeys Wild Party runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/oriental_prosperity': {
        title: 'Oriental Prosperity: 96% RTP, 3,269x Max Win | {brand}',
        description: 'Oriental Prosperity runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/crypto_gold': {
        title: 'Crypto Gold: 96% RTP, 8,329x Max Win | {brand}',
        description: 'Crypto Gold runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/grimms_bounty_hanset_and_gretel': {
        title: 'Grimms Bounty Hanset and Gretel: 96.75% RTP | {brand}',
        description: 'Grimms Bounty Hanset and Gretel runs at 96.75% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/rave_party_fever': {
        title: 'Rave Party Fever: 96% RTP, 4,699x Max Win | {brand}',
        description: 'Rave Party Fever runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/raider_janes_crypt_of_fortune': {
        title: "Raider Jane's Crypt of Fortune: 96.0% RTP | {brand}",
        description: "Raider Jane's Crypt of Fortune runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/fortune_tiger': {
        title: 'Fortune Tiger: 96% RTP, 2,500x Max Win | {brand}',
        description: 'Fortune Tiger runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/jurassic_kingdom': {
        title: 'Jurassic Kingdom: 96% RTP, 6,684x Max Win | {brand}',
        description: 'Jurassic Kingdom runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/chocolate_deluxe': {
        title: 'Chocolate Deluxe: 96.76% RTP, 5,000x Max Win | {brand}',
        description: 'Chocolate Deluxe runs at 96.76% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/ganesha_gold': {
        title: 'Ganesha Gold: 96% RTP, 4,963x Max Win | {brand}',
        description: 'Ganesha Gold runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/double_fortune': {
        title: 'Double Fortune: 96% RTP, 6,165x Max Win | {brand}',
        description: 'Double Fortune runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/alchemy_gold': {
        title: 'Alchemy Gold: 96% RTP, 2,992x Max Win | {brand}',
        description: 'Alchemy Gold runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/shark_hunter': {
        title: 'Shark Hunter: 96.73% RTP, 5,000x Max Win | {brand}',
        description: 'Shark Hunter runs at 96.73% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/incan_wonders': {
        title: 'Incan Wonders: 96.74% RTP, 4,500x Max Win | {brand}',
        description: 'Incan Wonders runs at 96.74% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/battleground_royale': {
        title: 'Battleground Royale: 96% RTP, 1,690x Max Win | {brand}',
        description: 'Battleground Royale runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/wild_bandito': {
        title: 'Wild Bandito: 96% RTP, 2,525x Max Win | {brand}',
        description: 'Wild Bandito runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/win_win_fish_prawn_crab': {
        title: 'Win Win Fish Prawn Crab: 96% RTP, 3,672x Max Win | {brand}',
        description: 'Win Win Fish Prawn Crab runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/mask_carnival': {
        title: 'Mask Carnival: 96% RTP, 2,451x Max Win | {brand}',
        description: 'Mask Carnival runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/prosperity_lion': {
        title: 'Prosperity Lion: 96% RTP, 727x Max Win | {brand}',
        description: 'Prosperity Lion runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/spirited_wonders': {
        title: 'Spirited Wonders: 96% RTP, 7,388x Max Win | {brand}',
        description: 'Spirited Wonders runs at 96.0% RTP at {brand}, verified against the live game catalogue. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/treasure_island': {
        title: 'Treasure Island: 96.66% RTP | {brand}',
        description: 'Treasure Island runs at 96.66% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/speed_auto_roulette': {
        title: 'Speed Auto Roulette: 97.3% RTP | {brand}',
        description: 'Speed Auto Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/andar_bahar': {
        title: 'Andar Bahar: 98.1% RTP | {brand}',
        description: 'Andar Bahar runs at 98.1% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/roulette_macao': {
        title: 'Roulette Macao: 97.3% RTP | {brand}',
        description: 'Roulette Macao runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/dragon_tiger': {
        title: 'Dragon Tiger: 96.27% RTP | {brand}',
        description: 'Dragon Tiger runs at 96.27% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/one_blackjack': {
        title: 'One Blackjack: 99.28% RTP | {brand}',
        description: 'One Blackjack runs at 99.28% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/mega_baccarat': {
        title: 'Mega Baccarat: 98.76% RTP | {brand}',
        description: 'Mega Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/vegas_ball_bonanza': {
        title: 'Vegas Ball Bonanza: 96.66% RTP | {brand}',
        description: 'Vegas Ball Bonanza runs at 96.66% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/powerup_roulette': {
        title: 'PowerUP Roulette: 97.3% RTP | {brand}',
        description: 'PowerUP Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/auto_roulette': {
        title: 'Auto Roulette: 97.3% RTP | {brand}',
        description: 'Auto Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/romanian_roulette': {
        title: 'Romanian Roulette: 97.3% RTP | {brand}',
        description: 'Romanian Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/auto_mega_roulette': {
        title: 'Auto Mega Roulette: 97.3% RTP | {brand}',
        description: 'Auto Mega Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/mega_sic_bac': {
        title: 'Mega Sic Bac: 97.22% RTP | {brand}',
        description: 'Mega Sic Bac runs at 97.22% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/mega_wheel': {
        title: 'Mega Wheel: 96.66% RTP | {brand}',
        description: 'Mega Wheel runs at 96.66% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/mega_sic_bo': {
        title: 'Mega Sic Bo: 97.22% RTP | {brand}',
        description: 'Mega Sic Bo runs at 97.22% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/vip_roulette': {
        title: 'VIP Roulette: 97.3% RTP | {brand}',
        description: 'VIP Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/mega_roulette': {
        title: 'Mega Roulette: 97.3% RTP | {brand}',
        description: 'Mega Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/gates_of_olympus_roulette': {
        title: 'Gates of Olympus Roulette: 97.3% RTP | {brand}',
        description: 'Gates of Olympus Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/money_time': {
        title: 'Money Time: 96.56% RTP | {brand}',
        description: 'Money Time runs at 96.56% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/blackjack': {
        title: 'Blackjack: 99.28% RTP | {brand}',
        description: 'Blackjack runs at 99.28% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/brazilian_roulette': {
        title: 'Brazilian Roulette: 97.3% RTP | {brand}',
        description: 'Brazilian Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/korean_speed_baccarat': {
        title: 'Korean Speed Baccarat: 98.76% RTP | {brand}',
        description: 'Korean Speed Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/mega_roulette_3000': {
        title: 'Mega Roulette 3000: 97.3% RTP | {brand}',
        description: 'Mega Roulette 3000 runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/turkish_one_blackjack': {
        title: 'Turkish ONE Blackjack: 99.28% RTP | {brand}',
        description: 'Turkish ONE Blackjack runs at 99.28% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/punto_banco_italia_tricolore': {
        title: 'Punto Banco Italia Tricolore: 98.94% RTP | {brand}',
        description: 'Punto Banco Italia Tricolore runs at 98.94% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/indonesian_speed_baccarat': {
        title: 'Indonesian Speed Baccarat: 98.76% RTP | {brand}',
        description: 'Indonesian Speed Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/vietnamese_roulette': {
        title: 'Vietnamese Roulette: 97.3% RTP | {brand}',
        description: 'Vietnamese Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/thai_speed_baccarat': {
        title: 'Thai Speed Baccarat: 98.76% RTP | {brand}',
        description: 'Thai Speed Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/fortune_roulette': {
        title: 'Fortune Roulette: 97.3% RTP | {brand}',
        description: 'Fortune Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/korean_roulette': {
        title: 'Korean Roulette: 97.3% RTP | {brand}',
        description: 'Korean Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/blackjackx': {
        title: 'BlackjackX: 99.28% RTP | {brand}',
        description: 'BlackjackX runs at 99.28% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/chinese_speed_baccarat': {
        title: 'Chinese Speed Baccarat: 98.76% RTP | {brand}',
        description: 'Chinese Speed Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/roulette': {
        title: 'Live Roulette: 97.3% RTP | {brand}',
        description: 'Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/roulette_ruby': {
        title: 'Roulette Ruby: 97.3% RTP | {brand}',
        description: 'Roulette Ruby runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/thai_baccarat': {
        title: 'Thai Baccarat: 98.76% RTP | {brand}',
        description: 'Thai Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/sic_bo': {
        title: 'Sic Bo: 97.22% RTP | {brand}',
        description: 'Sic Bo runs at 97.22% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/indonesian_blackjackx': {
        title: 'Indonesian BlackjackX: 99.28% RTP | {brand}',
        description: 'Indonesian BlackjackX runs at 99.28% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/roulette_latina': {
        title: 'Roulette Latina: 97.3% RTP | {brand}',
        description: 'Roulette Latina runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/24d_spin': {
        title: '24D Spin: 97.3% RTP | {brand}',
        description: '24D Spin runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/german_roulette': {
        title: 'German Roulette: 97.3% RTP | {brand}',
        description: 'German Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/roulette_india': {
        title: 'Roulette India: 97.3% RTP | {brand}',
        description: 'Roulette India runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/lucky_roulette': {
        title: 'Lucky Roulette: 97.3% RTP | {brand}',
        description: 'Lucky Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/roulette_italia_tricolore': {
        title: 'Roulette Italia Tricolore: 97.3% RTP | {brand}',
        description: 'Roulette Italia Tricolore runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/speed_baccarat': {
        title: 'Speed Baccarat: 98.76% RTP | {brand}',
        description: 'Speed Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/crystal_roulette': {
        title: 'Crystal Roulette: 97.3% RTP | {brand}',
        description: 'Crystal Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/korean_blackjackx': {
        title: 'Korean BlackjackX: 99.28% RTP | {brand}',
        description: 'Korean BlackjackX runs at 99.28% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/the_bingo_spot': {
        title: 'The Bingo Spot: 96.44% RTP | {brand}',
        description: 'The Bingo Spot runs at 96.44% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/hilo_baccarat': {
        title: 'Hi-Lo Baccarat: 98.94% RTP | {brand}',
        description: 'Hi-Lo Baccarat runs at 98.94% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/japanese_speed_baccarat': {
        title: 'Japanese Speed Baccarat: 98.76% RTP | {brand}',
        description: 'Japanese Speed Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/vietnamese_speed_baccarat': {
        title: 'Vietnamese Speed Baccarat: 98.76% RTP | {brand}',
        description: 'Vietnamese Speed Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/italian_mega_roulette': {
        title: 'Italian Mega Roulette: 97.3% RTP | {brand}',
        description: 'Italian Mega Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/indonesian_roulette': {
        title: 'Indonesian Roulette: 97.3% RTP | {brand}',
        description: 'Indonesian Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/russian_roulette': {
        title: 'Russian Roulette: 97.3% RTP | {brand}',
        description: 'Russian Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/vip_auto_roulette': {
        title: 'VIP Auto Roulette: 97.3% RTP | {brand}',
        description: 'VIP Auto Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/fortune_baccarat': {
        title: 'Fortune Baccarat: 98.76% RTP | {brand}',
        description: 'Fortune Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/baccarat': {
        title: 'Baccarat: 98.76% RTP | {brand}',
        description: 'Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/prive_lounge_baccarat': {
        title: 'Prive Lounge Baccarat: 98.76% RTP | {brand}',
        description: 'Prive Lounge Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/prive_lounge_russian_poker': {
        title: 'Prive Lounge Russian Poker: 99.28% RTP | {brand}',
        description: 'Prive Lounge Russian Poker runs at 99.28% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/speed_roulette': {
        title: 'Speed Roulette: 97.3% RTP | {brand}',
        description: 'Speed Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/immersive_roulette_deluxe': {
        title: 'Immersive Roulette Deluxe: 94.0% RTP | {brand}',
        description: 'Immersive Roulette Deluxe runs at 94.0% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/brazilian_mega_roulette': {
        title: 'Brazilian Mega Roulette: 97.3% RTP | {brand}',
        description: 'Brazilian Mega Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/super_baccarat': {
        title: 'Super Baccarat: 98.76% RTP | {brand}',
        description: 'Super Baccarat runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/pay4d_speed_baccarat': {
        title: 'PAY4D SPEED BACCARAT: 98.76% RTP | {brand}',
        description: 'PAY4D SPEED BACCARAT runs at 98.76% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/dice_city': {
        title: 'Dice City: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Dice City runs at 94.0% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/turkish_mega_roulette': {
        title: 'Turkish Mega Roulette: 97.3% RTP | {brand}',
        description: 'Turkish Mega Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/turkish_roulette': {
        title: 'Turkish Roulette: 97.3% RTP | {brand}',
        description: 'Turkish Roulette runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/american_roulette': {
        title: 'Live American Roulette: 94.74% RTP | {brand}',
        description: 'American Roulette runs at 94.74% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/football_blitz_top_card': {
        title: 'Football Blitz Top Card: 97.3% RTP, 500x Max Win | {brand}',
        description: 'Football Blitz Top Card runs at 97.3% RTP at {brand}, streamed live with a real dealer. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/3_rockin_penguins': {
        title: '3 Rockin Penguins: 95.77% RTP, 10,000x Max Win | {brand}',
        description: '3 Rockin Penguins runs at 95.77% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/3_chili_charms': {
        title: '3 Chili Charms: 96.2% RTP, 15,000x Max Win | {brand}',
        description: '3 Chili Charms runs at 96.2% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/depths_of_fortune_2': {
        title: 'Depths of Fortune 2: 96.1% RTP, 10,000x Max Win | {brand}',
        description: 'Depths of Fortune 2 runs at 96.1% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/crypto_crown_40': {
        title: 'Crypto Crown 40: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Crypto Crown 40 runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/pots_of_power_zeus': {
        title: 'Pots of Power Zeus: 96.1% RTP, 10,000x Max Win | {brand}',
        description: 'Pots of Power Zeus runs at 96.1% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/40_power_joker': {
        title: '40 Power Joker: 96.73% RTP, 5,000x Max Win | {brand}',
        description: '40 Power Joker runs at 96.73% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/3_power_genies': {
        title: '3 Power Genies: 94% RTP, 10,000x Max Win | {brand}',
        description: '3 Power Genies runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/prince_of_purrwood': {
        title: 'Prince of Purrwood: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Prince of Purrwood runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/3_power_dragons': {
        title: '3 Power Dragons: 94% RTP, 15,000x Max Win | {brand}',
        description: '3 Power Dragons runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/monkeypop_2': {
        title: 'MonkeyPop 2: 94% RTP, 10,000x Max Win | {brand}',
        description: 'MonkeyPop 2 runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/crypto_crown_10': {
        title: 'Crypto Crown 10: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Crypto Crown 10 runs at 96% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/3_power_bears': {
        title: '3 Power Bears: 95.99% RTP, 15,000x Max Win | {brand}',
        description: '3 Power Bears runs at 95.99% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/blessings_of_caishen': {
        title: 'Blessings of Caishen: 96.02% RTP, 15,000x Max Win | {brand}',
        description: 'Blessings of Caishen runs at 96.02% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/3_builder_piggies': {
        title: '3 Builder Piggies: 96% RTP, 10,000x Max Win | {brand}',
        description: '3 Builder Piggies runs at 96% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/dyna_mule': {
        title: 'Dyna Mule: 95.97% RTP, 20,000x Max Win | {brand}',
        description: 'Dyna Mule runs at 95.97% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/3_jungle_beats': {
        title: '3 Jungle Beats: 94% RTP, 10,000x Max Win | {brand}',
        description: '3 Jungle Beats runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/crazy_mart_bonanza': {
        title: 'Crazy Mart Bonanza: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Crazy Mart Bonanza runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/diamond_dez': {
        title: 'Diamond Dez: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Diamond Dez runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/piggy_pop_grand_affair_2': {
        title: 'Piggy Pop Grand Affair 2: 94.03% RTP, 15,000x Max Win | {brand}',
        description: 'Piggy Pop Grand Affair 2 runs at 94.03% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/crypto_crown_20': {
        title: 'Crypto Crown 20: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Crypto Crown 20 runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/carioca_vibes': {
        title: 'Carioca Vibes: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Carioca Vibes runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/crypto_crown_5': {
        title: 'Crypto Crown 5: 94.17% RTP, 5,000x Max Win | {brand}',
        description: 'Crypto Crown 5 runs at 94.17% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/totally_hot': {
        title: 'Totally Hot: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Totally Hot runs at 94% RTP at {brand}, with a 2,500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aviamasters_xmas': {
        title: 'Aviamasters Xmas: 97% RTP, 2,500x Max Win | {brand}',
        description: 'Aviamasters Xmas runs at 97% RTP at {brand}, with a 2,500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/royal_beellion_hold_and_win': {
        title: 'Royal Beellion Hold and Win: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Royal Beellion Hold and Win runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/clash_of_gods_anubis_vs_hades': {
        title: 'Clash of Gods Anubis vs Hades: 94% RTP | {brand}',
        description: 'Clash of Gods Anubis vs Hades runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/dusty_duel': {
        title: 'Dusty Duel: 97% RTP, 5,000x Max Win | {brand}',
        description: 'Dusty Duel runs at 97% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/arrow_game': {
        title: 'Arrow Game: 97.33% RTP | {brand}',
        description: 'Arrow Game runs at 97.33% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/shark_and_spark_hold_and_win': {
        title: 'Shark and Spark Hold and Win: 97% RTP, 5,000x Max Win | {brand}',
        description: 'Shark and Spark Hold and Win runs at 97% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/chicken_shot': {
        title: 'Chicken Shot: 97% RTP, 64x Max Win | {brand}',
        description: 'Chicken Shot runs at 97% RTP at {brand}, with a 64x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/multi_rush': {
        title: 'Multi Rush: 96.15% RTP, 10,000x Max Win | {brand}',
        description: 'Multi Rush runs at 96.15% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_birds': {
        title: 'Lucky Birds: 96% RTP, 12,000x Max Win | {brand}',
        description: 'Lucky Birds runs at 96% RTP at {brand}, with a 12,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/ultras': {
        title: 'Ultras: 97% RTP, 5,000x Max Win | {brand}',
        description: 'Ultras runs at 97% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/the_godfather_3_pillars_of_power': {
        title: 'The Godfather: 3 Pillars of Power: 96.57% RTP | {brand}',
        description: 'The Godfather: 3 Pillars of Power runs at 96.57% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/bgaming/fashiontv_diamonds': {
        title: 'FashionTV Diamonds: 96% RTP | {brand}',
        description: 'FashionTV Diamonds runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/always_up': {
        title: 'Always Up: 94% RTP, 559x Max Win | {brand}',
        description: 'Always Up runs at 94% RTP at {brand}, with a 559x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/penalty_duel_with_julio_cesar': {
        title: 'Penalty Duel with Julio Cesar: 96.28% RTP | {brand}',
        description: 'Penalty Duel with Julio Cesar runs at 96.28% RTP at {brand}, with a 4,860x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/winter_trophy_hold_and_win': {
        title: 'Winter Trophy Hold and Win: 96.14% RTP, 5,624x Max Win | {brand}',
        description: 'Winter Trophy Hold and Win runs at 96.14% RTP at {brand}, with a 5,624x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/always_up_x10000': {
        title: 'Always Up x10000: 96.05% RTP, 10,490x Max Win | {brand}',
        description: 'Always Up x10000 runs at 96.05% RTP at {brand}, with a 10,490x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/star_trek_the_next_generation': {
        title: 'Star Trek The Next Generation: 94% RTP | {brand}',
        description: 'Star Trek The Next Generation runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/chicken_fire': {
        title: 'Chicken Fire: 95.9% RTP, 5,000x Max Win | {brand}',
        description: 'Chicken Fire runs at 95.9% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/frozen_fruit': {
        title: 'Frozen Fruit: 94% RTP, 6,600x Max Win | {brand}',
        description: 'Frozen Fruit runs at 94% RTP at {brand}, with a 6,600x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fishing_time': {
        title: 'Fishing Time: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Fishing Time runs at 96% RTP at {brand}, with a 1,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/royal_easter': {
        title: 'Royal Easter: 94% RTP, 500x Max Win | {brand}',
        description: 'Royal Easter runs at 94% RTP at {brand}, with a 500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/elements_of_power': {
        title: 'Elements of Power: 94% RTP, 1,206x Max Win | {brand}',
        description: 'Elements of Power runs at 94% RTP at {brand}, with a 1,206x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_coin': {
        title: 'Wild Coin: 96.23% RTP | {brand}',
        description: 'Wild Coin runs at 96.23% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/yommi_rush': {
        title: 'Yommi Rush: 96.32% RTP, 2,000x Max Win | {brand}',
        description: 'Yommi Rush runs at 96.32% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/bling_blitz_diamond_drop': {
        title: 'Bling Blitz Diamond Drop: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Bling Blitz Diamond Drop runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/jewel_boom_super_drop': {
        title: 'Jewel Boom Super Drop: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Jewel Boom Super Drop runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/hot_chilli_bells_100': {
        title: 'Hot Chilli Bells 100: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Hot Chilli Bells 100 runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_million': {
        title: 'Wild Million: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Million runs at 94% RTP at {brand}, with a 5,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/open_it': {
        title: 'Open It: 94% RTP, 64x Max Win | {brand}',
        description: 'Open It runs at 94% RTP at {brand}, with a 64x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/reel_of_ra': {
        title: 'Reel of Ra: 97.02% RTP, 2,500x Max Win | {brand}',
        description: 'Reel of Ra runs at 97.02% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/treasure_explorer': {
        title: 'Treasure Explorer: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Treasure Explorer runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/chicken_rush_2': {
        title: 'Chicken Rush 2: 97% RTP, 2,505x Max Win | {brand}',
        description: 'Chicken Rush 2 runs at 97% RTP at {brand}, with a 2,505x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/derby_rush': {
        title: 'Derby Rush: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Derby Rush runs at 94% RTP at {brand}, with a 5,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/hot_rocket_5x_3x_2x': {
        title: 'Hot Rocket 5x 3x 2x: 96.1% RTP, 2,500x Max Win | {brand}',
        description: 'Hot Rocket 5x 3x 2x runs at 96.1% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/golden_paw_hold_and_win': {
        title: 'Golden Paw Hold and Win: 97% RTP, 2,000x Max Win | {brand}',
        description: 'Golden Paw Hold and Win runs at 97% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/train_heist_johnny_coin': {
        title: 'Train Heist Johnny Coin: 97% RTP | {brand}',
        description: 'Train Heist Johnny Coin runs at 97% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_pack_2026_cup': {
        title: 'Lucky Pack 2026 Cup: 96.1% RTP, 10,490x Max Win | {brand}',
        description: 'Lucky Pack 2026 Cup runs at 96.1% RTP at {brand}, with a 10,490x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/golden_avalon_hold_and_win': {
        title: 'Golden Avalon Hold and Win: 96.56% RTP, 3,000x Max Win | {brand}',
        description: 'Golden Avalon Hold and Win runs at 96.56% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/frenzy_clusters': {
        title: 'Frenzy Clusters: 97.11% RTP, 10,000x Max Win | {brand}',
        description: 'Frenzy Clusters runs at 97.11% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/grand_buffalo_hold_and_win': {
        title: 'Grand Buffalo Hold and Win: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Grand Buffalo Hold and Win runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fishing_club_2': {
        title: 'Fishing Club 2: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Fishing Club 2 runs at 94% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/mystic_reels': {
        title: 'Mystic Reels: 96% RTP, 4,559x Max Win | {brand}',
        description: 'Mystic Reels runs at 96% RTP at {brand}, with a 4,559x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/miss_cherry_wild_frames': {
        title: 'Miss Cherry Wild Frames: 97% RTP, 3,000x Max Win | {brand}',
        description: 'Miss Cherry Wild Frames runs at 97% RTP at {brand}, with a 3,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/surrender_multihand_blackjack': {
        title: 'Surrender Multihand Blackjack: 99.48% RTP | {brand}',
        description: 'Surrender Multihand Blackjack runs at 99.48% RTP at {brand}, with a 1,059x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/sweet_samurai': {
        title: 'Sweet Samurai: 97.6% RTP, 4,500x Max Win | {brand}',
        description: 'Sweet Samurai runs at 97.6% RTP at {brand}, with a 4,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gemhalla_xtreme': {
        title: 'Gemhalla Xtreme: 97.17% RTP, 1,000x Max Win | {brand}',
        description: 'Gemhalla Xtreme runs at 97.17% RTP at {brand}, with a 1,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/yokai': {
        title: 'Yokai: 97% RTP, 8,000x Max Win | {brand}',
        description: 'Yokai runs at 97% RTP at {brand}, with a 8,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/plinko_2_halloween': {
        title: 'Plinko 2 Halloween: 99% RTP, 10,000x Max Win | {brand}',
        description: 'Plinko 2 Halloween runs at 99% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/alien_fruits_3': {
        title: 'Alien Fruits 3: 97% RTP, 10,000x Max Win | {brand}',
        description: 'Alien Fruits 3 runs at 97% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/big_boat_big_catch': {
        title: 'Big Boat Big Catch: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Big Boat Big Catch runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_lager_x9990': {
        title: 'Lucky Lager X9990: 94% RTP, 10,490x Max Win | {brand}',
        description: 'Lucky Lager X9990 runs at 94% RTP at {brand}, with a 10,490x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gates_of_power': {
        title: 'Gates of Power: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Gates of Power runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/train_heist_johnny_cash': {
        title: 'Train Heist Johnny Cash: 97% RTP, 10,000x Max Win | {brand}',
        description: 'Train Heist Johnny Cash runs at 97% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/money_maker': {
        title: 'Money Maker: 97.03% RTP, 1,000x Max Win | {brand}',
        description: 'Money Maker runs at 97.03% RTP at {brand}, with a 1,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fruit_million_respin': {
        title: 'Fruit Million Respin: 97% RTP, 3,000x Max Win | {brand}',
        description: 'Fruit Million Respin runs at 97% RTP at {brand}, with a 3,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_tiger_2': {
        title: 'Wild Tiger 2: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Tiger 2 runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/kicker_mania': {
        title: 'Kicker Mania: 97% RTP, 64x Max Win | {brand}',
        description: 'Kicker Mania runs at 97% RTP at {brand}, with a 64x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/almighty_mustang_express': {
        title: 'Almighty Mustang Express: 95% RTP, 5,000x Max Win | {brand}',
        description: 'Almighty Mustang Express runs at 95% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/lucky_fire_blitz_megaways': {
        title: 'Lucky Fire Blitz Megaways: 95% RTP, 5,000x Max Win | {brand}',
        description: 'Lucky Fire Blitz Megaways runs at 95% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/big_catch_even_bigger_bass': {
        title: 'Big Catch Even Bigger Bass: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Big Catch Even Bigger Bass runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/kong_even_bigger_balls': {
        title: 'Kong Even Bigger Balls: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Kong Even Bigger Balls runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/fishin_frenzy_the_big_catch_megaways': {
        title: 'Fishin Frenzy The Big Catch Megaways: 94.95% RTP | {brand}',
        description: 'Fishin Frenzy The Big Catch Megaways runs at 94.95% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/mega_charged_cash': {
        title: 'Mega Charged Cash: 95% RTP, 5,000x Max Win | {brand}',
        description: 'Mega Charged Cash runs at 95% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/lucky_fire_blitz_win_boost': {
        title: 'Lucky Fire Blitz Win Boost: 95% RTP, 5,000x Max Win | {brand}',
        description: 'Lucky Fire Blitz Win Boost runs at 95% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/wolf_fury_fire_blitz': {
        title: 'Wolf Fury Fire Blitz: 94% RTP, 12,000x Max Win | {brand}',
        description: 'Wolf Fury Fire Blitz runs at 94% RTP at {brand}, with a 12,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/wolf_legend_gold_megaways': {
        title: 'Wolf Legend Gold Megaways: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Wolf Legend Gold Megaways runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/pig_wizard_cash_lock': {
        title: 'Pig Wizard Cash Lock: 95% RTP, 5,500x Max Win | {brand}',
        description: 'Pig Wizard Cash Lock runs at 95% RTP at {brand}, with a 5,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_power_force_5_megaways': {
        title: 'Cash Strike Power force 5 Megaways: 94% RTP | {brand}',
        description: 'Cash Strike Power force 5 Megaways runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/blueprint-gaming/cash_strike_power_force_5': {
        title: 'Cash Strike Power Force 5: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Strike Power Force 5 runs at 95% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/triple_action_cash_strike': {
        title: 'Triple Action Cash Strike: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Triple Action Cash Strike runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/red_hot_catch': {
        title: 'Red Hot Catch: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Red Hot Catch runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/big_cat_gold': {
        title: 'Big Cat Gold: 95% RTP, 2,500x Max Win | {brand}',
        description: 'Big Cat Gold runs at 95% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/saint_nicked_3_present_tense': {
        title: 'Saint Nicked 3 Present Tense: 93% RTP, 10,000x Max Win | {brand}',
        description: 'Saint Nicked 3 Present Tense runs at 93% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/kong_even_bigger_christmas': {
        title: 'Kong Even Bigger Christmas: 93% RTP, 10,000x Max Win | {brand}',
        description: 'Kong Even Bigger Christmas runs at 93% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_xcash': {
        title: 'Cash Strike X-Cash: 95.02% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Strike X-Cash runs at 95.02% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/rise_of_atlantis_legacy': {
        title: 'Rise of Atlantis Legacy: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Rise of Atlantis Legacy runs at 95% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_hotstepper_2': {
        title: 'Cash Strike Hotstepper 2: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Strike Hotstepper 2 runs at 95% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/majestic_fury_power_5': {
        title: 'Majestic Fury Power 5: 95% RTP, 5,000x Max Win | {brand}',
        description: 'Majestic Fury Power 5 runs at 95% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_triple_fire': {
        title: 'Cash Strike Triple Fire: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Strike Triple Fire runs at 95% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/scarab_rising_megaways': {
        title: 'Scarab Rising Megaways: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Scarab Rising Megaways runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/wild_silverback': {
        title: 'Wild Silverback: 96.1% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Silverback runs at 96.1% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/henhouse_hustle_hold_and_win': {
        title: 'Henhouse Hustle: Hold and Win: 95.8% RTP | {brand}',
        description: 'Henhouse Hustle: Hold and Win runs at 95.8% RTP at {brand}, with a 6,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/diamond_forge_link_and_loot': {
        title: 'Diamond Forge Link and Loot: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Diamond Forge Link and Loot runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/fortune_paw': {
        title: 'Fortune Paw: 96.1% RTP, 2,500x Max Win | {brand}',
        description: 'Fortune Paw runs at 96.1% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/mustang_hold_and_win': {
        title: 'Mustang Hold and Win: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Mustang Hold and Win runs at 94% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/twin_buffalo_hold_and_win': {
        title: 'Twin Buffalo Hold and Win: 94% RTP, 5,100x Max Win | {brand}',
        description: 'Twin Buffalo Hold and Win runs at 94% RTP at {brand}, with a 5,100x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/fish_tales_double_catch_max_scatter': {
        title: 'Fish Tales: Double Catch Max Scatter: 96% RTP | {brand}',
        description: 'Fish Tales: Double Catch Max Scatter runs at 96% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/boominggames/sacred_buffalo': {
        title: 'Sacred Buffalo: 95.6% RTP, 8,000x Max Win | {brand}',
        description: 'Sacred Buffalo runs at 95.6% RTP at {brand}, with a 8,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/mustangs_and_stallions': {
        title: 'Mustangs and Stallions: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Mustangs and Stallions runs at 94% RTP at {brand}, with a 4,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/64_nuggets_hold_and_win': {
        title: '64 Nuggets Hold and Win: 94% RTP, 10,000x Max Win | {brand}',
        description: '64 Nuggets Hold and Win runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/ultra_buffalo_hold_and_win': {
        title: 'Ultra Buffalo Hold and Win: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Ultra Buffalo Hold and Win runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/black_friday_cart_craze': {
        title: 'Black Friday Cart Craze: 94% RTP, 8,000x Max Win | {brand}',
        description: 'Black Friday Cart Craze runs at 94% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/mr_oinksters_hold_and_win_10000': {
        title: "Mr. Oinkster's Hold and Win 10,000: 95.6% RTP | {brand}",
        description: "Mr. Oinkster's Hold and Win 10,000 runs at 95.6% RTP at {brand}, with a 10,250x max win and medium volatility. Crypto deposits, instant withdrawals, no."
    },
    '/p/boominggames/berserkin_buffalo_power_hit': {
        title: 'Berserkin Buffalo Power Hit: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Berserkin Buffalo Power Hit runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/fortune_surge': {
        title: 'Fortune Surge: 96.1% RTP, 2,000x Max Win | {brand}',
        description: 'Fortune Surge runs at 96.1% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/64_presents_hold_and_win': {
        title: '64 Presents Hold and Win: 95.9% RTP, 10,000x Max Win | {brand}',
        description: '64 Presents Hold and Win runs at 95.9% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/blazing_bullets_hold_and_win': {
        title: 'Blazing Bullets: Hold and Win: 95.8% RTP | {brand}',
        description: 'Blazing Bullets: Hold and Win runs at 95.8% RTP at {brand}, with a 2,300x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/gold_and_glamour_hold_and_win': {
        title: 'Gold and Glamour Hold and Win: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Gold and Glamour Hold and Win runs at 96% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/way_of_the_wolf_hold_and_win_extreme_10000': {
        title: 'Way of the Wolf Hold and Win Extreme 10000: 95.9% RTP | {brand}',
        description: 'Way of the Wolf Hold and Win Extreme 10000 runs at 95.9% RTP at {brand}, with a 12,000x max win and medium volatility. Crypto deposits, instant.'
    },
    '/p/boominggames/fish_tales_monster_bass_10000': {
        title: 'Fish Tales Monster Bass 10000: 94% RTP | {brand}',
        description: 'Fish Tales Monster Bass 10000 runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/tasty_bonanza_max_scatter': {
        title: 'Tasty Bonanza Max Scatter: 96.1% RTP, 15,000x Max Win | {brand}',
        description: 'Tasty Bonanza Max Scatter runs at 96.1% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/inferno_fortune_instastrike': {
        title: 'Inferno Fortune InstaStrike: 94% RTP, 2,150x Max Win | {brand}',
        description: 'Inferno Fortune InstaStrike runs at 94% RTP at {brand}, with a 2,150x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/polar_buffalo_extreme_hold_and_win_25000': {
        title: 'Polar Buffalo Extreme Hold and Win 25,000: 96% RTP | {brand}',
        description: 'Polar Buffalo Extreme Hold and Win 25,000 runs at 96% RTP at {brand}, with a 27,000x max win and high volatility. Crypto deposits, instant withdrawals,.'
    },
    '/p/boominggames/classico': {
        title: 'Classico: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Classico runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/ronaldinhos_streetball_bonanza': {
        title: "Ronaldinho's Streetball Bonanza: 96.1% RTP | {brand}",
        description: "Ronaldinho's Streetball Bonanza runs at 96.1% RTP at {brand}, with a 6,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/mr_oinksters_power_hit': {
        title: "Mr. Oinkster's Power Hit: 94% RTP, 2,150x Max Win | {brand}",
        description: "Mr. Oinkster's Power Hit runs at 94% RTP at {brand}, with a 2,150x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/greedy_for_gold_hold_and_win': {
        title: 'Greedy for Gold: Hold and Win: 95.9% RTP | {brand}',
        description: 'Greedy for Gold: Hold and Win runs at 95.9% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/bubble_works': {
        title: 'Bubble Works: 95.9% RTP, 6,000x Max Win | {brand}',
        description: 'Bubble Works runs at 95.9% RTP at {brand}, with a 6,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/blazin_bonus': {
        title: "Blazin' Bonus: 95.9% RTP, 2,680x Max Win | {brand}",
        description: "Blazin' Bonus runs at 95.9% RTP at {brand}, with a 2,680x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/booming_buffalo_hold_and_win_extreme_25000': {
        title: 'Booming Buffalo Hold and Win Extreme 25,000: 96.1% RTP | {brand}',
        description: 'Booming Buffalo Hold and Win Extreme 25,000 runs at 96.1% RTP at {brand}, with a 27,000x max win and high volatility. Crypto deposits, instant.'
    },
    '/p/flush-originals/crash': {
        title: 'Crash: 98% RTP | {brand}',
        description: 'Crash runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/dragons_tower': {
        title: "Dragon's Tower: 98% RTP | {brand}",
        description: "Dragon's Tower runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/flush-originals/keno': {
        title: 'Keno: 98% RTP | {brand}',
        description: 'Keno runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/baccarat': {
        title: 'Baccarat: 98% RTP, 9x Max Win | {brand}',
        description: 'Baccarat runs at 98% RTP at {brand}, with a 9x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/limbo': {
        title: 'Limbo: 98% RTP | {brand}',
        description: 'Limbo runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/mines': {
        title: 'Mines: 98% RTP | {brand}',
        description: 'Mines runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/blackjack': {
        title: 'Blackjack: 98% RTP, 5x Max Win | {brand}',
        description: 'Blackjack runs at 98% RTP at {brand}, with a 5x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/cross_the_road': {
        title: 'Cross the Road: 98% RTP, 3,236,072x Max Win | {brand}',
        description: 'Cross the Road runs at 98% RTP at {brand}, with a 3,236,072x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/dice': {
        title: 'Dice: 98% RTP | {brand}',
        description: 'Dice runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/plinko': {
        title: 'Plinko: 98% RTP | {brand}',
        description: 'Plinko runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/cross_the_lake': {
        title: 'Cross The Lake: 98% RTP, 5,189,702x Max Win | {brand}',
        description: 'Cross The Lake runs at 98% RTP at {brand}, with a 5,189,702x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/american_roulette': {
        title: 'American Roulette: 98% RTP, 36x Max Win | {brand}',
        description: 'American Roulette runs at 98% RTP at {brand}, with a 36x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/traffic_jam': {
        title: 'Traffic Jam: 98% RTP, 15x Max Win | {brand}',
        description: 'Traffic Jam runs at 98% RTP at {brand}, with a 15x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/video_poker': {
        title: 'Video Poker: 98% RTP | {brand}',
        description: 'Video Poker runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/coin_flip': {
        title: 'Coin Flip: 98% RTP, 2,076,178x Max Win | {brand}',
        description: 'Coin Flip runs at 98% RTP at {brand}, with a 2,076,178x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/hilo': {
        title: 'Hilo: 98% RTP | {brand}',
        description: 'Hilo runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/slider': {
        title: 'Slider: 98% RTP | {brand}',
        description: 'Slider runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/diamonds': {
        title: 'Diamonds: 98% RTP | {brand}',
        description: 'Diamonds runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/roulette': {
        title: 'Roulette: 98% RTP, 36x Max Win | {brand}',
        description: 'Roulette runs at 98% RTP at {brand}, with a 36x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/wheel': {
        title: 'Wheel: 98% RTP | {brand}',
        description: 'Wheel runs at 98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/the_luxe': {
        title: 'The Luxe: 96.33% RTP, 20,000x Max Win | {brand}',
        description: 'The Luxe runs at 96.33% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/miami_mayhem': {
        title: 'Miami Mayhem: 96.35% RTP, 15,000x Max Win | {brand}',
        description: 'Miami Mayhem runs at 96.35% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/prince_treasure': {
        title: 'Prince Treasure: 55.03% RTP, 40,000x Max Win | {brand}',
        description: 'Prince Treasure runs at 55.03% RTP at {brand}, with a 40,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/happy_scratch': {
        title: 'Happy Scratch: 92.02% RTP, 10,000x Max Win | {brand}',
        description: 'Happy Scratch runs at 92.02% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/plinko': {
        title: 'Plinko: 96% RTP, 3,700x Max Win | {brand}',
        description: 'Plinko runs at 96% RTP at {brand}, with a 3,700x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/3_cursed_chests_hold_and_win': {
        title: '3 Cursed Chests: Hold and Win: 96% RTP, 2,500x Max Win | {brand}',
        description: '3 Cursed Chests: Hold and Win runs at 96% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/balloons': {
        title: 'Balloons: 50.18% RTP, 80,000x Max Win | {brand}',
        description: 'Balloons runs at 50.18% RTP at {brand}, with a 80,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/crown_of_the_undying': {
        title: 'Crown of the Undying: 96.26% RTP | {brand}',
        description: 'Crown of the Undying runs at 96.26% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/scratch_platinum': {
        title: 'SCRATCH! Platinum: 76.67% RTP, 100,000x Max Win | {brand}',
        description: 'SCRATCH! Platinum runs at 76.67% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/sand_and_ashes': {
        title: 'Sand and Ashes: 94.21% RTP, 10,000x Max Win | {brand}',
        description: 'Sand and Ashes runs at 94.21% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/jaws_of_justice': {
        title: 'Jaws of Justice: 96.2% RTP, 10,000x Max Win | {brand}',
        description: 'Jaws of Justice runs at 96.2% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_digger': {
        title: 'Le Digger: 94.29% RTP, 15,000x Max Win | {brand}',
        description: 'Le Digger runs at 94.29% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/the_perfect_scratch': {
        title: 'The Perfect Scratch: 70.1% RTP, 100,000x Max Win | {brand}',
        description: 'The Perfect Scratch runs at 70.1% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/miss_candys_sweet_escape': {
        title: "Miss Candy's Sweet Escape: 96% RTP | {brand}",
        description: "Miss Candy's Sweet Escape runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/supreme_zeus': {
        title: 'Supreme Zeus: 96.39% RTP, 12,500x Max Win | {brand}',
        description: 'Supreme Zeus runs at 96.39% RTP at {brand}, with a 12,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/aliens_among_us': {
        title: 'Aliens Among Us: 96.36% RTP, 15,000x Max Win | {brand}',
        description: 'Aliens Among Us runs at 96.36% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/love_is_all_you_need': {
        title: 'LOVE is all you need: 61% RTP, 50,000x Max Win | {brand}',
        description: 'LOVE is all you need runs at 61% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/ruby_rush': {
        title: 'Ruby Rush: 59.21% RTP, 40,000x Max Win | {brand}',
        description: 'Ruby Rush runs at 59.21% RTP at {brand}, with a 40,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/diamond_rush': {
        title: 'Diamond Rush: 59.21% RTP, 40,000x Max Win | {brand}',
        description: 'Diamond Rush runs at 59.21% RTP at {brand}, with a 40,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/behind_bars_master_plan': {
        title: 'Behind Bars: Master Plan: 96.29% RTP | {brand}',
        description: 'Behind Bars: Master Plan runs at 96.29% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/eggstra_cash': {
        title: 'Eggstra Cash: 52.66% RTP, 50,000x Max Win | {brand}',
        description: 'Eggstra Cash runs at 52.66% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/spooky_scary_scratchy': {
        title: 'Spooky Scary Scratchy: 55.61% RTP, 100,000x Max Win | {brand}',
        description: 'Spooky Scary Scratchy runs at 55.61% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/scratchy_mini': {
        title: 'Scratchy Mini: 50.38% RTP, 25,000x Max Win | {brand}',
        description: 'Scratchy Mini runs at 50.38% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/death_becomes_you': {
        title: 'Death Becomes You: 96.34% RTP, 15,000x Max Win | {brand}',
        description: 'Death Becomes You runs at 96.34% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/opa_santorini': {
        title: 'Opa Santorini!: 96.31% RTP | {brand}',
        description: 'Opa Santorini! runs at 96.31% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_hooligan': {
        title: 'Le Hooligan: 96.34% RTP, 10,000x Max Win | {brand}',
        description: 'Le Hooligan runs at 96.34% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/army_of_ares': {
        title: 'Army of Ares: 96.26% RTP, 15,000x Max Win | {brand}',
        description: 'Army of Ares runs at 96.26% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_football_fan': {
        title: 'Le Football Fan: 96.41% RTP, 2,500x Max Win | {brand}',
        description: 'Le Football Fan runs at 96.41% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_scratch': {
        title: 'Lucky Scratch: 85.44% RTP, 10,000x Max Win | {brand}',
        description: 'Lucky Scratch runs at 85.44% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/marlin_masters_og': {
        title: 'Marlin Masters OG: 96.25% RTP, 7,500x Max Win | {brand}',
        description: 'Marlin Masters OG runs at 96.25% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/shave_the_beard': {
        title: 'Shave the Beard: 75.32% RTP, 50,000x Max Win | {brand}',
        description: 'Shave the Beard runs at 75.32% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/chaos_crew_scratch': {
        title: 'Chaos Crew Scratch: 60.12% RTP, 100,000x Max Win | {brand}',
        description: 'Chaos Crew Scratch runs at 60.12% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/grug_make_fire': {
        title: 'Grug Make Fire: 96.19% RTP, 10,000x Max Win | {brand}',
        description: 'Grug Make Fire runs at 96.19% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_numbers_x8': {
        title: 'Lucky Numbers x8: 64.4% RTP, 75,000x Max Win | {brand}',
        description: 'Lucky Numbers x8 runs at 64.4% RTP at {brand}, with a 75,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/go_panda': {
        title: 'Go Panda: 55.32% RTP, 100,000x Max Win | {brand}',
        description: 'Go Panda runs at 55.32% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/magic_piggy_og': {
        title: 'Magic Piggy OG: 94.18% RTP, 2,500x Max Win | {brand}',
        description: 'Magic Piggy OG runs at 94.18% RTP at {brand}, with a 2,500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dream_car_speed': {
        title: 'Dream Car Speed: 66.07% RTP, 20,000x Max Win | {brand}',
        description: 'Dream Car Speed runs at 66.07% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/belle_the_blade_hunter': {
        title: 'Belle the Blade Hunter: 96% RTP | {brand}',
        description: 'Belle the Blade Hunter runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_numbers_x16': {
        title: 'Lucky Numbers x16: 68.89% RTP, 83,333x Max Win | {brand}',
        description: 'Lucky Numbers x16 runs at 68.89% RTP at {brand}, with a 83,333x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/arena_of_iron': {
        title: 'Arena of Iron: 96.33% RTP | {brand}',
        description: 'Arena of Iron runs at 96.33% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rat_riches': {
        title: 'Rat Riches: 52.66% RTP, 50,000x Max Win | {brand}',
        description: 'Rat Riches runs at 52.66% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cut_the_grass': {
        title: 'Cut the Grass: 75% RTP, 50,000x Max Win | {brand}',
        description: 'Cut the Grass runs at 75% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/express_200_scratch': {
        title: 'Express 200 Scratch: 85.1% RTP, 100x Max Win | {brand}',
        description: 'Express 200 Scratch runs at 85.1% RTP at {brand}, with a 100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_bunny': {
        title: 'Le Bunny: 94.18% RTP, 20,000x Max Win | {brand}',
        description: 'Le Bunny runs at 94.18% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/king_treasure': {
        title: 'King Treasure: 53.11% RTP, 40,000x Max Win | {brand}',
        description: 'King Treasure runs at 53.11% RTP at {brand}, with a 40,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_numbers_x20': {
        title: 'Lucky Numbers x20: 69.14% RTP, 80,000x Max Win | {brand}',
        description: 'Lucky Numbers x20 runs at 69.14% RTP at {brand}, with a 80,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/crownlings_clusters': {
        title: 'Crownlings Clusters: 96.22% RTP | {brand}',
        description: 'Crownlings Clusters runs at 96.22% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/frogs_scratch': {
        title: 'Frogs Scratch: 65.27% RTP, 100,000x Max Win | {brand}',
        description: 'Frogs Scratch runs at 65.27% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cursed_crypt': {
        title: 'Cursed Crypt: 96.22% RTP, 10,000x Max Win | {brand}',
        description: 'Cursed Crypt runs at 96.22% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cash_pool': {
        title: 'Cash Pool: 55.61% RTP, 100,000x Max Win | {brand}',
        description: 'Cash Pool runs at 55.61% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/drill_the_thrill': {
        title: 'Drill the Thrill: 96.32% RTP | {brand}',
        description: 'Drill the Thrill runs at 96.32% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/shave_the_sheep': {
        title: 'Shave the Sheep: 53.77% RTP, 75,000x Max Win | {brand}',
        description: 'Shave the Sheep runs at 53.77% RTP at {brand}, with a 75,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_cowboy': {
        title: 'Le Cowboy: 96.28% RTP, 25,000x Max Win | {brand}',
        description: 'Le Cowboy runs at 96.28% RTP at {brand}, with a 25,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/grinning_harvest': {
        title: 'Grinning Harvest: 96% RTP | {brand}',
        description: 'Grinning Harvest runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/gold_coins': {
        title: 'Gold Coins: 61% RTP, 50,000x Max Win | {brand}',
        description: 'Gold Coins runs at 61% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_shot': {
        title: 'Lucky Shot: 64.9% RTP, 75,000x Max Win | {brand}',
        description: 'Lucky Shot runs at 64.9% RTP at {brand}, with a 75,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/great_game_rockies': {
        title: 'Great Game Rockies: 96.33% RTP, 5,000x Max Win | {brand}',
        description: 'Great Game Rockies runs at 96.33% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/the_crime_file': {
        title: 'The Crime File: 96.33% RTP | {brand}',
        description: 'The Crime File runs at 96.33% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/clawsy_collector': {
        title: 'Clawsy Collector: 96.27% RTP | {brand}',
        description: 'Clawsy Collector runs at 96.27% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/queen_treasure': {
        title: 'Queen Treasure: 56.7% RTP, 40,000x Max Win | {brand}',
        description: 'Queen Treasure runs at 56.7% RTP at {brand}, with a 40,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/henry_8th_calves_of_steel': {
        title: 'Henry 8th Calves of Steel: 96.32% RTP | {brand}',
        description: 'Henry 8th Calves of Steel runs at 96.32% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/jelly_slice': {
        title: 'Jelly Slice: 96.24% RTP, 10,000x Max Win | {brand}',
        description: 'Jelly Slice runs at 96.24% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/koi_cash': {
        title: 'Koi Cash: 71.76% RTP, 200,000x Max Win | {brand}',
        description: 'Koi Cash runs at 71.76% RTP at {brand}, with a 200,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/tiger_scratch': {
        title: 'Tiger Scratch: 50.29% RTP, 100,000x Max Win | {brand}',
        description: 'Tiger Scratch runs at 50.29% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/stack_em_scratch': {
        title: "Stack 'em Scratch: 60.12% RTP, 100,000x Max Win | {brand}",
        description: "Stack 'em Scratch runs at 60.12% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/twentyone': {
        title: 'Twenty-One: 96% RTP, 1,500x Max Win | {brand}',
        description: 'Twenty-One runs at 96% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/scratchy': {
        title: 'Scratchy: 55.17% RTP, 25,000x Max Win | {brand}',
        description: 'Scratchy runs at 55.17% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/scratch_gold': {
        title: 'SCRATCH! Gold: 73.41% RTP, 100,000x Max Win | {brand}',
        description: 'SCRATCH! Gold runs at 73.41% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dandy_diamonds': {
        title: 'Dandy Diamonds: 96.33% RTP, 5,000x Max Win | {brand}',
        description: 'Dandy Diamonds runs at 96.33% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cash_vault_i': {
        title: 'Cash Vault I: 65.45% RTP, 30,000x Max Win | {brand}',
        description: 'Cash Vault I runs at 65.45% RTP at {brand}, with a 30,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dynasty_of_death': {
        title: 'Dynasty of Death: 94.29% RTP, 12,500x Max Win | {brand}',
        description: 'Dynasty of Death runs at 94.29% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dream_car_urban': {
        title: 'Dream Car Urban: 68.17% RTP, 10,000x Max Win | {brand}',
        description: 'Dream Car Urban runs at 68.17% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/its_bananas': {
        title: "It's Bananas!: 64.73% RTP, 75,000x Max Win | {brand}",
        description: "It's Bananas! runs at 64.73% RTP at {brand}, with a 75,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/leather_heads': {
        title: 'Leather Heads: 96.31% RTP | {brand}',
        description: 'Leather Heads runs at 96.31% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rise_of_fortuna': {
        title: 'Rise of Fortuna: 96.28% RTP, 10,000x Max Win | {brand}',
        description: 'Rise of Fortuna runs at 96.28% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/nitro_nights': {
        title: 'Nitro Nights: 96.31% RTP, 15,000x Max Win | {brand}',
        description: 'Nitro Nights runs at 96.31% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_numbers_x12': {
        title: 'Lucky Numbers x12: 68.38% RTP, 75,000x Max Win | {brand}',
        description: 'Lucky Numbers x12 runs at 68.38% RTP at {brand}, with a 75,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cash_vault_ii': {
        title: 'Cash Vault II: 65.2% RTP, 30,000x Max Win | {brand}',
        description: 'Cash Vault II runs at 65.2% RTP at {brand}, with a 30,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/mines': {
        title: 'Mines: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Mines runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/colors': {
        title: 'Colors: 96% RTP, 211x Max Win | {brand}',
        description: 'Colors runs at 96% RTP at {brand}, with a 211x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/demon_queen': {
        title: 'Demon Queen: 96.26% RTP | {brand}',
        description: 'Demon Queen runs at 96.26% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/summer_scratch': {
        title: 'Summer Scratch: 70.1% RTP, 100,000x Max Win | {brand}',
        description: 'Summer Scratch runs at 70.1% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/coins': {
        title: 'Coins: 96% RTP, 3,932x Max Win | {brand}',
        description: 'Coins runs at 96% RTP at {brand}, with a 3,932x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/tai_the_toad': {
        title: 'Tai the Toad: 96.3% RTP, 7,500x Max Win | {brand}',
        description: 'Tai the Toad runs at 96.3% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/mirage_city': {
        title: 'Mirage City: 94.35% RTP | {brand}',
        description: 'Mirage City runs at 94.35% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/snow_scratcher': {
        title: 'Snow Scratcher: 52.66% RTP, 50,000x Max Win | {brand}',
        description: 'Snow Scratcher runs at 52.66% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_prachaun': {
        title: 'Le Prachaun: 96.28% RTP, 15,000x Max Win | {brand}',
        description: 'Le Prachaun runs at 96.28% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/harvest_wilds': {
        title: 'Harvest Wilds: 96.35% RTP, 10,000x Max Win | {brand}',
        description: 'Harvest Wilds runs at 96.35% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/power_of_ten': {
        title: 'Power of Ten: 94.35% RTP, 10,000x Max Win | {brand}',
        description: 'Power of Ten runs at 94.35% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/marlin_masters_atlantis': {
        title: 'Marlin Masters: Atlantis: 96.27% RTP, 10,000x Max Win | {brand}',
        description: 'Marlin Masters: Atlantis runs at 96.27% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/red_rascal': {
        title: 'Red Rascal: 94.29% RTP, 15,000x Max Win | {brand}',
        description: 'Red Rascal runs at 94.29% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/crazy_donuts': {
        title: 'Crazy Donuts: 53.62% RTP, 150,000x Max Win | {brand}',
        description: 'Crazy Donuts runs at 53.62% RTP at {brand}, with a 150,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_santa': {
        title: 'Le Santa: 96.14% RTP, 20,000x Max Win | {brand}',
        description: 'Le Santa runs at 96.14% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/scratch_bronze': {
        title: 'SCRATCH! Bronze: 68.1% RTP, 100,000x Max Win | {brand}',
        description: 'SCRATCH! Bronze runs at 68.1% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/scratch_silver': {
        title: 'SCRATCH! Silver: 70.1% RTP, 100,000x Max Win | {brand}',
        description: 'SCRATCH! Silver runs at 70.1% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/break_the_ice': {
        title: 'Break the Ice: a disputed 66.53% RTP | {brand}',
        description: "The {brand} catalogue reports Break the Ice at 66.53% RTP; Hacksaw's data sheet says 96%. Both figures, and why they differ."
    },
    '/p/hacksaw-gaming/football_scratch': {
        title: 'Football Scratch: 65.27% RTP, 100,000x Max Win | {brand}',
        description: 'Football Scratch runs at 65.27% RTP at {brand}, with a 100,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/scratchy_big': {
        title: 'Scratchy Big: 59% RTP, 25,000x Max Win | {brand}',
        description: 'Scratchy Big runs at 59% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/xmas_magic': {
        title: 'Xmas Magic: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Xmas Magic runs at 94% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/golden_ticket': {
        title: 'Golden Ticket: 94% RTP, 18,566x Max Win | {brand}',
        description: 'Golden Ticket runs at 94% RTP at {brand}, with a 18,566x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/temple_of_three': {
        title: 'Temple of Three: 96.2% RTP, 10,000x Max Win | {brand}',
        description: 'Temple of Three runs at 96.2% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_north_radiant_skies': {
        title: 'Wild North Radiant Skies: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Wild North Radiant Skies runs at 94% RTP at {brand}, with a 2,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/reactoonz_blitzways': {
        title: 'Reactoonz Blitzways: 96.2% RTP, 10,000x Max Win | {brand}',
        description: 'Reactoonz Blitzways runs at 96.2% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legion_gold_reckoning': {
        title: 'Legion Gold Reckoning: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Legion Gold Reckoning runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/stompin_gold': {
        title: "Stompin' Gold: 96.2% RTP, 50,000x Max Win | {brand}",
        description: "Stompin' Gold runs at 96.2% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/valhalluck': {
        title: 'Valhalluck: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Valhalluck runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cursed_moon_power_collection': {
        title: 'Cursed Moon Power Collection: 96.2% RTP | {brand}',
        description: 'Cursed Moon Power Collection runs at 96.2% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_olympus_bingo': {
        title: 'Rise of Olympus Bingo: 97.38% RTP, 4,250x Max Win | {brand}',
        description: 'Rise of Olympus Bingo runs at 97.38% RTP at {brand}, with a 4,250x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/holy_moo_extreme_power': {
        title: 'Holy Moo! Extreme Power: 96.2% RTP, 4,000x Max Win | {brand}',
        description: 'Holy Moo! Extreme Power runs at 96.2% RTP at {brand}, with a 4,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wrappin_gold': {
        title: 'Wrappin Gold: 94% RTP, 1,525x Max Win | {brand}',
        description: 'Wrappin Gold runs at 94% RTP at {brand}, with a 1,525x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/triple_launch_fortune_wild': {
        title: 'Triple Launch Fortune Wild: 94.23% RTP, 8,000x Max Win | {brand}',
        description: 'Triple Launch Fortune Wild runs at 94.23% RTP at {brand}, with a 8,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/track_n_gold': {
        title: "Track n' Gold: 94.2% RTP, 5,500x Max Win | {brand}",
        description: "Track n' Gold runs at 94.2% RTP at {brand}, with a 5,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/moon_princess_extreme': {
        title: 'Moon Princess Extreme: 96.2% RTP, 50,000x Max Win | {brand}',
        description: 'Moon Princess Extreme runs at 96.2% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/unigoat': {
        title: 'Unigoat: 96.2% RTP, 20,000x Max Win | {brand}',
        description: 'Unigoat runs at 96.2% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/crabbys_gold_ii': {
        title: "Crabby's Gold II: 96.22% RTP, 30,000x Max Win | {brand}",
        description: "Crabby's Gold II runs at 96.22% RTP at {brand}, with a 30,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/lawn_n_disorder': {
        title: "Lawn N' Disorder: 94% RTP, 50,000x Max Win | {brand}",
        description: "Lawn N' Disorder runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/piggy_blitz_casino_gold': {
        title: 'Piggy Blitz Casino Gold: 94% RTP, 8,000x Max Win | {brand}',
        description: 'Piggy Blitz Casino Gold runs at 94% RTP at {brand}, with a 8,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/viking_runecraft_1000': {
        title: 'Viking Runecraft 1000: 96.24% RTP, 60,000x Max Win | {brand}',
        description: 'Viking Runecraft 1000 runs at 96.24% RTP at {brand}, with a 60,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/nugget_n_nonsense': {
        title: "Nugget N' Nonsense: 94% RTP, 50,000x Max Win | {brand}",
        description: "Nugget N' Nonsense runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/manta_mayhem': {
        title: 'Manta Mayhem: 96.2% RTP, 9,000x Max Win | {brand}',
        description: 'Manta Mayhem runs at 96.2% RTP at {brand}, with a 9,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fates_fortune': {
        title: "Fate's Fortune: 96.2% RTP, 5,000x Max Win | {brand}",
        description: "Fate's Fortune runs at 96.2% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/legion_gold_and_the_throne_of_dead': {
        title: 'Legion Gold And The Throne Of Dead: 96.2% RTP | {brand}',
        description: 'Legion Gold And The Throne Of Dead runs at 96.2% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/play-n-go/primal_rampage': {
        title: 'Primal Rampage: 94.2% RTP, 2,500x Max Win | {brand}',
        description: 'Primal Rampage runs at 94.2% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gnawn_gold': {
        title: "Gnaw'n Gold: 94.24% RTP, 40,000x Max Win | {brand}",
        description: "Gnaw'n Gold runs at 94.24% RTP at {brand}, with a 40,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/grannys_wild': {
        title: "Granny's Wild: 94.2% RTP, 2,800x Max Win | {brand}",
        description: "Granny's Wild runs at 94.2% RTP at {brand}, with a 2,800x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/moon_princess_100': {
        title: 'Moon Princess 100: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Moon Princess 100 runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/tomb_of_gold_reimagined': {
        title: 'Tomb of Gold Reimagined: 96.24% RTP, 10,000x Max Win | {brand}',
        description: 'Tomb of Gold Reimagined runs at 96.24% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/spice_spice_baby': {
        title: 'Spice Spice Baby: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Spice Spice Baby runs at 94% RTP at {brand}, with a 6,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/book_of_dead_go_collect': {
        title: 'Book of Dead Go Collect: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Book of Dead Go Collect runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/shark_feast': {
        title: 'Shark Feast: 94.2% RTP, 40,000x Max Win | {brand}',
        description: 'Shark Feast runs at 94.2% RTP at {brand}, with a 40,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/roulette': {
        title: 'Roulette: 94% RTP | {brand}',
        description: 'Roulette runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_red_queen': {
        title: 'The Red Queen: 94.05% RTP | {brand}',
        description: 'The Red Queen runs at 94.05% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/baccarat': {
        title: 'Baccarat: 94% RTP | {brand}',
        description: 'Baccarat runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_knight_king': {
        title: 'The Knight King: 94.06% RTP | {brand}',
        description: 'The Knight King runs at 94.06% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_archer': {
        title: 'Fire Archer: 94.08% RTP | {brand}',
        description: 'Fire Archer runs at 94.08% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/firebird_spirit_connect_and_collect': {
        title: 'Firebird Spirit - Connect & Collect: 94% RTP | {brand}',
        description: 'Firebird Spirit - Connect & Collect runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rabbit_garden': {
        title: 'Rabbit Garden™: 94.07% RTP | {brand}',
        description: 'Rabbit Garden™ runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/da_vincis_treasure': {
        title: "Da Vinci's Treasure: 94.02% RTP | {brand}",
        description: "Da Vinci's Treasure runs at 94.02% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/jokers_jewels_hot': {
        title: "Joker's Jewels Hot: 94.5% RTP | {brand}",
        description: "Joker's Jewels Hot runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/candy_jar_clusters': {
        title: 'Candy Jar Clusters™: 94.07% RTP | {brand}',
        description: 'Candy Jar Clusters™ runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_xmas_xtreme': {
        title: 'Big Bass Xmas Xtreme: 94.05% RTP | {brand}',
        description: 'Big Bass Xmas Xtreme runs at 94.05% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/diamonds_are_forever_3_lines': {
        title: 'Diamonds are Forever 3 Lines: 96.96% RTP | {brand}',
        description: 'Diamonds are Forever 3 Lines runs at 96.96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/amazing_money_machine': {
        title: 'Amazing Money Machine: 94.44% RTP | {brand}',
        description: 'Amazing Money Machine runs at 94.44% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/john_hunter_and_the_tomb_of_the_scarab_queen': {
        title: 'John Hunter and the Tomb of the Scarab: 95.5% RTP | {brand}',
        description: 'John Hunter and the Tomb of the Scarab Queen runs at 95.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gold_rush': {
        title: 'Gold Rush: 94.5% RTP, 161x Max Win | {brand}',
        description: 'Gold Rush runs at 94.5% RTP at {brand}, with a 161x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_multihold': {
        title: 'The Dog House Multihold: 94.1% RTP | {brand}',
        description: 'The Dog House Multihold runs at 94.1% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_hold_and_spinner': {
        title: 'Big Bass - Hold & Spinner™: 94.07% RTP | {brand}',
        description: 'Big Bass - Hold & Spinner™ runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cult': {
        title: 'CULT: 96.51% RTP, 10,000x Max Win | {brand}',
        description: 'CULT runs at 96.51% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_bonanza_2500': {
        title: 'Sweet Bonanza 2500: 96.52% RTP, 25,000x Max Win | {brand}',
        description: 'Sweet Bonanza 2500 runs at 96.52% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fury_of_anubis': {
        title: 'Fury of Anubis: 96.52% RTP, 10,000x Max Win | {brand}',
        description: 'Fury of Anubis runs at 96.52% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_megaways_1000': {
        title: 'The Dog House Megaways 1000: 96.5% RTP | {brand}',
        description: 'The Dog House Megaways 1000 runs at 96.5% RTP at {brand}, with a 25,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/snow_party': {
        title: 'Snow Party: 96.5% RTP, 5,000x Max Win | {brand}',
        description: 'Snow Party runs at 96.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_pots_megaways': {
        title: 'Dragon Pots Megaways: 96.58% RTP, 10,000x Max Win | {brand}',
        description: 'Dragon Pots Megaways runs at 96.58% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_olympus_pop': {
        title: 'Gates of Olympus POP: 96.5% RTP, 25,000x Max Win | {brand}',
        description: 'Gates of Olympus POP runs at 96.5% RTP at {brand}, with a 25,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/caishens_cash_pots': {
        title: "Caishen's Cash Pots: 96.49% RTP, 10,000x Max Win | {brand}",
        description: "Caishen's Cash Pots runs at 96.49% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/luxor_of_cleopatra': {
        title: 'Luxor of Cleopatra: 96.51% RTP, 12,500x Max Win | {brand}',
        description: 'Luxor of Cleopatra runs at 96.51% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/triple_pot_plinko_hercules': {
        title: 'Triple Pot Plinko Hercules: 96.55% RTP | {brand}',
        description: 'Triple Pot Plinko Hercules runs at 96.55% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/candy_rush': {
        title: 'Candy Rush: 96.58% RTP, 15,000x Max Win | {brand}',
        description: 'Candy Rush runs at 96.58% RTP at {brand}, with a 15,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/slots_lobby': {
        title: 'Slots Lobby: 94% RTP | {brand}',
        description: 'Slots Lobby runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sanatorium_secrets': {
        title: 'Sanatorium Secrets: 96.47% RTP, 10,000x Max Win | {brand}',
        description: 'Sanatorium Secrets runs at 96.47% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/idol_pop_fever': {
        title: 'Idol Pop Fever: 96.5% RTP, 5,000x Max Win | {brand}',
        description: 'Idol Pop Fever runs at 96.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fortune_dragon': {
        title: 'Fortune Dragon: 93.99% RTP, 3,520x Max Win | {brand}',
        description: 'Fortune Dragon runs at 93.99% RTP at {brand}, with a 3,520x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_magic_cauldron': {
        title: 'The Magic Cauldron: 94.54% RTP | {brand}',
        description: 'The Magic Cauldron runs at 94.54% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/book_of_tut': {
        title: 'Book of Tut: 94.5% RTP | {brand}',
        description: 'Book of Tut runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/steamin_reels': {
        title: 'Steamin Reels: 96.53% RTP | {brand}',
        description: 'Steamin Reels runs at 96.53% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/furry_bonanza_megaways': {
        title: 'Furry Bonanza Megaways: 96.5% RTP, 5,000x Max Win | {brand}',
        description: 'Furry Bonanza Megaways runs at 96.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_big_dog_house': {
        title: 'The Big Dog House: 96.53% RTP, 15,000x Max Win | {brand}',
        description: 'The Big Dog House runs at 96.53% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sunnydaze_asylum': {
        title: 'Sunnydaze Asylum: 96.53% RTP, 10,000x Max Win | {brand}',
        description: 'Sunnydaze Asylum runs at 96.53% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jokers_revenge': {
        title: "Joker's Revenge: 96.51% RTP, 10,000x Max Win | {brand}",
        description: "Joker's Revenge runs at 96.51% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/cosmic_clusters': {
        title: 'Cosmic Clusters!: 96.45% RTP, 5,000x Max Win | {brand}',
        description: 'Cosmic Clusters! runs at 96.45% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sleeping_dragon_ultra_dark': {
        title: 'Sleeping Dragon Ultra Dark: 96.5% RTP, 20,000x Max Win | {brand}',
        description: 'Sleeping Dragon Ultra Dark runs at 96.5% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bermuda_riches': {
        title: 'Bermuda Riches: 94.36% RTP | {brand}',
        description: 'Bermuda Riches runs at 94.36% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/heartbreakers': {
        title: 'Heartbreakers: 96.53% RTP, 10,000x Max Win | {brand}',
        description: 'Heartbreakers runs at 96.53% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/plinko': {
        title: 'Plinko+: 94.53% RTP, 1,240x Max Win | {brand}',
        description: 'Plinko+ runs at 94.53% RTP at {brand}, with a 1,240x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_football_bonanza': {
        title: 'Big Bass Football Bonanza: 96.5% RTP, 5,000x Max Win | {brand}',
        description: 'Big Bass Football Bonanza runs at 96.5% RTP at {brand}, with a 5,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_tiger': {
        title: 'Dragon Tiger: 94% RTP | {brand}',
        description: 'Dragon Tiger runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_bonus_baccarat': {
        title: 'Dragon Bonus Baccarat: 98.94% RTP | {brand}',
        description: 'Dragon Bonus Baccarat runs at 98.94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/spire': {
        title: 'Spire+: 94.61% RTP, 256,901x Max Win | {brand}',
        description: 'Spire+ runs at 94.61% RTP at {brand}, with a 256,901x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/launch_to_riches': {
        title: 'Launch to Riches: 96.52% RTP, 5,000x Max Win | {brand}',
        description: 'Launch to Riches runs at 96.52% RTP at {brand}, with a 5,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_gladiator': {
        title: 'Wild Gladiator: 94.07% RTP | {brand}',
        description: 'Wild Gladiator runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/great_ghosts': {
        title: 'Great Ghosts!: 96.5% RTP, 40,000x Max Win | {brand}',
        description: 'Great Ghosts! runs at 96.5% RTP at {brand}, with a 40,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mahjong_wins_triple_pot': {
        title: 'Mahjong Wins Triple Pot: 96.5% RTP, 100,000x Max Win | {brand}',
        description: 'Mahjong Wins Triple Pot runs at 96.5% RTP at {brand}, with a 100,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/little_gem': {
        title: 'Little Gem: 94.62% RTP | {brand}',
        description: 'Little Gem runs at 94.62% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/irish_crown': {
        title: 'Irish Crown: 94.51% RTP, 5,000x Max Win | {brand}',
        description: 'Irish Crown runs at 94.51% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/better_barn_house_bonanza': {
        title: 'Better Barn House Bonanza: 96.5% RTP, 35,000x Max Win | {brand}',
        description: 'Better Barn House Bonanza runs at 96.5% RTP at {brand}, with a 35,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/panda_fortune_2': {
        title: 'Panda Fortune 2: 94.5% RTP | {brand}',
        description: 'Panda Fortune 2 runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_trophy_catch': {
        title: 'Big Bass Trophy Catch: 96.5% RTP | {brand}',
        description: 'Big Bass Trophy Catch runs at 96.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_treasure': {
        title: 'Aztec Treasure: 94.5% RTP | {brand}',
        description: 'Aztec Treasure runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cyber_pup_megaways': {
        title: 'Cyber Pup Megaways: 96.09% RTP, 40,000x Max Win | {brand}',
        description: 'Cyber Pup Megaways runs at 96.09% RTP at {brand}, with a 40,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/inca_queen': {
        title: 'Inca Queen: 96.55% RTP, 5,000x Max Win | {brand}',
        description: 'Inca Queen runs at 96.55% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mr_nulls_wicked_wares': {
        title: "Mr Null's Wicked Wares: 96.49% RTP, 5,000x Max Win | {brand}",
        description: "Mr Null's Wicked Wares runs at 96.49% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/book_of_tut_respin': {
        title: 'Book of Tut Respin: 94.47% RTP | {brand}',
        description: 'Book of Tut Respin runs at 94.47% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/american_blackjack': {
        title: 'American Blackjack: 94% RTP, 24x Max Win | {brand}',
        description: 'American Blackjack runs at 94% RTP at {brand}, with a 24x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/death_dominion': {
        title: 'Death Dominion: 96.54% RTP, 20,000x Max Win | {brand}',
        description: 'Death Dominion runs at 96.54% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/haunted_crypt': {
        title: 'Haunted Crypt: 96.51% RTP, 10,000x Max Win | {brand}',
        description: 'Haunted Crypt runs at 96.51% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragons_gate_bonus_choice': {
        title: "Dragon's Gate Bonus Choice: 96.5% RTP, 10,000x Max Win | {brand}",
        description: "Dragon's Gate Bonus Choice runs at 96.5% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/bear_crazy': {
        title: 'Bear Crazy: 96.52% RTP, 3,900x Max Win | {brand}',
        description: 'Bear Crazy runs at 96.52% RTP at {brand}, with a 3,900x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chicken': {
        title: 'Chicken+: 97.5% RTP, 3,138,009x Max Win | {brand}',
        description: 'Chicken+ runs at 97.5% RTP at {brand}, with a 3,138,009x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/spaceman': {
        title: 'Spaceman: 96.5% RTP | {brand}',
        description: 'Spaceman runs at 96.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/out_of_the_woods': {
        title: 'Out of the Woods: 96.52% RTP, 10,000x Max Win | {brand}',
        description: 'Out of the Woods runs at 96.52% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mines': {
        title: 'Mines+: 94.5% RTP, 5,070,293x Max Win | {brand}',
        description: 'Mines+ runs at 94.5% RTP at {brand}, with a 5,070,293x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/limbo': {
        title: 'Limbo+: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Limbo+ runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/super_gummy_strike': {
        title: 'Super Gummy Strike: 94.5% RTP, 20,000x Max Win | {brand}',
        description: 'Super Gummy Strike runs at 94.5% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_blast': {
        title: 'Big Bass Blast: 96.5% RTP | {brand}',
        description: 'Big Bass Blast runs at 96.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/emerald_king_wheel_of_wealth': {
        title: 'Emerald King Wheel of Wealth: 96.53% RTP | {brand}',
        description: 'Emerald King Wheel of Wealth runs at 96.53% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hell_butcher': {
        title: 'Hell Butcher: 96.55% RTP, 20,000x Max Win | {brand}',
        description: 'Hell Butcher runs at 96.55% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jelly_express': {
        title: 'Jelly Express: 96.5% RTP, 5,000x Max Win | {brand}',
        description: 'Jelly Express runs at 96.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_train_4': {
        title: 'Money Train 4: 94% RTP | {brand}',
        description: 'Money Train 4 runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/million-games/chicken_x_and_friends': {
        title: 'Chicken X and Friends: 94% RTP | {brand}',
        description: 'Chicken X and Friends runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/boom_city': {
        title: 'Boom City: 96.66% RTP | {brand}',
        description: 'Boom City runs at 96.66% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/royal_joker_hold_and_win': {
        title: 'Royal Joker: Hold and Win: 95.62% RTP | {brand}',
        description: 'Royal Joker: Hold and Win runs at 95.62% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/sweet_bonanza_candyland': {
        title: 'Sweet Bonanza CandyLand: 96.66% RTP | {brand}',
        description: 'Sweet Bonanza CandyLand runs at 96.66% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/indigomagic/ikusa': {
        title: 'Ikusa: 96% RTP | {brand}',
        description: 'Ikusa runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/epic_bullets_and_bounty': {
        title: 'Epic Bullets and Bounty: 94.28% RTP, 20,000x Max Win | {brand}',
        description: 'Epic Bullets and Bounty runs at 94.28% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/frkn_bananas': {
        title: 'FRKN Bananas: 96.31% RTP, 10,000x Max Win | {brand}',
        description: 'FRKN Bananas runs at 96.31% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/sugar_merge_up': {
        title: 'Sugar Merge Up: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Sugar Merge Up runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/hanzos_dojo': {
        title: "Hanzo's Dojo: 96% RTP | {brand}",
        description: "Hanzo's Dojo runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pgsoft/the_great_icescape': {
        title: 'The Great Icescape: 96% RTP, 7,963x Max Win | {brand}',
        description: 'The Great Icescape runs at 96% RTP at {brand}, with a 7,963x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/honey_rush_black_and_yellow': {
        title: 'Honey Rush Black and Yellow: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Honey Rush Black and Yellow runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/buildin_even_more_bucks': {
        title: "Buildin' Even More Bucks: 94.2% RTP, 5,000x Max Win | {brand}",
        description: "Buildin' Even More Bucks runs at 94.2% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/indigomagic/golden_gals_cash_towers': {
        title: "Golden Gal's Cash Towers: 97.57% RTP | {brand}",
        description: "Golden Gal's Cash Towers runs at 97.57% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/deal_with_death': {
        title: 'Deal with Death: 94.3% RTP, 20,000x Max Win | {brand}',
        description: 'Deal with Death runs at 94.3% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/munchy_milo': {
        title: 'Munchy Milo: 94.26% RTP, 10,000x Max Win | {brand}',
        description: 'Munchy Milo runs at 94.26% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/eternal_duel': {
        title: 'Eternal Duel: 94.24% RTP, 15,000x Max Win | {brand}',
        description: 'Eternal Duel runs at 94.24% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/snakes_and_ladders_live': {
        title: 'Snakes & Ladders Live: 96.66% RTP, 20,570x Max Win | {brand}',
        description: 'Snakes & Ladders Live runs at 96.66% RTP at {brand}, with a 20,570x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dark_spiral': {
        title: 'Dark Spiral: 94.22% RTP, 10,000x Max Win | {brand}',
        description: 'Dark Spiral runs at 94.22% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/luckys_wild_pub_2': {
        title: "Lucky's Wild Pub 2: 96.5% RTP, 15,000x Max Win | {brand}",
        description: "Lucky's Wild Pub 2 runs at 96.5% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/stormforged': {
        title: 'Stormforged: 96.41% RTP, 12,500x Max Win | {brand}',
        description: 'Stormforged runs at 96.41% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/alice_wonderluck': {
        title: 'Alice Wonderluck: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Alice Wonderluck runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/alien_fruits': {
        title: 'Alien Fruits: 96% RTP, 15,000x Max Win | {brand}',
        description: 'Alien Fruits runs at 96% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/alien_fruits_2': {
        title: 'Alien Fruits 2: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Alien Fruits 2 runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/all_star_fruits': {
        title: 'All Star Fruits: 97.04% RTP, 1,500x Max Win | {brand}',
        description: 'All Star Fruits runs at 97.04% RTP at {brand}, with a 1,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aloha_king_elvis': {
        title: 'Aloha King Elvis: 94.98% RTP, 2,000x Max Win | {brand}',
        description: 'Aloha King Elvis runs at 94.98% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/arrow_slot': {
        title: 'Arrow Slot: 94% RTP, 3,600x Max Win | {brand}',
        description: 'Arrow Slot runs at 94% RTP at {brand}, with a 3,600x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/avalon_the_lost_kingdom': {
        title: 'Avalon: The Lost Kingdom: 95% RTP, 5,000x Max Win | {brand}',
        description: 'Avalon: The Lost Kingdom runs at 95% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aviamasters': {
        title: 'Aviamasters: 94% RTP, 250x Max Win | {brand}',
        description: 'Aviamasters runs at 94% RTP at {brand}, with a 250x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aviamasters_2': {
        title: 'Aviamasters 2: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Aviamasters 2 runs at 94% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aztec_clusters': {
        title: 'Aztec Clusters: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Aztec Clusters runs at 94% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aztec_magic_bonanza': {
        title: 'Aztec Magic Bonanza: 94% RTP, 10,200x Max Win | {brand}',
        description: 'Aztec Magic Bonanza runs at 94% RTP at {brand}, with a 10,200x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aztec_magic_deluxe': {
        title: 'Aztec Magic Deluxe: 96.96% RTP, 5,000x Max Win | {brand}',
        description: 'Aztec Magic Deluxe runs at 96.96% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aztec_magic_megaways': {
        title: 'Aztec Magic MEGAWAYS: 94% RTP, 12,960x Max Win | {brand}',
        description: 'Aztec Magic MEGAWAYS runs at 94% RTP at {brand}, with a 12,960x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/aztecs_claw_wild_dice': {
        title: "Aztec's Claw Wild Dice: 94% RTP, 6,000x Max Win | {brand}",
        description: "Aztec's Claw Wild Dice runs at 94% RTP at {brand}, with a 6,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/balloon_mania': {
        title: 'Balloon Mania: 94% RTP, 64x Max Win | {brand}',
        description: 'Balloon Mania runs at 94% RTP at {brand}, with a 64x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/beast_band': {
        title: 'Beast Band: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Beast Band runs at 94% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/beer_bonanza': {
        title: 'Beer Bonanza: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Beer Bonanza runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/big_atlantis_frenzy': {
        title: 'Big Atlantis Frenzy: 94% RTP, 4,248x Max Win | {brand}',
        description: 'Big Atlantis Frenzy runs at 94% RTP at {brand}, with a 4,248x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/blackbeards_bounty': {
        title: "Blackbeard's Bounty: 94% RTP, 20,000x Max Win | {brand}",
        description: "Blackbeard's Bounty runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/blazing_fire_pots_hold_and_spin': {
        title: 'Blazing Fire Pots Hold and Spin: 94.11% RTP | {brand}',
        description: 'Blazing Fire Pots Hold and Spin runs at 94.11% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/bgaming/bonanza_billion': {
        title: 'Bonanza Billion: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Bonanza Billion runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/bonanza_billion_xtreme': {
        title: 'Bonanza Billion Xtreme: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Bonanza Billion Xtreme runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/bonanza_trillion': {
        title: 'Bonanza Trillion: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Bonanza Trillion runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/bone_bonanza': {
        title: 'Bone Bonanza: 94% RTP, 14,134x Max Win | {brand}',
        description: 'Bone Bonanza runs at 94% RTP at {brand}, with a 14,134x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/book_of_cats': {
        title: 'Book of Cats: 96.99% RTP, 10,000x Max Win | {brand}',
        description: 'Book of Cats runs at 96.99% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/book_of_cats_megaways': {
        title: 'Book of Cats Megaways: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Book of Cats Megaways runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/book_of_kemet': {
        title: 'Book of Kemet: 94.82% RTP, 7,791x Max Win | {brand}',
        description: 'Book of Kemet runs at 94.82% RTP at {brand}, with a 7,791x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/book_of_panda_megaways': {
        title: 'Book Of Panda Megaways: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Book Of Panda Megaways runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/book_of_pyramids': {
        title: 'Book of Pyramids: 97.13% RTP, 9,999x Max Win | {brand}',
        description: 'Book of Pyramids runs at 97.13% RTP at {brand}, with a 9,999x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/brave_viking': {
        title: 'Brave Viking Slot | 6,000x Max Win | {brand}',
        description: 'Play Brave Viking slot with Bitcoin at {brand}. Medium-High volatility, 6,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/burning_chilli_243': {
        title: 'Burning Chilli 243: 94% RTP, 500x Max Win | {brand}',
        description: 'Burning Chilli 243 runs at 94% RTP at {brand}, with a 500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/burning_chilli_x': {
        title: 'Burning Chilli X: 94% RTP, 850x Max Win | {brand}',
        description: 'Burning Chilli X runs at 94% RTP at {brand}, with a 850x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/candy_monsta': {
        title: 'Candy Monsta: 94.06% RTP, 1,000x Max Win | {brand}',
        description: 'Candy Monsta runs at 94.06% RTP at {brand}, with a 1,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/capymania_green': {
        title: 'Capymania Green: 94% RTP, 100,000x Max Win | {brand}',
        description: 'Capymania Green runs at 94% RTP at {brand}, with a 100,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/capymania_orange': {
        title: 'Capymania Orange: 94% RTP, 100,000x Max Win | {brand}',
        description: 'Capymania Orange runs at 94% RTP at {brand}, with a 100,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/capymania_yellow': {
        title: 'Capymania Yellow: 94% RTP, 100,000x Max Win | {brand}',
        description: 'Capymania Yellow runs at 94% RTP at {brand}, with a 100,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/carnival_bonanza': {
        title: 'Carnival Bonanza: 94% RTP, 14,134x Max Win | {brand}',
        description: 'Carnival Bonanza runs at 94% RTP at {brand}, with a 14,134x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/catch_the_gold_hold_and_win': {
        title: 'Catch the Gold Hold and Win: 94.98% RTP | {brand}',
        description: 'Catch the Gold Hold and Win runs at 94.98% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/catdiana': {
        title: 'Catdiana: 95.3% RTP, 2,500x Max Win | {brand}',
        description: 'Catdiana runs at 95.3% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/cats_soup': {
        title: "Cat's Soup: 98% RTP, 8,000x Max Win | {brand}",
        description: "Cat's Soup runs at 98% RTP at {brand}, with a 8,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/cherry_fiesta': {
        title: 'Cherry Fiesta Slot | 5,000x Max Win | {brand}',
        description: 'Play Cherry Fiesta slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/chicken_rush': {
        title: 'Chicken Rush: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Chicken Rush runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/classic_multihand_blackjack': {
        title: 'Classic Multihand Blackjack: 99.4% RTP, 3x Max Win | {brand}',
        description: 'Classic Multihand Blackjack runs at 99.4% RTP at {brand}, with a 3x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/clover_bonanza': {
        title: 'Clover Bonanza: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Clover Bonanza runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/clucking_hell': {
        title: 'Clucking Hell: 94% RTP, 6,666x Max Win | {brand}',
        description: 'Clucking Hell runs at 94% RTP at {brand}, with a 6,666x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/crazy_starter': {
        title: 'Crazy Starter Slot | 5,000x Max Win | {brand}',
        description: 'Play Crazy Starter slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/crystal_clusters': {
        title: 'Crystal Clusters: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Crystal Clusters runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/deep_sea': {
        title: 'Deep Sea: 94% RTP, 2,692x Max Win | {brand}',
        description: 'Deep Sea runs at 94% RTP at {brand}, with a 2,692x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/desert_treasure': {
        title: 'Desert Treasure Slot | 8,000x Max Win | {brand}',
        description: 'Play Desert Treasure slot with Bitcoin at {brand}. Medium-High volatility, 8,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/diamond_of_jungle': {
        title: 'Diamond of Jungle: 94% RTP, 1,500x Max Win | {brand}',
        description: 'Diamond of Jungle runs at 94% RTP at {brand}, with a 1,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/dice_bonanza': {
        title: 'Dice Bonanza: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Dice Bonanza runs at 94% RTP at {brand}, with a 15,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/dice_million': {
        title: 'Dice Million: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Dice Million runs at 94% RTP at {brand}, with a 3,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/dig_dig_digger': {
        title: 'Dig Dig Digger: 94.82% RTP, 7,791x Max Win | {brand}',
        description: 'Dig Dig Digger runs at 94.82% RTP at {brand}, with a 7,791x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/disco_party': {
        title: 'Disco Party: 94% RTP, 1,500x Max Win | {brand}',
        description: 'Disco Party runs at 94% RTP at {brand}, with a 1,500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/divine_queen_heart_of_ice': {
        title: 'Divine Queen Heart of Ice: 97% RTP, 5,000x Max Win | {brand}',
        description: 'Divine Queen Heart of Ice runs at 97% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/domnitors': {
        title: 'Domnitors Slot | 10,000x Max Win | {brand}',
        description: 'Play Domnitors slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/domnitors_deluxe': {
        title: 'Domnitors Deluxe Slot | 10,000x Max Win | {brand}',
        description: 'Play Domnitors Deluxe slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/domnitors_treasure': {
        title: "Domnitor's Treasure: 94% RTP, 2,000x Max Win | {brand}",
        description: "Domnitor's Treasure runs at 94% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/doomsday_saloon': {
        title: 'Doomsday Saloon: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Doomsday Saloon runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/dragon_age_hold_and_win_dragon_age': {
        title: 'Dragon Age Hold and Win (Dragon Age): 96.14% RTP | {brand}',
        description: 'Dragon Age Hold and Win (Dragon Age) runs at 96.14% RTP at {brand}, with a 5,624x max win and medium volatility. Crypto deposits, instant withdrawals,.'
    },
    '/p/bgaming/dragon_queens_megaways': {
        title: 'Dragon Queens Megaways: 96.75% RTP, 6,000x Max Win | {brand}',
        description: 'Dragon Queens Megaways runs at 96.75% RTP at {brand}, with a 6,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/dragons_gold_100': {
        title: "Dragon's Gold 100: 94% RTP, 3,000x Max Win | {brand}",
        description: "Dragon's Gold 100 runs at 94% RTP at {brand}, with a 3,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/easter_heist': {
        title: 'Easter Heist: 94% RTP, 5,624x Max Win | {brand}',
        description: 'Easter Heist runs at 94% RTP at {brand}, with a 5,624x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/elvis_frog_in_vegas': {
        title: 'Elvis Frog In Vegas: 95.3% RTP, 2,500x Max Win | {brand}',
        description: 'Elvis Frog In Vegas runs at 95.3% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/elvis_frog_trueways': {
        title: 'Elvis Frog TRUEWAYS: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Elvis Frog TRUEWAYS runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/face_off': {
        title: 'Face Off: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Face Off runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fantasy_park': {
        title: 'Fantasy Park Slot | 5,000x Max Win | {brand}',
        description: 'Play Fantasy Park slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fiesta_clusters': {
        title: 'Fiesta Clusters: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Fiesta Clusters runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fire_lightning': {
        title: 'Fire Lightning: 93.9% RTP, 1,000x Max Win | {brand}',
        description: 'Fire Lightning runs at 93.9% RTP at {brand}, with a 1,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fishing_club': {
        title: 'Fishing Club: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Fishing Club runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/forgotten': {
        title: 'Forgotten: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Forgotten runs at 94% RTP at {brand}, with a 7,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fortuna_trueways': {
        title: 'Fortuna TRUEWAYS: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Fortuna TRUEWAYS runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fortune_bells': {
        title: 'Fortune Bells: 94% RTP, 4,684x Max Win | {brand}',
        description: 'Fortune Bells runs at 94% RTP at {brand}, with a 4,684x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fortune_red_packets': {
        title: 'Fortune Red Packets: 98.4% RTP, 14x Max Win | {brand}',
        description: 'Fortune Red Packets runs at 98.4% RTP at {brand}, with a 14x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fortune_spin': {
        title: 'Fortune Spin: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Fortune Spin runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/forty_fruity_million': {
        title: 'Forty Fruity Million: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Forty Fruity Million runs at 94% RTP at {brand}, with a 6,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/four_lucky_clover': {
        title: 'Four Lucky Clover: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Four Lucky Clover runs at 94% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/four_lucky_diamonds': {
        title: 'Four Lucky Diamonds: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Four Lucky Diamonds runs at 94% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fruit_million': {
        title: 'Fruit Million: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Fruit Million runs at 94% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gangsterz': {
        title: 'Gangsterz: 96.25% RTP, 12,000x Max Win | {brand}',
        description: 'Gangsterz runs at 96.25% RTP at {brand}, with a 12,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gemhalla': {
        title: 'Gemhalla: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Gemhalla runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gemza': {
        title: 'Gemza: 97.17% RTP, 5,000x Max Win | {brand}',
        description: 'Gemza runs at 97.17% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gift_rush': {
        title: 'Gift Rush: 94% RTP, 559x Max Win | {brand}',
        description: 'Gift Rush runs at 94% RTP at {brand}, with a 559x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/god_of_wealth_hold_and_win': {
        title: 'God of Wealth Hold And Win: 95.24% RTP, 2,000x Max Win | {brand}',
        description: 'God of Wealth Hold And Win runs at 95.24% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gold_magnate': {
        title: 'Gold Magnate: 94% RTP, 10,490x Max Win | {brand}',
        description: 'Gold Magnate runs at 94% RTP at {brand}, with a 10,490x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gold_of_minos': {
        title: 'Gold of Minos: 94% RTP, 15,360x Max Win | {brand}',
        description: 'Gold of Minos runs at 94% RTP at {brand}, with a 15,360x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/gold_rush_with_johnny_cash': {
        title: 'Gold Rush with Johnny Cash: 94% RTP, 5,820x Max Win | {brand}',
        description: 'Gold Rush with Johnny Cash runs at 94% RTP at {brand}, with a 5,820x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/golden_pinata_hold_and_win': {
        title: 'Golden Pinata Hold and Win: 94% RTP, 5,624x Max Win | {brand}',
        description: 'Golden Pinata Hold and Win runs at 94% RTP at {brand}, with a 5,624x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/golden_pride': {
        title: 'Golden Pride: 94% RTP, 15,360x Max Win | {brand}',
        description: 'Golden Pride runs at 94% RTP at {brand}, with a 15,360x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/grand_mustang': {
        title: 'Grand Mustang: 94% RTP, 5,624x Max Win | {brand}',
        description: 'Grand Mustang runs at 94% RTP at {brand}, with a 5,624x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/grand_patron': {
        title: 'Grand Patron: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Grand Patron runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/halloween_bonanza': {
        title: 'Halloween Bonanza: 94% RTP, 10,200x Max Win | {brand}',
        description: 'Halloween Bonanza runs at 94% RTP at {brand}, with a 10,200x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/haunted_reels': {
        title: 'Haunted Reels: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Haunted Reels runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/hawaii_cocktails': {
        title: 'Hawaii Cocktails Slot | 5,000x Max Win | {brand}',
        description: 'Play Hawaii Cocktails slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/heads_and_tails': {
        title: 'Heads and Tails: 99% RTP, 2x Max Win | {brand}',
        description: 'Heads and Tails runs at 99% RTP at {brand}, with a 2x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/heads_and_tails_xy': {
        title: 'Heads And Tails XY: 99% RTP, 2x Max Win | {brand}',
        description: 'Heads And Tails XY runs at 99% RTP at {brand}, with a 2x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/heart_of_tiki': {
        title: 'Heart of Tiki: 96.96% RTP, 5,000x Max Win | {brand}',
        description: 'Heart of Tiki runs at 96.96% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/hello_easter': {
        title: 'Hello Easter Slot | 9,000x Max Win | {brand}',
        description: 'Play Hello Easter slot with Bitcoin at {brand}. Medium-High volatility, 9,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/hit_the_route': {
        title: 'Hit The Route: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Hit The Route runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/hot_chilli_bells': {
        title: 'Hot Chilli Bells: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Hot Chilli Bells runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/hottest_666': {
        title: 'Hottest 666: 96% RTP, 6,600x Max Win | {brand}',
        description: 'Hottest 666 runs at 96% RTP at {brand}, with a 6,600x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/infinity_pull': {
        title: 'Infinity Pull: 94% RTP, 100x Max Win | {brand}',
        description: 'Infinity Pull runs at 94% RTP at {brand}, with a 100x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/jogo_do_bicho': {
        title: 'Jogo Do Bicho: 94% RTP, 17,000x Max Win | {brand}',
        description: 'Jogo Do Bicho runs at 94% RTP at {brand}, with a 17,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/jogo_do_bicho_simple': {
        title: 'Jogo Do Bicho Simple: 94% RTP, 12x Max Win | {brand}',
        description: 'Jogo Do Bicho Simple runs at 94% RTP at {brand}, with a 12x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/johnny_cash': {
        title: 'Johnny Cash: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Johnny Cash runs at 94% RTP at {brand}, with a 1,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/joker_queen': {
        title: 'Joker Queen: 96% RTP, 1,172x Max Win | {brand}',
        description: 'Joker Queen runs at 96% RTP at {brand}, with a 1,172x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/joker_vs_joker': {
        title: 'Joker vs Joker: 95.5% RTP, 7,500x Max Win | {brand}',
        description: 'Joker vs Joker runs at 95.5% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/joker_x_love': {
        title: 'Joker X Love: 96.23% RTP, 1,059x Max Win | {brand}',
        description: 'Joker X Love runs at 96.23% RTP at {brand}, with a 1,059x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/jokers_million': {
        title: "Joker's Million: 97.34% RTP, 3,000x Max Win | {brand}",
        description: "Joker's Million runs at 97.34% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/journey_flirt': {
        title: 'Journey Flirt Slot | 15,000x Max Win | {brand}',
        description: 'Play Journey Flirt slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/jungle_queen': {
        title: 'Jungle Queen: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Jungle Queen runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/keepers_of_the_secret': {
        title: 'Keepers Of The Secret: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Keepers Of The Secret runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/krakens_hunger': {
        title: "Kraken's Hunger: 94% RTP, 5,000x Max Win | {brand}",
        description: "Kraken's Hunger runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/lady_lucky_gun': {
        title: 'Lady Lucky Gun: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Lady Lucky Gun runs at 94% RTP at {brand}, with a 1,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lady_wolf_moon': {
        title: 'Lady Wolf Moon: 94% RTP, 27,000x Max Win | {brand}',
        description: 'Lady Wolf Moon runs at 94% RTP at {brand}, with a 27,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lady_wolf_moon_megaways': {
        title: 'Lady Wolf Moon Megaways: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Lady Wolf Moon Megaways runs at 94% RTP at {brand}, with a 6,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/loki_loot': {
        title: 'Loki Loot: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Loki Loot runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/luck_and_magic': {
        title: 'Luck & Magic: 94% RTP, 1,039x Max Win | {brand}',
        description: 'Luck & Magic runs at 94% RTP at {brand}, with a 1,039x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_8_merge_up': {
        title: 'Lucky 8 Merge Up: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Lucky 8 Merge Up runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_blue': {
        title: 'Lucky Blue Slot | 5,000x Max Win | {brand}',
        description: 'Play Lucky Blue slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lucky_crew': {
        title: 'Lucky Crew: 94% RTP, 3,525x Max Win | {brand}',
        description: 'Lucky Crew runs at 94% RTP at {brand}, with a 3,525x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_dama_muerta': {
        title: 'Lucky Dama Muerta: 94% RTP, 2,750x Max Win | {brand}',
        description: 'Lucky Dama Muerta runs at 94% RTP at {brand}, with a 2,750x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_dragon_multidice_x': {
        title: 'Lucky Dragon MultiDice X: 94% RTP, 7,776x Max Win | {brand}',
        description: 'Lucky Dragon MultiDice X runs at 94% RTP at {brand}, with a 7,776x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_ducky': {
        title: 'Lucky Ducky: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Lucky Ducky runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_farm_bonanza': {
        title: 'Lucky Farm Bonanza: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Lucky Farm Bonanza runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_ladys_clover': {
        title: "Lucky Lady's Clover: 97.31% RTP, 10,000x Max Win | {brand}",
        description: "Lucky Lady's Clover runs at 97.31% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/lucky_lu': {
        title: 'Lucky Lu: 94% RTP, 559x Max Win | {brand}',
        description: 'Lucky Lu runs at 94% RTP at {brand}, with a 559x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_oak': {
        title: 'Lucky Oak: 94% RTP, 9,991x Max Win | {brand}',
        description: 'Lucky Oak runs at 94% RTP at {brand}, with a 9,991x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/magic_mummy_megaways': {
        title: 'Magic Mummy Megaways: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Magic Mummy Megaways runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/maneki_88_fortunes': {
        title: 'Maneki 88 Fortunes: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Maneki 88 Fortunes runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/maneki_88_gold': {
        title: 'Maneki 88 Gold: 96.9% RTP, 2,614x Max Win | {brand}',
        description: 'Maneki 88 Gold runs at 96.9% RTP at {brand}, with a 2,614x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/mechanical_clover': {
        title: 'Mechanical Clover: 95.42% RTP, 24,360x Max Win | {brand}',
        description: 'Mechanical Clover runs at 95.42% RTP at {brand}, with a 24,360x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/merge_up': {
        title: 'Merge Up: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Merge Up runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/merge_up_2': {
        title: 'Merge Up 2: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Merge Up 2 runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/mice_and_magic_wonder_spin': {
        title: 'Mice & Magic Wonder Spin: 95.48% RTP, 2,820x Max Win | {brand}',
        description: 'Mice & Magic Wonder Spin runs at 95.48% RTP at {brand}, with a 2,820x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/miss_cherry_fruits': {
        title: 'Miss Cherry Fruits: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Miss Cherry Fruits runs at 94% RTP at {brand}, with a 1,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/miss_cherry_fruits_jackpot_party': {
        title: 'Miss Cherry Fruits Jackpot Party: 95.51% RTP | {brand}',
        description: 'Miss Cherry Fruits Jackpot Party runs at 95.51% RTP at {brand}, with a 1,299x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/bgaming/monster_hunt': {
        title: 'Monster Hunt: 94.65% RTP, 1,299x Max Win | {brand}',
        description: 'Monster Hunt runs at 94.65% RTP at {brand}, with a 1,299x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/mummys_gold': {
        title: "Mummy's Gold: 96.96% RTP, 5,000x Max Win | {brand}",
        description: "Mummy's Gold runs at 96.96% RTP at {brand}, with a 5,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/bgaming/mystery_garden': {
        title: 'Mystery Garden: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Mystery Garden runs at 94% RTP at {brand}, with a 2,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/mystery_heist': {
        title: 'Mystery Heist: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Mystery Heist runs at 94% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/olympus_trueways': {
        title: 'Olympus Trueways: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Olympus Trueways runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/oof_the_goldmine_planet': {
        title: 'OOF The Goldmine Planet: 94% RTP, 5,000x Max Win | {brand}',
        description: 'OOF The Goldmine Planet runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/panda_fortune_rush': {
        title: 'Panda Fortune Rush: 96.03% RTP, 1,750x Max Win | {brand}',
        description: 'Panda Fortune Rush runs at 96.03% RTP at {brand}, with a 1,750x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/panda_luck': {
        title: 'Panda Luck: 94% RTP, 2,124x Max Win | {brand}',
        description: 'Panda Luck runs at 94% RTP at {brand}, with a 2,124x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/penalty_duel': {
        title: 'Penalty Duel: 94% RTP, 4,860x Max Win | {brand}',
        description: 'Penalty Duel runs at 94% RTP at {brand}, with a 4,860x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/penny_pelican': {
        title: 'Penny Pelican: 94% RTP, 3,525x Max Win | {brand}',
        description: 'Penny Pelican runs at 94% RTP at {brand}, with a 3,525x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/piggy_bank_hold_and_win': {
        title: 'Piggy Bank Hold and Win: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Piggy Bank Hold and Win runs at 94% RTP at {brand}, with a 2,500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/platinum_lightning': {
        title: 'Platinum Lightning: 96.29% RTP, 8,888x Max Win | {brand}',
        description: 'Platinum Lightning runs at 96.29% RTP at {brand}, with a 8,888x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/platinum_lightning_deluxe': {
        title: 'Platinum Lightning Deluxe: 96.29% RTP, 8,888x Max Win | {brand}',
        description: 'Platinum Lightning Deluxe runs at 96.29% RTP at {brand}, with a 8,888x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/pop_zen': {
        title: 'Pop Zen: 96.25% RTP, 12,000x Max Win | {brand}',
        description: 'Pop Zen runs at 96.25% RTP at {brand}, with a 12,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/potion_spells': {
        title: 'Potion Spells: 96.25% RTP, 12,000x Max Win | {brand}',
        description: 'Potion Spells runs at 96.25% RTP at {brand}, with a 12,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/princess_of_sky': {
        title: 'Princess Of Sky Slot | 10,000x Max Win | {brand}',
        description: 'Play Princess Of Sky slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/recycle_riches': {
        title: 'Recycle Riches: 96.14% RTP, 10,000x Max Win | {brand}',
        description: 'Recycle Riches runs at 96.14% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/retro_trader': {
        title: 'Retro Trader: 99% RTP, 3x Max Win | {brand}',
        description: 'Retro Trader runs at 99% RTP at {brand}, with a 3x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/road_2_riches': {
        title: 'Road 2 Riches: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Road 2 Riches runs at 94% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/robospin': {
        title: 'Robospin: 98% RTP, 63x Max Win | {brand}',
        description: 'Robospin runs at 98% RTP at {brand}, with a 63x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/rocket_eruption_triple_blast': {
        title: 'Rocket Eruption Triple Blast: 96.57% RTP | {brand}',
        description: 'Rocket Eruption Triple Blast runs at 96.57% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/rotating_element': {
        title: 'Rotating Element: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rotating Element runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/royal_fruits_multilines': {
        title: 'Royal Fruits MultiLines: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Royal Fruits MultiLines runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/royal_highroad': {
        title: 'Royal High-Road: 94% RTP, 5,624x Max Win | {brand}',
        description: 'Royal High-Road runs at 94% RTP at {brand}, with a 5,624x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/royal_roulette_500x': {
        title: 'Royal Roulette 500x: 97.3% RTP, 500x Max Win | {brand}',
        description: 'Royal Roulette 500x runs at 97.3% RTP at {brand}, with a 500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/sakura_riches_60': {
        title: 'Sakura Riches 60: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Sakura Riches 60 runs at 94% RTP at {brand}, with a 3,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/savage_buffalo_spirit': {
        title: 'Savage Buffalo Spirit: 94% RTP, 4,684x Max Win | {brand}',
        description: 'Savage Buffalo Spirit runs at 94% RTP at {brand}, with a 4,684x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/savage_buffalo_spirit_megaways': {
        title: 'Savage Buffalo Spirit Megaways: 94% RTP | {brand}',
        description: 'Savage Buffalo Spirit Megaways runs at 94% RTP at {brand}, with a 6,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/secret_bar_multidice_x': {
        title: 'Secret Bar Multidice X: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Secret Bar Multidice X runs at 94% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/slot_machine': {
        title: 'Slot Machine: 94% RTP, 2,124x Max Win | {brand}',
        description: 'Slot Machine runs at 94% RTP at {brand}, with a 2,124x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/snoop_dogg_dollars': {
        title: 'Snoop Dogg Dollars: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Snoop Dogg Dollars runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/soccermania': {
        title: 'Soccermania: 94% RTP, 1,039x Max Win | {brand}',
        description: 'Soccermania runs at 94% RTP at {brand}, with a 1,039x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/spin_and_spell': {
        title: 'Spin And Spell: 95.8% RTP, 1,000x Max Win | {brand}',
        description: 'Spin And Spell runs at 95.8% RTP at {brand}, with a 1,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/street_power': {
        title: 'Street Power: 94% RTP, 100x Max Win | {brand}',
        description: 'Street Power runs at 94% RTP at {brand}, with a 100x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/sugar_mix': {
        title: 'Sugar Mix: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Sugar Mix runs at 94% RTP at {brand}, with a 4,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/sweet_rush_megaways': {
        title: 'Sweet Rush Megaways: 94% RTP, 12,960x Max Win | {brand}',
        description: 'Sweet Rush Megaways runs at 94% RTP at {brand}, with a 12,960x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/tile_master': {
        title: 'Tile Master: 94% RTP, 100x Max Win | {brand}',
        description: 'Tile Master runs at 94% RTP at {brand}, with a 100x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/train_to_rio_grande': {
        title: 'Train to Rio Grande: 94% RTP, 10,490x Max Win | {brand}',
        description: 'Train to Rio Grande runs at 94% RTP at {brand}, with a 10,490x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/tramp_day': {
        title: 'Tramp Day: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Tramp Day runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/tramp_day_trueways': {
        title: 'Tramp Day Trueways: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Tramp Day Trueways runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/treasure_of_anubis': {
        title: 'Treasure of Anubis: 97.13% RTP, 1,939x Max Win | {brand}',
        description: 'Treasure of Anubis runs at 97.13% RTP at {brand}, with a 1,939x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/ufo_pyramids': {
        title: 'UFO Pyramids: 94% RTP, 5,000x Max Win | {brand}',
        description: 'UFO Pyramids runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/voodoo_people': {
        title: 'Voodoo People: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Voodoo People runs at 94% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wbc_ring_of_riches': {
        title: 'WBC Ring of Riches: 94% RTP, 9,200x Max Win | {brand}',
        description: 'WBC Ring of Riches runs at 94% RTP at {brand}, with a 9,200x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/west_town': {
        title: 'West Town: 96.95% RTP, 5,000x Max Win | {brand}',
        description: 'West Town runs at 96.95% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_card_gang': {
        title: 'Wild Card Gang: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Card Gang runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_cash': {
        title: 'Wild Cash: 94% RTP, 1,039x Max Win | {brand}',
        description: 'Wild Cash runs at 94% RTP at {brand}, with a 1,039x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_cash_dice': {
        title: 'Wild Cash Dice: 94% RTP, 9,990x Max Win | {brand}',
        description: 'Wild Cash Dice runs at 94% RTP at {brand}, with a 9,990x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_cash_x9990': {
        title: 'Wild Cash X9990: 94% RTP, 9,990x Max Win | {brand}',
        description: 'Wild Cash X9990 runs at 94% RTP at {brand}, with a 9,990x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_chicago': {
        title: 'Wild Chicago: 94% RTP, 4,684x Max Win | {brand}',
        description: 'Wild Chicago runs at 94% RTP at {brand}, with a 4,684x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_clusters': {
        title: 'Wild Clusters: 96.71% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Clusters runs at 96.71% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_heart': {
        title: 'Wild Heart: 94% RTP, 2,820x Max Win | {brand}',
        description: 'Wild Heart runs at 94% RTP at {brand}, with a 2,820x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_moon_thieves': {
        title: 'Wild Moon Thieves: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Moon Thieves runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_tiger': {
        title: 'Wild Tiger: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Wild Tiger runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_west_trueways': {
        title: 'Wild West TRUEWAYS: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Wild West TRUEWAYS runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/wild_wick': {
        title: 'Wild Wick: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Wild Wick runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/winter_fishing_club': {
        title: 'Winter Fishing Club: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Winter Fishing Club runs at 94% RTP at {brand}, with a 3,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/zeus_goes_wild': {
        title: 'Zeus Goes Wild: 94% RTP, 800x Max Win | {brand}',
        description: 'Zeus Goes Wild runs at 94% RTP at {brand}, with a 800x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/2_wild_2_die': {
        title: '2 Wild 2 Die: 96.25% RTP, 15,000x Max Win | {brand}',
        description: '2 Wild 2 Die runs at 96.25% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/aiko_and_the_wind_spirit': {
        title: 'Aiko and the Wind Spirit: 96.29% RTP, 10,000x Max Win | {brand}',
        description: 'Aiko and the Wind Spirit runs at 96.29% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/alpha_eagle': {
        title: 'Alpha Eagle: 96.26% RTP, 10,000x Max Win | {brand}',
        description: 'Alpha Eagle runs at 96.26% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/aztec_twist': {
        title: 'Aztec Twist Slot | Play Online | {brand}',
        description: 'Play Aztec Twist by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/bash_bros': {
        title: 'Bash Bros: 96.26% RTP, 10,000x Max Win | {brand}',
        description: 'Bash Bros runs at 96.26% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/beam_boys': {
        title: 'Beam Boys: 96.35% RTP, 12,500x Max Win | {brand}',
        description: 'Beam Boys runs at 96.35% RTP at {brand}, with a 12,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/beast_below': {
        title: 'Beast Below: 96.29% RTP, 10,000x Max Win | {brand}',
        description: 'Beast Below runs at 96.29% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/benny_the_beer': {
        title: 'Benny The Beer: 96.17% RTP, 10,000x Max Win | {brand}',
        description: 'Benny The Beer runs at 96.17% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/bloodthirst': {
        title: 'Bloodthirst: 96.19% RTP, 10,000x Max Win | {brand}',
        description: 'Bloodthirst runs at 96.19% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/book_of_time': {
        title: 'Book of Time: 96.13% RTP, 10,000x Max Win | {brand}',
        description: 'Book of Time runs at 96.13% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/booze_bash': {
        title: 'Booze Bash: 96.31% RTP, 12,500x Max Win | {brand}',
        description: 'Booze Bash runs at 96.31% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/born_wild': {
        title: 'Born Wild: 96.2% RTP, 2,500x Max Win | {brand}',
        description: 'Born Wild runs at 96.2% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/bouncy_bombs': {
        title: 'Bouncy Bombs: 96.22% RTP, 10,000x Max Win | {brand}',
        description: 'Bouncy Bombs runs at 96.22% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/break_bones': {
        title: 'Break Bones: 96.22% RTP, 3,333x Max Win | {brand}',
        description: 'Break Bones runs at 96.22% RTP at {brand}, with a 3,333x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/buffalo_stacknsync': {
        title: "Buffalo Stack'n'Sync: 96.36% RTP | {brand}",
        description: "Buffalo Stack'n'Sync runs at 96.36% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/bullets_and_bounty': {
        title: 'Bullets and Bounty: 96.27% RTP, 20,000x Max Win | {brand}',
        description: 'Bullets and Bounty runs at 96.27% RTP at {brand}, with a 20,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cash_compass': {
        title: 'Cash Compass Slot | Play Online | {brand}',
        description: 'Play Cash Compass by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cash_crew': {
        title: 'Cash Crew: 96.26% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Crew runs at 96.26% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cash_quest': {
        title: 'Cash Quest: 96.32% RTP, 7,500x Max Win | {brand}',
        description: 'Cash Quest runs at 96.32% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/chaos_crew': {
        title: 'Chaos Crew Slot | 10,000x Max Win | {brand}',
        description: 'Play Chaos Crew slot with Bitcoin at {brand}. Extreme volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/chaos_crew_2': {
        title: 'Chaos Crew 2: 96.27% RTP, 20,000x Max Win | {brand}',
        description: 'Chaos Crew 2 runs at 96.27% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/chaos_crew_3': {
        title: 'Chaos Crew 3: 96.18% RTP, 30,000x Max Win | {brand}',
        description: 'Chaos Crew 3 runs at 96.18% RTP at {brand}, with a 30,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/circle_of_life': {
        title: 'Circle of Life: 96.33% RTP, 15,000x Max Win | {brand}',
        description: 'Circle of Life runs at 96.33% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cloud_princess': {
        title: 'Cloud Princess: 96.24% RTP, 10,000x Max Win | {brand}',
        description: 'Cloud Princess runs at 96.24% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/cubes': {
        title: 'Cubes Slot | Play Online | {brand}',
        description: 'Play Cubes by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cubes_2': {
        title: 'Cubes 2 Slot | Play Online | {brand}',
        description: 'Play Cubes 2 by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cursed_seas': {
        title: 'Cursed Seas: 96.22% RTP, 12,500x Max Win | {brand}',
        description: 'Cursed Seas runs at 96.22% RTP at {brand}, with a 12,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/danny_dollar': {
        title: 'Danny Dollar: 96.21% RTP, 12,500x Max Win | {brand}',
        description: 'Danny Dollar runs at 96.21% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dark_summoning': {
        title: 'Dark Summoning: 96.36% RTP, 10,666x Max Win | {brand}',
        description: 'Dark Summoning runs at 96.36% RTP at {brand}, with a 10,666x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dawn_of_kings': {
        title: 'Dawn of Kings: 96.24% RTP, 10,000x Max Win | {brand}',
        description: 'Dawn of Kings runs at 96.24% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/densho': {
        title: 'Densho: 96.4% RTP, 10,000x Max Win | {brand}',
        description: 'Densho runs at 96.4% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/divine_drop': {
        title: 'Divine Drop: 96.25% RTP, 10,000x Max Win | {brand}',
        description: 'Divine Drop runs at 96.25% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/donny_and_danny': {
        title: 'Donny and Danny: 96.29% RTP, 12,500x Max Win | {brand}',
        description: 'Donny and Danny runs at 96.29% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/donut_division': {
        title: 'Donut Division: 96.3% RTP, 12,500x Max Win | {brand}',
        description: 'Donut Division runs at 96.3% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dork_unit': {
        title: 'Dork Unit: 96.28% RTP, 10,000x Max Win | {brand}',
        description: 'Dork Unit runs at 96.28% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dorks_of_the_deep': {
        title: 'Dorks of the Deep: 96.2% RTP, 10,000x Max Win | {brand}',
        description: 'Dorks of the Deep runs at 96.2% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/double_rainbow': {
        title: 'Double Rainbow: 96.38% RTP, 5,000x Max Win | {brand}',
        description: 'Double Rainbow runs at 96.38% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dragons_domain': {
        title: 'Dragons Domain Slot | 10,000x Max Win | {brand}',
        description: 'Play Dragons Domain slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/dropem': {
        title: "Drop'em: 96.21% RTP, 10,000x Max Win | {brand}",
        description: "Drop'em runs at 96.21% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/duel_at_dawn': {
        title: 'Duel at Dawn: 96.3% RTP, 15,000x Max Win | {brand}',
        description: 'Duel at Dawn runs at 96.3% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/dusk_princess': {
        title: 'Dusk Princess: 94.42% RTP, 10,000x Max Win | {brand}',
        description: 'Dusk Princess runs at 94.42% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/evil_eyes': {
        title: 'Evil Eyes: 96.24% RTP, 12,500x Max Win | {brand}',
        description: 'Evil Eyes runs at 96.24% RTP at {brand}, with a 12,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/eye_of_medusa': {
        title: 'Eye of Medusa: 96.2% RTP, 10,000x Max Win | {brand}',
        description: 'Eye of Medusa runs at 96.2% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/eye_of_the_panda': {
        title: 'Eye of the Panda: 96.26% RTP, 10,000x Max Win | {brand}',
        description: 'Eye of the Panda runs at 96.26% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/fear_the_dark': {
        title: 'Fear the Dark: 96.25% RTP, 5,000x Max Win | {brand}',
        description: 'Fear the Dark runs at 96.25% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/feel_the_beat': {
        title: 'Feel The Beat: 96.2% RTP, 10,000x Max Win | {brand}',
        description: 'Feel The Beat runs at 96.2% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/fighter_pit': {
        title: 'Fighter Pit: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'Fighter Pit runs at 96.3% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/fire_my_laser': {
        title: 'Fire my Laser: 96.31% RTP, 15,000x Max Win | {brand}',
        description: 'Fire my Laser runs at 96.31% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/fist_of_destruction': {
        title: 'Fist Of Destruction: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'Fist Of Destruction runs at 96.3% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/forest_fortune': {
        title: 'Forest Fortune: 96.31% RTP, 5,000x Max Win | {brand}',
        description: 'Forest Fortune runs at 96.31% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/franks_farm': {
        title: "Frank's Farm: 96.31% RTP, 5,000x Max Win | {brand}",
        description: "Frank's Farm runs at 96.31% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/freds_food_truck': {
        title: "Fred's Food Truck: 96.33% RTP, 10,000x Max Win | {brand}",
        description: "Fred's Food Truck runs at 96.33% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/fruit_duel': {
        title: 'Fruit Duel: 96.3% RTP, 3,333x Max Win | {brand}',
        description: 'Fruit Duel runs at 96.3% RTP at {brand}, with a 3,333x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/frutz': {
        title: 'Frutz Slot | Play Online | {brand}',
        description: 'Play Frutz by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/get_the_cheese': {
        title: 'Get the CHEESE: 96.31% RTP, 10,000x Max Win | {brand}',
        description: 'Get the CHEESE runs at 96.31% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/gladiator_legends': {
        title: 'Gladiator Legends: 96.31% RTP, 10,000x Max Win | {brand}',
        description: 'Gladiator Legends runs at 96.31% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/gronks_gems': {
        title: "Gronk's Gems: 96.24% RTP, 7,500x Max Win | {brand}",
        description: "Gronk's Gems runs at 96.24% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/hand_of_anubis': {
        title: 'Hand of Anubis: 96.24% RTP, 10,000x Max Win | {brand}',
        description: 'Hand of Anubis runs at 96.24% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/hopnpop': {
        title: 'HopnPop Slot | 10,000x Max Win | {brand}',
        description: 'Play HopnPop slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/hot_ross': {
        title: 'Hot Ross: 94.32% RTP, 15,000x Max Win | {brand}',
        description: 'Hot Ross runs at 94.32% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/hounds_of_hell': {
        title: 'Hounds of Hell: 96.27% RTP, 20,000x Max Win | {brand}',
        description: 'Hounds of Hell runs at 96.27% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/immortal_desire': {
        title: 'Immortal Desire: 96.24% RTP, 10,000x Max Win | {brand}',
        description: 'Immortal Desire runs at 96.24% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/invictus': {
        title: 'Invictus: 96.24% RTP, 10,000x Max Win | {brand}',
        description: 'Invictus runs at 96.24% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/itero': {
        title: 'ITERO: 96.18% RTP, 10,000x Max Win | {brand}',
        description: 'ITERO runs at 96.18% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/joker_bombs': {
        title: 'Joker Bombs: 96.48% RTP, 5,000x Max Win | {brand}',
        description: 'Joker Bombs runs at 96.48% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/keep_em_cool': {
        title: "Keep 'em Cool: 96.19% RTP, 5,000x Max Win | {brand}",
        description: "Keep 'em Cool runs at 96.19% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/keepem': {
        title: "Keep'em: 96.27% RTP, 10,000x Max Win | {brand}",
        description: "Keep'em runs at 96.27% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/king_carrot': {
        title: 'King Carrot: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'King Carrot runs at 96.3% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/klowns': {
        title: 'Klowns: 96.26% RTP, 10,000x Max Win | {brand}',
        description: 'Klowns runs at 96.26% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_bandit': {
        title: 'Le Bandit: 96.34% RTP, 10,000x Max Win | {brand}',
        description: 'Le Bandit runs at 96.34% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_fisherman': {
        title: 'Le Fisherman: 94.33% RTP, 15,000x Max Win | {brand}',
        description: 'Le Fisherman runs at 94.33% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_king': {
        title: 'Le King: 96.14% RTP, 20,000x Max Win | {brand}',
        description: 'Le King runs at 96.14% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_pharaoh': {
        title: 'Le Pharaoh: 96.21% RTP, 15,000x Max Win | {brand}',
        description: 'Le Pharaoh runs at 96.21% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_viking': {
        title: 'Le Viking: 96.32% RTP, 10,000x Max Win | {brand}',
        description: 'Le Viking runs at 96.32% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/le_zeus': {
        title: 'Le Zeus: 96.26% RTP, 20,000x Max Win | {brand}',
        description: 'Le Zeus runs at 96.26% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/let_it_snow': {
        title: 'Let It Snow Slot | Play Online | {brand}',
        description: 'Play Let It Snow by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/life_and_death': {
        title: 'Life and Death: 96.36% RTP, 15,000x Max Win | {brand}',
        description: 'Life and Death runs at 96.36% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/magic_piggy': {
        title: 'Magic Piggy: 96.19% RTP, 7,500x Max Win | {brand}',
        description: 'Magic Piggy runs at 96.19% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/marlin_masters': {
        title: 'Marlin Masters: 96.24% RTP, 7,500x Max Win | {brand}',
        description: 'Marlin Masters runs at 96.24% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/marlin_masters_the_big_haul': {
        title: 'Marlin Masters: The Big Haul: 96.28% RTP | {brand}',
        description: 'Marlin Masters: The Big Haul runs at 96.28% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/mayan_stackways': {
        title: 'Mayan Stackways: 96.23% RTP, 10,000x Max Win | {brand}',
        description: 'Mayan Stackways runs at 96.23% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/miami_multiplier': {
        title: 'Miami Multiplier Slot | Play Online | {brand}',
        description: 'Play Miami Multiplier by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/mighty_masks': {
        title: 'Mighty Masks: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'Mighty Masks runs at 96.3% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/mystery_motel': {
        title: 'Mystery Motel Slot | Play Online | {brand}',
        description: 'Play Mystery Motel by Hacksaw Gaming at {brand}. High volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/octo_attack': {
        title: 'Octo Attack: 96.27% RTP, 10,000x Max Win | {brand}',
        description: 'Octo Attack runs at 96.27% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/omnom': {
        title: 'OmNom Slot | 4,800x Max Win | {brand}',
        description: 'Play OmNom slot with Bitcoin at {brand}. Medium volatility, 4,800x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/orb_of_destiny': {
        title: 'Orb of Destiny: 96.27% RTP, 10,000x Max Win | {brand}',
        description: 'Orb of Destiny runs at 96.27% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/outlaws_inc': {
        title: 'Outlaws Inc.: 96.23% RTP, 10,000x Max Win | {brand}',
        description: 'Outlaws Inc. runs at 96.23% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/phoenix_duelreels': {
        title: 'Phoenix DuelReels: 96.27% RTP, 10,000x Max Win | {brand}',
        description: 'Phoenix DuelReels runs at 96.27% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/pray_for_six': {
        title: 'Pray for Six: 94.29% RTP, 20,000x Max Win | {brand}',
        description: 'Pray for Six runs at 94.29% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/pray_for_three': {
        title: 'Pray for Three: 96.33% RTP, 13,333x Max Win | {brand}',
        description: 'Pray for Three runs at 96.33% RTP at {brand}, with a 13,333x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/pug_life': {
        title: 'Pug Life: 96.33% RTP, 7,500x Max Win | {brand}',
        description: 'Pug Life runs at 96.33% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rad_maxx': {
        title: 'Rad Maxx: 96.32% RTP, 12,500x Max Win | {brand}',
        description: 'Rad Maxx runs at 96.32% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rainbow_princess': {
        title: 'Rainbow Princess: 96.36% RTP, 10,000x Max Win | {brand}',
        description: 'Rainbow Princess runs at 96.36% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/reign_of_rome': {
        title: 'Reign of Rome: 96.27% RTP, 15,000x Max Win | {brand}',
        description: 'Reign of Rome runs at 96.27% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rip_city': {
        title: 'RIP City: 96.22% RTP, 12,500x Max Win | {brand}',
        description: 'RIP City runs at 96.22% RTP at {brand}, with a 12,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rise_of_ymir': {
        title: 'Rise of Ymir: 96.31% RTP, 15,000x Max Win | {brand}',
        description: 'Rise of Ymir runs at 96.31% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rocket_reels': {
        title: 'Rocket Reels: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'Rocket Reels runs at 96.3% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/ronin_stackways': {
        title: 'Ronin Stackways: 96.35% RTP, 5,000x Max Win | {brand}',
        description: 'Ronin Stackways runs at 96.35% RTP at {brand}, with a 5,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rotten': {
        title: 'Rotten: 96.27% RTP, 10,000x Max Win | {brand}',
        description: 'Rotten runs at 96.27% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/rusty_and_curly': {
        title: 'Rusty and Curly: 96.29% RTP, 10,000x Max Win | {brand}',
        description: 'Rusty and Curly runs at 96.29% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/shaolin_master': {
        title: 'Shaolin Master: 96.31% RTP, 10,000x Max Win | {brand}',
        description: 'Shaolin Master runs at 96.31% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/sixsixsix': {
        title: 'SixSixSix: 96.15% RTP, 16,666x Max Win | {brand}',
        description: 'SixSixSix runs at 96.15% RTP at {brand}, with a 16,666x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/slayers_inc': {
        title: 'Slayers Inc: 96.28% RTP, 15,000x Max Win | {brand}',
        description: 'Slayers Inc runs at 96.28% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/smoking_dragon': {
        title: 'Smoking Dragon: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'Smoking Dragon runs at 96.3% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/snow_slingers': {
        title: 'Snow Slingers Slot | 10,000x Max Win | {brand}',
        description: 'Play Snow Slingers slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/spear_of_athena': {
        title: 'Spear of Athena: 96.2% RTP, 15,000x Max Win | {brand}',
        description: 'Spear of Athena runs at 96.2% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/spinman': {
        title: 'Spinman: 96.23% RTP, 10,000x Max Win | {brand}',
        description: 'Spinman runs at 96.23% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/spinman_hv': {
        title: 'Spinman H.V.: 96.23% RTP, 10,000x Max Win | {brand}',
        description: 'Spinman H.V. runs at 96.23% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/stackem': {
        title: "Stack'em: 96.2% RTP, 10,000x Max Win | {brand}",
        description: "Stack'em runs at 96.2% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/hacksaw-gaming/steamrunners': {
        title: 'Steamrunners: 96.32% RTP, 10,000x Max Win | {brand}',
        description: 'Steamrunners runs at 96.32% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/stickem': {
        title: 'StickEm Slot | 2,048x (in sticky win spin); 1,000x (bonus ',
        description: 'Play StickEm slot with Bitcoin at {brand}. Medium volatility, 2,048x (in sticky win spin); 1,000x (bonus wheel) max win. BTC, ETH, USDT accepted.'
    },
    '/p/hacksaw-gaming/stormborn': {
        title: 'Stormborn: 96.27% RTP, 15,000x Max Win | {brand}',
        description: 'Stormborn runs at 96.27% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/strength_of_hercules': {
        title: 'Strength of Hercules: 96.31% RTP, 10,000x Max Win | {brand}',
        description: 'Strength of Hercules runs at 96.31% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/sun_princess': {
        title: 'Sun Princess: 96.29% RTP, 10,000x Max Win | {brand}',
        description: 'Sun Princess runs at 96.29% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/superstar_sevens': {
        title: 'Superstar Sevens: 94.27% RTP, 10,000x Max Win | {brand}',
        description: 'Superstar Sevens runs at 94.27% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/tasty_treats': {
        title: 'Tasty Treats: 96.21% RTP, 10,000x Max Win | {brand}',
        description: 'Tasty Treats runs at 96.21% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/temple_of_torment': {
        title: 'Temple of Torment: 96.2% RTP, 10,000x Max Win | {brand}',
        description: 'Temple of Torment runs at 96.2% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/the_bowery_boys': {
        title: 'The Bowery Boys: 96.41% RTP, 10,000x Max Win | {brand}',
        description: 'The Bowery Boys runs at 96.41% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/the_count': {
        title: 'The Count: 96.3% RTP, 12,500x Max Win | {brand}',
        description: 'The Count runs at 96.3% RTP at {brand}, with a 12,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/the_respinners': {
        title: 'The Respinners Slot | Play Online | {brand}',
        description: 'Play The Respinners by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/the_wildwood_curse': {
        title: 'The Wildwood Curse: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'The Wildwood Curse runs at 96.3% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/tiger_legends': {
        title: 'Tiger Legends: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'Tiger Legends runs at 96.3% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/time_spinners': {
        title: 'Time Spinners: 96.19% RTP, 10,000x Max Win | {brand}',
        description: 'Time Spinners runs at 96.19% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/toshi_video_club': {
        title: 'Toshi Video Club: 96.17% RTP, 10,000x Max Win | {brand}',
        description: 'Toshi Video Club runs at 96.17% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/toshi_ways_club': {
        title: 'Toshi Ways Club: 96.09% RTP, 10,000x Max Win | {brand}',
        description: 'Toshi Ways Club runs at 96.09% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/twisted_lab': {
        title: 'Twisted Lab: 96.3% RTP, 15,000x Max Win | {brand}',
        description: 'Twisted Lab runs at 96.3% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/ultimate_slot_of_america': {
        title: 'Ultimate Slot of America: 96.35% RTP, 10,000x Max Win | {brand}',
        description: 'Ultimate Slot of America runs at 96.35% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/undead_fortune': {
        title: 'Undead Fortune: 96.29% RTP, 10,000x Max Win | {brand}',
        description: 'Undead Fortune runs at 96.29% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/vending_machine': {
        title: 'Vending Machine: 96.28% RTP, 5,000x Max Win | {brand}',
        description: 'Vending Machine runs at 96.28% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/wanted_dead_or_a_wild': {
        title: 'Wanted Dead or a Wild: 96.38% RTP, 12,500x Max Win | {brand}',
        description: 'Wanted Dead or a Wild runs at 96.38% RTP at {brand}, with a 12,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/warrior_ways': {
        title: 'Warrior Ways: 96.33% RTP, 10,000x Max Win | {brand}',
        description: 'Warrior Ways runs at 96.33% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/wings_of_horus': {
        title: 'Wings of Horus Slot | 15,000x Max Win | {brand}',
        description: 'Play Wings of Horus slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/wishbringer': {
        title: 'Wishbringer: 96.33% RTP, 10,000x Max Win | {brand}',
        description: 'Wishbringer runs at 96.33% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/xmas_drop': {
        title: 'Xmas Drop: 96.22% RTP, 12,500x Max Win | {brand}',
        description: 'Xmas Drop runs at 96.22% RTP at {brand}, with a 12,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/xpander': {
        title: 'Xpander Slot | 10,000x Max Win | {brand}',
        description: 'Play Xpander slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/ze_zeus': {
        title: 'Ze Zeus: 96.34% RTP, 10,000x Max Win | {brand}',
        description: 'Ze Zeus runs at 96.34% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/zeus_ze_zecond': {
        title: 'Zeus Ze Zecond: 94.18% RTP, 20,000x Max Win | {brand}',
        description: 'Zeus Ze Zecond runs at 94.18% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/3_buzzing_wilds': {
        title: '3 Buzzing Wilds: 94.05% RTP, 5,000x Max Win | {brand}',
        description: '3 Buzzing Wilds runs at 94.05% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/3_dancing_monkeys': {
        title: '3 Dancing Monkeys: 94% RTP, 12,077x Max Win | {brand}',
        description: '3 Dancing Monkeys runs at 94% RTP at {brand}, with a 12,077x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/3_genie_wishes': {
        title: '3 Genie Wishes: 94% RTP, 519x Max Win | {brand}',
        description: '3 Genie Wishes runs at 94% RTP at {brand}, with a 519x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/3_kingdoms_battle_of_red_cliffs': {
        title: '3 Kingdoms - Battle of Red Cliffs: 94.01% RTP | {brand}',
        description: '3 Kingdoms - Battle of Red Cliffs runs at 94.01% RTP at {brand}, with a 200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/3_magic_eggs': {
        title: '3 Magic Eggs: 96.51% RTP, 5,000x Max Win | {brand}',
        description: '3 Magic Eggs runs at 96.51% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/5_frozen_charms_megaways': {
        title: '5 Frozen Charms Megaways: 94.54% RTP, 5,000x Max Win | {brand}',
        description: '5 Frozen Charms Megaways runs at 94.54% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/5_lions': {
        title: '5 Lions: 93.99% RTP, 3,520x Max Win | {brand}',
        description: '5 Lions runs at 93.99% RTP at {brand}, with a 3,520x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/5_lions_dance': {
        title: '5 Lions Dance: 94.5% RTP, 2,700x Max Win | {brand}',
        description: '5 Lions Dance runs at 94.5% RTP at {brand}, with a 2,700x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/5_lions_gold': {
        title: '5 Lions Gold: 95.5% RTP, 7,342x Max Win | {brand}',
        description: '5 Lions Gold runs at 95.5% RTP at {brand}, with a 7,342x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/5_lions_megaways': {
        title: '5 Lions Megaways: 94.54% RTP, 5,000x Max Win | {brand}',
        description: '5 Lions Megaways runs at 94.54% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/5_lions_megaways_2': {
        title: '5 Lions Megaways 2: 94.5% RTP, 8,000x Max Win | {brand}',
        description: '5 Lions Megaways 2 runs at 94.5% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/5_lions_reborn': {
        title: '5 Lions Reborn: 94.5% RTP, 5,000x Max Win | {brand}',
        description: '5 Lions Reborn runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/5_rabbits_megaways': {
        title: '5 Rabbits MegaWays: 94.54% RTP, 5,000x Max Win | {brand}',
        description: '5 Rabbits MegaWays runs at 94.54% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/6_jokers': {
        title: '6 Jokers: 94.53% RTP, 5,000x Max Win | {brand}',
        description: '6 Jokers runs at 94.53% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/7_clovers_of_fortune': {
        title: '7 Clovers of Fortune: 93.95% RTP, 4,454x Max Win | {brand}',
        description: '7 Clovers of Fortune runs at 93.95% RTP at {brand}, with a 4,454x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/7_monkeys': {
        title: '7 Monkeys: 92.71% RTP, 4,500x Max Win | {brand}',
        description: '7 Monkeys runs at 92.71% RTP at {brand}, with a 4,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/7_monkeys_jp': {
        title: '7 Monkeys Jp Slot | Play Online | {brand}',
        description: 'Play 7 Monkeys Jp by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/7_piggies': {
        title: '7 piggies: 95.99% RTP, 39,000x Max Win | {brand}',
        description: '7 piggies runs at 95.99% RTP at {brand}, with a 39,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/888_bonanza': {
        title: '888 Bonanza: 95.5% RTP | {brand}',
        description: '888 Bonanza runs at 95.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/888_dragons': {
        title: '888 Dragons: 95.76% RTP, 100x Max Win | {brand}',
        description: '888 Dragons runs at 95.76% RTP at {brand}, with a 100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/888_gold': {
        title: '888 Gold Slot | 2,001x Max Win | {brand}',
        description: 'Play 888 Gold slot with Bitcoin at {brand}. Medium-High volatility, 2,001x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/8_dragons': {
        title: '8 Dragons: 93.19% RTP, 7,500x Max Win | {brand}',
        description: '8 Dragons runs at 93.19% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/8_golden_dragon_challenge': {
        title: '8 Golden Dragon Challenge: 94.02% RTP | {brand}',
        description: '8 Golden Dragon Challenge runs at 94.02% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/african_elephant': {
        title: 'African Elephant: 94.03% RTP, 15,000x Max Win | {brand}',
        description: 'African Elephant runs at 94.03% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aladdin_and_the_sorcerer': {
        title: 'Aladdin and the Sorcerer: 94.51% RTP, 6,532x Max Win | {brand}',
        description: 'Aladdin and the Sorcerer runs at 94.51% RTP at {brand}, with a 6,532x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/alien_invaders': {
        title: 'Alien Invaders: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Alien Invaders runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/anacoda_gold': {
        title: 'Anacoda Gold: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Anacoda Gold runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ancient_egypt': {
        title: 'Ancient Egypt: 95.64% RTP, 5,511x Max Win | {brand}',
        description: 'Ancient Egypt runs at 95.64% RTP at {brand}, with a 5,511x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ancient_egypt_classic': {
        title: 'Ancient Egypt Classic: 95.5% RTP, 5,015x Max Win | {brand}',
        description: 'Ancient Egypt Classic runs at 95.5% RTP at {brand}, with a 5,015x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ancient_island_megaways': {
        title: 'Ancient Island Megaways: 94.55% RTP, 10,000x Max Win | {brand}',
        description: 'Ancient Island Megaways runs at 94.55% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/angel_vs_sinner': {
        title: 'Angel vs Sinner: 94.55% RTP, 15,000x Max Win | {brand}',
        description: 'Angel vs Sinner runs at 94.55% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/anime_mecha_megaways': {
        title: 'Anime Mecha Megaways: 94.08% RTP, 40,000x Max Win | {brand}',
        description: 'Anime Mecha Megaways runs at 94.08% RTP at {brand}, with a 40,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/argonauts': {
        title: 'Argonauts: 94.52% RTP, 10,000x Max Win | {brand}',
        description: 'Argonauts runs at 94.52% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/asgard': {
        title: 'Asgard: 95.47% RTP, 500x Max Win | {brand}',
        description: 'Asgard runs at 95.47% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_blaze': {
        title: 'Aztec Blaze: 94.5% RTP, 2,000x Max Win | {brand}',
        description: 'Aztec Blaze runs at 94.5% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_bonanza': {
        title: 'Aztec Bonanza: 94.53% RTP, 19,440x Max Win | {brand}',
        description: 'Aztec Bonanza runs at 94.53% RTP at {brand}, with a 19,440x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_gems': {
        title: 'Aztec Gems: 94.52% RTP, 375x Max Win | {brand}',
        description: 'Aztec Gems runs at 94.52% RTP at {brand}, with a 375x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_gems_deluxe': {
        title: 'Aztec Gems Deluxe: 94.5% RTP, 22,519x Max Win | {brand}',
        description: 'Aztec Gems Deluxe runs at 94.5% RTP at {brand}, with a 22,519x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_gems_megaways': {
        title: 'Aztec Gems Megaways: 94.53% RTP, 10,000x Max Win | {brand}',
        description: 'Aztec Gems Megaways runs at 94.53% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_king': {
        title: 'Aztec King: 95.5% RTP, 10,500x Max Win | {brand}',
        description: 'Aztec King runs at 95.5% RTP at {brand}, with a 10,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_king_megaways': {
        title: 'Aztec King MegaWays: 94.69% RTP, 20,000x Max Win | {brand}',
        description: 'Aztec King MegaWays runs at 94.69% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_powernudge': {
        title: 'Aztec Powernudge: 94.49% RTP, 5,000x Max Win | {brand}',
        description: 'Aztec Powernudge runs at 94.49% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_smash': {
        title: 'Aztec Smash: 94.5% RTP, 9,000x Max Win | {brand}',
        description: 'Aztec Smash runs at 94.5% RTP at {brand}, with a 9,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/aztec_treasure_hunt': {
        title: 'Aztec Treasure Hunt: 94.99% RTP, 5,000x Max Win | {brand}',
        description: 'Aztec Treasure Hunt runs at 94.99% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/badge_blitz': {
        title: 'Badge Blitz: 94.49% RTP, 3,000x Max Win | {brand}',
        description: 'Badge Blitz runs at 94.49% RTP at {brand}, with a 3,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bali_dragon': {
        title: 'Bali Dragon Slot | 1,040x Max Win | {brand}',
        description: 'Play Bali Dragon slot with Bitcoin at {brand}. Medium-High volatility, 1,040x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bandit_megaways': {
        title: 'Bandit Megaways: 94.56% RTP, 5,000x Max Win | {brand}',
        description: 'Bandit Megaways runs at 94.56% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/barn_festival': {
        title: 'Barn Festival: 94.46% RTP, 20,000x Max Win | {brand}',
        description: 'Barn Festival runs at 94.46% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/barnyard_megahays_megaways': {
        title: 'Barnyard Megahays Megaways™: 94.5% RTP | {brand}',
        description: 'Barnyard Megahays Megaways™ runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bee_keeper': {
        title: 'Bee Keeper: 94.53% RTP, 2,100x Max Win | {brand}',
        description: 'Bee Keeper runs at 94.53% RTP at {brand}, with a 2,100x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/beware_the_deep_megaways': {
        title: 'Beware The Deep Megaways: 94.48% RTP, 10,000x Max Win | {brand}',
        description: 'Beware The Deep Megaways runs at 94.48% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_amazon_xtreme': {
        title: 'Big Bass Amazon Xtreme: 94.05% RTP | {brand}',
        description: 'Big Bass Amazon Xtreme runs at 94.05% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_bonanza': {
        title: 'Big Bass Bonanza: 94.02% RTP, 2,100x Max Win | {brand}',
        description: 'Big Bass Bonanza runs at 94.02% RTP at {brand}, with a 2,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_bonanza_1000': {
        title: 'Big Bass Bonanza 1000: 94.51% RTP | {brand}',
        description: 'Big Bass Bonanza 1000 runs at 94.51% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_bonanza_3_reeler': {
        title: 'Big Bass Bonanza 3 Reeler: 94.5% RTP | {brand}',
        description: 'Big Bass Bonanza 3 Reeler runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_bonanza_hold_and_spinner': {
        title: 'Big Bass Bonanza Hold And Spinner Slot | Pragmatic Play | ',
        description: 'Play Big Bass Bonanza Hold And Spinner by Pragmatic Play at {brand}. Medium-High volatility, hold and spin. Deposit with BTC, ETH, USDT.'
    },
    '/p/pragmatic-play/big_bass_bonanza_keeping_it_reel': {
        title: 'Big Bass Bonanza - Keeping it Reel: 94.07% RTP | {brand}',
        description: 'Big Bass Bonanza - Keeping it Reel runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_bonanza_megaways': {
        title: 'Big Bass Bonanza Megaways: 94.62% RTP | {brand}',
        description: 'Big Bass Bonanza Megaways runs at 94.62% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_bonanza_reel_action': {
        title: 'Big Bass Bonanza - Reel Action: 94.5% RTP | {brand}',
        description: 'Big Bass Bonanza - Reel Action runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_boxing_bonus_round': {
        title: 'Big Bass Boxing Bonus Round: 94.5% RTP | {brand}',
        description: 'Big Bass Boxing Bonus Round runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_christmas_bash': {
        title: 'Big Bass Christmas Bash: 94.6% RTP | {brand}',
        description: 'Big Bass Christmas Bash runs at 94.6% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_christmas_frozen_lake': {
        title: 'Big Bass Christmas Frozen Lake: 94.07% RTP | {brand}',
        description: 'Big Bass Christmas Frozen Lake runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_crash': {
        title: 'Big Bass Crash: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Big Bass Crash runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_day_at_the_races': {
        title: 'Big Bass Day at the Races: 94.05% RTP | {brand}',
        description: 'Big Bass Day at the Races runs at 94.05% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_floats_my_boat': {
        title: 'Big Bass Floats My Boat: 94.08% RTP | {brand}',
        description: 'Big Bass Floats My Boat runs at 94.08% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_halloween': {
        title: 'Big Bass Halloween: 94.09% RTP, 5,000x Max Win | {brand}',
        description: 'Big Bass Halloween runs at 94.09% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_halloween_2': {
        title: 'Big Bass Halloween 2: 94.6% RTP, 5,000x Max Win | {brand}',
        description: 'Big Bass Halloween 2 runs at 94.6% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_halloween_3': {
        title: 'Big Bass Halloween 3: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Big Bass Halloween 3 runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_hold_and_spinner_megaways': {
        title: 'Big Bass Hold & Spinner Megaways: 94.62% RTP | {brand}',
        description: 'Big Bass Hold & Spinner Megaways runs at 94.62% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_mission_fishin': {
        title: "Big Bass Mission Fishin': 94.5% RTP | {brand}",
        description: "Big Bass Mission Fishin' runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/big_bass_raceday_repeat': {
        title: 'Big Bass Raceday Repeat: 96.51% RTP, 5,000x Max Win | {brand}',
        description: 'Big Bass Raceday Repeat runs at 96.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_reel_repeat': {
        title: 'Big Bass Reel Repeat: 94.52% RTP, 5,000x Max Win | {brand}',
        description: 'Big Bass Reel Repeat runs at 94.52% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_return_to_the_races': {
        title: 'Big Bass Return to the Races: 94.07% RTP | {brand}',
        description: 'Big Bass Return to the Races runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_secrets_of_the_golden_lake': {
        title: 'Big Bass Secrets of the Golden Lake: 94.07% RTP | {brand}',
        description: 'Big Bass Secrets of the Golden Lake runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_splash': {
        title: 'Big Bass Splash: 94.6% RTP, 5,000x Max Win | {brand}',
        description: 'Big Bass Splash runs at 94.6% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_splash_1000': {
        title: 'Big Bass Splash 1000: 94.53% RTP | {brand}',
        description: 'Big Bass Splash 1000 runs at 94.53% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_bass_vegas_double_down_deluxe': {
        title: 'Big Bass Vegas Double Down Deluxe: 94.5% RTP | {brand}',
        description: 'Big Bass Vegas Double Down Deluxe runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_burger_load_it_up_with_xtra_cheese': {
        title: 'Big Burger Load it up with Xtra Cheese: 94.07% RTP | {brand}',
        description: 'Big Burger Load it up with Xtra Cheese runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/big_juan': {
        title: 'Big Juan: 94.6% RTP | {brand}',
        description: 'Big Juan runs at 94.6% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bigger_barn_house_bonanza': {
        title: 'Bigger Barn House Bonanza: 94.5% RTP, 25,000x Max Win | {brand}',
        description: 'Bigger Barn House Bonanza runs at 94.5% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bigger_bass_blizzard_christmas_catch': {
        title: 'Bigger Bass Blizzard - Christmas Catch: 94.07% RTP | {brand}',
        description: 'Bigger Bass Blizzard - Christmas Catch runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bigger_bass_bonanza': {
        title: 'Bigger Bass Bonanza: 94.62% RTP, 4,000x Max Win | {brand}',
        description: 'Bigger Bass Bonanza runs at 94.62% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bigger_bass_splash': {
        title: 'Bigger Bass Splash: 94.5% RTP | {brand}',
        description: 'Bigger Bass Splash runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bingo_mania': {
        title: 'Bingo Mania: 94.48% RTP, 5,000x Max Win | {brand}',
        description: 'Bingo Mania runs at 94.48% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/black_bull': {
        title: 'Black Bull: 94.24% RTP, 4,500x Max Win | {brand}',
        description: 'Black Bull runs at 94.24% RTP at {brand}, with a 4,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/blade_and_fangs': {
        title: 'Blade & Fangs: 94.03% RTP, 5,000x Max Win | {brand}',
        description: 'Blade & Fangs runs at 94.03% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/blazing_wilds_megaways': {
        title: 'Blazing Wilds Megaways: 94.03% RTP, 10,000x Max Win | {brand}',
        description: 'Blazing Wilds Megaways runs at 94.03% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/blitz_super_wheel': {
        title: 'Blitz Super Wheel: 94.52% RTP, 10,000x Max Win | {brand}',
        description: 'Blitz Super Wheel runs at 94.52% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bloody_dawn': {
        title: 'Bloody Dawn: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Bloody Dawn runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bomb_bonanza': {
        title: 'Bomb Bonanza: 94.5% RTP, 2,015x Max Win | {brand}',
        description: 'Bomb Bonanza runs at 94.5% RTP at {brand}, with a 2,015x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bonanza_gold': {
        title: 'Bonanza Gold: 95.45% RTP, 21,175x Max Win | {brand}',
        description: 'Bonanza Gold runs at 95.45% RTP at {brand}, with a 21,175x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/book_of_aztec_king': {
        title: 'Book of Aztec King: 94.5% RTP, 5,533x Max Win | {brand}',
        description: 'Book of Aztec King runs at 94.5% RTP at {brand}, with a 5,533x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/book_of_golden_sands': {
        title: 'Book of Golden Sands: 94.05% RTP, 10,000x Max Win | {brand}',
        description: 'Book of Golden Sands runs at 94.05% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/book_of_kingdoms': {
        title: 'Book Of Kingdoms: 95.65% RTP | {brand}',
        description: 'Book Of Kingdoms runs at 95.65% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/book_of_monsters': {
        title: 'Book of Monsters: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Book of Monsters runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/book_of_the_fallen': {
        title: 'Book Of The Fallen Slot | 5,000x Max Win | {brand}',
        description: 'Play Book Of The Fallen slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bounty_gold': {
        title: 'Bounty Gold: 94.51% RTP, 5,000x Max Win | {brand}',
        description: 'Bounty Gold runs at 94.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bounty_hunter': {
        title: 'Bounty Hunter: 94.49% RTP, 10,000x Max Win | {brand}',
        description: 'Bounty Hunter runs at 94.49% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bow_of_artemis': {
        title: 'Bow of Artemis: 94.05% RTP, 10,000x Max Win | {brand}',
        description: 'Bow of Artemis runs at 94.05% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/brick_house_bonanza': {
        title: 'Brick House Bonanza: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Brick House Bonanza runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bubble_pop': {
        title: 'Bubble Pop: 94.5% RTP, 27,000x Max Win | {brand}',
        description: 'Bubble Pop runs at 94.5% RTP at {brand}, with a 27,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/buffalo_king': {
        title: 'Buffalo King: 94.55% RTP, 93,750x Max Win | {brand}',
        description: 'Buffalo King runs at 94.55% RTP at {brand}, with a 93,750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/buffalo_king_megaways': {
        title: 'Buffalo King Megaways: 94.51% RTP, 5,000x Max Win | {brand}',
        description: 'Buffalo King Megaways runs at 94.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/buffalo_king_untamed_megaways': {
        title: 'Buffalo King Untamed Megaways: 94% RTP | {brand}',
        description: 'Buffalo King Untamed Megaways runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/bull_fiesta': {
        title: 'Bull Fiesta: 93.99% RTP, 2,500x Max Win | {brand}',
        description: 'Bull Fiesta runs at 93.99% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/busy_bees': {
        title: 'Busy Bees: 94.8% RTP, 3,325x Max Win | {brand}',
        description: 'Busy Bees runs at 94.8% RTP at {brand}, with a 3,325x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/caishens_cash': {
        title: "Caishen's Cash: 95.5% RTP, 21,749x Max Win | {brand}",
        description: "Caishen's Cash runs at 95.5% RTP at {brand}, with a 21,749x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/caishens_gold': {
        title: "Caishen's Gold: 94.05% RTP, 21,749x Max Win | {brand}",
        description: "Caishen's Gold runs at 94.05% RTP at {brand}, with a 21,749x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/candy_blitz': {
        title: 'Candy Blitz: 94.03% RTP, 10,000x Max Win | {brand}',
        description: 'Candy Blitz runs at 94.03% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/candy_blitz_bombs': {
        title: 'Candy Blitz Bombs: 94.55% RTP, 5,000x Max Win | {brand}',
        description: 'Candy Blitz Bombs runs at 94.55% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/candy_corner': {
        title: 'Candy Corner: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Candy Corner runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/candy_jar_cluster': {
        title: 'Candy Jar Cluster Slot | 10,000x Max Win | {brand}',
        description: 'Play Candy Jar Cluster slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, cluster pays. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/candy_stars': {
        title: 'Candy Stars: 94.31% RTP, 5,000x Max Win | {brand}',
        description: 'Candy Stars runs at 94.31% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/candy_village': {
        title: 'Candy Village: 95.5% RTP, 21,175x Max Win | {brand}',
        description: 'Candy Village runs at 95.5% RTP at {brand}, with a 21,175x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/captain_kraken_megaways': {
        title: 'Captain Kraken Megaways: 94.54% RTP, 5,000x Max Win | {brand}',
        description: 'Captain Kraken Megaways runs at 94.54% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cash_bonanza': {
        title: 'Cash Bonanza: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Cash Bonanza runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cash_box': {
        title: 'Cash Box: 94.09% RTP, 5,000x Max Win | {brand}',
        description: 'Cash Box runs at 94.09% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cash_chips': {
        title: 'Cash Chips: 94.02% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Chips runs at 94.02% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cash_elevator': {
        title: 'Cash Elevator: 94.63% RTP | {brand}',
        description: 'Cash Elevator runs at 94.63% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cash_patrol': {
        title: 'Cash Patrol: 95.5% RTP, 10,500x Max Win | {brand}',
        description: 'Cash Patrol runs at 95.5% RTP at {brand}, with a 10,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cash_surge': {
        title: 'Cash Surge: 94.49% RTP, 5,000x Max Win | {brand}',
        description: 'Cash Surge runs at 94.49% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/casino_heist_megaways': {
        title: 'Casino Heist Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Casino Heist Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/castle_of_fire': {
        title: 'Castle of Fire: 93.99% RTP, 8,000x Max Win | {brand}',
        description: 'Castle of Fire runs at 93.99% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chase_for_glory': {
        title: 'Chase for Glory: 94% RTP, 7,887x Max Win | {brand}',
        description: 'Chase for Glory runs at 94% RTP at {brand}, with a 7,887x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cheeky_emperor': {
        title: 'Cheeky Emperor: 94.48% RTP, 2,500x Max Win | {brand}',
        description: 'Cheeky Emperor runs at 94.48% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chests_of_cai_shen': {
        title: 'Chests of Cai Shen: 94.47% RTP, 10,000x Max Win | {brand}',
        description: 'Chests of Cai Shen runs at 94.47% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chests_of_cai_shen_2': {
        title: 'Chests of Cai Shen 2: 94.5% RTP, 15,000x Max Win | {brand}',
        description: 'Chests of Cai Shen 2 runs at 94.5% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chicken_chase': {
        title: 'Chicken Chase: 94.55% RTP, 210x Max Win | {brand}',
        description: 'Chicken Chase runs at 94.55% RTP at {brand}, with a 210x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chicken_drop': {
        title: 'Chicken Drop: 94.53% RTP, 5,000x Max Win | {brand}',
        description: 'Chicken Drop runs at 94.53% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chilli_heat': {
        title: 'Chilli Heat: 95.52% RTP, 2,512x Max Win | {brand}',
        description: 'Chilli Heat runs at 95.52% RTP at {brand}, with a 2,512x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chilli_heat_megaways': {
        title: 'Chilli Heat MEGAWAYS: 94.57% RTP, 5,000x Max Win | {brand}',
        description: 'Chilli Heat MEGAWAYS runs at 94.57% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/chilli_heat_spicy_spins': {
        title: 'Chilli Heat Spicy Spins: 94.55% RTP, 10,000x Max Win | {brand}',
        description: 'Chilli Heat Spicy Spins runs at 94.55% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/christmas_big_bass_bonanza': {
        title: 'Christmas Big Bass Bonanza: 94.62% RTP | {brand}',
        description: 'Christmas Big Bass Bonanza runs at 94.62% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/christmas_carol_megaways': {
        title: 'Christmas Carol Megaways: 94.69% RTP, 20,000x Max Win | {brand}',
        description: 'Christmas Carol Megaways runs at 94.69% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cleocatra': {
        title: 'Cleocatra: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Cleocatra runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/clover_gold': {
        title: 'Clover Gold: 94.51% RTP, 5,000x Max Win | {brand}',
        description: 'Clover Gold runs at 94.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/club_tropicana': {
        title: 'Club Tropicana: 94.07% RTP, 5,000x Max Win | {brand}',
        description: 'Club Tropicana runs at 94.07% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/club_tropicana_happy_hour': {
        title: 'Club Tropicana Happy Hour: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Club Tropicana Happy Hour runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/coffee_wild': {
        title: 'Coffee Wild: 94.47% RTP, 4,000x Max Win | {brand}',
        description: 'Coffee Wild runs at 94.47% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/colossal_cash_zone': {
        title: 'Colossal Cash Zone: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Colossal Cash Zone runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/congo_cash': {
        title: 'Congo Cash: 94.5% RTP, 4,400x Max Win | {brand}',
        description: 'Congo Cash runs at 94.5% RTP at {brand}, with a 4,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/congo_cash_xl': {
        title: 'Congo Cash XL: 94.48% RTP, 4,400x Max Win | {brand}',
        description: 'Congo Cash XL runs at 94.48% RTP at {brand}, with a 4,400x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cosmic_cash': {
        title: 'Cosmic Cash: 94.6% RTP, 2,650x Max Win | {brand}',
        description: 'Cosmic Cash runs at 94.6% RTP at {brand}, with a 2,650x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cowboy_coins': {
        title: 'Cowboy Coins: 94.12% RTP, 30,000x Max Win | {brand}',
        description: 'Cowboy Coins runs at 94.12% RTP at {brand}, with a 30,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cowboys_gold': {
        title: 'Cowboys Gold: 94.5% RTP, 6,065x Max Win | {brand}',
        description: 'Cowboys Gold runs at 94.5% RTP at {brand}, with a 6,065x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/crank_it_up': {
        title: 'Crank It Up: 94.97% RTP, 10,000x Max Win | {brand}',
        description: 'Crank It Up runs at 94.97% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/crown_of_fire': {
        title: 'Crown of Fire: 94.21% RTP, 1,000x Max Win | {brand}',
        description: 'Crown of Fire runs at 94.21% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/crown_of_fire_jackpot_play': {
        title: 'Crown Of Fire Jackpot Play Slot | 1,000x Max Win | {brand}',
        description: 'Play Crown Of Fire Jackpot Play slot with Bitcoin at {brand}. Medium volatility, 1,000x max win, jackpot play. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/crystal_caverns_megaways': {
        title: 'Crystal Caverns MEGAWAYS: 94.38% RTP, 10,000x Max Win | {brand}',
        description: 'Crystal Caverns MEGAWAYS runs at 94.38% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/curse_of_the_werewolf_megaways': {
        title: 'Curse of the Werewolf Megaways: 94.5% RTP | {brand}',
        description: 'Curse of the Werewolf Megaways runs at 94.5% RTP at {brand}, with a 40,976x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cyber_heist': {
        title: 'Cyber Heist: 94.09% RTP, 5,000x Max Win | {brand}',
        description: 'Cyber Heist runs at 94.09% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cyberheist_city': {
        title: 'Cyberheist City: 96.5% RTP, 5,000x Max Win | {brand}',
        description: 'Cyberheist City runs at 96.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/cyclops_smash': {
        title: 'Cyclops Smash: 94.06% RTP, 10,000x Max Win | {brand}',
        description: 'Cyclops Smash runs at 94.06% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dance_party': {
        title: 'Dance Party: 94.5% RTP, 36,450x Max Win | {brand}',
        description: 'Dance Party runs at 94.5% RTP at {brand}, with a 36,450x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/davincis_treasure': {
        title: "Davinci's Treasure Slot | 48,000x Max Win | {brand}",
        description: "Play Davinci's Treasure slot with Bitcoin at {brand}. Medium-High volatility, 48,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/day_of_dead': {
        title: 'Day of Dead: 94.47% RTP, 4,500x Max Win | {brand}',
        description: 'Day of Dead runs at 94.47% RTP at {brand}, with a 4,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/demon_pots': {
        title: 'Demon Pots: 94.02% RTP | {brand}',
        description: 'Demon Pots runs at 94.02% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/devilicious': {
        title: 'Devilicious: 94.41% RTP, 10,000x Max Win | {brand}',
        description: 'Devilicious runs at 94.41% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/devils_13': {
        title: "Devil's 13: 95.06% RTP, 1,101x Max Win | {brand}",
        description: "Devil's 13 runs at 95.06% RTP at {brand}, with a 1,101x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/diamond_cascade': {
        title: 'Diamond Cascade: 93.98% RTP, 8,000x Max Win | {brand}',
        description: 'Diamond Cascade runs at 93.98% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/diamond_strike': {
        title: 'Diamond Strike: 94.16% RTP, 1,246x Max Win | {brand}',
        description: 'Diamond Strike runs at 94.16% RTP at {brand}, with a 1,246x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/diamonds_of_egypt': {
        title: 'Diamonds of Egypt: 94.49% RTP, 2,500x Max Win | {brand}',
        description: 'Diamonds of Egypt runs at 94.49% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ding_dong_christmas_bells': {
        title: 'Ding Dong Christmas Bells: 94.03% RTP, 2,100x Max Win | {brand}',
        description: 'Ding Dong Christmas Bells runs at 94.03% RTP at {brand}, with a 2,100x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/disco_lady': {
        title: 'Disco Lady: 94.31% RTP, 5,000x Max Win | {brand}',
        description: 'Disco Lady runs at 94.31% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/down_the_rails': {
        title: 'Down the Rails: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Down the Rails runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/drago_jewels_of_fortune': {
        title: 'Drago - Jewels of Fortune: 94.5% RTP, 48,000x Max Win | {brand}',
        description: 'Drago - Jewels of Fortune runs at 94.5% RTP at {brand}, with a 48,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_gold_88': {
        title: 'Dragon Gold 88: 94.6% RTP | {brand}',
        description: 'Dragon Gold 88 runs at 94.6% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_hero': {
        title: 'Dragon Hero: 94.03% RTP, 5,000x Max Win | {brand}',
        description: 'Dragon Hero runs at 94.03% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_hot_hold_and_spin': {
        title: 'Dragon Hot Hold & Spin: 94.64% RTP | {brand}',
        description: 'Dragon Hot Hold & Spin runs at 94.64% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_king_hot_pots': {
        title: 'Dragon King Hot Pots: 94.54% RTP | {brand}',
        description: 'Dragon King Hot Pots runs at 94.54% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_kingdom': {
        title: 'Dragon Kingdom: 94.04% RTP, 400x Max Win | {brand}',
        description: 'Dragon Kingdom runs at 94.04% RTP at {brand}, with a 400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_kingdom_eyes_of_fire': {
        title: 'Dragon Kingdom - Eyes of Fire: 94.49% RTP | {brand}',
        description: 'Dragon Kingdom - Eyes of Fire runs at 94.49% RTP at {brand}, with a 1,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dragon_tiger_fortunes': {
        title: 'Dragon Tiger Fortunes: 96.54% RTP, 8,200x Max Win | {brand}',
        description: 'Dragon Tiger Fortunes runs at 96.54% RTP at {brand}, with a 8,200x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/drill_that_gold': {
        title: 'Drill That Gold: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Drill That Gold runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/duel_of_night_and_day': {
        title: 'Duel of Night and Day: 94.49% RTP, 10,000x Max Win | {brand}',
        description: 'Duel of Night and Day runs at 94.49% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dwarf_and_dragon': {
        title: 'Dwarf & Dragon: 94.53% RTP, 14,000x Max Win | {brand}',
        description: 'Dwarf & Dragon runs at 94.53% RTP at {brand}, with a 14,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dwarven_gold_deluxe': {
        title: 'Dwarven Gold Deluxe: 94.41% RTP, 1,000x Max Win | {brand}',
        description: 'Dwarven Gold Deluxe runs at 94.41% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/dynamite_diggin_doug': {
        title: 'Dynamite Diggin Doug: 94.52% RTP | {brand}',
        description: 'Dynamite Diggin Doug runs at 94.52% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/egg_rush_jackpot_play': {
        title: 'Egg Rush Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Egg Rush Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/egyptian_fortunes': {
        title: 'Egyptian Fortunes: 94% RTP, 309x Max Win | {brand}',
        description: 'Egyptian Fortunes runs at 94% RTP at {brand}, with a 309x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/elemental_gems_megaways': {
        title: 'Elemental Gems Megaways: 94.46% RTP, 5,000x Max Win | {brand}',
        description: 'Elemental Gems Megaways runs at 94.46% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/emerald_king': {
        title: 'Emerald King: 95.51% RTP | {brand}',
        description: 'Emerald King runs at 95.51% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/emerald_king_rainbow_road': {
        title: 'Emerald King Rainbow Road: 94.6% RTP | {brand}',
        description: 'Emerald King Rainbow Road runs at 94.6% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/emperor_caishen': {
        title: 'Emperor Caishen: 94.51% RTP, 2,500x Max Win | {brand}',
        description: 'Emperor Caishen runs at 94.51% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/empty_the_bank': {
        title: 'Empty the Bank: 94.48% RTP, 10,000x Max Win | {brand}',
        description: 'Empty the Bank runs at 94.48% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/escape_the_pyramid_fire_and_ice': {
        title: 'Escape the Pyramid Fire and Ice: 94.5% RTP | {brand}',
        description: 'Escape the Pyramid Fire and Ice runs at 94.5% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/pragmatic-play/eternal_empress_freeze_time': {
        title: 'Eternal Empress - Freeze Time: 94.5% RTP | {brand}',
        description: 'Eternal Empress - Freeze Time runs at 94.5% RTP at {brand}, with a 4,888x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/excalibur_unleashed': {
        title: 'Excalibur Unleashed: 94.01% RTP | {brand}',
        description: 'Excalibur Unleashed runs at 94.01% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/extra_juicy': {
        title: 'Extra juicy: 95.52% RTP, 60,000x Max Win | {brand}',
        description: 'Extra juicy runs at 95.52% RTP at {brand}, with a 60,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/extra_juicy_megaways': {
        title: 'Extra Juicy MEGAWAYS: 94.45% RTP, 5,000x Max Win | {brand}',
        description: 'Extra Juicy MEGAWAYS runs at 94.45% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/eye_of_cleopatra': {
        title: 'Eye of Cleopatra: 94.5% RTP, 4,000x Max Win | {brand}',
        description: 'Eye of Cleopatra runs at 94.5% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/eye_of_spartacus': {
        title: 'Eye of Spartacus: 94.45% RTP, 10,000x Max Win | {brand}',
        description: 'Eye of Spartacus runs at 94.45% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/eye_of_the_storm': {
        title: 'Eye of the Storm: 94.64% RTP | {brand}',
        description: 'Eye of the Storm runs at 94.64% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fairytale_fortune': {
        title: 'Fairytale Fortune: 95.02% RTP, 500x Max Win | {brand}',
        description: 'Fairytale Fortune runs at 95.02% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fangtastic_freespins': {
        title: 'Fangtastic Freespins: 94.54% RTP | {brand}',
        description: 'Fangtastic Freespins runs at 94.54% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fat_panda': {
        title: 'Fat Panda: 94.01% RTP, 20,000x Max Win | {brand}',
        description: 'Fat Panda runs at 94.01% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fiesta_fortune': {
        title: 'Fiesta Fortune: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Fiesta Fortune runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/finger_lickn_free_spins': {
        title: "Finger Lick'n Free Spins: 94.55% RTP, 6,000x Max Win | {brand}",
        description: "Finger Lick'n Free Spins runs at 94.55% RTP at {brand}, with a 6,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/fire_88': {
        title: 'Fire 88: 95.47% RTP, 902x Max Win | {brand}',
        description: 'Fire 88 runs at 95.47% RTP at {brand}, with a 902x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_hot_100': {
        title: 'Fire Hot 100: 94.3% RTP, 2,700x Max Win | {brand}',
        description: 'Fire Hot 100 runs at 94.3% RTP at {brand}, with a 2,700x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_hot_100_jackpot_play': {
        title: 'Fire Hot 100 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Fire Hot 100 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/fire_hot_20': {
        title: 'Fire Hot 20: 94.33% RTP, 1,234x Max Win | {brand}',
        description: 'Fire Hot 20 runs at 94.33% RTP at {brand}, with a 1,234x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_hot_20_jackpot_play': {
        title: 'Fire Hot 20 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Fire Hot 20 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/fire_hot_40': {
        title: 'Fire Hot 40: 94.33% RTP, 2,700x Max Win | {brand}',
        description: 'Fire Hot 40 runs at 94.33% RTP at {brand}, with a 2,700x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_hot_40_jackpot_play': {
        title: 'Fire Hot 40 Jackpot Play Slot | 5,000x Max Win | {brand}',
        description: 'Play Fire Hot 40 Jackpot Play slot with Bitcoin at {brand}. Medium volatility, 5,000x max win, jackpot play. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_hot_5': {
        title: 'Fire Hot 5: 94.32% RTP, 1,392x Max Win | {brand}',
        description: 'Fire Hot 5 runs at 94.32% RTP at {brand}, with a 1,392x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_hot_5_jackpot_play': {
        title: 'Fire Hot 5 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Fire Hot 5 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/fire_portals': {
        title: 'Fire Portals: 94.08% RTP, 10,000x Max Win | {brand}',
        description: 'Fire Portals runs at 94.08% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_stampede': {
        title: 'Fire Stampede: 93.99% RTP, 4,275x Max Win | {brand}',
        description: 'Fire Stampede runs at 93.99% RTP at {brand}, with a 4,275x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_stampede_2': {
        title: 'Fire Stampede 2: 94.43% RTP, 8,300x Max Win | {brand}',
        description: 'Fire Stampede 2 runs at 94.43% RTP at {brand}, with a 8,300x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_stampede_ultimate': {
        title: 'Fire Stampede Ultimate: 96.45% RTP, 12,500x Max Win | {brand}',
        description: 'Fire Stampede Ultimate runs at 96.45% RTP at {brand}, with a 12,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_strike': {
        title: 'Fire Strike: 94.5% RTP, 27,000x Max Win | {brand}',
        description: 'Fire Strike runs at 94.5% RTP at {brand}, with a 27,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fire_strike_2': {
        title: 'Fire Strike 2: 94.44% RTP, 25,000x Max Win | {brand}',
        description: 'Fire Strike 2 runs at 94.44% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fish_eye': {
        title: 'Fish Eye: 94.1% RTP | {brand}',
        description: 'Fish Eye runs at 94.1% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fishin_reels': {
        title: 'Fishin Reels: 94.5% RTP, 1,200x Max Win | {brand}',
        description: 'Fishin Reels runs at 94.5% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon': {
        title: 'Floating Dragon: 94.62% RTP, 3,000x Max Win | {brand}',
        description: 'Floating Dragon runs at 94.62% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon_dragon_boat_festival': {
        title: 'Floating Dragon - Dragon Boat Festival: 94.07% RTP | {brand}',
        description: 'Floating Dragon - Dragon Boat Festival runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon_hold_and_spin_megaways': {
        title: 'Floating Dragon Hold And Spin Megaways Slot | Pragmatic Pl',
        description: 'Play Floating Dragon Hold And Spin Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/floating_dragon_megaways': {
        title: 'Floating Dragon Megaways: 94.62% RTP | {brand}',
        description: 'Floating Dragon Megaways runs at 94.62% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon_new_year_festival_ultra_megaways': {
        title: 'Floating Dragon New Year Festival Ultr: 94.62% RTP | {brand}',
        description: 'Floating Dragon New Year Festival Ultra Megaways runs at 94.62% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon_wild_horses': {
        title: 'Floating Dragon Wild Horses: 96.5% RTP | {brand}',
        description: 'Floating Dragon Wild Horses runs at 96.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon_year_of_the_snake': {
        title: 'Floating Dragon Year of the Snake: 94.6% RTP | {brand}',
        description: 'Floating Dragon Year of the Snake runs at 94.6% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fonzos_feline_fortunes': {
        title: "Fonzo's Feline Fortunes: 94.5% RTP | {brand}",
        description: "Fonzo's Feline Fortunes runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/forge_of_olympus': {
        title: 'Forge of Olympus: 93.96% RTP, 5,000x Max Win | {brand}',
        description: 'Forge of Olympus runs at 93.96% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/forging_wilds': {
        title: 'Forging Wilds: 94.46% RTP, 10,000x Max Win | {brand}',
        description: 'Forging Wilds runs at 94.46% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fortune_ace': {
        title: 'Fortune Ace: 94.27% RTP, 5,000x Max Win | {brand}',
        description: 'Fortune Ace runs at 94.27% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fortune_ace_scatter': {
        title: 'Fortune Ace Scatter: 94.5% RTP, 100,000x Max Win | {brand}',
        description: 'Fortune Ace Scatter runs at 94.5% RTP at {brand}, with a 100,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fortune_hitn_roll': {
        title: "Fortune Hit'n Roll: 94.52% RTP, 5,000x Max Win | {brand}",
        description: "Fortune Hit'n Roll runs at 94.52% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/fortune_of_giza': {
        title: 'Fortune of Giza: 95.51% RTP, 5,000x Max Win | {brand}',
        description: 'Fortune of Giza runs at 95.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fortune_of_olympus': {
        title: 'Fortune of Olympus: 96.55% RTP, 10,000x Max Win | {brand}',
        description: 'Fortune of Olympus runs at 96.55% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fortunes_of_aztec': {
        title: 'Fortunes of Aztec: 94.04% RTP, 10,000x Max Win | {brand}',
        description: 'Fortunes of Aztec runs at 94.04% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/frightening_frankie': {
        title: 'Frightening Frankie: 94.53% RTP, 2,800x Max Win | {brand}',
        description: 'Frightening Frankie runs at 94.53% RTP at {brand}, with a 2,800x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/frogs_and_bugs': {
        title: 'Frogs & Bugs: 94.4% RTP, 3,000x Max Win | {brand}',
        description: 'Frogs & Bugs runs at 94.4% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/front_runner_odds_on': {
        title: 'Front Runner Odds On: 94.51% RTP | {brand}',
        description: 'Front Runner Odds On runs at 94.51% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/frozen_tropics': {
        title: 'Frozen Tropics: 94.14% RTP | {brand}',
        description: 'Frozen Tropics runs at 94.14% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fruit_party': {
        title: 'Fruit Party: 94.45% RTP, 5,000x Max Win | {brand}',
        description: 'Fruit Party runs at 94.45% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fruit_party_2': {
        title: 'Fruit Party 2: 94.46% RTP, 5,000x Max Win | {brand}',
        description: 'Fruit Party 2 runs at 94.46% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fruit_rainbow': {
        title: 'Fruit Rainbow: 94.5% RTP, 2,000x Max Win | {brand}',
        description: 'Fruit Rainbow runs at 94.5% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fruity_treats': {
        title: 'Fruity Treats: 94.04% RTP, 5,000x Max Win | {brand}',
        description: 'Fruity Treats runs at 94.04% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fu_fu_fu': {
        title: 'Fu Fu Fu: 95.76% RTP, 100x Max Win | {brand}',
        description: 'Fu Fu Fu runs at 95.76% RTP at {brand}, with a 100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/fury_of_odin_megaways': {
        title: 'Fury of Odin Megaways: 93.98% RTP, 15,000x Max Win | {brand}',
        description: 'Fury of Odin Megaways runs at 93.98% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gameshow_party_jackpot_play': {
        title: 'Gameshow Party Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Gameshow Party Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/gates_of_aztec': {
        title: 'Gates of Aztec: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Gates of Aztec runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca': {
        title: 'Gates of Gatot Kaca: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Gates of Gatot Kaca runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca_1000': {
        title: 'Gates of Gatot Kaca 1000: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Gates of Gatot Kaca 1000 runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca_super_scatter': {
        title: 'Gates of Gatot Kaca Super Scatter: 95.5% RTP | {brand}',
        description: 'Gates of Gatot Kaca Super Scatter runs at 95.5% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/pragmatic-play/gates_of_hades': {
        title: 'Gates of Hades: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Gates of Hades runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_olympus': {
        title: 'Gates of Olympus: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Gates of Olympus runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_olympus_1000': {
        title: 'Gates of Olympus 1000: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Gates of Olympus 1000 runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_olympus_dice': {
        title: 'Gates Of Olympus Dice Slot | 15,000x Max Win | {brand}',
        description: 'Play Gates Of Olympus Dice slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, dice variant. Crypto deposits.'
    },
    '/p/pragmatic-play/gates_of_olympus_super_scatter': {
        title: 'Gates of Olympus Super Scatter: 94.52% RTP | {brand}',
        description: 'Gates of Olympus Super Scatter runs at 94.52% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_olympus_xmas_1000': {
        title: 'Gates of Olympus Xmas 1000: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Gates of Olympus Xmas 1000 runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gates_of_valhalla': {
        title: 'Gates of Valhalla: 94.47% RTP, 10,000x Max Win | {brand}',
        description: 'Gates of Valhalla runs at 94.47% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gatot_kacas_fury': {
        title: "Gatot Kaca's Fury: 94.51% RTP, 5,000x Max Win | {brand}",
        description: "Gatot Kaca's Fury runs at 94.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/gears_of_horus': {
        title: 'Gears of Horus: 94.09% RTP, 10,000x Max Win | {brand}',
        description: 'Gears of Horus runs at 94.09% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gem_elevator': {
        title: 'Gem Elevator: 94.54% RTP, 10,000x Max Win | {brand}',
        description: 'Gem Elevator runs at 94.54% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gem_fire_fortune': {
        title: 'Gem Fire Fortune: 94.52% RTP, 15,000x Max Win | {brand}',
        description: 'Gem Fire Fortune runs at 94.52% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gem_trio': {
        title: 'Gem Trio: 94.5% RTP, 20,000x Max Win | {brand}',
        description: 'Gem Trio runs at 94.5% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gems_bonanza': {
        title: 'Gems Bonanza: 94.53% RTP, 10,000x Max Win | {brand}',
        description: 'Gems Bonanza runs at 94.53% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gems_of_serengeti': {
        title: 'Gems Of Serengeti Slot | 4,000x Max Win | {brand}',
        description: 'Play Gems Of Serengeti slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gemstone': {
        title: 'Gemstone Slot | Play Online | {brand}',
        description: 'Play Gemstone by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/genies_gem_bonanza': {
        title: "Genie's Gem Bonanza: 94.5% RTP, 10,000x Max Win | {brand}",
        description: "Genie's Gem Bonanza runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/goblin_heist_powernudge': {
        title: 'Goblin Heist Powernudge: 94.34% RTP, 4,000x Max Win | {brand}',
        description: 'Goblin Heist Powernudge runs at 94.34% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gods_of_giza': {
        title: 'Gods of Giza: 94.03% RTP, 5,000x Max Win | {brand}',
        description: 'Gods of Giza runs at 94.03% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gold_oasis': {
        title: 'Gold Oasis: 94.05% RTP, 7,260x Max Win | {brand}',
        description: 'Gold Oasis runs at 94.05% RTP at {brand}, with a 7,260x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gold_party': {
        title: 'Gold Party: 94.47% RTP, 5,163x Max Win | {brand}',
        description: 'Gold Party runs at 94.47% RTP at {brand}, with a 5,163x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gold_party_2_after_hours': {
        title: 'Gold Party 2 After Hours: 94.5% RTP, 10,312x Max Win | {brand}',
        description: 'Gold Party 2 After Hours runs at 94.5% RTP at {brand}, with a 10,312x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gold_train': {
        title: 'Gold Train: 94.17% RTP, 513x Max Win | {brand}',
        description: 'Gold Train runs at 94.17% RTP at {brand}, with a 513x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/golden_ox': {
        title: 'Golden Ox: 93.99% RTP, 2,500x Max Win | {brand}',
        description: 'Golden Ox runs at 93.99% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/golden_pig': {
        title: 'Golden Pig: 93.99% RTP, 2,500x Max Win | {brand}',
        description: 'Golden Pig runs at 93.99% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/good_luck_and_good_fortune': {
        title: 'Good Luck & Good Fortune: 94.03% RTP | {brand}',
        description: 'Good Luck & Good Fortune runs at 94.03% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gorilla_mayhem': {
        title: 'Gorilla Mayhem: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Gorilla Mayhem runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/grace_of_ebisu': {
        title: 'Grace of Ebisu: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Grace of Ebisu runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/gravity_bonanza': {
        title: 'Gravity Bonanza: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Gravity Bonanza runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/great_lagoon': {
        title: 'Great Lagoon: 96.64% RTP | {brand}',
        description: 'Great Lagoon runs at 96.64% RTP at {brand} and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/great_reef': {
        title: 'Great Reef: 93.8% RTP, 3,000x Max Win | {brand}',
        description: 'Great Reef runs at 93.8% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/great_rhino': {
        title: 'Great Rhino: 95.48% RTP, 900x Max Win | {brand}',
        description: 'Great Rhino runs at 95.48% RTP at {brand}, with a 900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/great_rhino_deluxe': {
        title: 'Great Rhino Deluxe: 94.54% RTP, 6,242x Max Win | {brand}',
        description: 'Great Rhino Deluxe runs at 94.54% RTP at {brand}, with a 6,242x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/great_rhino_megaways': {
        title: 'Great Rhino Megaways: 94.69% RTP, 20,000x Max Win | {brand}',
        description: 'Great Rhino Megaways runs at 94.69% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/greedy_fortune_pig': {
        title: 'Greedy Fortune Pig: 94.5% RTP, 8,888x Max Win | {brand}',
        description: 'Greedy Fortune Pig runs at 94.5% RTP at {brand}, with a 8,888x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/greedy_wolf': {
        title: 'Greedy Wolf: 94.54% RTP, 3,000x Max Win | {brand}',
        description: 'Greedy Wolf runs at 94.54% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/greek_gods': {
        title: 'Greek Gods: 95.5% RTP, 4,320x Max Win | {brand}',
        description: 'Greek Gods runs at 95.5% RTP at {brand}, with a 4,320x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hammerstorm': {
        title: 'Hammerstorm: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Hammerstorm runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hand_of_midas_2': {
        title: 'Hand of Midas 2: 94.06% RTP, 8,000x Max Win | {brand}',
        description: 'Hand of Midas 2 runs at 94.06% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/happy_fortune': {
        title: 'Happy Fortune Slot | 5,000x Max Win | {brand}',
        description: 'Play Happy Fortune slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/heart_of_cleopatra': {
        title: 'Heart of Cleopatra: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Heart of Cleopatra runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/heart_of_rio': {
        title: 'Heart of Rio: 95.5% RTP, 10,500x Max Win | {brand}',
        description: 'Heart of Rio runs at 95.5% RTP at {brand}, with a 10,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/heist_for_the_golden_nuggets': {
        title: 'Heist for the Golden Nuggets: 94.07% RTP | {brand}',
        description: 'Heist for the Golden Nuggets runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hellvis_wild': {
        title: 'Hellvis Wild: 93.96% RTP | {brand}',
        description: 'Hellvis Wild runs at 93.96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hercules_and_pegasus': {
        title: 'Hercules and Pegasus: 94.5% RTP, 2,000x Max Win | {brand}',
        description: 'Hercules and Pegasus runs at 94.5% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hercules_son_of_zeus': {
        title: 'Hercules Son of Zeus: 94% RTP, 800x Max Win | {brand}',
        description: 'Hercules Son of Zeus runs at 94% RTP at {brand}, with a 800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/heroic_spin': {
        title: 'Heroic Spin Slot | 10,000x Max Win | {brand}',
        description: 'Play Heroic Spin slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/heroic_spins': {
        title: 'Heroic Spins: 93.99% RTP, 10,000x Max Win | {brand}',
        description: 'Heroic Spins runs at 93.99% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/high_flyer': {
        title: 'High Flyer: 94% RTP, 1,000,000x Max Win | {brand}',
        description: 'High Flyer runs at 94% RTP at {brand}, with a 1,000,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/himalayan_wild': {
        title: 'Himalayan Wild: 94.51% RTP, 10,000x Max Win | {brand}',
        description: 'Himalayan Wild runs at 94.51% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hockey_attack': {
        title: 'Hockey Attack: 94.3% RTP, 2,500x Max Win | {brand}',
        description: 'Hockey Attack runs at 94.3% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hokkaido_wolf': {
        title: 'Hokkaido Wolf: 94.76% RTP, 4,608x Max Win | {brand}',
        description: 'Hokkaido Wolf runs at 94.76% RTP at {brand}, with a 4,608x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/holiday_ride': {
        title: 'Holiday Ride: 94.73% RTP, 5,000x Max Win | {brand}',
        description: 'Holiday Ride runs at 94.73% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/honey_honey_honey': {
        title: 'Honey Honey Honey: 94.5% RTP, 910x Max Win | {brand}',
        description: 'Honey Honey Honey runs at 94.5% RTP at {brand}, with a 910x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_chilli': {
        title: 'Hot Chilli: 95.53% RTP, 888x Max Win | {brand}',
        description: 'Hot Chilli runs at 95.53% RTP at {brand}, with a 888x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_fiesta': {
        title: 'Hot Fiesta: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Hot Fiesta runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_pepper': {
        title: 'Hot Pepper: 93.92% RTP, 10,000x Max Win | {brand}',
        description: 'Hot Pepper runs at 93.92% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_safari': {
        title: 'Hot Safari: 94.07% RTP, 4,000x Max Win | {brand}',
        description: 'Hot Safari runs at 94.07% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_to_burn': {
        title: 'Hot to Burn: 95.67% RTP, 1,000x Max Win | {brand}',
        description: 'Hot to Burn runs at 95.67% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_to_burn_7_deadly_free_spins': {
        title: 'Hot to Burn - 7 Deadly Free Spins: 94.53% RTP | {brand}',
        description: 'Hot to Burn - 7 Deadly Free Spins runs at 94.53% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_to_burn_extreme': {
        title: 'Hot To Burn Extreme: 94.51% RTP | {brand}',
        description: 'Hot To Burn Extreme runs at 94.51% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_to_burn_hold_and_spin': {
        title: 'Hot to Burn Hold and Spin: 94.65% RTP | {brand}',
        description: 'Hot to Burn Hold and Spin runs at 94.65% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_to_burn_jackpot_play': {
        title: 'Hot To Burn Jackpot Play Slot | 1,000x Max Win | {brand}',
        description: 'Play Hot To Burn Jackpot Play slot with Bitcoin at {brand}. Medium volatility, 1,000x max win, jackpot play. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hot_to_burn_multiplier': {
        title: 'Hot To Burn Multiplier: 94.51% RTP | {brand}',
        description: 'Hot To Burn Multiplier runs at 94.51% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hot_tuna': {
        title: 'Hot Tuna: 96.53% RTP, 2,500x Max Win | {brand}',
        description: 'Hot Tuna runs at 96.53% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/hundreds_and_thousands': {
        title: 'Hundreds and Thousands: 94.52% RTP | {brand}',
        description: 'Hundreds and Thousands runs at 94.52% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ice_lobster': {
        title: 'Ice Lobster: 94.56% RTP, 5,000x Max Win | {brand}',
        description: 'Ice Lobster runs at 94.56% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ice_mint': {
        title: 'Ice Mint: 94.48% RTP, 10,000x Max Win | {brand}',
        description: 'Ice Mint runs at 94.48% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/infective_wild': {
        title: 'Infective Wild: 94.02% RTP, 5,000x Max Win | {brand}',
        description: 'Infective Wild runs at 94.02% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/irish_charms': {
        title: 'Irish Charms: 96.96% RTP, 3,000x Max Win | {brand}',
        description: 'Irish Charms runs at 96.96% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jackpot_blaze': {
        title: 'Jackpot Blaze: 94.54% RTP, 5,000x Max Win | {brand}',
        description: 'Jackpot Blaze runs at 94.54% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jackpot_hunter': {
        title: 'Jackpot Hunter: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Jackpot Hunter runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jade_butterfly': {
        title: 'Jade Butterfly: 95.12% RTP, 636x Max Win | {brand}',
        description: 'Jade Butterfly runs at 95.12% RTP at {brand}, with a 636x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jane_hunter_and_the_mask_of_montezuma': {
        title: 'Jane Hunter and the Mask of Montezuma: 94.05% RTP | {brand}',
        description: 'Jane Hunter and the Mask of Montezuma runs at 94.05% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals,.'
    },
    '/p/pragmatic-play/jasmine_dreams': {
        title: 'Jasmine Dreams: 94.4% RTP, 2,500x Max Win | {brand}',
        description: 'Jasmine Dreams runs at 94.4% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jewel_rush': {
        title: 'Jewel Rush: 94.45% RTP, 5,000x Max Win | {brand}',
        description: 'Jewel Rush runs at 94.45% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/john_hunter_and_galileos_secrets': {
        title: "John Hunter and Galileo's Secrets: 94.5% RTP | {brand}",
        description: "John Hunter and Galileo's Secrets runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no."
    },
    '/p/pragmatic-play/john_hunter_and_the_aztec_treasure': {
        title: 'John Hunter And The Aztec Treasure Slot | 10,804x Max Win ',
        description: 'Play John Hunter And The Aztec Treasure slot with Bitcoin at {brand}. Medium-High volatility, 10,804x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut': {
        title: 'John Hunter and the Book of Tut: 94.5% RTP | {brand}',
        description: 'John Hunter and the Book of Tut runs at 94.5% RTP at {brand}, with a 5,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut_megaways': {
        title: 'John Hunter and the Book of Tut Megaways: 94.05% RTP | {brand}',
        description: 'John Hunter and the Book of Tut Megaways runs at 94.05% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut_respin': {
        title: 'John Hunter And The Book Of Tut Respin Slot | 4,000x Max W',
        description: 'Play John Hunter And The Book Of Tut Respin slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits.'
    },
    '/p/pragmatic-play/john_hunter_and_the_mayan_gods': {
        title: 'John Hunter And The Mayan Gods: 94.43% RTP | {brand}',
        description: 'John Hunter And The Mayan Gods runs at 94.43% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/john_hunter_and_the_quest_for_bermuda_riches': {
        title: 'John Hunter And The Quest For Bermuda Riches Slot | 5,000x',
        description: 'Play John Hunter And The Quest For Bermuda Riches slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits.'
    },
    '/p/pragmatic-play/john_hunter_tomb_of_the_scarab_queen': {
        title: 'John Hunter Tomb Of The Scarab Queen Slot | 10,804x Max Wi',
        description: 'Play John Hunter Tomb Of The Scarab Queen slot with Bitcoin at {brand}. Medium-High volatility, 10,804x max win, Crypto deposits.'
    },
    '/p/pragmatic-play/joker_jewels_dice': {
        title: 'Joker Jewels Dice: 96.5% RTP, 1,040x Max Win | {brand}',
        description: 'Joker Jewels Dice runs at 96.5% RTP at {brand}, with a 1,040x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/joker_king': {
        title: 'Joker King: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Joker King runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/joker_race': {
        title: 'Joker Race: 95.54% RTP | {brand}',
        description: 'Joker Race runs at 95.54% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jokers_jewel_hot': {
        title: "Joker's Jewel Hot Slot | 27,000x Max Win | {brand}",
        description: "Play Joker's Jewel Hot slot with Bitcoin at {brand}. Medium-High volatility, 27,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/jokers_jewels': {
        title: "Joker's Jewels: 95.48% RTP, 1,040x Max Win | {brand}",
        description: "Joker's Jewels runs at 95.48% RTP at {brand}, with a 1,040x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/jokers_jewels_cash': {
        title: "Joker's Jewels Cash: 94.51% RTP, 5,000x Max Win | {brand}",
        description: "Joker's Jewels Cash runs at 94.51% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/jokers_jewels_hold_and_spin': {
        title: "Joker's Jewels Hold and Spin: 94.54% RTP | {brand}",
        description: "Joker's Jewels Hold and Spin runs at 94.54% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/jokers_jewels_wild': {
        title: "Joker's Jewels Wild: 94.48% RTP, 1,420x Max Win | {brand}",
        description: "Joker's Jewels Wild runs at 94.48% RTP at {brand}, with a 1,420x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/journey_to_the_west': {
        title: 'Journey to the West: 94.04% RTP, 400x Max Win | {brand}',
        description: 'Journey to the West runs at 94.04% RTP at {brand}, with a 400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/juicy_fruits': {
        title: 'Juicy Fruits: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Juicy Fruits runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/juicy_fruits_multihold': {
        title: 'Juicy Fruits Multihold: 94.06% RTP, 8,000x Max Win | {brand}',
        description: 'Juicy Fruits Multihold runs at 94.06% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jumbo_safari': {
        title: 'Jumbo Safari: 94.53% RTP, 3,000x Max Win | {brand}',
        description: 'Jumbo Safari runs at 94.53% RTP at {brand}, with a 3,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/jungle_gorilla': {
        title: 'Jungle Gorilla: 94.21% RTP, 2,806x Max Win | {brand}',
        description: 'Jungle Gorilla runs at 94.21% RTP at {brand}, with a 2,806x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/king_of_spear': {
        title: 'King of Spear: 96.25% RTP, 5,000x Max Win | {brand}',
        description: 'King of Spear runs at 96.25% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/kingdom_of_asgard': {
        title: 'Kingdom of Asgard: 94.51% RTP, 5,000x Max Win | {brand}',
        description: 'Kingdom of Asgard runs at 94.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/kingdom_of_atlantis_jackpot_play': {
        title: 'Kingdom Of Atlantis Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Kingdom Of Atlantis Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/kingdom_of_the_dead': {
        title: 'Kingdom of the Dead: 94.08% RTP, 10,000x Max Win | {brand}',
        description: 'Kingdom of the Dead runs at 94.08% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/knight_hot_spotz': {
        title: 'Knight Hot Spotz: 94.5% RTP, 2,000x Max Win | {brand}',
        description: 'Knight Hot Spotz runs at 94.5% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/knights_vs_barbarians': {
        title: 'Knights vs Barbarians: 96.51% RTP, 10,000x Max Win | {brand}',
        description: 'Knights vs Barbarians runs at 96.51% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/koi_pond': {
        title: 'Koi Pond: 94.5% RTP, 2,500x Max Win | {brand}',
        description: 'Koi Pond runs at 94.5% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/krakens_sky_bounty': {
        title: "Kraken's Sky Bounty: 94.03% RTP, 5,000x Max Win | {brand}",
        description: "Kraken's Sky Bounty runs at 94.03% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/lady_godiva': {
        title: 'Lady Godiva: 94.05% RTP, 2,400x Max Win | {brand}',
        description: 'Lady Godiva runs at 94.05% RTP at {brand}, with a 2,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lamp_of_infinity': {
        title: 'Lamp Of Infinity: 94.02% RTP, 5,000x Max Win | {brand}',
        description: 'Lamp Of Infinity runs at 94.02% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lava_balls': {
        title: 'Lava Balls: 94.5% RTP, 4,800x Max Win | {brand}',
        description: 'Lava Balls runs at 94.5% RTP at {brand}, with a 4,800x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/legend_of_heroes_megaways': {
        title: 'Legend of Heroes MegaWays: 94.59% RTP, 1,250x Max Win | {brand}',
        description: 'Legend of Heroes MegaWays runs at 94.59% RTP at {brand}, with a 1,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/leprechaun_carol': {
        title: 'Leprechaun Carol: 95.51% RTP, 6,000x Max Win | {brand}',
        description: 'Leprechaun Carol runs at 95.51% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/leprechaun_song': {
        title: 'Leprechaun Song: 95.45% RTP, 757x Max Win | {brand}',
        description: 'Leprechaun Song runs at 95.45% RTP at {brand}, with a 757x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/little_gem_hold_and_spin': {
        title: 'Little Gem Hold And Spin Slot | Pragmatic Play | {brand}',
        description: 'Play Little Gem Hold And Spin by Pragmatic Play at {brand}. Medium-High volatility, hold and spin. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/lobster_bobs_crazy_crab_shack': {
        title: "Lobster Bob's Crazy Crab Shack: 94.03% RTP | {brand}",
        description: "Lobster Bob's Crazy Crab Shack runs at 94.03% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/lobster_bobs_sea_food_and_win_it': {
        title: "Lobster Bob's Sea Food and Win It: 94.02% RTP | {brand}",
        description: "Lobster Bob's Sea Food and Win It runs at 94.02% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/lobster_house': {
        title: 'Lobster House: 94.5% RTP, 4,000x Max Win | {brand}',
        description: 'Lobster House runs at 94.5% RTP at {brand}, with a 4,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lokis_riches': {
        title: "Loki's Riches: 94.04% RTP, 10,000x Max Win | {brand}",
        description: "Loki's Riches runs at 94.04% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/lucky_dragon_ball': {
        title: 'Lucky Dragon Ball: 95.49% RTP, 10,000x Max Win | {brand}',
        description: 'Lucky Dragon Ball runs at 95.49% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lucky_dragons': {
        title: 'Lucky Dragons: 94% RTP, 800x Max Win | {brand}',
        description: 'Lucky Dragons runs at 94% RTP at {brand}, with a 800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lucky_fishing_megaways': {
        title: 'Lucky Fishing MegaWays: 94.59% RTP, 5,000x Max Win | {brand}',
        description: 'Lucky Fishing MegaWays runs at 94.59% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lucky_grace_and_charm': {
        title: 'Lucky, Grace & Charm: 94.62% RTP | {brand}',
        description: 'Lucky, Grace & Charm runs at 94.62% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lucky_lightning': {
        title: 'Lucky Lightning: 94.52% RTP, 10,100x Max Win | {brand}',
        description: 'Lucky Lightning runs at 94.52% RTP at {brand}, with a 10,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lucky_new_year': {
        title: 'Lucky New Year: 93.99% RTP, 2,500x Max Win | {brand}',
        description: 'Lucky New Year runs at 93.99% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/lucky_new_year_tiger_treasures': {
        title: 'Lucky New Year: Tiger Treasures: 93.99% RTP | {brand}',
        description: 'Lucky New Year: Tiger Treasures runs at 93.99% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/luckys_wild_pub': {
        title: "Lucky's Wild Pub: 94.5% RTP, 10,000x Max Win | {brand}",
        description: "Lucky's Wild Pub runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/madame_destiny': {
        title: 'Madame Destiny: 95.48% RTP, 1,500x Max Win | {brand}',
        description: 'Madame Destiny runs at 95.48% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/madame_destiny_megaways': {
        title: 'Madame Destiny Megaways: 94.63% RTP, 5,000x Max Win | {brand}',
        description: 'Madame Destiny Megaways runs at 94.63% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/magic_journey': {
        title: 'Magic Journey: 95.51% RTP, 1,000x Max Win | {brand}',
        description: 'Magic Journey runs at 95.51% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/magic_money_maze': {
        title: 'Magic Money Maze: 94.57% RTP | {brand}',
        description: 'Magic Money Maze runs at 94.57% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/magicians_secrets': {
        title: "Magician's Secrets: 94.49% RTP, 5,000x Max Win | {brand}",
        description: "Magician's Secrets runs at 94.49% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/mahjong_panda': {
        title: 'Mahjong Panda: 94.27% RTP, 5,000x Max Win | {brand}',
        description: 'Mahjong Panda runs at 94.27% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mahjong_wins': {
        title: 'Mahjong Wins: 94.27% RTP, 5,000x Max Win | {brand}',
        description: 'Mahjong Wins runs at 94.27% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mahjong_wins_bonus': {
        title: 'Mahjong Wins Bonus: 94.27% RTP, 1,000x Max Win | {brand}',
        description: 'Mahjong Wins Bonus runs at 94.27% RTP at {brand}, with a 1,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mahjong_wins_super_scatter': {
        title: 'Mahjong Wins Super Scatter: 94.5% RTP | {brand}',
        description: 'Mahjong Wins Super Scatter runs at 94.5% RTP at {brand}, with a 100,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mahjong_x': {
        title: 'Mahjong X Slot | 21,175x Max Win | {brand}',
        description: 'Play Mahjong X slot with Bitcoin at {brand}. Medium-High volatility, 21,175x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/majestic_express_gold_run': {
        title: 'Majestic Express Gold Run: 94.49% RTP, 20,000x Max Win | {brand}',
        description: 'Majestic Express Gold Run runs at 94.49% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mammoth_gold_megaways': {
        title: 'Mammoth Gold Megaways: 94.08% RTP, 10,000x Max Win | {brand}',
        description: 'Mammoth Gold Megaways runs at 94.08% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/master_chens_fortune': {
        title: "Master Chen's Fortune: 95.51% RTP, 1,160x Max Win | {brand}",
        description: "Master Chen's Fortune runs at 95.51% RTP at {brand}, with a 1,160x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/master_joker': {
        title: 'Master Joker: 95.49% RTP, 10,000x Max Win | {brand}',
        description: 'Master Joker runs at 95.49% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/medusas_stone': {
        title: "Medusa's Stone: 94.5% RTP, 7,000x Max Win | {brand}",
        description: "Medusa's Stone runs at 94.5% RTP at {brand}, with a 7,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/mermaids_treasure_love': {
        title: "Mermaid's Treasure Love: 94.54% RTP, 10,000x Max Win | {brand}",
        description: "Mermaid's Treasure Love runs at 94.54% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/might_of_freya_megaways': {
        title: 'Might of Freya Megaways™: 94.51% RTP, 8,000x Max Win | {brand}',
        description: 'Might of Freya Megaways™ runs at 94.51% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/might_of_ra': {
        title: 'Might of Ra: 94.46% RTP, 22,500x Max Win | {brand}',
        description: 'Might of Ra runs at 94.46% RTP at {brand}, with a 22,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mighty_kong': {
        title: 'Mighty Kong: 94% RTP, 955x Max Win | {brand}',
        description: 'Mighty Kong runs at 94% RTP at {brand}, with a 955x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mighty_munching_melons': {
        title: 'Mighty Munching Melons: 94.03% RTP | {brand}',
        description: 'Mighty Munching Melons runs at 94.03% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mining_rush': {
        title: 'Mining Rush: 94.51% RTP, 10,000x Max Win | {brand}',
        description: 'Mining Rush runs at 94.51% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mochimon': {
        title: 'Mochimon: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Mochimon runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/moleionaire': {
        title: 'Moleionaire: 94.08% RTP, 5,000x Max Win | {brand}',
        description: 'Moleionaire runs at 94.08% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/money_money_money': {
        title: 'Money Money Money: 95.02% RTP, 88x Max Win | {brand}',
        description: 'Money Money Money runs at 95.02% RTP at {brand}, with a 88x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/money_mouse': {
        title: 'Money Mouse: 93.99% RTP, 2,500x Max Win | {brand}',
        description: 'Money Mouse runs at 93.99% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/money_roll': {
        title: 'Money Roll: 96.93% RTP, 2,001x Max Win | {brand}',
        description: 'Money Roll runs at 96.93% RTP at {brand}, with a 2,001x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/money_stacks': {
        title: 'Money Stacks: 94.54% RTP, 5,000x Max Win | {brand}',
        description: 'Money Stacks runs at 94.54% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/money_stacks_megaways': {
        title: 'Money Stacks Megaways: 94.51% RTP, 1,000x Max Win | {brand}',
        description: 'Money Stacks Megaways runs at 94.51% RTP at {brand}, with a 1,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/monkey_king_rush': {
        title: 'Monkey King Rush Slot | 5,000x Max Win | {brand}',
        description: 'Play Monkey King Rush slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/monkey_madness': {
        title: 'Monkey Madness: 94.45% RTP, 181x Max Win | {brand}',
        description: 'Monkey Madness runs at 94.45% RTP at {brand}, with a 181x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/monkey_warrior': {
        title: 'Monkey Warrior: 95.5% RTP, 6,080x Max Win | {brand}',
        description: 'Monkey Warrior runs at 95.5% RTP at {brand}, with a 6,080x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/monster_superlanche': {
        title: 'Monster Superlanche: 94.05% RTP, 5,000x Max Win | {brand}',
        description: 'Monster Superlanche runs at 94.05% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/moonshot': {
        title: 'Moonshot: 94.5% RTP | {brand}',
        description: 'Moonshot runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/muertos_multiplier_megaways': {
        title: 'Muertos Multiplier Megaways: 94.08% RTP | {brand}',
        description: 'Muertos Multiplier Megaways runs at 94.08% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/multihand_blackjack': {
        title: 'Multihand Blackjack: 94% RTP | {brand}',
        description: 'Multihand Blackjack runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mummys_jewels': {
        title: "Mummy's Jewels: 94.5% RTP, 10,000x Max Win | {brand}",
        description: "Mummy's Jewels runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/mummys_jewels_100': {
        title: "Mummy's Jewels 100: 96.5% RTP, 30,000x Max Win | {brand}",
        description: "Mummy's Jewels 100 runs at 96.5% RTP at {brand}, with a 30,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/mustang_gold': {
        title: 'Mustang Gold: 96.53% RTP, 12,000x Max Win | {brand}',
        description: 'Mustang Gold runs at 96.53% RTP at {brand}, with a 12,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mustang_gold_megaways': {
        title: 'Mustang Gold Megaways™: 94.49% RTP, 5,000x Max Win | {brand}',
        description: 'Mustang Gold Megaways™ runs at 94.49% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mustang_trail': {
        title: 'Mustang Trail: 94.07% RTP, 5,000x Max Win | {brand}',
        description: 'Mustang Trail runs at 94.07% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mysterious': {
        title: 'Mysterious: 94.5% RTP, 9,648x Max Win | {brand}',
        description: 'Mysterious runs at 94.5% RTP at {brand}, with a 9,648x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mysterious_egypt': {
        title: 'Mysterious Egypt: 94.5% RTP, 5,533x Max Win | {brand}',
        description: 'Mysterious Egypt runs at 94.5% RTP at {brand}, with a 5,533x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mystery_mice': {
        title: 'Mystery Mice: 94.48% RTP, 5,000x Max Win | {brand}',
        description: 'Mystery Mice runs at 94.48% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/mystic_chief': {
        title: 'Mystic Chief: 94.48% RTP, 5,000x Max Win | {brand}',
        description: 'Mystic Chief runs at 94.48% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/nile_fortune': {
        title: 'Nile Fortune: 94.04% RTP, 2,500x Max Win | {brand}',
        description: 'Nile Fortune runs at 94.04% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/north_guardians': {
        title: 'North Guardians: 94.34% RTP, 5,000x Max Win | {brand}',
        description: 'North Guardians runs at 94.34% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/octobeer_fortunes': {
        title: 'Octobeer Fortunes: 94.52% RTP, 4,500x Max Win | {brand}',
        description: 'Octobeer Fortunes runs at 94.52% RTP at {brand}, with a 4,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/old_gold_miner_megaways': {
        title: 'Old Gold Miner Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Old Gold Miner Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/oodles_of_noodles': {
        title: 'Oodles of Noodles: 94.55% RTP | {brand}',
        description: 'Oodles of Noodles runs at 94.55% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/oracle_of_gold': {
        title: 'Oracle of Gold: 94.54% RTP, 10,000x Max Win | {brand}',
        description: 'Oracle of Gold runs at 94.54% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pandas_fortune': {
        title: "Panda's Fortune: 95.13% RTP, 7,272x Max Win | {brand}",
        description: "Panda's Fortune runs at 95.13% RTP at {brand}, with a 7,272x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/pandas_fortune_2': {
        title: 'Pandas Fortune 2 Slot | 5,000x Max Win | {brand}',
        description: 'Play Pandas Fortune 2 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pandemic_rising': {
        title: 'Pandemic Rising: 94.51% RTP, 14,000x Max Win | {brand}',
        description: 'Pandemic Rising runs at 94.51% RTP at {brand}, with a 14,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/peking_luck': {
        title: 'Peking Luck: 95.5% RTP, 180,000x Max Win | {brand}',
        description: 'Peking Luck runs at 95.5% RTP at {brand}, with a 180,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/penguins_christmas_party_time': {
        title: 'Penguins Christmas Party Time: 94.53% RTP | {brand}',
        description: 'Penguins Christmas Party Time runs at 94.53% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/peppes_pepperoni_pizza_plaza': {
        title: "Peppe's Pepperoni Pizza Plaza: 94.55% RTP | {brand}",
        description: "Peppe's Pepperoni Pizza Plaza runs at 94.55% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/phoenix_forge': {
        title: 'Phoenix Forge: 94.51% RTP, 5,000x Max Win | {brand}',
        description: 'Phoenix Forge runs at 94.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/piggy_bank_bills': {
        title: 'Piggy Bank Bills: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Piggy Bank Bills runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/piggy_bankers': {
        title: 'Piggy Bankers: 93.98% RTP, 10,000x Max Win | {brand}',
        description: 'Piggy Bankers runs at 93.98% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pinup_girls': {
        title: 'Pinup Girls: 94.43% RTP, 3,000x Max Win | {brand}',
        description: 'Pinup Girls runs at 94.43% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pirate_gold': {
        title: 'Pirate Gold: 95.5% RTP, 32,270x Max Win | {brand}',
        description: 'Pirate Gold runs at 95.5% RTP at {brand}, with a 32,270x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pirate_gold_deluxe': {
        title: 'Pirate Gold Deluxe: 94.48% RTP, 15,000x Max Win | {brand}',
        description: 'Pirate Gold Deluxe runs at 94.48% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pirate_golden_age': {
        title: 'Pirate Golden Age Slot | 3,000x Max Win | {brand}',
        description: 'Play Pirate Golden Age slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pirates_pub': {
        title: 'Pirates Pub: 94.02% RTP, 5,000x Max Win | {brand}',
        description: 'Pirates Pub runs at 94.02% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pixie_wings': {
        title: 'Pixie Wings: 95.66% RTP, 500x Max Win | {brand}',
        description: 'Pixie Wings runs at 95.66% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pizza_pizza_pizza': {
        title: 'PIZZA! PIZZA? PIZZA!: 94.02% RTP | {brand}',
        description: 'PIZZA! PIZZA? PIZZA! runs at 94.02% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pompeii_megareels_megaways': {
        title: 'Pompeii Megareels Megaways: 94.07% RTP | {brand}',
        description: 'Pompeii Megareels Megaways runs at 94.07% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pot_of_fortune': {
        title: 'Pot of Fortune: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Pot of Fortune runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/power_ball_1_min': {
        title: 'Power Ball 1 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 1 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_ball_2_min': {
        title: 'Power Ball 2 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 2 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_ball_3_min': {
        title: 'Power Ball 3 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 3 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_ball_4_min': {
        title: 'Power Ball 4 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 4 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_ball_5_min': {
        title: 'Power Ball 5 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 5 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_of_merlin_megaways': {
        title: 'Power of Merlin Megaways: 94.08% RTP | {brand}',
        description: 'Power of Merlin Megaways runs at 94.08% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/power_of_ninja': {
        title: 'Power of Ninja: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Power of Ninja runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/power_of_thor_megaways': {
        title: 'Power of Thor Megaways: 94.77% RTP, 5,000x Max Win | {brand}',
        description: 'Power of Thor Megaways runs at 94.77% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pub_kings': {
        title: 'Pub Kings: 94.04% RTP, 5,000x Max Win | {brand}',
        description: 'Pub Kings runs at 94.04% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pyramid_bonanza': {
        title: 'Pyramid Bonanza: 95.45% RTP, 21,175x Max Win | {brand}',
        description: 'Pyramid Bonanza runs at 95.45% RTP at {brand}, with a 21,175x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/pyramid_king': {
        title: 'Pyramid King: 94.5% RTP, 2,500x Max Win | {brand}',
        description: 'Pyramid King runs at 94.5% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/queen_of_gods': {
        title: 'Queen of Gods: 94.34% RTP, 1,839x Max Win | {brand}',
        description: 'Queen of Gods runs at 94.34% RTP at {brand}, with a 1,839x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/queenie': {
        title: 'Queenie: 94.56% RTP | {brand}',
        description: 'Queenie runs at 94.56% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/raging_bull': {
        title: 'Raging Bull: 95.5% RTP, 7,342x Max Win | {brand}',
        description: 'Raging Bull runs at 95.5% RTP at {brand}, with a 7,342x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/raging_waterfall_megaways': {
        title: 'Raging Waterfall Megaways: 94.52% RTP, 10,000x Max Win | {brand}',
        description: 'Raging Waterfall Megaways runs at 94.52% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rainbow_gold': {
        title: 'Rainbow Gold: 94.44% RTP, 5,000x Max Win | {brand}',
        description: 'Rainbow Gold runs at 94.44% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rainbow_reels': {
        title: 'Rainbow Reels: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rainbow Reels runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/reel_banks': {
        title: 'Reel Banks: 94.02% RTP, 5,000x Max Win | {brand}',
        description: 'Reel Banks runs at 94.02% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/release_the_bison': {
        title: 'Release the Bison: 94.49% RTP, 3,000x Max Win | {brand}',
        description: 'Release the Bison runs at 94.49% RTP at {brand}, with a 3,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/release_the_kraken': {
        title: 'Release the Kraken: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Release the Kraken runs at 94.5% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/release_the_kraken_2': {
        title: 'Release the Kraken 2: 93.98% RTP, 5,000x Max Win | {brand}',
        description: 'Release the Kraken 2 runs at 93.98% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/release_the_kraken_megaways': {
        title: 'Release the Kraken Megaways: 94.53% RTP | {brand}',
        description: 'Release the Kraken Megaways runs at 94.53% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/resurrecting_riches': {
        title: 'Resurrecting Riches: 94.49% RTP, 4,000x Max Win | {brand}',
        description: 'Resurrecting Riches runs at 94.49% RTP at {brand}, with a 4,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/return_of_the_dead': {
        title: 'Return of the Dead: 95.67% RTP | {brand}',
        description: 'Return of the Dead runs at 95.67% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/revenge_of_loki_megaways': {
        title: 'Revenge of Loki Megaways: 94.49% RTP, 10,000x Max Win | {brand}',
        description: 'Revenge of Loki Megaways runs at 94.49% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ride_the_lightning': {
        title: 'Ride the Lightning: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Ride the Lightning runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ripe_rewards': {
        title: 'Ripe Rewards: 94.99% RTP, 10,000x Max Win | {brand}',
        description: 'Ripe Rewards runs at 94.99% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rise_of_giza_powernudge': {
        title: 'Rise of Giza PowerNudge: 94.47% RTP, 4,000x Max Win | {brand}',
        description: 'Rise of Giza PowerNudge runs at 94.47% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rise_of_pyramids': {
        title: 'Rise of Pyramids: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rise of Pyramids runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rise_of_samurai': {
        title: 'Rise of Samurai: 94.04% RTP, 400x Max Win | {brand}',
        description: 'Rise of Samurai runs at 94.04% RTP at {brand}, with a 400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rise_of_samurai_4': {
        title: 'Rise of Samurai 4: 94.05% RTP, 15,000x Max Win | {brand}',
        description: 'Rise of Samurai 4 runs at 94.05% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rise_of_samurai_iii': {
        title: 'Rise of Samurai III: 95.55% RTP, 10,000x Max Win | {brand}',
        description: 'Rise of Samurai III runs at 95.55% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rise_of_samurai_megaways': {
        title: 'Rise of Samurai MegaWays: 94.63% RTP, 5,000x Max Win | {brand}',
        description: 'Rise of Samurai MegaWays runs at 94.63% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/robber_strike': {
        title: 'Robber Strike: 94.49% RTP, 5,000x Max Win | {brand}',
        description: 'Robber Strike runs at 94.49% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rock_vegas': {
        title: 'Rock Vegas: 94.5% RTP | {brand}',
        description: 'Rock Vegas runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rocket_blast_megaways': {
        title: 'Rocket Blast Megaways: 94.09% RTP, 10,000x Max Win | {brand}',
        description: 'Rocket Blast Megaways runs at 94.09% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rolling_in_treasures': {
        title: 'Rolling in Treasures: 96.5% RTP, 5,000x Max Win | {brand}',
        description: 'Rolling in Treasures runs at 96.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/rujak_bonanza': {
        title: 'Rujak Bonanza: 95.5% RTP, 21,175x Max Win | {brand}',
        description: 'Rujak Bonanza runs at 95.5% RTP at {brand}, with a 21,175x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/running_sushi': {
        title: 'Running Sushi: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Running Sushi runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/safari_king': {
        title: 'Safari King: 96.37% RTP, 868x Max Win | {brand}',
        description: 'Safari King runs at 96.37% RTP at {brand}, with a 868x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/saiyan_mania': {
        title: 'Saiyan Mania Slot | 5,000x Max Win | {brand}',
        description: 'Play Saiyan Mania slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/samurai_code': {
        title: 'Samurai Code: 94.07% RTP | {brand}',
        description: 'Samurai Code runs at 94.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/santa': {
        title: 'Santa: 94.09% RTP, 451x Max Win | {brand}',
        description: 'Santa runs at 94.09% RTP at {brand}, with a 451x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/santas_great_gifts': {
        title: "Santa's Great Gifts: 93.96% RTP, 5,000x Max Win | {brand}",
        description: "Santa's Great Gifts runs at 93.96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/santas_slay': {
        title: "Santa's Slay: 94.52% RTP, 2,000x Max Win | {brand}",
        description: "Santa's Slay runs at 94.52% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/santas_wonderland': {
        title: "Santa's Wonderland: 94.49% RTP, 7,500x Max Win | {brand}",
        description: "Santa's Wonderland runs at 94.49% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/santas_xmas_rush': {
        title: "Santa's Xmas Rush: 94.48% RTP, 10,000x Max Win | {brand}",
        description: "Santa's Xmas Rush runs at 94.48% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/savannah_legend': {
        title: 'Savannah Legend Slot | 10,000x Max Win | {brand}',
        description: 'Play Savannah Legend slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sea_fantasy': {
        title: 'Sea Fantasy: 94.06% RTP, 5,000x Max Win | {brand}',
        description: 'Sea Fantasy runs at 94.06% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/secret_city_gold': {
        title: 'Secret City Gold: 94.06% RTP, 10,000x Max Win | {brand}',
        description: 'Secret City Gold runs at 94.06% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/shield_of_sparta': {
        title: 'Shield Of Sparta: 94.5% RTP, 3,000x Max Win | {brand}',
        description: 'Shield Of Sparta runs at 94.5% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/shining_hot_100': {
        title: 'Shining Hot 100: 94.44% RTP, 2,500x Max Win | {brand}',
        description: 'Shining Hot 100 runs at 94.44% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/shining_hot_100_jackpot_play': {
        title: 'Shining Hot 100 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Shining Hot 100 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/shining_hot_20': {
        title: 'Shining Hot 20: 94.39% RTP, 2,500x Max Win | {brand}',
        description: 'Shining Hot 20 runs at 94.39% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/shining_hot_20_jackpot_play': {
        title: 'Shining Hot 20 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Shining Hot 20 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/shining_hot_40': {
        title: 'Shining Hot 40: 94.44% RTP, 2,500x Max Win | {brand}',
        description: 'Shining Hot 40 runs at 94.44% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/shining_hot_40_jackpot_play': {
        title: 'Shining Hot 40 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Shining Hot 40 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/shining_hot_5': {
        title: 'Shining Hot 5: 94.39% RTP, 2,500x Max Win | {brand}',
        description: 'Shining Hot 5 runs at 94.39% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/shining_hot_5_jackpot_play': {
        title: 'Shining Hot 5 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Shining Hot 5 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/sleeping_dragon': {
        title: 'Sleeping Dragon: 94.5% RTP, 15,000x Max Win | {brand}',
        description: 'Sleeping Dragon runs at 94.5% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/smugglers_cove': {
        title: 'Smugglers Cove: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Smugglers Cove runs at 94.5% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/snakes_and_ladders_megadice': {
        title: 'Snakes and Ladders Megadice: 94.57% RTP | {brand}',
        description: 'Snakes and Ladders Megadice runs at 94.57% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/snakes_and_ladders_snake_eyes': {
        title: 'Snakes & Ladders - Snake Eyes: 94.08% RTP | {brand}',
        description: 'Snakes & Ladders - Snake Eyes runs at 94.08% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/spartan_king': {
        title: 'Spartan King: 94.56% RTP, 7,494x Max Win | {brand}',
        description: 'Spartan King runs at 94.56% RTP at {brand}, with a 7,494x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/spellbinding_mystery': {
        title: 'Spellbinding Mystery: 94.02% RTP | {brand}',
        description: 'Spellbinding Mystery runs at 94.02% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/spellmaster': {
        title: 'Spellmaster: 94.5% RTP, 40,000x Max Win | {brand}',
        description: 'Spellmaster runs at 94.5% RTP at {brand}, with a 40,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/spin_and_score_megaways': {
        title: 'Spin & Score Megaways: 94.59% RTP, 5,000x Max Win | {brand}',
        description: 'Spin & Score Megaways runs at 94.59% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/spirit_of_adventure': {
        title: 'Spirit of Adventure: 94.55% RTP | {brand}',
        description: 'Spirit of Adventure runs at 94.55% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/star_bounty': {
        title: 'Star Bounty: 94.5% RTP, 25,920x Max Win | {brand}',
        description: 'Star Bounty runs at 94.5% RTP at {brand}, with a 25,920x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/star_pirates_code': {
        title: 'Star Pirates Code: 94.61% RTP | {brand}',
        description: 'Star Pirates Code runs at 94.61% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/starlight_archer_1000': {
        title: 'Starlight Archer 1000: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Starlight Archer 1000 runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/starlight_christmas': {
        title: 'Starlight Christmas: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Starlight Christmas runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/starlight_princess': {
        title: 'Starlight Princess: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Starlight Princess runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/starlight_princess_1000': {
        title: 'Starlight Princess 1000: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Starlight Princess 1000 runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/starlight_princess_pachi': {
        title: 'Starlight Princess Pachi: 94.04% RTP, 500x Max Win | {brand}',
        description: 'Starlight Princess Pachi runs at 94.04% RTP at {brand}, with a 500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/starlight_princess_super_scatter': {
        title: 'Starlight Princess Super Scatter: 94.52% RTP | {brand}',
        description: 'Starlight Princess Super Scatter runs at 94.52% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/pragmatic-play/starz_megaways': {
        title: 'Starz Megaways: 94.54% RTP, 10,000x Max Win | {brand}',
        description: 'Starz Megaways runs at 94.54% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sticky_bees': {
        title: 'Sticky Bees: 94.06% RTP | {brand}',
        description: 'Sticky Bees runs at 94.06% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/strawberry_cocktail': {
        title: 'Strawberry Cocktail: 94% RTP, 16,000x Max Win | {brand}',
        description: 'Strawberry Cocktail runs at 94% RTP at {brand}, with a 16,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/street_racer': {
        title: 'Street Racer: 94.5% RTP, 2,000x Max Win | {brand}',
        description: 'Street Racer runs at 94.5% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/striking_hot_5': {
        title: 'Striking Hot 5: 94.32% RTP, 5,000x Max Win | {brand}',
        description: 'Striking Hot 5 runs at 94.32% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/striking_hot_5_jackpot_play': {
        title: 'Striking Hot 5 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Striking Hot 5 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/sugar_rush': {
        title: 'Sugar Rush: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Sugar Rush runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sugar_rush_1000': {
        title: 'Sugar Rush 1000: 94.5% RTP, 25,000x Max Win | {brand}',
        description: 'Sugar Rush 1000 runs at 94.5% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sugar_rush_super_scatter': {
        title: 'Sugar Rush Super Scatter: 96.58% RTP, 50,000x Max Win | {brand}',
        description: 'Sugar Rush Super Scatter runs at 96.58% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sugar_rush_xmas': {
        title: 'Sugar Rush Xmas: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Sugar Rush Xmas runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sugar_supreme_powernudge': {
        title: 'Sugar Supreme Powernudge: 94.02% RTP, 5,000x Max Win | {brand}',
        description: 'Sugar Supreme Powernudge runs at 94.02% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sumo_supreme_megaways': {
        title: 'Sumo Supreme Megaways™: 94.56% RTP, 12,500x Max Win | {brand}',
        description: 'Sumo Supreme Megaways™ runs at 94.56% RTP at {brand}, with a 12,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/super_7s': {
        title: 'Super 7s: 96.5% RTP, 1,000x Max Win | {brand}',
        description: 'Super 7s runs at 96.5% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/super_joker': {
        title: 'Super Joker: 94.5% RTP, 1,500x Max Win | {brand}',
        description: 'Super Joker runs at 94.5% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/super_tiki_strike': {
        title: 'Super Tiki Strike: 96.5% RTP, 50,000x Max Win | {brand}',
        description: 'Super Tiki Strike runs at 96.5% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/super_x': {
        title: 'Super X: 95.56% RTP, 9,000x Max Win | {brand}',
        description: 'Super X runs at 95.56% RTP at {brand}, with a 9,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/supermania': {
        title: 'Supermania Slot | 5,000x Max Win | {brand}',
        description: 'Play Supermania slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_bonanza': {
        title: 'Sweet Bonanza: 95.45% RTP, 21,175x Max Win | {brand}',
        description: 'Sweet Bonanza runs at 95.45% RTP at {brand}, with a 21,175x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_bonanza_1000': {
        title: 'Sweet Bonanza 1000: 94.51% RTP, 25,000x Max Win | {brand}',
        description: 'Sweet Bonanza 1000 runs at 94.51% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_bonanza_dice': {
        title: 'Sweet Bonanza Dice: 95.5% RTP, 21,175x Max Win | {brand}',
        description: 'Sweet Bonanza Dice runs at 95.5% RTP at {brand}, with a 21,175x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_bonanza_super_scatter': {
        title: 'Sweet Bonanza Super Scatter: 94.48% RTP | {brand}',
        description: 'Sweet Bonanza Super Scatter runs at 94.48% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_bonanza_xmas': {
        title: 'Sweet Bonanza Xmas: 95.45% RTP, 21,175x Max Win | {brand}',
        description: 'Sweet Bonanza Xmas runs at 95.45% RTP at {brand}, with a 21,175x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_craze': {
        title: 'Sweet Craze: 94.54% RTP, 10,000x Max Win | {brand}',
        description: 'Sweet Craze runs at 94.54% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_kingdom': {
        title: 'Sweet Kingdom: 94.53% RTP, 10,000x Max Win | {brand}',
        description: 'Sweet Kingdom runs at 94.53% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_powernudge': {
        title: 'Sweet Powernudge: 94.07% RTP, 5,000x Max Win | {brand}',
        description: 'Sweet Powernudge runs at 94.07% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sweet_rush_bonanza': {
        title: 'Sweet Rush Bonanza: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Sweet Rush Bonanza runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/sword_of_ares': {
        title: 'Sword of Ares: 94.44% RTP, 10,000x Max Win | {brand}',
        description: 'Sword of Ares runs at 94.44% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/temple_guardians': {
        title: 'Temple Guardians: 94.54% RTP, 10,000x Max Win | {brand}',
        description: 'Temple Guardians runs at 94.54% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/temujin_treasures': {
        title: 'Temujin Treasures: 94.51% RTP, 9,000x Max Win | {brand}',
        description: 'Temujin Treasures runs at 94.51% RTP at {brand}, with a 9,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_alter_ego': {
        title: 'The Alter Ego: 93.99% RTP, 10,000x Max Win | {brand}',
        description: 'The Alter Ego runs at 93.99% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_amazing_money_machine': {
        title: 'The Amazing Money Machine Slot | 5,100x Max Win | {brand}',
        description: 'Play The Amazing Money Machine slot with Bitcoin at {brand}. Medium-High volatility, 5,100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_big_dawgs': {
        title: 'The Big Dawgs: 93.99% RTP, 5,000x Max Win | {brand}',
        description: 'The Big Dawgs runs at 93.99% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house': {
        title: 'The Dog House: 95.51% RTP, 6,750x Max Win | {brand}',
        description: 'The Dog House runs at 95.51% RTP at {brand}, with a 6,750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_dice_show': {
        title: 'The Dog House Dice Show: 95.51% RTP, 6,750x Max Win | {brand}',
        description: 'The Dog House Dice Show runs at 95.51% RTP at {brand}, with a 6,750x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_dog_or_alive': {
        title: 'The Dog House - Dog or Alive: 94.54% RTP | {brand}',
        description: 'The Dog House - Dog or Alive runs at 94.54% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_megaways': {
        title: 'The Dog House Megaways: 94.55% RTP, 12,305x Max Win | {brand}',
        description: 'The Dog House Megaways runs at 94.55% RTP at {brand}, with a 12,305x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_muttley_crew': {
        title: 'The Dog House - Muttley Crew: 94.47% RTP | {brand}',
        description: 'The Dog House - Muttley Crew runs at 94.47% RTP at {brand}, with a 7,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_royal_hunt': {
        title: 'The Dog House Royal Hunt: 94.52% RTP, 8,000x Max Win | {brand}',
        description: 'The Dog House Royal Hunt runs at 94.52% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_dragon_tiger': {
        title: 'The Dragon Tiger: 94.52% RTP, 18,125x Max Win | {brand}',
        description: 'The Dragon Tiger runs at 94.52% RTP at {brand}, with a 18,125x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_great_chicken_escape': {
        title: 'The Great Chicken Escape: 94.5% RTP, 5,500x Max Win | {brand}',
        description: 'The Great Chicken Escape runs at 94.5% RTP at {brand}, with a 5,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_great_stickup': {
        title: 'The Great Stick-Up: 94.4% RTP, 5,000x Max Win | {brand}',
        description: 'The Great Stick-Up runs at 94.4% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_hand_of_midas': {
        title: 'The Hand of Midas: 94.51% RTP, 5,000x Max Win | {brand}',
        description: 'The Hand of Midas runs at 94.51% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_magic_cauldron_enchanted_brew': {
        title: 'The Magic Cauldron Enchanted Brew Slot | Pragmatic Play | ',
        description: 'Play The Magic Cauldron Enchanted Brew by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/the_money_men_megaways': {
        title: 'The Money Men Megaways: 94.99% RTP, 10,000x Max Win | {brand}',
        description: 'The Money Men Megaways runs at 94.99% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_tiger_warrior': {
        title: 'The Tiger Warrior: 93.99% RTP, 2,500x Max Win | {brand}',
        description: 'The Tiger Warrior runs at 93.99% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_tweety_house': {
        title: 'The Tweety House: 95.51% RTP, 6,750x Max Win | {brand}',
        description: 'The Tweety House runs at 95.51% RTP at {brand}, with a 6,750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_ultimate_5': {
        title: 'The Ultimate 5: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'The Ultimate 5 runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_wild_gang': {
        title: 'The Wild Gang: 94.03% RTP, 10,000x Max Win | {brand}',
        description: 'The Wild Gang runs at 94.03% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/the_wild_machine': {
        title: 'The Wild Machine: 94.51% RTP, 7,000x Max Win | {brand}',
        description: 'The Wild Machine runs at 94.51% RTP at {brand}, with a 7,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/three_star_fortune': {
        title: 'Three Star Fortune: 94.49% RTP, 500x Max Win | {brand}',
        description: 'Three Star Fortune runs at 94.49% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/tic_tac_take': {
        title: 'Tic Tac Take: 94.57% RTP | {brand}',
        description: 'Tic Tac Take runs at 94.57% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/tiki_hut_megaways_jackpot_play': {
        title: 'Tiki Hut Megaways Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Tiki Hut Megaways Jackpot Play by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/timber_stacks': {
        title: 'Timber Stacks: 94.05% RTP, 10,000x Max Win | {brand}',
        description: 'Timber Stacks runs at 94.05% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/tiny_toads': {
        title: 'Tiny Toads: 94.5% RTP, 4,000x Max Win | {brand}',
        description: 'Tiny Toads runs at 94.5% RTP at {brand}, with a 4,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/towering_fortunes': {
        title: 'Towering Fortunes: 94.5% RTP, 6,422x Max Win | {brand}',
        description: 'Towering Fortunes runs at 94.5% RTP at {brand}, with a 6,422x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/treasure_horse': {
        title: 'Treasure Horse: 95.52% RTP, 6,000x Max Win | {brand}',
        description: 'Treasure Horse runs at 95.52% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/treasure_wild': {
        title: 'Treasure Wild: 94.52% RTP, 4,500x Max Win | {brand}',
        description: 'Treasure Wild runs at 94.52% RTP at {brand}, with a 4,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/treasures_of_osiris': {
        title: 'Treasures Of Osiris Slot | 10,000x Max Win | {brand}',
        description: 'Play Treasures Of Osiris slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/tree_of_riches': {
        title: 'Tree of Riches: 94.53% RTP, 2,880x Max Win | {brand}',
        description: 'Tree of Riches runs at 94.53% RTP at {brand}, with a 2,880x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/trees_of_treasure': {
        title: 'Trees of Treasure: 94.06% RTP, 15,000x Max Win | {brand}',
        description: 'Trees of Treasure runs at 94.06% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/triple_dragons': {
        title: 'Triple Dragons: 95.5% RTP, 1,000x Max Win | {brand}',
        description: 'Triple Dragons runs at 95.5% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/triple_pot_diamond': {
        title: 'Triple Pot Diamond: 96.57% RTP, 10,000x Max Win | {brand}',
        description: 'Triple Pot Diamond runs at 96.57% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/triple_pot_god': {
        title: 'Triple Pot God Slot | 5,000x Max Win | {brand}',
        description: 'Play Triple Pot God slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/triple_pot_gold': {
        title: 'Triple Pot Gold: 94.07% RTP, 5,000x Max Win | {brand}',
        description: 'Triple Pot Gold runs at 94.07% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/triple_tigers': {
        title: 'Triple Tigers: 95.58% RTP, 500x Max Win | {brand}',
        description: 'Triple Tigers runs at 95.58% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/tropical_pop_jackpot_play': {
        title: 'Tropical Pop Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Tropical Pop Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/tropical_tiki': {
        title: 'Tropical Tiki: 94.4% RTP, 3,000x Max Win | {brand}',
        description: 'Tropical Tiki runs at 94.4% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/tundras_fortune': {
        title: "Tundra's Fortune: 94.06% RTP, 12,500x Max Win | {brand}",
        description: "Tundra's Fortune runs at 94.06% RTP at {brand}, with a 12,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/twilight_princess': {
        title: 'Twilight Princess: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Twilight Princess runs at 94% RTP at {brand}, with a 7,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ultra_burn': {
        title: 'Ultra Burn: 95.63% RTP | {brand}',
        description: 'Ultra Burn runs at 95.63% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/ultra_hold_and_spin': {
        title: 'Ultra Hold and Spin: 95.65% RTP | {brand}',
        description: 'Ultra Hold and Spin runs at 95.65% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/vampires_vs_wolves': {
        title: 'Vampires vs Wolves: 94.45% RTP, 1,000x Max Win | {brand}',
        description: 'Vampires vs Wolves runs at 94.45% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/vampy_party': {
        title: 'Vampy Party: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Vampy Party runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/vegas_magic': {
        title: 'Vegas Magic: 94.07% RTP, 3,549x Max Win | {brand}',
        description: 'Vegas Magic runs at 94.07% RTP at {brand}, with a 3,549x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/vegas_nights': {
        title: 'Vegas Nights: 96.05% RTP, 3,558x Max Win | {brand}',
        description: 'Vegas Nights runs at 96.05% RTP at {brand}, with a 3,558x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/viking_forge': {
        title: 'Viking Forge: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Viking Forge runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/volcano_goddess': {
        title: 'Volcano Goddess: 94.5% RTP, 20,000x Max Win | {brand}',
        description: 'Volcano Goddess runs at 94.5% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/voodoo_magic': {
        title: 'Voodoo Magic: 94.5% RTP, 1,000x Max Win | {brand}',
        description: 'Voodoo Magic runs at 94.5% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/waves_of_poseidon': {
        title: 'Waves of Poseidon: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Waves of Poseidon runs at 94.5% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wheel_o_gold': {
        title: 'Wheel O Gold Slot | 10,000x Max Win | {brand}',
        description: 'Play Wheel O Gold slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wheel_of_happiness': {
        title: 'Wheel of Happiness: 94.46% RTP, 4,000x Max Win | {brand}',
        description: 'Wheel of Happiness runs at 94.46% RTP at {brand}, with a 4,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wheel_ogold': {
        title: "Wheel O'Gold: 94.02% RTP | {brand}",
        description: "Wheel O'Gold runs at 94.02% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/wild_beach_party': {
        title: 'Wild Beach Party: 94.46% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Beach Party runs at 94.46% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_bison_charge': {
        title: 'Wild Bison Charge: 94% RTP | {brand}',
        description: 'Wild Bison Charge runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_booster': {
        title: 'Wild Booster: 94.47% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Booster runs at 94.47% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_celebrity_bus_megaways': {
        title: 'Wild Celebrity Bus Megaways: 94.07% RTP | {brand}',
        description: 'Wild Celebrity Bus Megaways runs at 94.07% RTP at {brand}, with a 4,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_depths': {
        title: 'Wild Depths: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Depths runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_gladiators': {
        title: 'Wild Gladiators Slot | 4,000x Max Win | {brand}',
        description: 'Play Wild Gladiators slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_hop_and_drop': {
        title: 'Wild Hop & Drop: 94.44% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Hop & Drop runs at 94.44% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_pixies': {
        title: 'Wild Pixies: 95.5% RTP, 261x Max Win | {brand}',
        description: 'Wild Pixies runs at 95.5% RTP at {brand}, with a 261x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_skullz': {
        title: 'Wild Skullz: 96.44% RTP, 10,000x Max Win | {brand}',
        description: 'Wild Skullz runs at 96.44% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_spells': {
        title: 'Wild Spells: 93.67% RTP, 1,450x Max Win | {brand}',
        description: 'Wild Spells runs at 93.67% RTP at {brand}, with a 1,450x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_walker': {
        title: 'Wild Walker: 94.53% RTP, 4,980x Max Win | {brand}',
        description: 'Wild Walker runs at 94.53% RTP at {brand}, with a 4,980x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_west_gold': {
        title: 'Wild West Gold: 94.53% RTP, 10,000x Max Win | {brand}',
        description: 'Wild West Gold runs at 94.53% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_west_gold_blazing_bounty': {
        title: 'Wild West Gold Blazing Bounty: 94.49% RTP | {brand}',
        description: 'Wild West Gold Blazing Bounty runs at 94.49% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_west_gold_megaways': {
        title: 'Wild West Gold Megaways: 94.32% RTP, 5,000x Max Win | {brand}',
        description: 'Wild West Gold Megaways runs at 94.32% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_wild_bananas': {
        title: 'Wild Wild Bananas: 94.1% RTP, 12,000x Max Win | {brand}',
        description: 'Wild Wild Bananas runs at 94.1% RTP at {brand}, with a 12,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_wild_joker': {
        title: 'Wild Wild Joker: 94.49% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Wild Joker runs at 94.49% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_wild_pearls': {
        title: 'Wild Wild Pearls: 94.54% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Wild Pearls runs at 94.54% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_wild_riches': {
        title: 'Wild Wild Riches: 94.76% RTP, 4,608x Max Win | {brand}',
        description: 'Wild Wild Riches runs at 94.76% RTP at {brand}, with a 4,608x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_wild_riches_returns': {
        title: 'Wild Wild Riches Returns: 94.54% RTP, 10,000x Max Win | {brand}',
        description: 'Wild Wild Riches Returns runs at 94.54% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wild_wildebeest_wins': {
        title: 'Wild Wildebeest Wins: 94.56% RTP, 10,000x Max Win | {brand}',
        description: 'Wild Wildebeest Wins runs at 94.56% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wildies': {
        title: 'Wildies: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Wildies runs at 94% RTP at {brand}, with a 7,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wildman_super_bonanza': {
        title: 'Wildman Super Bonanza Slot | 10,000x Max Win | {brand}',
        description: 'Play Wildman Super Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wisdom_of_athena': {
        title: 'Wisdom of Athena: 94.09% RTP, 5,000x Max Win | {brand}',
        description: 'Wisdom of Athena runs at 94.09% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wisdom_of_athena_1000': {
        title: 'Wisdom of Athena 1000: 94.05% RTP, 10,000x Max Win | {brand}',
        description: 'Wisdom of Athena 1000 runs at 94.05% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wisdom_of_athena_1000_xmas': {
        title: 'Wisdom of Athena 1000 Xmas: 94.05% RTP | {brand}',
        description: 'Wisdom of Athena 1000 Xmas runs at 94.05% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/witch_heart_megaways': {
        title: 'Witch Heart Megaways: 94.52% RTP, 9,000x Max Win | {brand}',
        description: 'Witch Heart Megaways runs at 94.52% RTP at {brand}, with a 9,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wolf_gold': {
        title: 'Wolf Gold: 93.99% RTP, 2,500x Max Win | {brand}',
        description: 'Wolf Gold runs at 93.99% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wolf_gold_4_pack': {
        title: 'Wolf Gold 4 Pack: 94.49% RTP, 5,100x Max Win | {brand}',
        description: 'Wolf Gold 4 Pack runs at 94.49% RTP at {brand}, with a 5,100x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wolf_gold_ultimate': {
        title: 'Wolf Gold Ultimate: 94.53% RTP, 5,000x Max Win | {brand}',
        description: 'Wolf Gold Ultimate runs at 94.53% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/wukong_rush': {
        title: 'Wukong Rush: 94.5% RTP | {brand}',
        description: 'Wukong Rush runs at 94.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/year_of_the_dragon_king': {
        title: 'Year of the Dragon King: 94.08% RTP | {brand}',
        description: 'Year of the Dragon King runs at 94.08% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/yeti_quest': {
        title: 'Yeti Quest: 94.03% RTP, 5,000x Max Win | {brand}',
        description: 'Yeti Quest runs at 94.03% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/you_can_piggy_bank_on_it': {
        title: 'You Can Piggy Bank On It: 94.53% RTP, 2,100x Max Win | {brand}',
        description: 'You Can Piggy Bank On It runs at 94.53% RTP at {brand}, with a 2,100x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/yum_yum_powerways': {
        title: 'Yum Yum Powerways: 94.59% RTP, 5,000x Max Win | {brand}',
        description: 'Yum Yum Powerways runs at 94.59% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/zeus_vs_hades_gods_of_war': {
        title: 'Zeus vs Hades - Gods of War: 94.05% RTP | {brand}',
        description: 'Zeus vs Hades - Gods of War runs at 94.05% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/zeus_vs_hades_gods_of_war_250': {
        title: 'Zeus vs Hades Gods of War 250: 96.56% RTP | {brand}',
        description: 'Zeus vs Hades Gods of War 250 runs at 96.56% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/zeus_vs_typhoon': {
        title: 'Zeus vs Typhoon: 94.49% RTP, 10,000x Max Win | {brand}',
        description: 'Zeus vs Typhoon runs at 94.49% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/zombie_carnival': {
        title: 'Zombie Carnival: 94.5% RTP, 5,000x Max Win | {brand}',
        description: 'Zombie Carnival runs at 94.5% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/zombie_school_megaways': {
        title: 'Zombie School Megaways: 94.5% RTP, 10,000x Max Win | {brand}',
        description: 'Zombie School Megaways runs at 94.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play/zombie_train': {
        title: 'Zombie Train: 94.05% RTP, 15,000x Max Win | {brand}',
        description: 'Zombie Train runs at 94.05% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/80spop': {
        title: '80sPOP: 94% RTP, 20,000x Max Win | {brand}',
        description: '80sPOP runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/animals_strike': {
        title: 'Animals Strike: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Animals Strike runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/arcanapop': {
        title: 'ArcanaPop: 94% RTP, 20,000x Max Win | {brand}',
        description: 'ArcanaPop runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/astropop': {
        title: 'AstroPop: 94% RTP, 10,000x Max Win | {brand}',
        description: 'AstroPop runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/beastly_burglars': {
        title: 'Beastly Burglars: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Beastly Burglars runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/big_catch_craze': {
        title: 'Big Catch Craze: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Big Catch Craze runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/big_catch_xmas': {
        title: 'Big Catch Xmas: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Big Catch Xmas runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/bounty_pop': {
        title: 'Bounty Pop: 94% RTP, 37,910x Max Win | {brand}',
        description: 'Bounty Pop runs at 94% RTP at {brand}, with a 37,910x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/canyon_riches': {
        title: 'Canyon Riches: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Canyon Riches runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/captain_moregain': {
        title: "Captain More'gain: 94% RTP, 10,000x Max Win | {brand}",
        description: "Captain More'gain runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/avatarux/cherry_pop': {
        title: 'Cherry Pop: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Cherry Pop runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/cherry_pop_deluxe': {
        title: 'Cherry Pop Deluxe: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Cherry Pop Deluxe runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/cherrypop_burst': {
        title: 'CherryPop Burst: 94% RTP, 20,000x Max Win | {brand}',
        description: 'CherryPop Burst runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/cosmic_jokers': {
        title: 'Cosmic Jokers: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Cosmic Jokers runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/coyote_gold': {
        title: 'Coyote Gold: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Coyote Gold runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/critter_pop': {
        title: 'Critter Pop: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Critter Pop runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/crypto_bro': {
        title: 'Crypto Bro: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Crypto Bro runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/depths_of_fortune': {
        title: 'Depths of Fortune: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Depths of Fortune runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/donkey_and_the_goats': {
        title: 'Donkey & The Goats: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Donkey & The Goats runs at 94% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/duck_hunt_500': {
        title: 'Duck Hunt 500: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Duck Hunt 500 runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/electric_rush': {
        title: 'Electric Rush: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Electric Rush runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/electro_cubes': {
        title: 'Electro Cubes: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Electro Cubes runs at 94% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/floridaman': {
        title: 'Floridaman: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Floridaman runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/fruitillionaire': {
        title: 'Fruitillionaire: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Fruitillionaire runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/gempops': {
        title: 'GemPOPs: 94% RTP | {brand}',
        description: 'GemPOPs runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/gods_gone_wild': {
        title: 'Gods Gone Wild: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Gods Gone Wild runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/heliopopolis': {
        title: 'HelioPOPolis: 94% RTP, 50,000x Max Win | {brand}',
        description: 'HelioPOPolis runs at 94% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/hiphop_pop': {
        title: 'Hip-Hop Pop: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Hip-Hop Pop runs at 94% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/hippo_pop': {
        title: 'Hippo Pop: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Hippo Pop runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/imperial_coins': {
        title: 'Imperial Coins: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Imperial Coins runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/jinglepop': {
        title: 'JinglePOP: 94% RTP, 20,000x Max Win | {brand}',
        description: 'JinglePOP runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/juicypop': {
        title: 'JuicyPop: 94% RTP, 10,000x Max Win | {brand}',
        description: 'JuicyPop runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/jungle_pop': {
        title: 'Jungle Pop: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Jungle Pop runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/king_of_samba': {
        title: 'King of Samba: 94% RTP, 1,200x Max Win | {brand}',
        description: 'King of Samba runs at 94% RTP at {brand}, with a 1,200x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/kittypopins': {
        title: 'KittyPOPins: 94% RTP, 20,000x Max Win | {brand}',
        description: 'KittyPOPins runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/kokeshi_pop': {
        title: 'Kokeshi Pop: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Kokeshi Pop runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/lolli_pop': {
        title: 'Lolli Pop: 94% RTP, 13,000x Max Win | {brand}',
        description: 'Lolli Pop runs at 94% RTP at {brand}, with a 13,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/looney_pop': {
        title: 'Looney Pop: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Looney Pop runs at 94% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/majestic_meow': {
        title: 'Majestic Meow: 94% RTP, 94x Max Win | {brand}',
        description: 'Majestic Meow runs at 94% RTP at {brand}, with a 94x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/midnight_hunt': {
        title: 'Midnight Hunt: 94% RTP, 5,205x Max Win | {brand}',
        description: 'Midnight Hunt runs at 94% RTP at {brand}, with a 5,205x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/monkey_pop': {
        title: 'Monkey Pop: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Monkey Pop runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/nugget': {
        title: 'Nugget: 94% RTP, 25,000x Max Win | {brand}',
        description: 'Nugget runs at 94% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/papaya_pop': {
        title: 'Papaya Pop: 94% RTP, 10,542x Max Win | {brand}',
        description: 'Papaya Pop runs at 94% RTP at {brand}, with a 10,542x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/piggy_pop': {
        title: 'Piggy Pop: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Piggy Pop runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/piggypop_grand_affair': {
        title: 'PiggyPop Grand Affair: 94% RTP, 5,000x Max Win | {brand}',
        description: 'PiggyPop Grand Affair runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/pixel_paws': {
        title: 'Pixel Paws: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Pixel Paws runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/pixiepop': {
        title: 'PixiePop: 94% RTP, 20,000x Max Win | {brand}',
        description: 'PixiePop runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/pop_noir': {
        title: 'Pop Noir: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Pop Noir runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/pop_ogold': {
        title: "Pop o'Gold: 94% RTP, 20,000x Max Win | {brand}",
        description: "Pop o'Gold runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/avatarux/pop_rocks': {
        title: 'Pop Rocks: 94% RTP, 72,188x Max Win | {brand}',
        description: 'Pop Rocks runs at 94% RTP at {brand}, with a 72,188x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/raging_pop': {
        title: 'Raging Pop: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Raging Pop runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/rebel_paws': {
        title: 'Rebel Paws: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Rebel Paws runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/reef_pop': {
        title: 'Reef Pop: 94% RTP | {brand}',
        description: 'Reef Pop runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/reel_warriors': {
        title: 'Reel Warriors: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Reel Warriors runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/shippy_d_pop': {
        title: 'Shippy D Pop: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Shippy D Pop runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/silicon_spinners': {
        title: 'Silicon Spinners: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Silicon Spinners runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/sphinx_treasure': {
        title: 'Sphinx Treasure: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Sphinx Treasure runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/spinfection': {
        title: 'Spinfection: 94% RTP, 1,365x Max Win | {brand}',
        description: 'Spinfection runs at 94% RTP at {brand}, with a 1,365x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/spinxiety': {
        title: 'Spinxiety: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Spinxiety runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/sweet_gummy': {
        title: 'Sweet Gummy: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Sweet Gummy runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/the_vault_chase': {
        title: 'The Vault Chase: 94% RTP, 10,000x Max Win | {brand}',
        description: 'The Vault Chase runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/tik_talkers': {
        title: 'Tik Talkers: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Tik Talkers runs at 94% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/tiki_pop': {
        title: 'Tiki Pop: 94% RTP, 32,000x Max Win | {brand}',
        description: 'Tiki Pop runs at 94% RTP at {brand}, with a 32,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/tikipop_spooky_temples': {
        title: 'TikiPop Spooky Temples: 94% RTP, 32,000x Max Win | {brand}',
        description: 'TikiPop Spooky Temples runs at 94% RTP at {brand}, with a 32,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/toads_bounty': {
        title: "Toad's Bounty: 94% RTP, 10,000x Max Win | {brand}",
        description: "Toad's Bounty runs at 94% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/avatarux/vegas_fortune': {
        title: 'Vegas Fortune: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Vegas Fortune runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/wild_pops': {
        title: 'Wild Pops: 94% RTP, 17,707x Max Win | {brand}',
        description: 'Wild Pops runs at 94% RTP at {brand}, with a 17,707x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/witchy_poppins': {
        title: 'Witchy POPpins: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Witchy POPpins runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/worms_of_valor': {
        title: 'Worms of Valor: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Worms of Valor runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/xmas_pop_delight': {
        title: 'Xmas Pop Delight: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Xmas Pop Delight runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/zombie_apopalypse': {
        title: 'Zombie aPOPalypse: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Zombie aPOPalypse runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/big-time-gaming/apollo_pays': {
        title: 'Apollo Pays Slot | 116,030x Max Win | {brand}',
        description: 'Apollo Pays slot with 116,030x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/beef_lightning': {
        title: 'Play Beef Lightning Slot | 56,000x Payout | {brand}',
        description: 'Play Beef Lightning by Big Time Gaming. Medium volatility, 56,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/big_bad_bison': {
        title: 'Play Big Bad Bison | 55,260x Win | {brand}',
        description: 'Big Bad Bison at {brand}. Medium volatility, 55,260x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/big_bucks_deluxe': {
        title: 'Big Bucks Deluxe Slot | 89,600x Win | Play with Bitcoin',
        description: 'Big Bucks Deluxe slot with 89,600x max win and Hold and Spin. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/big-time-gaming/bonanza': {
        title: 'Bonanza Slot | 29,000x Win | Play with Bitcoin',
        description: 'Play Bonanza by Big Time Gaming. Medium volatility, 29,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/bonanza_falls': {
        title: 'Bonanza Falls Slot | Win Up to 10,000x | {brand}',
        description: 'Play Bonanza Falls at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/bonanza_megaways': {
        title: 'Bonanza Megaways | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Bonanza Megaways slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/boo': {
        title: 'Play Boo | 47,050x Win | {brand}',
        description: 'Deposit BTC and play Boo at {brand}. 47,050x max win, medium volatility, Wilds. 9 cryptos, zero fees.'
    },
    '/p/big-time-gaming/book_of_gods': {
        title: 'Book Of Gods Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Book Of Gods by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/burgers': {
        title: 'Burgers Slot | Win Up to 102,840x | {brand}',
        description: 'Burgers at {brand} crypto casino. 102,840x max win with Bonus Buy. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/castle_of_terror': {
        title: 'Castle of Terror | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Castle of Terror by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/chocolates': {
        title: 'Play Chocolates Slot | 13,000x Payout | {brand}',
        description: 'Chocolates slot with 13,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/christmas_bonanza': {
        title: 'Christmas Bonanza Slot | Win Up to 13,000x | {brand}',
        description: 'Christmas Bonanza at {brand}. Medium volatility, 13,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/christmas_catch': {
        title: 'Christmas Catch | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Christmas Catch at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/crystal_towers': {
        title: 'Crystal Towers Slot | 10,000x Max Win | {brand}',
        description: 'Crystal Towers slot with 10,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/cyberslot_megaclusters': {
        title: 'Cyberslot MegaClusters Slot | 23,960x Max Win | {brand}',
        description: 'Cyberslot MegaClusters by Big Time Gaming. Medium volatility slot with 23,960x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/danger_high_voltage': {
        title: 'Danger High Voltage | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Danger High Voltage by Big Time Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/danger_high_voltage_2': {
        title: 'Danger High Voltage 2 | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Danger High Voltage 2 slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/danger_high_voltage_2_megaways': {
        title: 'Danger High Voltage 2 Megaways Slot | 10,000x Win | {brand}',
        description: 'Play Danger High Voltage 2 Megaways by Big Time Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/diamond_fruits': {
        title: 'Play Diamond Fruits | 13,000x Max Win | {brand}',
        description: 'Diamond Fruits at {brand}. Medium volatility, 13,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/donuts': {
        title: 'Donuts | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Donuts slot with 13,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/dragon_born': {
        title: 'Dragon Born Slot | 13,000x Win | Play with Bitcoin',
        description: 'Spin Dragon Born with Bitcoin at {brand}. 13,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/extra_chilli': {
        title: 'Play Extra Chilli | 32,250x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Extra Chilli at {brand}. 32,250x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/big-time-gaming/extra_chilli_megaways': {
        title: 'Extra Chilli Megaways | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Extra Chilli Megaways by Big Time Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/extra_chilli_nfd': {
        title: 'Extra Chilli (NFD) | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Extra Chilli (NFD) by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/fireworks_megaways': {
        title: 'Fireworks Megaways Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Fireworks Megaways by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/fizzy_pennyslot': {
        title: 'Fizzy Pennyslot | 10,170x Max Win Bitcoin Slot | {brand}',
        description: 'Fizzy Pennyslot slot with 10,170x max win and Pennyslot. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/big-time-gaming/gifts_of_fortune': {
        title: 'Gifts of Fortune Slot | 13,000x Win | Play with Bitcoin',
        description: 'Spin Gifts of Fortune with Bitcoin at {brand}. 13,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/gold_megaways': {
        title: 'Gold Megaways Slot | 13,000x Win | Play with Bitcoin',
        description: 'Play Gold Megaways by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/golden_catch': {
        title: 'Golden Catch Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Golden Catch by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/golden_goose_megaways': {
        title: 'Play Golden Goose Megaways | 29,030x Win | {brand}',
        description: 'Golden Goose Megaways slot at {brand} crypto casino. High volatility, 29,030x max win with Cloud Prizes and Bonus Boy. Deposit BTC, ETH, USDT.'
    },
    '/p/big-time-gaming/holy_diver': {
        title: 'Holy Diver Slot | 13,000x Max Win | {brand}',
        description: 'Play Holy Diver by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/holy_diver_megaways': {
        title: 'Play Holy Diver Megaways | 10,000x Win | {brand}',
        description: 'Holy Diver Megaways at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/king_of_cats': {
        title: 'King of Cats | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play King of Cats by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/kingmaker': {
        title: 'KingMaker | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'KingMaker by Big Time Gaming. Medium volatility slot with 13,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/kingmaker_fully_loaded': {
        title: 'Play Kingmaker Fully Loaded | 10,000x Win | {brand}',
        description: 'Kingmaker Fully Loaded slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/lil_devil': {
        title: 'Lil Devil | 91,300x Max Win Crypto Slot | {brand}',
        description: 'Lil Devil at {brand}. Medium volatility, 91,300x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/lucky_streak_mk2': {
        title: 'Play Lucky Streak Mk2 | 13,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Lucky Streak Mk2 at {brand}. 13,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/big-time-gaming/max_megaways': {
        title: 'Max Megaways Slot | 13,000x Win | Play with Bitcoin',
        description: 'Max Megaways slot with 13,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/max_megaways_2': {
        title: 'Play Max Megaways 2 | 10,000x Max Win | {brand}',
        description: 'Max Megaways 2 slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/max_megaways_3': {
        title: 'Max Megaways 3 | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Max Megaways 3 by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/millionaire': {
        title: 'Play Millionaire Megapots Slot | 3,600x Payout | {brand}',
        description: 'Millionaire Megapots by Big Time Gaming. High volatility slot with 3,600x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/millionaire_mystery_box': {
        title: 'Millionaire Mystery Box Slot | 13,000x Max Win | {brand}',
        description: 'Play Millionaire Mystery Box by Big Time Gaming at {brand}. Medium volatility, 13,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/millionaire_rush': {
        title: 'Millionaire Rush | 13,000x Max Win Crypto Slot | {brand}',
        description: 'Millionaire Rush slot at {brand} crypto casino. Medium volatility with 13,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/monopoly_rush_hour': {
        title: 'Monopoly Rush Hour Slot | 10,000x Max Win | {brand}',
        description: 'Monopoly Rush Hour by Big Time Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/more_turkey': {
        title: 'More Turkey Slot | Win Up to 10,000x | {brand}',
        description: 'Play More Turkey at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/opal_fruits': {
        title: 'Play Opal Fruits | 13,000x Win | {brand}',
        description: 'Play Opal Fruits slot for real money at {brand}. 13,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/outlaw': {
        title: 'Play Outlaw | 13,000x Win | {brand}',
        description: 'Outlaw slot at {brand} crypto casino. Medium volatility with 13,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/over_the_moon': {
        title: 'Play Over The Moon | 24,070x Max Win | {brand}',
        description: 'Play Over The Moon slot for real money at {brand}. 24,070x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/panda_money': {
        title: 'Panda Money Slot | 10,000x Max Win | {brand}',
        description: 'Play Panda Money by Big Time Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/pirate_pays': {
        title: 'Pirate Pays | 104,400x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Pirate Pays with Bitcoin at {brand}. 104,400x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/pop': {
        title: 'Pop Slot | 13,000x Win | Play with Bitcoin',
        description: 'Spin Pop with Bitcoin at {brand}. 13,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/queen_of_riches': {
        title: 'Queen Of Riches | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Queen Of Riches by Big Time Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/rasputin_megaways': {
        title: 'Rasputin Megaways | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Rasputin Megaways with Bitcoin at {brand}. 13,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/royal_mint': {
        title: 'Play Royal Mint | 40,000x Win | {brand}',
        description: 'Play Royal Mint at {brand} crypto casino. Medium volatility, 40,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/sanctuary': {
        title: 'Play Sanctuary | 10,000x Win | {brand}',
        description: 'Play Sanctuary at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/slot_vegas': {
        title: 'Slot Vegas | 22,700x Max Win Bitcoin Slot | {brand}',
        description: 'Play Slot Vegas by Big Time Gaming at {brand}. Medium volatility, 22,700x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/slot_vegas_fully_loaded': {
        title: 'Slot Vegas Fully Loaded Slot | Win Up to 10,000x | {brand}',
        description: 'Play Slot Vegas Fully Loaded at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/spicy_meatballs': {
        title: 'Play Spicy Meatballs | 55,210x Win | {brand}',
        description: 'Play Spicy Meatballs slot for real money at {brand}. 55,210x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/star_clusters': {
        title: 'Star Clusters | 16,708x Max Win Crypto Slot | {brand}',
        description: 'Play Star Clusters slot for real money at {brand}. 16,708x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/temple_quest_spinfinity': {
        title: 'Play Temple Quest Spinfinity | 13,000x Win | {brand}',
        description: 'Play Temple Quest Spinfinity at {brand} crypto casino. Medium volatility, 13,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/the_final_countdown': {
        title: 'Play The Final Countdown | 13,000x Max Win | {brand}',
        description: 'Play The Final Countdown at {brand} crypto casino. Medium volatility, 13,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/the_golden_catch': {
        title: 'The Golden Catch Slot | 10,000x Max Win | {brand}',
        description: 'Play The Golden Catch by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/the_race': {
        title: 'Play The Race Slot | 13,960x Payout | {brand}',
        description: 'The Race by Big Time Gaming. Medium volatility slot with 13,960x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/trigger_happy': {
        title: 'Trigger Happy | 50,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Trigger Happy with Bitcoin at {brand}. 50,000x max win, high volatility, Target Wild. Instant payouts, zero platform fees.'
    },
    '/p/big-time-gaming/vegas_megaways': {
        title: 'Vegas MegaWays Slot | 13,000x Max Win | {brand}',
        description: 'Vegas MegaWays by Big Time Gaming. Medium volatility slot with 13,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/vegas_rush': {
        title: 'Vegas Rush | 13,570x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Vegas Rush with Bitcoin at {brand}. 13,570x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/white_rabbit': {
        title: 'White Rabbit | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play White Rabbit at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/big-time-gaming/white_rabbit_2': {
        title: 'White Rabbit 2 Slot | 10,000x Max Win | {brand}',
        description: 'Play White Rabbit 2 by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/white_rabbit_megaways': {
        title: 'White Rabbit Megaways Slot | 10,000x Win | Play with Bitcoin',
        description: 'White Rabbit Megaways slot with 10,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/white_rabbit_nfd': {
        title: 'White Rabbit (NFD) | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'White Rabbit (NFD) by Big Time Gaming. Medium volatility slot with 13,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/wild_flower': {
        title: 'Wild Flower | 13,000x Max Win Crypto Slot | {brand}',
        description: 'Wild Flower slot at {brand} crypto casino. Medium volatility with 13,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/wild_portals': {
        title: 'Play Wild Portals | 13,000x Max Win | {brand}',
        description: 'Play Wild Portals slot for real money at {brand}. 13,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/wild_unicorns': {
        title: 'Wild Unicorns | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Wild Unicorns at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/blueprint-gaming/777_deluxe': {
        title: '777 Deluxe: 95% RTP, 50,000x Max Win | {brand}',
        description: '777 Deluxe runs at 95% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/almighty_bear_megaways': {
        title: 'Almighty Bear Megaways: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Almighty Bear Megaways runs at 95% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/bankin_bacon': {
        title: "Bankin' Bacon: 96% RTP, 100x Max Win | {brand}",
        description: "Bankin' Bacon runs at 96% RTP at {brand}, with a 100x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/blueprint-gaming/bankin_more_bacon': {
        title: "Bankin' More Bacon: 94% RTP, 10,000x Max Win | {brand}",
        description: "Bankin' More Bacon runs at 94% RTP at {brand}, with a 10,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/blueprint-gaming/barx_safecracker_megaways': {
        title: 'Bar-X Safecracker Megaways: 96% RTP, 50x Max Win | {brand}',
        description: 'Bar-X Safecracker Megaways runs at 96% RTP at {brand}, with a 50x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/big_catch_bass_fishing_megaways': {
        title: 'Big Catch Bass Fishing Megaways: 94% RTP, 200x Max Win | {brand}',
        description: 'Big Catch Bass Fishing Megaways runs at 94% RTP at {brand}, with a 200x max win and medium/high volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/blueprint-gaming/big_catch_even_bigger_bass_2': {
        title: 'Big Catch Even Bigger Bass 2: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Big Catch Even Bigger Bass 2 runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/big_catch_even_bigger_bass_3_megaways': {
        title: 'Big Catch Even Bigger Bass 3 Megaways: 95% RTP | {brand}',
        description: 'Big Catch Even Bigger Bass 3 Megaways runs at 95% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/blueprint-gaming/big_money_frenzy_cash_gains': {
        title: 'Big Money Frenzy Cash Gains: 95% RTP, 5,000x Max Win | {brand}',
        description: 'Big Money Frenzy Cash Gains runs at 95% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/big_money_megaways': {
        title: 'Big Money Megaways: 95.01% RTP | {brand}',
        description: 'Big Money Megaways runs at 95.01% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/bigger_catch_bass_fishing': {
        title: 'Bigger Catch Bass Fishing: 95% RTP, 200x Max Win | {brand}',
        description: 'Bigger Catch Bass Fishing runs at 95% RTP at {brand}, with a 200x max win and n/a volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/bison_bonanza': {
        title: 'Bison Bonanza: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Bison Bonanza runs at 96% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/bison_rising_gold_strike': {
        title: 'Bison Rising Gold Strike: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Bison Rising Gold Strike runs at 94% RTP at {brand}, with a 10,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/bison_rising_megaways': {
        title: 'Bison Rising Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Bison Rising Megaways runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/bison_rising_reloaded_megaways': {
        title: 'Bison Rising Reloaded Megaways: 96% RTP | {brand}',
        description: 'Bison Rising Reloaded Megaways runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/blazing_cash': {
        title: 'Blazing Cash: 95% RTP, 500x Max Win | {brand}',
        description: 'Blazing Cash runs at 95% RTP at {brand}, with a 500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/bounty_hunter_unchained': {
        title: 'Bounty Hunter Unchained: 96.12% RTP, 10,000x Max Win | {brand}',
        description: 'Bounty Hunter Unchained runs at 96.12% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/bullion_blitz_power_play': {
        title: 'Bullion Blitz Power Play: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Bullion Blitz Power Play runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike': {
        title: 'Cash Strike: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Strike runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_hotstepper': {
        title: 'Cash Strike Hotstepper: 96% RTP, 50x Max Win | {brand}',
        description: 'Cash Strike Hotstepper runs at 96% RTP at {brand}, with a 50x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_hotstepper_megaways': {
        title: 'Cash Strike Hotstepper Megaways: 95% RTP | {brand}',
        description: 'Cash Strike Hotstepper Megaways runs at 95% RTP at {brand}, with a 50,000x max win and medium / high volatility. Crypto deposits, instant withdrawals,.'
    },
    '/p/blueprint-gaming/cash_strike_power_5': {
        title: 'Cash Strike Power 5: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Strike Power 5 runs at 95% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_power_up': {
        title: 'Cash Strike Power Up: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Strike Power Up runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_win_boost': {
        title: 'Cash Strike Win Boost: 95% RTP, 50,000x Max Win | {brand}',
        description: 'Cash Strike Win Boost runs at 95% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cashpots_blazinator': {
        title: 'Cashpots Blazinator: 95.05% RTP, 5,000x Max Win | {brand}',
        description: 'Cashpots Blazinator runs at 95.05% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/chilli_picante_megaways': {
        title: 'Chilli Picante Megaways: 94% RTP, 50x Max Win | {brand}',
        description: 'Chilli Picante Megaways runs at 94% RTP at {brand}, with a 50x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/cop_the_lot_megaways_power_play': {
        title: 'Cop the Lot Megaways Power Play: 95% RTP | {brand}',
        description: 'Cop the Lot Megaways Power Play runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/crabbin_for_cash_extra_big_splash': {
        title: 'Crabbin For Cash Extra Big Splash: 95% RTP | {brand}',
        description: 'Crabbin For Cash Extra Big Splash runs at 95% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/crabbin_for_cash_megaways': {
        title: "Crabbin' For Cash Megaways: 95.01% RTP | {brand}",
        description: "Crabbin' For Cash Megaways runs at 95.01% RTP at {brand}, with a 50,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no."
    },
    '/p/blueprint-gaming/crabbin_for_christmas': {
        title: 'Crabbin For Christmas: 95% RTP | {brand}',
        description: 'Crabbin For Christmas runs at 95% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/diamond_mine_extra_gold': {
        title: 'Diamond Mine Extra Gold: 96% RTP, 50x Max Win | {brand}',
        description: 'Diamond Mine Extra Gold runs at 96% RTP at {brand}, with a 50x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/diamond_mine_megaways': {
        title: 'Diamond Mine Megaways: 96% RTP, 50x Max Win | {brand}',
        description: 'Diamond Mine Megaways runs at 96% RTP at {brand}, with a 50x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/divine_links': {
        title: 'Divine Links: 94% RTP, 50x Max Win | {brand}',
        description: 'Divine Links runs at 94% RTP at {brand}, with a 50x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/dragonfall': {
        title: 'Dragonfall: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Dragonfall runs at 96% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/eagle_storm': {
        title: 'Eagle Storm: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Eagle Storm runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/el_jackpotto': {
        title: 'El Jackpotto: 96% RTP, 10,000x Max Win | {brand}',
        description: 'El Jackpotto runs at 96% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/eternal_phoenix_megaways': {
        title: 'Eternal Phoenix Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Eternal Phoenix Megaways runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/eye_of_horus_megaways': {
        title: 'Eye Of Horus Megaways | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Eye Of Horus Megaways slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/blueprint-gaming/eye_of_horus_rise_of_egypt': {
        title: 'Eye Of Horus Rise Of Egypt Slot | 10,000x Win | {brand}',
        description: 'Eye Of Horus Rise Of Egypt slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/eye_of_horus_tablets_of_destiny': {
        title: 'Play Eye of Horus Tablets of Destiny Megaways | {brand}',
        description: 'Play Eye of Horus Tablets of Destiny Megaways at {brand}. High volatility, 10,000x max win. Features Expanding Wilds. 9 cryptos.'
    },
    '/p/blueprint-gaming/fat_stacks_miami_cash': {
        title: 'Fat Stacks Miami Cash: 94.52% RTP | {brand}',
        description: 'Fat Stacks Miami Cash runs at 94.52% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/fishin_frenzy_big_catch_megaways': {
        title: 'Play Fishin Frenzy Big Catch Megaways | 10,000x Max Win | ',
        description: 'Fishin Frenzy Big Catch Megaways slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more.'
    },
    '/p/blueprint-gaming/fishin_frenzy_megaways': {
        title: 'Play Fishin Frenzy Megaways Slot | 10,000x Payout | {brand}',
        description: 'Play Fishin Frenzy Megaways by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/fishin_frenzy_power_4_slots': {
        title: 'Fishin Frenzy Power 4 Slots: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Fishin Frenzy Power 4 Slots runs at 96% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/frankensteins_fortune': {
        title: "Frankenstein's Fortune: 95% RTP, 2,000x Max Win | {brand}",
        description: "Frankenstein's Fortune runs at 95% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/blueprint-gaming/fruitopolis_fortune_play': {
        title: 'Fruitopolis Fortune Play: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Fruitopolis Fortune Play runs at 96% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/full_moon_fever': {
        title: 'Full Moon Fever: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Full Moon Fever runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/funky_buddha': {
        title: 'Funky Buddha: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Funky Buddha runs at 95% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/genie_jackpot_combo_frenzy': {
        title: 'Genie Jackpot Combo Frenzy: 95% RTP, 2,000x Max Win | {brand}',
        description: 'Genie Jackpot Combo Frenzy runs at 95% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/genie_jackpots_wishmaker': {
        title: 'Genie Jackpots Wishmaker: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Genie Jackpots Wishmaker runs at 96% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/gold_strike': {
        title: 'Gold Strike: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Gold Strike runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/gold_strike_2': {
        title: 'Gold Strike 2: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Gold Strike 2 runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/gold_strike_bonanza': {
        title: 'Play Gold Strike Bonanza Slot | 10,000x Payout | {brand}',
        description: 'Play Gold Strike Bonanza by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/gold_strike_express': {
        title: 'Gold Strike Express: 95% RTP, 7,000x Max Win | {brand}',
        description: 'Gold Strike Express runs at 95% RTP at {brand}, with a 7,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/gorilla_gold_megaways_power_4_slots': {
        title: 'Gorilla Gold Megaways: Power 4 slots: 96% RTP | {brand}',
        description: 'Gorilla Gold Megaways: Power 4 slots runs at 96% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/blueprint-gaming/hope_diamond': {
        title: 'Hope Diamond Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Hope Diamond by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/jungle_fortune_build_your_bonus': {
        title: 'Jungle Fortune Build Your Bonus: 94% RTP | {brand}',
        description: 'Jungle Fortune Build Your Bonus runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/king_kong_cash': {
        title: 'King Kong Cash: 96% RTP, 50,000x Max Win | {brand}',
        description: 'King Kong Cash runs at 96% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/king_kong_cash_dj_prime8': {
        title: 'King Kong Cash DJ Prime8: 95% RTP, 10,000x Max Win | {brand}',
        description: 'King Kong Cash DJ Prime8 runs at 95% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas': {
        title: 'King Kong Cash Even Bigger Bananas: 94% RTP | {brand}',
        description: 'King Kong Cash Even Bigger Bananas runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas_2': {
        title: 'King Kong Cash Even Bigger Bananas 2: 95% RTP | {brand}',
        description: 'King Kong Cash Even Bigger Bananas 2 runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas_4': {
        title: 'King Kong Cash Even Bigger Bananas 4: 95% RTP | {brand}',
        description: 'King Kong Cash Even Bigger Bananas 4 runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/blueprint-gaming/king_kong_splash': {
        title: 'King Kong Splash: 95% RTP, 10,000x Max Win | {brand}',
        description: 'King Kong Splash runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/king_of_the_west': {
        title: 'King of the West: 96% RTP, 50,000x Max Win | {brand}',
        description: 'King of the West runs at 96% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/kong_3_even_bigger_bonus': {
        title: 'Kong 3 Even Bigger Bonus: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Kong 3 Even Bigger Bonus runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/legacy_of_gods_megaways': {
        title: 'Legacy of Gods Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Legacy of Gods Megaways runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/legacy_of_ra_megaways': {
        title: 'Legacy Of Ra Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Legacy Of Ra Megaways runs at 96% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/lion_thunder': {
        title: 'Lion Thunder: 96.47% RTP, 10,000x Max Win | {brand}',
        description: 'Lion Thunder runs at 96.47% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/loti_fortune_spins': {
        title: 'LOTI Fortune Spins: 94% RTP, 10,000x Max Win | {brand}',
        description: 'LOTI Fortune Spins runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/loti_gold_spins': {
        title: 'LOTI Gold Spins: 94% RTP, 50,000x Max Win | {brand}',
        description: 'LOTI Gold Spins runs at 94% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/lucky_pharaoh': {
        title: 'Play Lucky Pharaoh | 10,000x Win | {brand}',
        description: 'Play Lucky Pharaoh slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/blueprint-gaming/majestic_fury_megaways': {
        title: 'Majestic Fury Megaways: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Majestic Fury Megaways runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/majestic_fury_megaways_unleashed': {
        title: 'Majestic Fury Megaways Unleashed: 95% RTP | {brand}',
        description: 'Majestic Fury Megaways Unleashed runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/blueprint-gaming/majestic_fury_win_stepper': {
        title: 'Majestic Fury Win Stepper: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Majestic Fury Win Stepper runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/maradona': {
        title: 'Maradona: 94% RTP, 800x Max Win | {brand}',
        description: 'Maradona runs at 94% RTP at {brand}, with a 800x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/maradona_el_diez': {
        title: 'Maradona El Diez: 95% RTP, 50,000x Max Win | {brand}',
        description: 'Maradona El Diez runs at 95% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/maradona_el_pibe_de_oro': {
        title: 'Maradona: El Pibe De Oro: 94% RTP | {brand}',
        description: 'Maradona: El Pibe De Oro runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/midas_king_of_gold': {
        title: 'Midas King Of Gold: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Midas King Of Gold runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/napoleon_2_fat_stacks': {
        title: 'Napoleon 2 Fat Stacks: 94.28% RTP, 50,000x Max Win | {brand}',
        description: 'Napoleon 2 Fat Stacks runs at 94.28% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/napoleon_deluxe': {
        title: 'Napoleon Deluxe: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Napoleon Deluxe runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/napoleon_megaways': {
        title: 'Napoleon Megaways: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Napoleon Megaways runs at 95% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/napoleon_rise_of_an_empire': {
        title: 'Napoleon: Rise of an Empire: 96% RTP, 100,000x Max Win | {brand}',
        description: 'Napoleon: Rise of an Empire runs at 96% RTP at {brand}, with a 100,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/plenty_o_fish': {
        title: "Plenty o' Fish: 95% RTP, 10,000x Max Win | {brand}",
        description: "Plenty o' Fish runs at 95% RTP at {brand}, with a 10,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/blueprint-gaming/primal_megaways': {
        title: 'Primal Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Primal Megaways runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/red_hot_chilli': {
        title: 'Red Hot Chilli: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Red Hot Chilli runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/red_hot_eruption': {
        title: 'Red Hot Eruption: 95% RTP, 8,000x Max Win | {brand}',
        description: 'Red Hot Eruption runs at 95% RTP at {brand}, with a 8,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/return_of_kong_megaways': {
        title: 'Return of Kong Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Return of Kong Megaways runs at 96% RTP at {brand}, with a 50,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/rhino_rampage': {
        title: 'Rhino Rampage: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Rhino Rampage runs at 96% RTP at {brand}, with a 50,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/rise_of_atlantis': {
        title: 'Rise of Atlantis: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Rise of Atlantis runs at 94% RTP at {brand}, with a 10,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/rise_of_atlantis_2': {
        title: 'Rise of Atlantis 2: 94% RTP | {brand}',
        description: 'Rise of Atlantis 2 runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/safari_gold_megaways': {
        title: 'Safari Gold Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Safari Gold Megaways runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/saint_nicked_2': {
        title: 'Saint Nicked 2: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Saint Nicked 2 runs at 94% RTP at {brand}, with a 10,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/spirit_wolf_wins': {
        title: 'Spirit Wolf Wins: 95% RTP, 50,000x Max Win | {brand}',
        description: 'Spirit Wolf Wins runs at 95% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/stickermania_wild_rumble': {
        title: 'Stickermania Wild Rumble: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Stickermania Wild Rumble runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/super_7_winner': {
        title: 'Super 7 Winner: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Super 7 Winner runs at 95% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/super_wild_diamonds': {
        title: 'Super Wild Diamonds: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Super Wild Diamonds runs at 96% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/sweet_success_megaways': {
        title: 'Sweet Success Megaways: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Sweet Success Megaways runs at 96% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/tasty_trailz': {
        title: 'Tasty Trailz: 94% RTP | {brand}',
        description: 'Tasty Trailz runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/temple_of_treasures_megaways': {
        title: 'Temple of Treasures Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Temple of Treasures Megaways runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/the_goat': {
        title: 'The G.O.A.T: 94% RTP, 50,000x Max Win | {brand}',
        description: 'The G.O.A.T runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/tomb_of_dead_power_4_slots': {
        title: 'Tomb of Dead: Power 4 slots: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Tomb of Dead: Power 4 slots runs at 96% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/trailblazer': {
        title: 'Trailblazer: 95% RTP, 5,000x Max Win | {brand}',
        description: 'Trailblazer runs at 95% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/treasures_of_the_dead': {
        title: 'Treasures of the Dead: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Treasures of the Dead runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/valletta_megaways': {
        title: 'Valletta Megaways: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Valletta Megaways runs at 96% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/viking_fall': {
        title: 'Viking Fall: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Viking Fall runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/vikings_unleashed_megaways': {
        title: 'Vikings Unleashed Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Vikings Unleashed Megaways runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/vikings_unleashed_reloaded_megaways': {
        title: 'Vikings Unleashed Reloaded Megaways: 96% RTP | {brand}',
        description: 'Vikings Unleashed Reloaded Megaways runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/way_of_the_tiger': {
        title: 'Way Of The Tiger | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Way Of The Tiger by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/blueprint-gaming/wish_upon_a_cashpot': {
        title: 'Wish Upon a Cashpot: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Wish Upon a Cashpot runs at 96% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/wish_upon_a_jackpot': {
        title: 'Wish Upon a Jackpot: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Wish Upon a Jackpot runs at 96% RTP at {brand}, with a 10,000x max win and medium/high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/wish_upon_a_jackpot_megaways': {
        title: 'Wish Upon a Jackpot Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Wish Upon a Jackpot Megaways runs at 96% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/wolf_legend_megaways': {
        title: 'Wolf Legend Megaways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Wolf Legend Megaways runs at 96% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/blueprint-gaming/wolf_legend_spinboost': {
        title: 'Wolf Legend Spinboost: 95% RTP, 10,000x Max Win | {brand}',
        description: 'Wolf Legend Spinboost runs at 95% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/64_gold_coins_hold_and_win': {
        title: '64 Gold Coins Hold and Win : 95.9% RTP | {brand}',
        description: '64 Gold Coins Hold and Win  runs at 95.9% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/64_gold_coins_hold_and_win_20000': {
        title: '64 Gold Coins Hold and Win 20000: 96% RTP | {brand}',
        description: '64 Gold Coins Hold and Win 20000 runs at 96% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/boominggames/arabian_spins': {
        title: 'Arabian Spins: 96% RTP | {brand}',
        description: 'Arabian Spins runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/bamboo_wilds': {
        title: 'Bamboo Wilds: 95.6% RTP, 7,000x Max Win | {brand}',
        description: 'Bamboo Wilds runs at 95.6% RTP at {brand}, with a 7,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/bang_bang': {
        title: 'Bang Bang: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Bang Bang runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/bang_bang_reloaded': {
        title: 'Bang Bang Reloaded: 95.7% RTP, 5,200x Max Win | {brand}',
        description: 'Bang Bang Reloaded runs at 95.7% RTP at {brand}, with a 5,200x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/big_apple_wins': {
        title: 'Big Apple Wins: 96% RTP, 1,200x Max Win | {brand}',
        description: 'Big Apple Wins runs at 96% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/blockchain_megaways': {
        title: 'Blockchain MEGAWAYS: 96.5% RTP, 40,320x Max Win | {brand}',
        description: 'Blockchain MEGAWAYS runs at 96.5% RTP at {brand}, with a 40,320x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/bonza_bucks_hold_and_win_extreme_10000': {
        title: 'Bonza Bucks Hold and Win Extreme 10000: 94% RTP | {brand}',
        description: 'Bonza Bucks Hold and Win Extreme 10000 runs at 94% RTP at {brand}, with a 12,000x max win and medium volatility. Crypto deposits, instant withdrawals,.'
    },
    '/p/boominggames/boogie_boom': {
        title: 'Boogie Boom: 95.7% RTP, 4,000x Max Win | {brand}',
        description: 'Boogie Boom runs at 95.7% RTP at {brand}, with a 4,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/book_of_tombs': {
        title: 'Book of Tombs: 95.4% RTP, 1,200x Max Win | {brand}',
        description: 'Book of Tombs runs at 95.4% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/booming_seven_deluxe': {
        title: 'Booming Seven Deluxe: 96.55% RTP, 1,200x Max Win | {brand}',
        description: 'Booming Seven Deluxe runs at 96.55% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/booming_seven_deluxe_legacy': {
        title: 'Booming Seven Deluxe Legacy: 94% RTP, 304x Max Win | {brand}',
        description: 'Booming Seven Deluxe Legacy runs at 94% RTP at {brand}, with a 304x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/buffalo_hold_and_win': {
        title: 'Buffalo Hold and Win: 95.9% RTP, 1,200x Max Win | {brand}',
        description: 'Buffalo Hold and Win runs at 95.9% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/buffalo_hold_and_win_extreme': {
        title: 'Buffalo Hold and Win Extreme: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Buffalo Hold and Win Extreme runs at 94% RTP at {brand}, with a 4,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/buffalo_hold_and_win_extreme_10000': {
        title: 'Buffalo Hold and Win Extreme 10000: 94% RTP | {brand}',
        description: 'Buffalo Hold and Win Extreme 10000 runs at 94% RTP at {brand}, with a 12,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/boominggames/burning_classic_2': {
        title: 'Burning Classic 2: 94% RTP, 5,100x Max Win | {brand}',
        description: 'Burning Classic 2 runs at 94% RTP at {brand}, with a 5,100x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/burning_classics': {
        title: 'Burning Classics: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Burning Classics runs at 94% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/burning_classics_5000': {
        title: 'Burning Classics 5000: 94% RTP, 5,100x Max Win | {brand}',
        description: 'Burning Classics 5000 runs at 94% RTP at {brand}, with a 5,100x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/burning_classics_royal_edition': {
        title: 'Burning Classics Royal Edition: 96.1% RTP | {brand}',
        description: 'Burning Classics Royal Edition runs at 96.1% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, no fees.'
    },
    '/p/boominggames/burning_love': {
        title: 'Burning Love: 94% RTP, 10,645x Max Win | {brand}',
        description: 'Burning Love runs at 94% RTP at {brand}, with a 10,645x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/cash_pig': {
        title: 'Cash Pig: 95.1% RTP | {brand}',
        description: 'Cash Pig runs at 95.1% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/cash_pig_2': {
        title: 'Cash Pig 2: 94% RTP, 8,000x Max Win | {brand}',
        description: 'Cash Pig 2 runs at 94% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/cash_pig_2_15000': {
        title: 'Cash Pig 2 15000: 95.8% RTP, 15,000x Max Win | {brand}',
        description: 'Cash Pig 2 15000 runs at 95.8% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/chief_hawks_spirit_walk': {
        title: "Chief Hawk's Spirit Walk: 94% RTP, 5,000x Max Win | {brand}",
        description: "Chief Hawk's Spirit Walk runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/classic_coins': {
        title: 'Classic Coins: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Classic Coins runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/classic_fantastic': {
        title: 'Classic Fantastic: 97% RTP, 7,063x Max Win | {brand}',
        description: 'Classic Fantastic runs at 97% RTP at {brand}, with a 7,063x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/coin_crusher_hold_and_win': {
        title: 'Coin Crusher Hold and Win: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Coin Crusher Hold and Win runs at 94% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/crack_the_bank_hold_and_win': {
        title: 'Crack the Bank Hold and Win: 95.7% RTP, 1,200x Max Win | {brand}',
        description: 'Crack the Bank Hold and Win runs at 95.7% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/diamond_hits': {
        title: 'Diamond Hits: 94% RTP, 2,150x Max Win | {brand}',
        description: 'Diamond Hits runs at 94% RTP at {brand}, with a 2,150x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/diamond_hits_trio_instastrike': {
        title: 'Diamond Hits Trio Instastrike: 95.7% RTP | {brand}',
        description: 'Diamond Hits Trio Instastrike runs at 95.7% RTP at {brand}, with a 12,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/diamond_riches': {
        title: 'Diamond Riches: 95.5% RTP, 1,200x Max Win | {brand}',
        description: 'Diamond Riches runs at 95.5% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/diamonds_diamonds_diamonds_hold_and_win': {
        title: 'Diamonds Diamonds Diamonds Hold and Win: 95.7% RTP | {brand}',
        description: 'Diamonds Diamonds Diamonds Hold and Win runs at 95.7% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals,.'
    },
    '/p/boominggames/diamonds_of_liberty': {
        title: 'Diamonds of Liberty: 94% RTP, 2,150x Max Win | {brand}',
        description: 'Diamonds of Liberty runs at 94% RTP at {brand}, with a 2,150x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/dynamite_trio': {
        title: 'Dynamite Trio: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Dynamite Trio runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/easter_classics': {
        title: 'Easter Classics: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Easter Classics runs at 94% RTP at {brand}, with a 2,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/fish_tales_colossal_catch_link_and_loot': {
        title: 'Fish Tales Colossal Catch Link and Loot: 96% RTP | {brand}',
        description: 'Fish Tales Colossal Catch Link and Loot runs at 96% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals,.'
    },
    '/p/boominggames/fish_tales_double_catch': {
        title: 'Fish Tales Double Catch: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Fish Tales Double Catch runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/fish_tales_halloween': {
        title: 'Fish Tales Halloween: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Fish Tales Halloween runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/fish_tales_monster_bass': {
        title: 'Fish Tales Monster Bass: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Fish Tales Monster Bass runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/flaming_chilies': {
        title: 'Flaming Chilies | 1,200x Max Win Crypto Slot | {brand}',
        description: 'Play Flaming Chilies slot for real money at {brand}. 1,200x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/boominggames/flaming_chillies': {
        title: 'Flaming Chillies: 95.5% RTP | {brand}',
        description: 'Flaming Chillies runs at 95.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/forbidden_temple_power_hit': {
        title: 'Forbidden Temple Power Hit: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Forbidden Temple Power Hit runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/fortune_and_finery': {
        title: 'Fortune & Finery: 95.1% RTP, 8,000x Max Win | {brand}',
        description: 'Fortune & Finery runs at 95.1% RTP at {brand}, with a 8,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/fruit_heaven_hold_and_win': {
        title: 'Fruit Heaven Hold and Win: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Fruit Heaven Hold and Win runs at 96% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/gamblelicious_hold_and_win': {
        title: 'Gamblelicious Hold and Win: 95.9% RTP, 1,200x Max Win | {brand}',
        description: 'Gamblelicious Hold and Win runs at 95.9% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/gold_gold_gold': {
        title: 'Gold Gold Gold: 96% RTP | {brand}',
        description: 'Gold Gold Gold runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/gold_gold_gold_5000': {
        title: 'Gold Gold Gold 5000: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Gold Gold Gold 5000 runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/gold_gold_gold_hold_and_win': {
        title: 'Gold Gold Gold Hold and Win: 95.6% RTP, 2,000x Max Win | {brand}',
        description: 'Gold Gold Gold Hold and Win runs at 95.6% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/greedy_for_gold_power_hit': {
        title: 'Greedy for Gold Power Hit: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Greedy for Gold Power Hit runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/greek_legends': {
        title: 'Greek Legends: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Greek Legends runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/holly_jolly_bonanza': {
        title: 'Holly Jolly Bonanza: 96.6% RTP, 6,500x Max Win | {brand}',
        description: 'Holly Jolly Bonanza runs at 96.6% RTP at {brand}, with a 6,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/holly_jolly_bonanza_2': {
        title: 'Holly Jolly Bonanza 2: 94% RTP, 6,500x Max Win | {brand}',
        description: 'Holly Jolly Bonanza 2 runs at 94% RTP at {brand}, with a 6,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/holly_jolly_cash_pig': {
        title: 'Holly Jolly Cash Pig: 94% RTP, 8,000x Max Win | {brand}',
        description: 'Holly Jolly Cash Pig runs at 94% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/hot_charge': {
        title: 'Hot Charge: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Hot Charge runs at 94% RTP at {brand}, with a 4,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/howling_for_gold': {
        title: 'Howling for Gold: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Howling for Gold runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/howling_wolves_megaways': {
        title: 'Howling Wolves MEGAWAYS: 96% RTP, 1,200x Max Win | {brand}',
        description: 'Howling Wolves MEGAWAYS runs at 96% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/inferno_fortune_power_hit': {
        title: 'Inferno Fortune Power Hit: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Inferno Fortune Power Hit runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/jam_bonanza': {
        title: 'Jam Bonanza: 96.6% RTP, 5,000x Max Win | {brand}',
        description: 'Jam Bonanza runs at 96.6% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/jesters_bells_bonanza': {
        title: "Jester's Bells Bonanza: 94% RTP, 5,000x Max Win | {brand}",
        description: "Jester's Bells Bonanza runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/jesters_riches': {
        title: "Jester's Riches: 95.5% RTP, 2,000x Max Win | {brand}",
        description: "Jester's Riches runs at 95.5% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/king_cobra': {
        title: 'King Cobra: 95.6% RTP, 6,500x Max Win | {brand}',
        description: 'King Cobra runs at 95.6% RTP at {brand}, with a 6,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/legendary_diamonds': {
        title: 'Legendary Diamonds: 95.6% RTP, 1,200x Max Win | {brand}',
        description: 'Legendary Diamonds runs at 95.6% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/let_it_spin': {
        title: 'Let it Spin: 95.2% RTP, 2,000x Max Win | {brand}',
        description: 'Let it Spin runs at 95.2% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/liberty_and_freedom_hold_and_win_extreme_10000': {
        title: 'Liberty and Freedom Hold and Win Extre: 94% RTP | {brand}',
        description: 'Liberty and Freedom Hold and Win Extreme 10000 runs at 94% RTP at {brand}, with a 12,000x max win and medium volatility. Crypto deposits, instant.'
    },
    '/p/boominggames/lucky_charms_trio': {
        title: 'Lucky Charms Trio: 95.4% RTP, 5,000x Max Win | {brand}',
        description: 'Lucky Charms Trio runs at 95.4% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/lucky_oasis': {
        title: 'Lucky Oasis: 95.9% RTP, 5,000x Max Win | {brand}',
        description: 'Lucky Oasis runs at 95.9% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/mighty_gorilla': {
        title: 'Mighty Gorilla: 95.2% RTP, 2,000x Max Win | {brand}',
        description: 'Mighty Gorilla runs at 95.2% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/mr_oinksters_hold_and_win': {
        title: 'Mr. Oinksters Hold and Win: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Mr. Oinksters Hold and Win runs at 94% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/paris_nights': {
        title: 'Paris Nights: 96% RTP, 1,200x Max Win | {brand}',
        description: 'Paris Nights runs at 96% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/payday_pig': {
        title: 'Payday Pig: 95.6% RTP, 1,500x Max Win | {brand}',
        description: 'Payday Pig runs at 95.6% RTP at {brand}, with a 1,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/power_of_atlantis_trio': {
        title: 'Power of Atlantis Trio: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Power of Atlantis Trio runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/power_of_hercules_bonanza': {
        title: 'Power of Hercules Bonanza: 95.9% RTP, 5,000x Max Win | {brand}',
        description: 'Power of Hercules Bonanza runs at 95.9% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/power_of_olympus': {
        title: 'Power of Olympus: 95.6% RTP, 8,066x Max Win | {brand}',
        description: 'Power of Olympus runs at 95.6% RTP at {brand}, with a 8,066x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/power_of_rome': {
        title: 'Power of Rome: 95.6% RTP, 2,500x Max Win | {brand}',
        description: 'Power of Rome runs at 95.6% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/ras_relics_bonanza': {
        title: "Ra's Relics Bonanza: 94% RTP, 6,500x Max Win | {brand}",
        description: "Ra's Relics Bonanza runs at 94% RTP at {brand}, with a 6,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/reels_paradise': {
        title: 'Reels Paradise: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Reels Paradise runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/rhino_hold_and_win': {
        title: 'Rhino Hold and Win: 95.9% RTP, 1,200x Max Win | {brand}',
        description: 'Rhino Hold and Win runs at 95.9% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/roll_the_dice': {
        title: 'Roll the Dice: 96.2% RTP, 1,200x Max Win | {brand}',
        description: 'Roll the Dice runs at 96.2% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/ronaldinho_scores_shoot_and_win': {
        title: 'Ronaldinho Scores  Shoot & Win: 96.1% RTP | {brand}',
        description: 'Ronaldinho Scores  Shoot & Win runs at 96.1% RTP at {brand}, with a 4,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/ronaldinho_spins': {
        title: 'Ronaldinho Spins: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Ronaldinho Spins runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/royal_wins': {
        title: 'Royal Wins: 96% RTP | {brand}',
        description: 'Royal Wins runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/santa_in_vegas': {
        title: 'Santa in Vegas: 94% RTP, 8,000x Max Win | {brand}',
        description: 'Santa in Vegas runs at 94% RTP at {brand}, with a 8,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/santas_snowball_smash_instant_win': {
        title: 'Santas Snowball Smash Instant Win: 96.1% RTP | {brand}',
        description: 'Santas Snowball Smash Instant Win runs at 96.1% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/secret_book_of_amun_ra': {
        title: 'Secret Book of Amun Ra: 95.4% RTP, 10,000x Max Win | {brand}',
        description: 'Secret Book of Amun Ra runs at 95.4% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/shields_of_gold_valkyrie_hold_and_win': {
        title: 'Shields of Gold Valkyrie Hold and Win: 94% RTP | {brand}',
        description: 'Shields of Gold Valkyrie Hold and Win runs at 94% RTP at {brand}, with a 2,200x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/boominggames/smoking_pistols': {
        title: 'Smoking Pistols: 95.6% RTP, 5,000x Max Win | {brand}',
        description: 'Smoking Pistols runs at 95.6% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/space_cows_to_the_moon': {
        title: "Space Cows to the Moo'n: 95.6% RTP, 5,000x Max Win | {brand}",
        description: "Space Cows to the Moo'n runs at 95.6% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/space_sam_walk_and_win': {
        title: 'Space Sam Walk and Win: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Space Sam Walk and Win runs at 94% RTP at {brand}, with a 7,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/spooktacular_bonanza': {
        title: 'Spooktacular Bonanza: 94% RTP, 6,500x Max Win | {brand}',
        description: 'Spooktacular Bonanza runs at 94% RTP at {brand}, with a 6,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/stampede_bonanza': {
        title: 'Stampede Bonanza: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Stampede Bonanza runs at 94% RTP at {brand}, with a 7,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/super_duper': {
        title: 'Super Duper: 97% RTP, 0x Max Win | {brand}',
        description: 'Super Duper runs at 97% RTP at {brand}, with a 0x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/tasty_bonanza': {
        title: 'Tasty Bonanza: 94% RTP, 6,500x Max Win | {brand}',
        description: 'Tasty Bonanza runs at 94% RTP at {brand}, with a 6,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/tasty_bonanza_1000': {
        title: 'Tasty Bonanza 1,000: 95.9% RTP, 10,000x Max Win | {brand}',
        description: 'Tasty Bonanza 1,000 runs at 95.9% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/the_chillies': {
        title: 'The Chillies: 94% RTP, 4,000x Max Win | {brand}',
        description: 'The Chillies runs at 94% RTP at {brand}, with a 4,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/the_mighty_toro': {
        title: 'The Mighty Toro: 95.6% RTP, 6,500x Max Win | {brand}',
        description: 'The Mighty Toro runs at 95.6% RTP at {brand}, with a 6,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/the_wild_wings_of_phoenix': {
        title: 'The Wild Wings of Phoenix: 95.4% RTP, 1,200x Max Win | {brand}',
        description: 'The Wild Wings of Phoenix runs at 95.4% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/the_wild_wings_of_phoenix_deluxe': {
        title: 'The Wild Wings of Phoenix Deluxe: 94% RTP | {brand}',
        description: 'The Wild Wings of Phoenix Deluxe runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/thunder_eagle_hold_and_win_10000': {
        title: 'Thunder Eagle Hold and Win 10000: 94% RTP | {brand}',
        description: 'Thunder Eagle Hold and Win 10000 runs at 94% RTP at {brand}, with a 12,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/boominggames/tnt_bonanza': {
        title: 'TNT Bonanza: 96.6% RTP, 2,000x Max Win | {brand}',
        description: 'TNT Bonanza runs at 96.6% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/tnt_bonanza_2': {
        title: 'TNT Bonanza 2: 94% RTP, 6,500x Max Win | {brand}',
        description: 'TNT Bonanza 2 runs at 94% RTP at {brand}, with a 6,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/treasure_vault': {
        title: 'Treasure Vault: 95.1% RTP, 1,200x Max Win | {brand}',
        description: 'Treasure Vault runs at 95.1% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/trollfufu_bonanza': {
        title: 'Trollfufu Bonanza: 96.1% RTP, 6,500x Max Win | {brand}',
        description: 'Trollfufu Bonanza runs at 96.1% RTP at {brand}, with a 6,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/ultimate_hold_n_win': {
        title: "Ultimate Hold 'N' Win: 94% RTP, 5,000x Max Win | {brand}",
        description: "Ultimate Hold 'N' Win runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/boominggames/vegas_wins': {
        title: 'Vegas Wins: 96% RTP, 1,200x Max Win | {brand}',
        description: 'Vegas Wins runs at 96% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/vip_filthy_riches': {
        title: 'VIP Filthy Riches: 96% RTP | {brand}',
        description: 'VIP Filthy Riches runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/wild_diamond_7x': {
        title: 'Wild Diamond 7x: 96.7% RTP, 1,200x Max Win | {brand}',
        description: 'Wild Diamond 7x runs at 96.7% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/boominggames/wild_wild_vegas': {
        title: 'Wild Wild Vegas: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Wild Wild Vegas runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/alice_in_adventureland': {
        title: 'Alice in Adventureland: 94% RTP, 10,006x Max Win | {brand}',
        description: 'Alice in Adventureland runs at 94% RTP at {brand}, with a 10,006x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/animal_carnival': {
        title: 'Animal Carnival: 96% RTP, 1,642x Max Win | {brand}',
        description: 'Animal Carnival runs at 96% RTP at {brand}, with a 1,642x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/bounty_showdown': {
        title: 'Bounty Showdown: 94% RTP, 4,761x Max Win | {brand}',
        description: 'Bounty Showdown runs at 94% RTP at {brand}, with a 4,761x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/caravan_of_riches': {
        title: 'Caravan of Riches: 96% RTP, 1,312x Max Win | {brand}',
        description: 'Caravan of Riches runs at 96% RTP at {brand}, with a 1,312x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/circle_of_sylvan': {
        title: 'Circle of Sylvan: 96.38% RTP, 5,000x Max Win | {brand}',
        description: 'Circle of Sylvan runs at 96.38% RTP at {brand}, with a 5,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/desert_shark': {
        title: 'Desert Shark: 96% RTP, 16,794x Max Win | {brand}',
        description: 'Desert Shark runs at 96% RTP at {brand}, with a 16,794x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/elemento': {
        title: 'Elemento: 96% RTP, 17,955x Max Win | {brand}',
        description: 'Elemento runs at 96% RTP at {brand}, with a 17,955x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/flower_fortunes_supreme': {
        title: 'Flower Fortunes Supreme: 96% RTP, 7,075x Max Win | {brand}',
        description: 'Flower Fortunes Supreme runs at 96% RTP at {brand}, with a 7,075x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/fortune_llama': {
        title: 'Fortune Llama: 96% RTP, 7,075x Max Win | {brand}',
        description: 'Fortune Llama runs at 96% RTP at {brand}, with a 7,075x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/golden_castle_titanways': {
        title: 'Golden Castle TitanWays: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Golden Castle TitanWays runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/hades_river_of_souls': {
        title: 'Hades: 94% RTP, 5,013x Max Win | {brand}',
        description: 'Hades: River of Souls runs at 94% RTP at {brand}, with a 5,013x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/heroes_hunt_2': {
        title: 'Heroes Hunt 2: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Heroes Hunt 2 runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/heroes_hunt_megaways': {
        title: 'Heroes Hunt MegaWays: 96% RTP, 36,274x Max Win | {brand}',
        description: 'Heroes Hunt MegaWays runs at 96% RTP at {brand}, with a 36,274x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/magikspell': {
        title: 'Magikspell: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Magikspell runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/maze_escape_megaways': {
        title: 'Maze Escape MegaWays: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Maze Escape MegaWays runs at 96% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/medallion_megaways': {
        title: 'Medallion MegaWays: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Medallion MegaWays runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/mystic_spells': {
        title: 'Mystic Spells: 96.01% RTP, 10,000x Max Win | {brand}',
        description: 'Mystic Spells runs at 96.01% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/pirate_multi_coins': {
        title: 'Pirate Multi Coins: 96.08% RTP, 4,999x Max Win | {brand}',
        description: 'Pirate Multi Coins runs at 96.08% RTP at {brand}, with a 4,999x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/rich_raptors': {
        title: 'Rich Raptors: 96% RTP, 8,024x Max Win | {brand}',
        description: 'Rich Raptors runs at 96% RTP at {brand}, with a 8,024x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/safari_sun': {
        title: 'Safari Sun: 96% RTP, 18,792x Max Win | {brand}',
        description: 'Safari Sun runs at 96% RTP at {brand}, with a 18,792x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/serpent_shrine': {
        title: 'Serpent Shrine: 96% RTP, 10,013x Max Win | {brand}',
        description: 'Serpent Shrine runs at 96% RTP at {brand}, with a 10,013x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/shadow_summoner_elementals': {
        title: 'Shadow Summoner Elementals: 96.31% RTP, 5,610x Max Win | {brand}',
        description: 'Shadow Summoner Elementals runs at 96.31% RTP at {brand}, with a 5,610x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/twisted_turbine': {
        title: 'Twisted Turbine: 96% RTP, 9,616x Max Win | {brand}',
        description: 'Twisted Turbine runs at 96% RTP at {brand}, with a 9,616x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/wins_of_mermaid_multi_power': {
        title: 'Wins of Mermaid Multi Power: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Wins of Mermaid Multi Power runs at 96% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/fantasma/wins_of_winter': {
        title: 'Wins of Winter: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Wins of Winter runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/nolimit-city/apocalypse_super_xnudge': {
        title: 'Play Apocalypse Slot | 20,000x Payout | {brand}',
        description: 'Spin Apocalypse with Bitcoin at {brand}. 20,000x max win, high volatility, xNudge Wild. Instant payouts, zero platform fees.'
    },
    '/p/nolimit-city/bangkok_hilton': {
        title: 'Bangkok Hilton | 44,444x Max Win Crypto Slot | {brand}',
        description: 'Bangkok Hilton at {brand} crypto casino. 44,444x max win with xWays. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/barbarian_fury': {
        title: 'Play Barbarian Fury Slot | 10,000x Payout | {brand}',
        description: 'Play Barbarian Fury by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/beheaded': {
        title: 'Play Beheaded | 15,950x Max Win | {brand}',
        description: 'Beheaded slot at {brand} crypto casino. High volatility, 15,950x max win with Cut Reel. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/benji_killed_in_vegas': {
        title: 'Benji Killed in Vegas Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Benji Killed in Vegas by Nolimit City at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/bizarre': {
        title: 'Play Bizarre Slot | 20,000x Payout | {brand}',
        description: 'Spin Bizarre with Bitcoin at {brand}. 20,000x max win, high volatility, xSplit. Instant payouts, zero platform fees.'
    },
    '/p/nolimit-city/blood_and_shadow': {
        title: 'Blood & Shadow Slot | 6,666x Win | Play with Bitcoin',
        description: 'Blood & Shadow by Nolimit City. Medium volatility slot with 6,666x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/blood_and_shadow_2': {
        title: 'Blood and Shadow 2 | 16,161x Max Win Crypto Slot | {brand}',
        description: 'Blood and Shadow 2 at {brand} crypto casino. 16,161x max win with Reel Area. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/blood_diamond': {
        title: 'Play Blood Diamond Slot | 14,780x Payout | {brand}',
        description: 'Play Blood Diamond by Nolimit City at {brand}. High volatility, 14,780x max win, Stacked Symbols. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/bonus_bunnies': {
        title: 'Play Bonus Bunnies | 6,925x Win | {brand}',
        description: 'Bonus Bunnies at {brand}. Medium volatility, 6,925x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/book_of_shadows': {
        title: 'Book Of Shadows Slot | 30,338x Win | Play with Bitcoin',
        description: 'Book Of Shadows slot with 30,338x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/bounty_hunters': {
        title: 'Play Bounty Hunters Slot | 10,000x Payout | {brand}',
        description: 'Bounty Hunters slot with 10,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/breakout': {
        title: 'Play Breakout Slot | 20,000x Payout | {brand}',
        description: 'Breakout by Nolimit City. Medium volatility slot with 20,000x max win and Syndicate Multiplier. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/nolimit-city/brick_snake_2000': {
        title: 'Brick Snake 2000 Slot | 10,000x Max Win | {brand}',
        description: 'Spin Brick Snake 2000 with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/brute_force': {
        title: 'Play Brute Force | 40,000x Max Win | {brand}',
        description: 'Brute Force at {brand} crypto casino. 40,000x max win with xNudge Wilds. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/brute_force_alien_onslaught': {
        title: 'Play Brute Force: Alien Onslaught | 80,000x Max Win | {brand}',
        description: 'Brute Force: Alien Onslaught slot at {brand} crypto casino. High volatility, 80,000x max win with xNudge. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/buffalo_hunter': {
        title: 'Buffalo Hunter Slot | Win Up to 12,647x | {brand}',
        description: 'Deposit Bitcoin and play Buffalo Hunter at {brand}. 12,647x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/bushido_way_xnudge': {
        title: 'Bushido Way xNudge Slot | Win Up to 30,000x | {brand}',
        description: 'Play Bushido Way xNudge slot for real money at {brand}. 30,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/casino_win_spin': {
        title: 'Play Casino Win Spin Slot | 2,000x Payout | {brand}',
        description: 'Play Casino Win Spin by Nolimit City at {brand}. Medium volatility, 2,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/catfish_hunters': {
        title: 'Play Catfish Hunters | 20,000x Max Win | {brand}',
        description: 'Play Catfish Hunters at {brand}. High volatility, 20,000x max win. Features xWays. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/coins_of_fortune': {
        title: 'Coins of Fortune | 2,700x Max Win Crypto Slot | {brand}',
        description: 'Play Coins of Fortune at {brand} crypto casino. Medium volatility, 2,700x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/crazy_ex_girlfriend': {
        title: 'Crazy Ex Girlfriend Slot | Win Up to 9,999x | {brand}',
        description: 'Crazy Ex Girlfriend slot at {brand} crypto casino. High volatility, 9,999x max win with xSplit. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/d_day': {
        title: 'D Day Slot | 10,000x Win | Play with Bitcoin',
        description: 'D Day by Nolimit City. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/das_xboot': {
        title: 'Das XBoot 2 Slot | 59,999x Win | Play with Bitcoin',
        description: 'Play Das XBoot 2 by Nolimit City at {brand}. High volatility, 59,999x max win, xBomb. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/dead_canary': {
        title: 'Dead Canary Slot | 65,000x Max Win | {brand}',
        description: 'Dead Canary slot with 65,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/dead_dead_or_deader': {
        title: 'Dead Dead or Deader | 19,349x Max Win Bitcoin Slot | {brand}',
        description: 'Play Dead Dead or Deader by Nolimit City at {brand}. High volatility, 19,349x max win, Wild. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/dead_men_walking': {
        title: 'Dead Men Walking Slot | 25,313x Win | Play with Bitcoin',
        description: 'Dead Men Walking by Nolimit City. High volatility slot with 25,313x max win and xNudge. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/nolimit-city/deadwood_rip': {
        title: 'Deadwood RIP Slot | 100,000x Max Win | {brand}',
        description: 'Play Deadwood RIP by Nolimit City. 100,000x max win, Fifth Reel, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/deadwood_xnudge': {
        title: 'Deadwood xNudge Slot | 13,950x Win | Play with Bitcoin',
        description: 'Spin Deadwood xNudge with Bitcoin at {brand}. 13,950x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/devils_crossroad': {
        title: 'Play Devils Crossroad | 10,000x Win | {brand}',
        description: 'Devils Crossroad at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/disorder': {
        title: 'Disorder Slot | Win Up to 23,500x | {brand}',
        description: 'Disorder at {brand} crypto casino. 23,500x max win with XBomb. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/disturbed': {
        title: 'Disturbed Slot | Win Up to 10,000x | {brand}',
        description: 'Play Disturbed slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/dj_psycho': {
        title: 'Dj Psycho | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Dj Psycho slot with 10,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/dragon_tribe': {
        title: 'Play Dragon Tribe | 27,000x Max Win | {brand}',
        description: 'Play Dragon Tribe slot for real money at {brand}. 27,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/duck_hunters': {
        title: 'Duck Hunters Happy Hour Slot | 33,333x Win | {brand}',
        description: 'Duck Hunters Happy Hour slot with 33,333x max win and xWays. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/nolimit-city/dungeon_quest': {
        title: 'Dungeon Quest | 450x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Dungeon Quest with Bitcoin at {brand}. 450x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/east_coast_vs_west_coast': {
        title: 'East Coast Vs West Coast | 30,618x Max Win Bitcoin Slot | ',
        description: 'East Coast Vs West Coast by Nolimit City. Medium volatility slot with 30,618x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/el_paso_gunfight_xnudge': {
        title: 'El Paso Gunfight xNudge Slot | Win Up to 44,440x | {brand}',
        description: 'El Paso Gunfight xNudge slot at {brand} crypto casino. Medium volatility with 44,440x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/evil_goblins_xbomb': {
        title: 'Play Evil Goblins Xbomb | 10,000x Win | {brand}',
        description: 'Evil Goblins Xbomb at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/fire_in_the_hole_2': {
        title: 'Play Fire In The Hole 2 | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Fire In The Hole 2 at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/fire_in_the_hole_3': {
        title: 'Fire in the Hole 3 Slot | 70,000x Max Win | {brand}',
        description: 'Fire in the Hole 3 slot with 70,000x max win and Collapsing Mine. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/nolimit-city/fire_in_the_hole_xbomb': {
        title: 'Play Fire In The Hole xBomb | 60,000x Win | {brand}',
        description: 'Fire In The Hole xBomb at {brand}. Medium volatility, 60,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/flight_mode': {
        title: 'Play Flight Mode | 5,051x Win | {brand}',
        description: 'Play Flight Mode at {brand}. High volatility, 5,051x max win. Features xGod. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/folsom_prison': {
        title: 'Play Folsom Prison | 75,000x Win | {brand}',
        description: 'Folsom Prison slot at {brand} crypto casino. Medium volatility with 75,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/fruits': {
        title: 'Play Fruits Slot | 2,910x Payout | {brand}',
        description: 'Play Fruits by Nolimit City. Medium volatility, 2,910x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/gaelic_gold': {
        title: 'Play Gaelic Gold | 9,837x Win | {brand}',
        description: 'Gaelic Gold at {brand}. Medium volatility, 9,837x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/gluttony': {
        title: 'Play Gluttony | 10,000x Win | {brand}',
        description: 'Gluttony slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/golden_genie_and_the_walking_wilds': {
        title: 'Play Golden Genie And The Walking Wilds | 9,583x Win | {brand}',
        description: 'Play Golden Genie And The Walking Wilds slot for real money at {brand}. 9,583x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/golden_shower': {
        title: 'Golden Shower Slot | Win Up to 19,999x | {brand}',
        description: 'Golden Shower at {brand} crypto casino. 19,999x max win with Drain. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/harlequin_carnival': {
        title: 'Harlequin Carnival | 5,861x Max Win Crypto Slot | {brand}',
        description: 'Play Harlequin Carnival slot for real money at {brand}. 5,861x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/highway_to_hell': {
        title: 'Play Highway to Hell Slot | 20,066x Payout | {brand}',
        description: 'Play Highway to Hell by Nolimit City at {brand}. High volatility, 20,066x max win, xBet. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/home_of_the_brave': {
        title: 'Play Home of the Brave | 61,446x Max Win | {brand}',
        description: 'Deposit BTC and play Home of the Brave at {brand}. 61,446x max win, high volatility, Hot Sauce Reels. 9 cryptos, zero fees.'
    },
    '/p/nolimit-city/hot_4_cash': {
        title: 'Hot 4 Cash Slot | Win Up to 2,400x | {brand}',
        description: 'Hot 4 Cash at {brand}. Medium volatility, 2,400x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/hot_nudge': {
        title: 'Hot Nudge Slot | 10,000x Win | Play with Bitcoin',
        description: 'Hot Nudge by Nolimit City. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/ice_ice_yeti': {
        title: 'Ice Ice Yeti | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Ice Ice Yeti by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/immortal_fruits': {
        title: 'Immortal Fruits Slot | 2,787x Max Win | {brand}',
        description: 'Play Immortal Fruits by Nolimit City. Medium volatility, 2,787x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/infectious_5_xways': {
        title: 'Play Infectious 5 xWays | 55,555x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Infectious 5 xWays at {brand}. 55,555x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/jingle_balls': {
        title: 'Jingle Balls | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Jingle Balls at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/karen_maneater': {
        title: 'Karen Maneater Slot | 11,757x Win | Play with Bitcoin',
        description: 'Karen Maneater slot with 11,757x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/kenneth_must_die': {
        title: 'Play Kenneth Must Die | 10,000x Win | {brand}',
        description: 'Play Kenneth Must Die slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/kill_em_all': {
        title: 'Kill Em All Slot | 11,916x Max Win | {brand}',
        description: 'Spin Kill Em All with Bitcoin at {brand}. 11,916x max win, high volatility, Hack and Slash. Instant payouts, zero platform fees.'
    },
    '/p/nolimit-city/kiss_my_chainsaw': {
        title: 'Play Kiss My Chainsaw | 10,000x Max Win | {brand}',
        description: 'Play Kiss My Chainsaw slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/kitchen_drama_bbq_frenzy': {
        title: 'Kitchen Drama Bbq Frenzy | 10,000x Max Win Bitcoin Slot | ',
        description: 'Play Kitchen Drama Bbq Frenzy by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/kitchen_drama_sushi_mania': {
        title: 'Play Kitchen Drama Sushi Mania | 10,000x Win | {brand}',
        description: 'Play Kitchen Drama Sushi Mania at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/land_of_the_free': {
        title: 'Land Of The Free Slot | Win Up to 10,000x | {brand}',
        description: 'Play Land Of The Free slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/legion_x': {
        title: 'Legion X Slot | 31,000x Max Win | {brand}',
        description: 'Legion X slot with 31,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/little_bighorn': {
        title: 'Play Little Bighorn | 25,676x Win | {brand}',
        description: 'Little Bighorn at {brand}. Medium volatility, 25,676x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/loner': {
        title: 'Loner | 14,999x Max Win Crypto Slot | {brand}',
        description: 'Play Loner slot for real money. 14,999x max win, Monitors. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/nolimit-city/manhattan_goes_wild': {
        title: 'Play Manhattan Goes Wild | 2,025x Win | {brand}',
        description: 'Play Manhattan Goes Wild slot for real money at {brand}. 2,025x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/mayan_magic_wildfire': {
        title: 'Play Mayan Magic Wildfire Slot | 1,264x Payout | {brand}',
        description: 'Mayan Magic Wildfire slot with 1,264x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/mental': {
        title: 'Mental Slot | 66,666x Win | Play with Bitcoin',
        description: 'Mental slot with 66,666x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/mental_2': {
        title: 'Play Mental 2 | 99,999x Win | {brand}',
        description: 'Deposit BTC and play Mental 2 at {brand}. 99,999x max win, high volatility, Fire Frames and Fire Reels. 9 cryptos, zero fees.'
    },
    '/p/nolimit-city/milky_ways': {
        title: 'Milky Ways | 5,664x Max Win Bitcoin Slot | {brand}',
        description: 'Milky Ways slot with 5,664x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/misery_mining': {
        title: 'Play Misery Mining | 70,000x Max Win | {brand}',
        description: 'Play Misery Mining at {brand} crypto casino. Medium volatility, 70,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/monkeys_gold_xpays': {
        title: "Monkey's Gold xPays Slot | 12,683x Max Win | {brand}",
        description: "Spin Monkey's Gold xPays with Bitcoin at {brand}. 12,683x max win, medium volatility. Instant crypto withdrawals, zero platform fees."
    },
    '/p/nolimit-city/nine_to_five': {
        title: 'Nine To Five | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Nine To Five slot with 10,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/oktoberfest': {
        title: 'Oktoberfest | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Oktoberfest at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/outsourced_payday': {
        title: 'Outsourced Payday Slot | Win Up to 10,000x | {brand}',
        description: 'Outsourced Payday slot at {brand} crypto casino. Medium volatility, 10,000x max win with Claw Machine. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/outsourced_slash_game': {
        title: 'Outsourced Slash Game Slot | Win Up to 1,500x | {brand}',
        description: 'Outsourced Slash Game slot at {brand} crypto casino. Medium volatility, 1,500x max win with Slash Game. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/owls': {
        title: 'Play Owls Slot | 1,370x Payout | {brand}',
        description: 'Spin Owls with Bitcoin at {brand}. 1,370x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/pearl_harbor': {
        title: 'Pearl Harbor | 41,127x Max Win Bitcoin Slot | {brand}',
        description: 'Play Pearl Harbor by Nolimit City. Medium volatility, 41,127x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/pixies_vs_pirates': {
        title: 'Play Pixies vs Pirates Slot | 11,907x Payout | {brand}',
        description: 'Play Pixies vs Pirates by Nolimit City at {brand}. Medium volatility, 11,907x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/poison_eve': {
        title: 'Poison Eve | 6,091x Max Win Bitcoin Slot | {brand}',
        description: 'Poison Eve by Nolimit City. Medium volatility slot with 6,091x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/possessed': {
        title: 'Possessed | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Possessed by Nolimit City at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/punk_rocker': {
        title: 'Play Punk Rocker 3 Slot | 19,089x Payout | {brand}',
        description: 'Play Punk Rocker 3 by Nolimit City at {brand}. High volatility, 19,089x max win, xWays. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/punk_rocker_2': {
        title: 'Play Punk Rocker 2 | 30,141x Win | {brand}',
        description: 'Play Punk Rocker 2 at {brand}. High volatility, 30,141x max win. Features Riot Respins. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/punk_toilet': {
        title: 'Play Punk Toilet | 33,333x Win | {brand}',
        description: 'Play Punk Toilet slot for real money at {brand}. 33,333x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/remember_gulag': {
        title: 'Play Remember Gulag | 30,000x Max Win | {brand}',
        description: 'Remember Gulag slot at {brand} crypto casino. Medium volatility with 30,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/road_kill': {
        title: 'Road Kill | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Road Kill by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/road_rage': {
        title: 'Play Road Rage | 36,000x Win | {brand}',
        description: 'Play Road Rage slot for real money at {brand}. 36,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/rock_bottom': {
        title: 'Rock Bottom Slot | 19,690x Win | Play with Bitcoin',
        description: 'Spin Rock Bottom with Bitcoin at {brand}. 19,690x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/san_quentin_2_death_row': {
        title: 'San Quentin 2 Death Row | 200,000x Max Win Crypto Slot | {brand}',
        description: 'San Quentin 2 Death Row at {brand} crypto casino. 200,000x max win with Enhancer Cells. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/san_quentin_xways': {
        title: 'Play San Quentin xWays | 150,000x Max Win | {brand}',
        description: 'San Quentin xWays at {brand}. Medium volatility, 150,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/serial': {
        title: 'Play Serial | 10,000x Max Win | {brand}',
        description: 'Serial at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/skate_or_die': {
        title: 'Skate or Die Slot | 30,000x Win | Play with Bitcoin',
        description: 'Play Skate or Die by Nolimit City at {brand}. High volatility, 30,000x max win, Extra Sauce Row. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/space_donkey': {
        title: 'Space Donkey Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Space Donkey by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/starstruck': {
        title: 'Starstruck Slot | Win Up to 1,636x | {brand}',
        description: 'Starstruck slot at {brand} crypto casino. Medium volatility with 1,636x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/stockholm_syndrome': {
        title: 'Play Stockholm Syndrome | 28,873x Win | {brand}',
        description: 'Play Stockholm Syndrome at {brand}. High volatility, 28,873x max win. Features Con Man Wild. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/supersized': {
        title: 'Supersized Slot | Win Up to 12,345x | {brand}',
        description: 'Play Supersized at {brand}. High volatility, 12,345x max win. Features Clone. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/tesla_jolt': {
        title: 'Tesla Jolt Slot | 582x Win | Play with Bitcoin',
        description: 'Tesla Jolt by Nolimit City. Medium volatility slot with 582x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/the_border': {
        title: 'Play The Border | 44,288x Win | {brand}',
        description: 'Play The Border slot for real money at {brand}. 44,288x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/the_cage': {
        title: 'Play The Cage | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play The Cage at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/the_creepy_carnival': {
        title: 'The Creepy Carnival Slot | 798x Max Win | {brand}',
        description: 'Play The Creepy Carnival by Nolimit City at {brand}. Medium volatility, 798x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/the_crypt': {
        title: 'The Crypt 2 | 31,248x Max Win Crypto Slot | {brand}',
        description: 'Play The Crypt 2 at {brand}. High volatility, 31,248x max win. Features Reel Area. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/the_rave': {
        title: 'Play The Rave | 41,500x Max Win | {brand}',
        description: 'Play The Rave at {brand} crypto casino. Medium volatility, 41,500x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/thor_hammer_time': {
        title: 'Thor: Hammer Time | 2,328x Max Win Crypto Slot | {brand}',
        description: 'Play Thor: Hammer Time slot for real money at {brand}. 2,328x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/tomb_of_akhenaten': {
        title: 'Play Tomb of Akhenaten | 26,261x Max Win | {brand}',
        description: 'Tomb of Akhenaten at {brand}. Medium volatility, 26,261x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/tomb_of_nefertiti': {
        title: 'Tomb of Nefertiti | 3,768x Max Win Bitcoin Slot | {brand}',
        description: 'Tomb of Nefertiti slot with 3,768x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/tombstone': {
        title: 'Tombstone Slot | 11,456x Win | Play with Bitcoin',
        description: 'Tombstone slot with 11,456x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/tombstone_no_mercy': {
        title: 'Play Tombstone No Mercy | 10,000x Win | {brand}',
        description: 'Tombstone No Mercy at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/tombstone_rip': {
        title: 'Play Tombstone RIP Slot | 300,000x Payout | {brand}',
        description: 'Tombstone RIP by Nolimit City. Medium volatility slot with 300,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/tombstone_slaughter_el_gordos_revenge': {
        title: "Tombstone Slaughter: El Gordo's Revenge Slot | {brand}",
        description: "Spin Tombstone Slaughter: El Gordo's Revenge with Bitcoin at {brand}. 500,000x max win, high volatility, Reel Setup. Instant payouts, zero platform fees."
    },
    '/p/nolimit-city/tractor_beam': {
        title: 'Play Tractor Beam Slot | 3,408x Payout | {brand}',
        description: 'Play Tractor Beam by Nolimit City. Medium volatility, 3,408x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/true_grit_redemption': {
        title: 'True Grit Redemption Slot | 20,220x Max Win | {brand}',
        description: 'Play True Grit Redemption by Nolimit City at {brand}. Medium volatility, 20,220x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/true_kult': {
        title: 'True Kult Slot | 10,000x Max Win | {brand}',
        description: 'Play True Kult by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/tsar_wars': {
        title: 'Play Tsar Wars | 19,755x Win | {brand}',
        description: 'Tsar Wars slot at {brand} crypto casino. High volatility, 19,755x max win with xBomb. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/ugliest_catch': {
        title: 'Ugliest Catch Slot | 10,000x Max Win | {brand}',
        description: 'Ugliest Catch by Nolimit City. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/walk_of_shame': {
        title: 'Play Walk of Shame | 9,822x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Walk of Shame at {brand}. 9,822x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/warrior_graveyard_xnudge': {
        title: 'Warrior Graveyard Xnudge Slot | Win Up to 10,000x | {brand}',
        description: 'Play Warrior Graveyard Xnudge at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/whacked': {
        title: 'Play Whacked Online | {brand}',
        description: 'Whacked by Nolimit City at {brand} crypto casino. Medium volatility. Play with Bitcoin, ETH, USDT. Fast crypto payouts.'
    },
    '/p/nolimit-city/wixx': {
        title: 'Play WiXX | 1,398x Max Win | {brand}',
        description: 'Play WiXX slot for real money at {brand}. 1,398x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/xways_hoarder_2': {
        title: 'XWays Hoarder 2 | 25,920x Max Win Bitcoin Slot | {brand}',
        description: 'Play XWays Hoarder 2 by Nolimit City at {brand}. High volatility, 25,920x max win, xWays. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/xways_hoarder_xsplit': {
        title: 'xWays Hoarder xSplit Slot | 11,030x Max Win | {brand}',
        description: 'xWays Hoarder xSplit slot with 11,030x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/play-n-go/1001_mystery_genie_fortunes': {
        title: '1001 Mystery Genie Fortunes: 94% RTP, 1,234x Max Win | {brand}',
        description: '1001 Mystery Genie Fortunes runs at 94% RTP at {brand}, with a 1,234x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/13th_trial_hercules_abyssways': {
        title: '13th Trial Hercules Abyssways: 94% RTP | {brand}',
        description: '13th Trial Hercules Abyssways runs at 94% RTP at {brand}, with a 60,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/15_crystal_roses_a_tale_of_love': {
        title: '15 Crystal Roses: A Tale of Love: 94% RTP | {brand}',
        description: '15 Crystal Roses: A Tale of Love runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/24k_dragon': {
        title: '24K Dragon: 94% RTP, 24,000x Max Win | {brand}',
        description: '24K Dragon runs at 94% RTP at {brand}, with a 24,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/3_blades_and_blessings': {
        title: '3 Blades and Blessings: 94% RTP, 4,000x Max Win | {brand}',
        description: '3 Blades and Blessings runs at 94% RTP at {brand}, with a 4,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/3_clown_monty': {
        title: '3 Clown Monty: 94% RTP, 20,000x Max Win | {brand}',
        description: '3 Clown Monty runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/3_clown_monty_ii': {
        title: '3 Clown Monty II: 94% RTP, 500x Max Win | {brand}',
        description: '3 Clown Monty II runs at 94% RTP at {brand}, with a 500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/3_hand_casino': {
        title: '3 Hand Casino: 94% RTP, 213x Max Win | {brand}',
        description: '3 Hand Casino runs at 94% RTP at {brand}, with a 213x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/5x_magic': {
        title: '5x Magic: 94% RTP, 1,050x Max Win | {brand}',
        description: '5x Magic runs at 94% RTP at {brand}, with a 1,050x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/7_sins': {
        title: '7 Sins: 94% RTP, 1,580x Max Win | {brand}',
        description: '7 Sins runs at 94% RTP at {brand}, with a 1,580x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ace_of_spades': {
        title: 'Ace of Spades: 94% RTP, 4,167x Max Win | {brand}',
        description: 'Ace of Spades runs at 94% RTP at {brand}, with a 4,167x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/agent_destiny': {
        title: 'Agent Destiny: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Agent Destiny runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/agent_of_hearts': {
        title: 'Agent of Hearts: 94% RTP, 5,263x Max Win | {brand}',
        description: 'Agent of Hearts runs at 94% RTP at {brand}, with a 5,263x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/animal_madness': {
        title: 'Animal Madness: 94% RTP, 2,250x Max Win | {brand}',
        description: 'Animal Madness runs at 94% RTP at {brand}, with a 2,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ankh_of_anubis': {
        title: 'Ankh of Anubis: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Ankh of Anubis runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ankh_of_anubis_awakening': {
        title: 'Ankh of Anubis Awakening: 94% RTP | {brand}',
        description: 'Ankh of Anubis Awakening runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/annihilator': {
        title: 'Annihilator: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Annihilator runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/athena_ascending': {
        title: 'Athena Ascending: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Athena Ascending runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/aztec_idols': {
        title: 'Aztec Idols: 94% RTP, 22,725x Max Win | {brand}',
        description: 'Aztec Idols runs at 94% RTP at {brand}, with a 22,725x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/aztec_warrior_princess': {
        title: 'Aztec Warrior Princess: 94% RTP, 10,657x Max Win | {brand}',
        description: 'Aztec Warrior Princess runs at 94% RTP at {brand}, with a 10,657x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/bakers_treat': {
        title: "Baker's Treat: 94% RTP, 5,000x Max Win | {brand}",
        description: "Baker's Treat runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/banana_rock': {
        title: 'Banana Rock: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Banana Rock runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/banana_rush': {
        title: 'Banana Rush: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Banana Rush runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/banquet_of_dead': {
        title: 'Banquet of Dead: 94% RTP | {brand}',
        description: 'Banquet of Dead runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/bao_shi': {
        title: 'Bao Shi: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Bao Shi runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/barn_busters': {
        title: 'Barn Busters: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Barn Busters runs at 94% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/baron_lord_of_saturday': {
        title: 'Baron: Lord of Saturday: 94% RTP | {brand}',
        description: 'Baron: Lord of Saturday runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/battle_royal': {
        title: 'Battle Royal: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Battle Royal runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/beast_of_wealth': {
        title: 'Beast Of Wealth | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Beast Of Wealth by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/beasts_of_fire': {
        title: 'Beasts Of Fire: 94% RTP, 25,000x Max Win | {brand}',
        description: 'Beasts Of Fire runs at 94% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/beasts_of_fire_maximum': {
        title: 'Beasts of Fire Maximum: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Beasts of Fire Maximum runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/big_win_777': {
        title: 'Big Win 777: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Big Win 777 runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/big_win_cat': {
        title: 'Big Win Cat: 94% RTP, 800x Max Win | {brand}',
        description: 'Big Win Cat runs at 94% RTP at {brand}, with a 800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/big_win_city_pawsperity': {
        title: 'Big Win City Pawsperity: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Big Win City Pawsperity runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/black_mamba': {
        title: 'Black Mamba: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Black Mamba runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/blazin_bullfrog': {
        title: "Blazin' Bullfrog: 94% RTP, 1,215x Max Win | {brand}",
        description: "Blazin' Bullfrog runs at 94% RTP at {brand}, with a 1,215x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/blinged': {
        title: 'Blinged: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Blinged runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/boat_bonanza': {
        title: 'Boat Bonanza: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Boat Bonanza runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/boat_bonanza_christmas': {
        title: 'Boat Bonanza Christmas: 94% RTP | {brand}',
        description: 'Boat Bonanza Christmas runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/boat_bonanza_colossal_catch': {
        title: 'Boat Bonanza Colossal Catch: 94% RTP | {brand}',
        description: 'Boat Bonanza Colossal Catch runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/boat_bonanza_croconile': {
        title: 'Boat Bonanza Croconile: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Boat Bonanza Croconile runs at 94% RTP at {brand}, with a 6,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/boat_bonanza_down_under': {
        title: 'Boat Bonanza Down Under: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Boat Bonanza Down Under runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/boat_bonanza_rider': {
        title: 'Boat Bonanza Rider | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Boat Bonanza Rider with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/book_of_dead': {
        title: 'Book of Dead: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Book of Dead runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/bubblin_riches': {
        title: 'Bubblin Riches: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Bubblin Riches runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/bucking_rider': {
        title: 'Play Bucking Rider | 10,000x Win | {brand}',
        description: 'Play Bucking Rider at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/buffalo_of_wealth': {
        title: 'Buffalo of Wealth: 94% RTP, 7,000x Max Win | {brand}',
        description: 'Buffalo of Wealth runs at 94% RTP at {brand}, with a 7,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/buildin_bucks': {
        title: "Buildin' Bucks: 94% RTP | {brand}",
        description: "Buildin' Bucks runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/buildin_more_bucks': {
        title: 'Buildin More Bucks: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Buildin More Bucks runs at 94% RTP at {brand}, with a 7,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/bull_in_a_china_shop': {
        title: 'Bull in a China Shop: 94% RTP, 5,800x Max Win | {brand}',
        description: 'Bull in a China Shop runs at 94% RTP at {brand}, with a 5,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/bull_in_a_rodeo': {
        title: 'Bull in a Rodeo: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Bull in a Rodeo runs at 94% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/bullion_express': {
        title: 'Bullion Express: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Bullion Express runs at 94% RTP at {brand}, with a 6,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/candy_island_princess': {
        title: 'Candy Island Princess: 94% RTP, 2,200x Max Win | {brand}',
        description: 'Candy Island Princess runs at 94% RTP at {brand}, with a 2,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/canine_carnage': {
        title: 'Canine Carnage: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Canine Carnage runs at 94% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/captain_glum_pirate_hunter': {
        title: 'Captain Glum: Pirate Hunter: 94% RTP, 9,000x Max Win | {brand}',
        description: 'Captain Glum: Pirate Hunter runs at 94% RTP at {brand}, with a 9,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/captain_xenos_earth_adventure': {
        title: "Captain Xeno's Earth Adventure: 94% RTP | {brand}",
        description: "Captain Xeno's Earth Adventure runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/cash_a_cabana': {
        title: 'Cash a Cabana: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Cash a Cabana runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cash_of_command': {
        title: 'Cash of Command: 94% RTP, 5,336x Max Win | {brand}',
        description: 'Cash of Command runs at 94% RTP at {brand}, with a 5,336x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cash_pump': {
        title: 'Cash Pump: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Cash Pump runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cash_vandal': {
        title: 'Cash Vandal: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Cash Vandal runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cashin_joker': {
        title: "Cashin' Joker: 94% RTP, 10,888x Max Win | {brand}",
        description: "Cashin' Joker runs at 94% RTP at {brand}, with a 10,888x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/cat_wilde_and_the_doom_of_dead': {
        title: 'Cat Wilde and the Doom of Dead: 94% RTP | {brand}',
        description: 'Cat Wilde and the Doom of Dead runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cat_wilde_and_the_incan_quest': {
        title: 'Cat Wilde and the Incan Quest: 94% RTP | {brand}',
        description: 'Cat Wilde and the Incan Quest runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cat_wilde_and_the_lost_chapter': {
        title: 'Cat Wilde and the Lost Chapter: 94% RTP | {brand}',
        description: 'Cat Wilde and the Lost Chapter runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cat_wilde_and_the_pyramids_of_dead': {
        title: 'Cat Wilde and the Pyramids of Dead: 94% RTP | {brand}',
        description: 'Cat Wilde and the Pyramids of Dead runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cat_wilde_in_the_eclipse_of_the_sun_god': {
        title: 'Cat Wilde in the Eclipse of the Sun God: 94% RTP | {brand}',
        description: 'Cat Wilde in the Eclipse of the Sun God runs at 94% RTP at {brand}, with a 5,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cats_and_cash': {
        title: 'Cats and Cash: 94% RTP, 1,154x Max Win | {brand}',
        description: 'Cats and Cash runs at 94% RTP at {brand}, with a 1,154x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/celebration_of_wealth': {
        title: 'Celebration Of Wealth | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Celebration Of Wealth at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/chambers_of_ancients': {
        title: 'Chambers of Ancients: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Chambers of Ancients runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/champions_of_mithrune': {
        title: 'Champions of Mithrune: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Champions of Mithrune runs at 94% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/charlie_chance': {
        title: 'Charlie Chance: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Charlie Chance runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/charlie_chance_and_the_curse_of_cleopatra': {
        title: 'Charlie Chance and The Curse of Cleopatra: 94% RTP | {brand}',
        description: 'Charlie Chance and The Curse of Cleopatra runs at 94% RTP at {brand}, with a 5,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/charlie_chance_in_hell_to_pay': {
        title: 'Charlie Chance in Hell to Pay: 94% RTP, 6,666x Max Win | {brand}',
        description: 'Charlie Chance in Hell to Pay runs at 94% RTP at {brand}, with a 6,666x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/chinese_new_year': {
        title: 'Chinese New Year: 94% RTP, 22,725x Max Win | {brand}',
        description: 'Chinese New Year runs at 94% RTP at {brand}, with a 22,725x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/chronos_joker': {
        title: 'Chronos Joker: 94% RTP, 1,600x Max Win | {brand}',
        description: 'Chronos Joker runs at 94% RTP at {brand}, with a 1,600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/city_of_sound': {
        title: 'City of Sound: 94% RTP, 4,000x Max Win | {brand}',
        description: 'City of Sound runs at 94% RTP at {brand}, with a 4,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/clash_of_camelot': {
        title: 'Clash of Camelot: 94% RTP, 35,000x Max Win | {brand}',
        description: 'Clash of Camelot runs at 94% RTP at {brand}, with a 35,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/cloud_quest': {
        title: 'Cloud Quest: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Cloud Quest runs at 94% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/coils_of_cash': {
        title: 'Coils of Cash: 94% RTP, 30,000x Max Win | {brand}',
        description: 'Coils of Cash runs at 94% RTP at {brand}, with a 30,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/colt_lightning': {
        title: 'Colt Lightning: 94% RTP, 25,000x Max Win | {brand}',
        description: 'Colt Lightning runs at 94% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/colt_lightning_firestorm': {
        title: 'Colt Lightning Firestorm: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Colt Lightning Firestorm runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/contact': {
        title: 'Contact: 94% RTP, 1,518x Max Win | {brand}',
        description: 'Contact runs at 94% RTP at {brand}, with a 1,518x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/copsnrobbers': {
        title: "Cops'n'Robbers: 94% RTP, 28,961x Max Win | {brand}",
        description: "Cops'n'Robbers runs at 94% RTP at {brand}, with a 28,961x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/count_jokula': {
        title: 'Count Jokula: 94% RTP, 1,500x Max Win | {brand}',
        description: 'Count Jokula runs at 94% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/court_of_hearts': {
        title: 'Court of Hearts: 94% RTP, 8,500x Max Win | {brand}',
        description: 'Court of Hearts runs at 94% RTP at {brand}, with a 8,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/coywolf_cash': {
        title: 'Coywolf Cash: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Coywolf Cash runs at 94% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/crabbys_gold': {
        title: "Crabby's Gold: 94% RTP, 70,000x Max Win | {brand}",
        description: "Crabby's Gold runs at 94% RTP at {brand}, with a 70,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/crazy_cows': {
        title: 'Crazy Cows: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Crazy Cows runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/crystal_hall': {
        title: 'Crystal Hall: 94% RTP | {brand}',
        description: 'Crystal Hall runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/crystal_sun': {
        title: 'Crystal Sun: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Crystal Sun runs at 94% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/dansband_pa_turne': {
        title: 'Dansband Pa Turne: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Dansband Pa Turne runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/dawn_of_egypt': {
        title: 'Dawn of Egypt: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Dawn of Egypt runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/demon': {
        title: 'Demon: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Demon runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/derby_wheel': {
        title: 'Derby Wheel: 94% RTP, 2,240x Max Win | {brand}',
        description: 'Derby Wheel runs at 94% RTP at {brand}, with a 2,240x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/diamond_vortex': {
        title: 'Diamond Vortex: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Diamond Vortex runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/diamonds_of_the_realm': {
        title: 'Diamonds of the Realm: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Diamonds of the Realm runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/dio_killing_the_dragon': {
        title: 'DIO - Killing the Dragon: 94% RTP, 15,000x Max Win | {brand}',
        description: 'DIO - Killing the Dragon runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/disco_diamonds': {
        title: 'Disco Diamonds: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Disco Diamonds runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/divina_commedia_i_nove_cerchi': {
        title: 'Divina Commedia I Nove Cerchi: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Divina Commedia I Nove Cerchi runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/divine_divas': {
        title: 'Divine Divas: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Divine Divas runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/divine_showdown': {
        title: 'Divine Showdown: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Divine Showdown runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/doom_of_egypt': {
        title: 'Doom of Egypt: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Doom of Egypt runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/dr_toonz': {
        title: 'Dr. Toonz: 94% RTP, 22,000x Max Win | {brand}',
        description: 'Dr. Toonz runs at 94% RTP at {brand}, with a 22,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/dragon_maiden': {
        title: 'Dragon Maiden: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Dragon Maiden runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/dragon_ship': {
        title: 'Dragon Ship: 94% RTP, 8,032x Max Win | {brand}',
        description: 'Dragon Ship runs at 94% RTP at {brand}, with a 8,032x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/dragonfates_favour': {
        title: "Dragonfate's Favour: 94% RTP, 30,000x Max Win | {brand}",
        description: "Dragonfate's Favour runs at 94% RTP at {brand}, with a 30,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/easter_eggs': {
        title: 'Easter Eggs: 94% RTP, 6,569x Max Win | {brand}',
        description: 'Easter Eggs runs at 94% RTP at {brand}, with a 6,569x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/easter_eggspedition': {
        title: 'Easter Eggspedition: 94% RTP | {brand}',
        description: 'Easter Eggspedition runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/enchanted_crystals': {
        title: 'Enchanted Crystals: 94% RTP, 68,308x Max Win | {brand}',
        description: 'Enchanted Crystals runs at 94% RTP at {brand}, with a 68,308x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/enchanted_meadow': {
        title: 'Enchanted Meadow: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Enchanted Meadow runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/energoonz': {
        title: 'Energoonz: 94% RTP, 18,566x Max Win | {brand}',
        description: 'Energoonz runs at 94% RTP at {brand}, with a 18,566x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/eye_of_atum': {
        title: 'Eye of Atum: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Eye of Atum runs at 94% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/eye_of_the_kraken': {
        title: 'Eye of the Kraken: 94% RTP, 2,107x Max Win | {brand}',
        description: 'Eye of the Kraken runs at 94% RTP at {brand}, with a 2,107x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fangs_and_fire': {
        title: 'Fangs and Fire: 94% RTP, 60,000x Max Win | {brand}',
        description: 'Fangs and Fire runs at 94% RTP at {brand}, with a 60,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fat_frankies': {
        title: 'Fat Frankies: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Fat Frankies runs at 94% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fate_of_dead_blitzways': {
        title: 'Fate of Dead Blitzways: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Fate of Dead Blitzways runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/feline_fury': {
        title: 'Feline Fury: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Feline Fury runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fire_joker': {
        title: 'Fire Joker: 94% RTP, 800x Max Win | {brand}',
        description: 'Fire Joker runs at 94% RTP at {brand}, with a 800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fire_joker_100': {
        title: 'Fire Joker 100: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Fire Joker 100 runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fire_joker_blitz': {
        title: 'Fire Joker Blitz: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Fire Joker Blitz runs at 94% RTP at {brand}, with a 6,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fire_joker_freeze': {
        title: 'Fire Joker Freeze: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Fire Joker Freeze runs at 94% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fire_toad': {
        title: 'Fire Toad: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Fire Toad runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fire_toad_2': {
        title: 'Fire Toad 2: 94% RTP, 5,300x Max Win | {brand}',
        description: 'Fire Toad 2 runs at 94% RTP at {brand}, with a 5,300x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/firefly_frenzy': {
        title: 'Firefly Frenzy: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Firefly Frenzy runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/forge_of_fortunes': {
        title: 'Forge of Fortunes: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Forge of Fortunes runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/forge_of_gems': {
        title: 'Forge of Gems: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Forge of Gems runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fortune_rewind': {
        title: 'Fortune Rewind: 94% RTP, 8,500x Max Win | {brand}',
        description: 'Fortune Rewind runs at 94% RTP at {brand}, with a 8,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fortune_teller': {
        title: 'Fortune Teller: 94% RTP, 10,658x Max Win | {brand}',
        description: 'Fortune Teller runs at 94% RTP at {brand}, with a 10,658x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fortunes_of_ali_baba': {
        title: 'Fortunes of Ali Baba: 94% RTP, 9,968x Max Win | {brand}',
        description: 'Fortunes of Ali Baba runs at 94% RTP at {brand}, with a 9,968x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fox_mayhem': {
        title: 'Fox Mayhem: 94% RTP, 400,000x Max Win | {brand}',
        description: 'Fox Mayhem runs at 94% RTP at {brand}, with a 400,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/free_reelin_joker': {
        title: "Free Reelin' Joker: 94% RTP, 1,000x Max Win | {brand}",
        description: "Free Reelin' Joker runs at 94% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/free_reelin_joker_1000': {
        title: 'Free Reelin Joker 1000: 94% RTP, 10,500x Max Win | {brand}',
        description: 'Free Reelin Joker 1000 runs at 94% RTP at {brand}, with a 10,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/frozen_gems': {
        title: 'Frozen Gems: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Frozen Gems runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fruit_bonanza': {
        title: 'Play Fruit Bonanza | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Fruit Bonanza at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/fu_er_dai': {
        title: 'Fu Er Dai: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Fu Er Dai runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/fulong_88': {
        title: 'Fulong 88: 94% RTP | {brand}',
        description: 'Fulong 88 runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/game_of_gladiators': {
        title: 'Game of Gladiators: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Game of Gladiators runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/game_of_gladiators_uprising': {
        title: 'Game of Gladiators Uprising: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Game of Gladiators Uprising runs at 94% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gargantoonz': {
        title: 'Gargantoonz: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Gargantoonz runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gates_of_troy': {
        title: 'Gates of Troy: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Gates of Troy runs at 94% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gemix': {
        title: 'Gemix: 94% RTP, 4,514x Max Win | {brand}',
        description: 'Gemix runs at 94% RTP at {brand}, with a 4,514x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gemix_100': {
        title: 'Gemix 100: 94% RTP | {brand}',
        description: 'Gemix 100 runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gemix_2': {
        title: 'Gemix 2: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Gemix 2 runs at 94% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gerards_gambit': {
        title: "Gerard's Gambit: 94% RTP, 300,000x Max Win | {brand}",
        description: "Gerard's Gambit runs at 94% RTP at {brand}, with a 300,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/ghost_of_dead': {
        title: 'Ghost of Dead: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Ghost of Dead runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gift_shop': {
        title: 'Gift Shop | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Gift Shop by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/gigantoonz': {
        title: 'Gigantoonz: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Gigantoonz runs at 94% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/go_craps': {
        title: 'Go Craps: 99.69% RTP, 10,000x Max Win | {brand}',
        description: 'Go Craps runs at 99.69% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gold_king': {
        title: 'Gold King: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Gold King runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gold_of_fortune_god': {
        title: 'Gold of Fortune God: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Gold of Fortune God runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gold_trophy_2': {
        title: 'Gold Trophy 2: 94% RTP, 67,332x Max Win | {brand}',
        description: 'Gold Trophy 2 runs at 94% RTP at {brand}, with a 67,332x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gold_volcano': {
        title: 'Gold Volcano: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Gold Volcano runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/golden_caravan': {
        title: 'Golden Caravan: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Golden Caravan runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/golden_colts': {
        title: 'Golden Colts: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Golden Colts runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/golden_goal': {
        title: 'Golden Goal | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Golden Goal with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/golden_legend': {
        title: 'Golden Legend: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Golden Legend runs at 94% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/golden_osiris': {
        title: 'Golden Osiris: 94% RTP, 12,000x Max Win | {brand}',
        description: 'Golden Osiris runs at 94% RTP at {brand}, with a 12,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/golden_ticket_2': {
        title: 'Golden Ticket 2: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Golden Ticket 2 runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/grim_muerto': {
        title: 'Grim Muerto: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Grim Muerto runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/gunslinger_reloaded': {
        title: 'Gunslinger Reloaded | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Gunslinger Reloaded by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/happy_halloween': {
        title: 'Happy Halloween: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Happy Halloween runs at 94% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/highway_legends': {
        title: 'Highway Legends: 94% RTP, 62,500x Max Win | {brand}',
        description: 'Highway Legends runs at 94% RTP at {brand}, with a 62,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/holiday_season': {
        title: 'Holiday Season: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Holiday Season runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/holiday_spirits': {
        title: 'Holiday Spirits: 94% RTP, 1,600x Max Win | {brand}',
        description: 'Holiday Spirits runs at 94% RTP at {brand}, with a 1,600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/honey_rush': {
        title: 'Honey Rush: 94% RTP, 9,000x Max Win | {brand}',
        description: 'Honey Rush runs at 94% RTP at {brand}, with a 9,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/honey_rush_100': {
        title: 'Honey Rush 100: 94% RTP, 5,000,000x Max Win | {brand}',
        description: 'Honey Rush 100 runs at 94% RTP at {brand}, with a 5,000,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/hooligan_hustle': {
        title: 'Hooligan Hustle: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Hooligan Hustle runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/hope_unleashed_fortune_reels': {
        title: 'Hope Unleashed Fortune Reels: 96.2% RTP | {brand}',
        description: 'Hope Unleashed Fortune Reels runs at 96.2% RTP at {brand}, with a 1,234x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/hot_dog_heist': {
        title: 'Hot Dog Heist: 94% RTP | {brand}',
        description: 'Hot Dog Heist runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/hotel_yetiway': {
        title: 'Hotel Yeti-Way: 94% RTP, 30,000x Max Win | {brand}',
        description: 'Hotel Yeti-Way runs at 94% RTP at {brand}, with a 30,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/house_of_doom': {
        title: 'House of Doom: 94% RTP, 2,500x Max Win | {brand}',
        description: 'House of Doom runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/house_of_doom_2_the_crypt': {
        title: 'House of Doom 2: The Crypt: 94% RTP, 6,000x Max Win | {brand}',
        description: 'House of Doom 2: The Crypt runs at 94% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ice_joker': {
        title: 'Ice Joker: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Ice Joker runs at 94% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/idol_of_fortune': {
        title: 'Idol of Fortune: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Idol of Fortune runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/immortails_of_egypt': {
        title: 'ImmorTails of Egypt: 94% RTP, 10,000x Max Win | {brand}',
        description: 'ImmorTails of Egypt runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/imperial_opera': {
        title: 'Imperial Opera: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Imperial Opera runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/inferno_joker': {
        title: 'Inferno Joker: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Inferno Joker runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/inferno_star': {
        title: 'Inferno Star: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Inferno Star runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/invading_vegas': {
        title: 'Invading Vegas: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Invading Vegas runs at 94% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/invading_vegas_las_christmas': {
        title: 'Invading Vegas: Las Christmas: 94% RTP | {brand}',
        description: 'Invading Vegas: Las Christmas runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/invading_vegas_revenge_on_mars': {
        title: 'Invading Vegas Revenge on Mars: 94% RTP | {brand}',
        description: 'Invading Vegas Revenge on Mars runs at 94% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/irish_gold': {
        title: 'Irish Gold: 94% RTP, 1,050x Max Win | {brand}',
        description: 'Irish Gold runs at 94% RTP at {brand}, with a 1,050x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/iron_girl': {
        title: 'Iron Girl: 94% RTP, 1,071x Max Win | {brand}',
        description: 'Iron Girl runs at 94% RTP at {brand}, with a 1,071x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/jade_magician': {
        title: 'Jade Magician: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Jade Magician runs at 94% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/jewel_box': {
        title: 'Jewel Box: 94% RTP, 1,756x Max Win | {brand}',
        description: 'Jewel Box runs at 94% RTP at {brand}, with a 1,756x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/joker_flip': {
        title: 'Joker Flip: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Joker Flip runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/jolly_roger': {
        title: 'Jolly Roger: 94% RTP, 928x Max Win | {brand}',
        description: 'Jolly Roger runs at 94% RTP at {brand}, with a 928x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/jolly_roger_2': {
        title: 'Jolly Roger 2: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Jolly Roger 2 runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/jolly_roger_wild_kraken': {
        title: 'Jolly Roger Wild Kraken: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Jolly Roger Wild Kraken runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/journey_to_paris': {
        title: 'Journey to Paris: 94% RTP | {brand}',
        description: 'Journey to Paris runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/king_of_sweets': {
        title: 'King of Sweets: 94% RTP, 5,000x Max Win | {brand}',
        description: 'King of Sweets runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/kingdom_below': {
        title: 'Kingdom Below: 94% RTP | {brand}',
        description: 'Kingdom Below runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/kings_mask': {
        title: "King's Mask: 94% RTP, 10,000x Max Win | {brand}",
        description: "King's Mask runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/kings_mask_eclipse_of_gods': {
        title: "King's Mask: Eclipse of Gods: 94% RTP | {brand}",
        description: "King's Mask: Eclipse of Gods runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/lab_of_madness': {
        title: 'Lab of Madness: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Lab of Madness runs at 94% RTP at {brand}, with a 6,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/lady_of_fortune': {
        title: 'Lady of Fortune: 94% RTP, 1,756x Max Win | {brand}',
        description: 'Lady of Fortune runs at 94% RTP at {brand}, with a 1,756x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/lady_of_fortune_destiny_spins': {
        title: 'Lady of Fortune Destiny Spins: 94% RTP, 1,950x Max Win | {brand}',
        description: 'Lady of Fortune Destiny Spins runs at 94% RTP at {brand}, with a 1,950x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/lady_of_fortune_remastered': {
        title: 'Lady of Fortune Remastered: 94% RTP, 1,500x Max Win | {brand}',
        description: 'Lady of Fortune Remastered runs at 94% RTP at {brand}, with a 1,500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legacy_of_dead': {
        title: 'Legacy of Dead: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Legacy of Dead runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legacy_of_dynasties': {
        title: 'Legacy of Dynasties: 94% RTP | {brand}',
        description: 'Legacy of Dynasties runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legacy_of_egypt': {
        title: 'Legacy of Egypt: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Legacy of Egypt runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legacy_of_gems_blitzways': {
        title: 'Legacy of Gems Blitzways: 94% RTP | {brand}',
        description: 'Legacy of Gems Blitzways runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legacy_of_inca': {
        title: 'Legacy of Inca: 94% RTP, 6,500x Max Win | {brand}',
        description: 'Legacy of Inca runs at 94% RTP at {brand}, with a 6,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legacy_of_undead_dragon_abyssways': {
        title: 'Legacy of Undead Dragon Abyssways: 94% RTP | {brand}',
        description: 'Legacy of Undead Dragon Abyssways runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/play-n-go/legend_of_the_ice_dragon': {
        title: 'Legend of the Ice Dragon: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Legend of the Ice Dragon runs at 94% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legion_gold': {
        title: 'Legion Gold: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Legion Gold runs at 94% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legion_gold_and_the_sphinx_of_dead': {
        title: 'Legion Gold and the Sphinx of Dead: 94% RTP | {brand}',
        description: 'Legion Gold and the Sphinx of Dead runs at 94% RTP at {brand}, with a 1,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/play-n-go/legion_gold_unleashed': {
        title: 'Legion Gold Unleashed: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Legion Gold Unleashed runs at 94% RTP at {brand}, with a 1,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/legion_gold_victory': {
        title: 'Legion Gold Victory: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Legion Gold Victory runs at 94% RTP at {brand}, with a 4,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/leprechaun_goes_egypt': {
        title: 'Leprechaun goes Egypt: 94% RTP, 6,569x Max Win | {brand}',
        description: 'Leprechaun goes Egypt runs at 94% RTP at {brand}, with a 6,569x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/leprechaun_goes_to_hell': {
        title: 'Play Leprechaun Goes To Hell | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Leprechaun Goes To Hell at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/leprechaun_goes_wild': {
        title: 'Leprechaun Goes Wild: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Leprechaun Goes Wild runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/leprechauns_diamond_dig': {
        title: "Leprechaun's Diamond Dig: 94% RTP, 3,000x Max Win | {brand}",
        description: "Leprechaun's Diamond Dig runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/leprechauns_vault': {
        title: "Leprechaun's Vault: 94% RTP, 9,000x Max Win | {brand}",
        description: "Leprechaun's Vault runs at 94% RTP at {brand}, with a 9,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/lion_saga_odyssey': {
        title: 'Lion Saga Odyssey: 94% RTP | {brand}',
        description: 'Lion Saga Odyssey runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/loot_and_labyrinths': {
        title: 'Loot and Labyrinths: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Loot and Labyrinths runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/lord_merlin_and_the_lady_of_the_lake': {
        title: 'Lord Merlin and the Lady of the Lake: 94% RTP | {brand}',
        description: 'Lord Merlin and the Lady of the Lake runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/love_is_in_the_fair': {
        title: 'Love is in the Fair: 94% RTP | {brand}',
        description: 'Love is in the Fair runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/love_joker': {
        title: 'Love Joker: 94% RTP, 1,008x Max Win | {brand}',
        description: 'Love Joker runs at 94% RTP at {brand}, with a 1,008x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/luchamigos': {
        title: 'Luchamigos: 94% RTP, 1,000,000x Max Win | {brand}',
        description: 'Luchamigos runs at 94% RTP at {brand}, with a 1,000,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/lucky_diamonds': {
        title: 'Lucky Diamonds: 94% RTP, 833x Max Win | {brand}',
        description: 'Lucky Diamonds runs at 94% RTP at {brand}, with a 833x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/madame_ink': {
        title: 'Madame Ink: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Madame Ink runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mafia_gold': {
        title: 'Mafia Gold: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Mafia Gold runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mahjong_88': {
        title: 'Mahjong 88: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Mahjong 88 runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/matsuri': {
        title: 'Matsuri: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Matsuri runs at 94% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/medusas_madness': {
        title: "Medusa's Madness: 94% RTP, 2,000x Max Win | {brand}",
        description: "Medusa's Madness runs at 94% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/mega_don_feeding_frenzy': {
        title: 'Mega Don: Feeding Frenzy: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Mega Don: Feeding Frenzy runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mega_don_triple_threat': {
        title: 'Mega Don Triple Threat: 94% RTP, 25,000x Max Win | {brand}',
        description: 'Mega Don Triple Threat runs at 94% RTP at {brand}, with a 25,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/megadon': {
        title: 'Megadon: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Megadon runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/merlin_and_the_ice_queen_morgana': {
        title: 'Merlin and the Ice Queen Morgana: 94% RTP | {brand}',
        description: 'Merlin and the Ice Queen Morgana runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/merlin_journey_of_flame': {
        title: 'Merlin: Journey of Flame: 94% RTP, 750,000x Max Win | {brand}',
        description: 'Merlin: Journey of Flame runs at 94% RTP at {brand}, with a 750,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/merlin_realm_of_charm': {
        title: 'Merlin Realm of Charm: 94% RTP | {brand}',
        description: 'Merlin Realm of Charm runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/merlins_grimoire': {
        title: "Merlin's Grimoire: 94% RTP, 30,000x Max Win | {brand}",
        description: "Merlin's Grimoire runs at 94% RTP at {brand}, with a 30,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/mermaids_diamond': {
        title: "Mermaid's Diamond: 94% RTP, 5,000x Max Win | {brand}",
        description: "Mermaid's Diamond runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/merry_xmas': {
        title: 'Merry Xmas: 94% RTP, 1,756x Max Win | {brand}',
        description: 'Merry Xmas runs at 94% RTP at {brand}, with a 1,756x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/midnight_gold': {
        title: 'Midnight Gold: 94% RTP | {brand}',
        description: 'Midnight Gold runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/miner_donkey_rider': {
        title: 'Play Miner Donkey Rider Slot | 10,000x Payout | {brand}',
        description: "Miner Donkey Rider by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/miner_donkey_trouble': {
        title: 'Miner Donkey Trouble: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Miner Donkey Trouble runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mirror_joker': {
        title: 'Mirror Joker: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Mirror Joker runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mission_cash': {
        title: 'Mission Cash: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Mission Cash runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mole_digger': {
        title: 'Mole Digger: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Mole Digger runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/money_wheel': {
        title: 'Money Wheel: 94% RTP, 46x Max Win | {brand}',
        description: 'Money Wheel runs at 94% RTP at {brand}, with a 46x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/monkey_battle_for_the_scrolls': {
        title: 'Monkey: Battle for the Scrolls: 94% RTP | {brand}',
        description: 'Monkey: Battle for the Scrolls runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/monkey_donkey_rider': {
        title: 'Monkey Donkey Rider Slot | 10,000x Max Win | {brand}',
        description: "Play Monkey Donkey Rider by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/moon_princess': {
        title: 'Moon Princess: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Moon Princess runs at 94% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/moon_princess_christmas_kingdom': {
        title: 'Moon Princess: Christmas Kingdom: 94% RTP | {brand}',
        description: 'Moon Princess: Christmas Kingdom runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/moon_princess_origins': {
        title: 'Moon Princess Origins: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Moon Princess Origins runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/moon_princess_power_of_love': {
        title: 'Moon Princess: Power of Love: 94% RTP | {brand}',
        description: 'Moon Princess: Power of Love runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/moon_princess_stargazing': {
        title: 'Moon Princess Stargazing: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Moon Princess Stargazing runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/moon_princess_trinity': {
        title: 'Moon Princess Trinity: 94% RTP, 400,000x Max Win | {brand}',
        description: 'Moon Princess Trinity runs at 94% RTP at {brand}, with a 400,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/motley_crue': {
        title: 'Motley Crue: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Motley Crue runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mount_m': {
        title: 'Mount M: 94% RTP, 13,000x Max Win | {brand}',
        description: 'Mount M runs at 94% RTP at {brand}, with a 13,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/muerto_en_mictlan': {
        title: 'Muerto En Mictlan: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Muerto En Mictlan runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/multifruit_81': {
        title: 'Multifruit 81: 94% RTP, 2,520x Max Win | {brand}',
        description: 'Multifruit 81 runs at 94% RTP at {brand}, with a 2,520x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mystery_egg_surprise': {
        title: 'Mystery Egg Surprise: 94% RTP, 6,480x Max Win | {brand}',
        description: 'Mystery Egg Surprise runs at 94% RTP at {brand}, with a 6,480x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mystery_genie_fortunes_of_the_lamp': {
        title: 'Mystery Genie Fortunes of the Lamp: 94% RTP | {brand}',
        description: 'Mystery Genie Fortunes of the Lamp runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mystery_joker': {
        title: 'Mystery Joker: 94% RTP, 6,480x Max Win | {brand}',
        description: 'Mystery Joker runs at 94% RTP at {brand}, with a 6,480x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/mystery_joker_6000': {
        title: 'Mystery Joker 6000: 94% RTP, 2,398x Max Win | {brand}',
        description: 'Mystery Joker 6000 runs at 94% RTP at {brand}, with a 2,398x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/myth': {
        title: 'Myth: 94% RTP, 67,332x Max Win | {brand}',
        description: 'Myth runs at 94% RTP at {brand}, with a 67,332x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/myth_of_dead': {
        title: 'Myth of Dead: 94% RTP | {brand}',
        description: 'Myth of Dead runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/naughty_nicks_book': {
        title: "Naughty Nick's Book: 94% RTP, 7,500x Max Win | {brand}",
        description: "Naughty Nick's Book runs at 94% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/new_year_riches': {
        title: 'New Year Riches: 94% RTP, 5,000x Max Win | {brand}',
        description: 'New Year Riches runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ninja_fruits': {
        title: 'Ninja Fruits: 94% RTP, 22,725x Max Win | {brand}',
        description: 'Ninja Fruits runs at 94% RTP at {brand}, with a 22,725x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/oasis_of_dead': {
        title: 'Oasis of Dead: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Oasis of Dead runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/octopus_treasure': {
        title: 'Octopus Treasure: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Octopus Treasure runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/odin_protector_of_realms': {
        title: 'Odin: Protector of Realms: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Odin: Protector of Realms runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/pack_and_cash': {
        title: 'Pack and Cash: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Pack and Cash runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/pandastic_adventure': {
        title: 'Pandastic Adventure: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Pandastic Adventure runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/pandoras_box_of_evil': {
        title: "Pandora's Box of Evil: 94% RTP, 6,000x Max Win | {brand}",
        description: "Pandora's Box of Evil runs at 94% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/pearl_lagoon': {
        title: 'Pearl Lagoon: 94% RTP, 67,332x Max Win | {brand}',
        description: 'Pearl Lagoon runs at 94% RTP at {brand}, with a 67,332x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/pearls_of_india': {
        title: 'Pearls of India: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Pearls of India runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/perfect_gems': {
        title: 'Perfect Gems: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Perfect Gems runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/phoenix_reborn': {
        title: 'Phoenix Reborn: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Phoenix Reborn runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/photo_safari': {
        title: 'Photo Safari: 94% RTP, 10,658x Max Win | {brand}',
        description: 'Photo Safari runs at 94% RTP at {brand}, with a 10,658x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/piggy_bank_farm': {
        title: 'Piggy Bank Farm: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Piggy Bank Farm runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/piggy_blitz': {
        title: 'Piggy Blitz: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Piggy Blitz runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/piggy_blitz_disco_gold': {
        title: 'Piggy Blitz Disco Gold: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Piggy Blitz Disco Gold runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/piggy_heist': {
        title: 'Piggy Heist: 94% RTP, 70,000x Max Win | {brand}',
        description: 'Piggy Heist runs at 94% RTP at {brand}, with a 70,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/pilgrim_of_dead': {
        title: 'Pilgrim of Dead: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Pilgrim of Dead runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/pimped': {
        title: 'Pimped: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Pimped runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/pirahna_pays': {
        title: 'Pirahna Pays: 94% RTP | {brand}',
        description: 'Pirahna Pays runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/planet_fortune': {
        title: 'Planet Fortune: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Planet Fortune runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/potion_of_madness': {
        title: 'Potion of Madness: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Potion of Madness runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/prism_of_gems': {
        title: 'Prism of Gems: 94% RTP, 30,000x Max Win | {brand}',
        description: 'Prism of Gems runs at 94% RTP at {brand}, with a 30,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/prissy_princess': {
        title: 'Prissy Princess: 94% RTP, 1,250x Max Win | {brand}',
        description: 'Prissy Princess runs at 94% RTP at {brand}, with a 1,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/prosperity_palace': {
        title: 'Prosperity Palace: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Prosperity Palace runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/puebla_parade': {
        title: 'Puebla Parade: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Puebla Parade runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/queens_day_tilt': {
        title: "Queen's Day Tilt: 94% RTP, 5,000x Max Win | {brand}",
        description: "Queen's Day Tilt runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/rabbit_hole_riches': {
        title: 'Rabbit Hole Riches: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rabbit Hole Riches runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rage_to_riches': {
        title: 'Rage to Riches: 94% RTP, 29,348x Max Win | {brand}',
        description: 'Rage to Riches runs at 94% RTP at {brand}, with a 29,348x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/raging_rex': {
        title: 'Raging Rex: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Raging Rex runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/raging_rex_2': {
        title: 'Raging Rex 2: 94% RTP, 30,000x Max Win | {brand}',
        description: 'Raging Rex 2 runs at 94% RTP at {brand}, with a 30,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/raging_rex_3': {
        title: 'Raging Rex 3: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Raging Rex 3 runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rainforest_magic': {
        title: 'Rainforest Magic: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rainforest Magic runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rainforest_magic_bingo': {
        title: 'Rainforest Magic Bingo: 94% RTP, 4,250x Max Win | {brand}',
        description: 'Rainforest Magic Bingo runs at 94% RTP at {brand}, with a 4,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rally_4_riches': {
        title: 'Rally 4 Riches: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rally 4 Riches runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ras_reckoning': {
        title: "Ra's Reckoning: 94% RTP, 50,000x Max Win | {brand}",
        description: "Ra's Reckoning runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/rascal_riches': {
        title: 'Play Rascal Riches Slot | 900,000x Payout | {brand}',
        description: "Play Rascal Riches by Play'n GO at {brand}. High volatility, 900,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/reactoonz': {
        title: 'Reactoonz: 94% RTP, 4,570x Max Win | {brand}',
        description: 'Reactoonz runs at 94% RTP at {brand}, with a 4,570x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/reactoonz_100': {
        title: 'Reactoonz 100: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Reactoonz 100 runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/reactoonz_2': {
        title: 'Reactoonz 2: 94% RTP, 5,083x Max Win | {brand}',
        description: 'Reactoonz 2 runs at 94% RTP at {brand}, with a 5,083x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rich_wilde_and_the_amulet_of_dead': {
        title: 'Rich Wilde and the Amulet of Dead: 94% RTP | {brand}',
        description: 'Rich Wilde and the Amulet of Dead runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rich_wilde_and_the_pearls_of_vishnu': {
        title: 'Rich Wilde and the Pearls of Vishnu: 94% RTP | {brand}',
        description: 'Rich Wilde and the Pearls of Vishnu runs at 94% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/play-n-go/rich_wilde_and_the_shield_of_athena': {
        title: 'Rich Wilde and The Shield of Athena: 94% RTP | {brand}',
        description: 'Rich Wilde and The Shield of Athena runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_dead': {
        title: 'Rich Wilde and the Tome of Dead: 94% RTP | {brand}',
        description: 'Rich Wilde and the Tome of Dead runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_insanity': {
        title: 'Rich Wilde and the Tome of Insanity: 94% RTP | {brand}',
        description: 'Rich Wilde and the Tome of Insanity runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_madness': {
        title: 'Rich Wilde and the Tome of Madness: 94% RTP | {brand}',
        description: 'Rich Wilde and the Tome of Madness runs at 94% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rich_wilde_and_the_wandering_city': {
        title: 'Rich Wilde and the Wandering City: 94% RTP | {brand}',
        description: 'Rich Wilde and the Wandering City runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/riches_of_ra': {
        title: 'Riches of RA: 94% RTP, 8,032x Max Win | {brand}',
        description: 'Riches of RA runs at 94% RTP at {brand}, with a 8,032x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/riches_of_robin': {
        title: 'Riches of Robin: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Riches of Robin runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/riddle_reels_a_case_of_riches': {
        title: 'Riddle Reels: A Case of Riches: 94% RTP | {brand}',
        description: 'Riddle Reels: A Case of Riches runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ring_of_odin': {
        title: 'Ring of Odin: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Ring of Odin runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rings_of_prosperity': {
        title: 'Rings of Prosperity: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rings of Prosperity runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_athena': {
        title: 'Rise of Athena: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rise of Athena runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_dead': {
        title: 'Rise of Dead: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rise of Dead runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_gods_reckoning': {
        title: 'Rise of Gods Reckoning: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rise of Gods Reckoning runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_merlin': {
        title: 'Rise of Merlin: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rise of Merlin runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_olympus': {
        title: 'Rise of Olympus: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Rise of Olympus runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_olympus_100': {
        title: 'Rise of Olympus 100: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Rise of Olympus 100 runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_olympus_1000': {
        title: 'Rise of Olympus 1000: 94% RTP, 40,000x Max Win | {brand}',
        description: 'Rise of Olympus 1000 runs at 94% RTP at {brand}, with a 40,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_olympus_extreme': {
        title: 'Rise of Olympus Extreme: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Rise of Olympus Extreme runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_olympus_origins': {
        title: 'Rise of Olympus Origins: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Rise of Olympus Origins runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rise_of_orpheus': {
        title: 'Rise of Orpheus: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Rise of Orpheus runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rocco_gallo': {
        title: 'Rocco Gallo: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Rocco Gallo runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ronins_honour': {
        title: "Ronin's Honour: 94% RTP, 750,000x Max Win | {brand}",
        description: "Ronin's Honour runs at 94% RTP at {brand}, with a 750,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/rosy_orbit_treasure_turn': {
        title: 'Rosy Orbit Treasure Turn: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Rosy Orbit Treasure Turn runs at 94% RTP at {brand}, with a 6,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/rotiki': {
        title: 'Rotiki: 94% RTP, 1,000x Max Win | {brand}',
        description: 'Rotiki runs at 94% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/royal_masquerade': {
        title: 'Royal Masquerade: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Royal Masquerade runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/ruff_heist': {
        title: 'Ruff Heist: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Ruff Heist runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sabaton': {
        title: 'Sabaton: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Sabaton runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/safari_of_wealth': {
        title: 'Safari of Wealth: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Safari of Wealth runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sails_of_gold': {
        title: 'Sails of Gold: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Sails of Gold runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sails_of_riches': {
        title: 'Sails of Riches: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Sails of Riches runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/samba_carnival': {
        title: 'Samba Carnival: 94% RTP, 1,756x Max Win | {brand}',
        description: 'Samba Carnival runs at 94% RTP at {brand}, with a 1,756x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/scales_of_dead': {
        title: 'Scales of Dead: 94% RTP, 2,000,000x Max Win | {brand}',
        description: 'Scales of Dead runs at 94% RTP at {brand}, with a 2,000,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/scourge_of_rome': {
        title: 'Scourge of Rome: 94% RTP | {brand}',
        description: 'Scourge of Rome runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/scroll_of_dead': {
        title: 'Scroll of Dead: 94% RTP, 7,500x Max Win | {brand}',
        description: 'Scroll of Dead runs at 94% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/scroll_of_seth': {
        title: 'Scroll of Seth: 94% RTP, 500,000x Max Win | {brand}',
        description: 'Scroll of Seth runs at 94% RTP at {brand}, with a 500,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sea_hunter': {
        title: 'Sea Hunter: 94% RTP, 920x Max Win | {brand}',
        description: 'Sea Hunter runs at 94% RTP at {brand}, with a 920x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/secret_of_dead': {
        title: 'Secret of Dead: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Secret of Dead runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/shamrock_miner': {
        title: 'Shamrock Miner: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Shamrock Miner runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sherwood_gold': {
        title: 'Sherwood Gold: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Sherwood Gold runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/shimmering_woods': {
        title: 'Shimmering Woods: 94% RTP, 25,000x Max Win | {brand}',
        description: 'Shimmering Woods runs at 94% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sisters_of_the_sun': {
        title: 'Sisters of The Sun: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Sisters of The Sun runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sizzling_spins': {
        title: 'Sizzling Spins: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Sizzling Spins runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/slashimi': {
        title: 'Slashimi: 94% RTP, 500,000x Max Win | {brand}',
        description: 'Slashimi runs at 94% RTP at {brand}, with a 500,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sobeks_godly_spins': {
        title: "Sobek's Godly Spins: 94% RTP | {brand}",
        description: "Sobek's Godly Spins runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/space_race': {
        title: 'Space Race: 94% RTP, 10,658x Max Win | {brand}',
        description: 'Space Race runs at 94% RTP at {brand}, with a 10,658x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/spark_of_genius': {
        title: 'Spark of Genius: 94% RTP | {brand}',
        description: 'Spark of Genius runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sparky_and_shortz': {
        title: 'Sparky and Shortz: 94% RTP, 10x Max Win | {brand}',
        description: 'Sparky and Shortz runs at 94% RTP at {brand}, with a 10x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sparky_and_shortz_hidden_joules': {
        title: 'Sparky & Shortz Hidden Joules: 94% RTP | {brand}',
        description: 'Sparky & Shortz Hidden Joules runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/speed_cash': {
        title: 'Speed Cash Slot | 10,000x Max Win | {brand}',
        description: 'Spin Speed Cash with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/spin_party': {
        title: 'Spin Party: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Spin Party runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/spinnin_records_into_the_beat': {
        title: 'Spinnin Records into the Beat: 94% RTP, 4,000x Max Win | {brand}',
        description: 'Spinnin Records into the Beat runs at 94% RTP at {brand}, with a 4,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/spinnin_records_raving_reels': {
        title: 'Spinnin Records Raving Reels: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Spinnin Records Raving Reels runs at 94% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/stadium_of_riches': {
        title: 'Stadium of Riches: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Stadium of Riches runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/star_joker': {
        title: 'Star Joker: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Star Joker runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/static_nightmare': {
        title: 'Static Nightmare: 94% RTP, 30,000x Max Win | {brand}',
        description: 'Static Nightmare runs at 94% RTP at {brand}, with a 30,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/stepping_diamonds': {
        title: 'Stepping Diamonds: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Stepping Diamonds runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sticky_joker': {
        title: 'Sticky Joker: 94% RTP, 1,650x Max Win | {brand}',
        description: 'Sticky Joker runs at 94% RTP at {brand}, with a 1,650x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/street_magic': {
        title: 'Street Magic: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Street Magic runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/super_flip': {
        title: 'Super Flip: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Super Flip runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/super_flip_deluxe': {
        title: 'Super Flip Deluxe: 94% RTP, 1,200x Max Win | {brand}',
        description: 'Super Flip Deluxe runs at 94% RTP at {brand}, with a 1,200x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/super_wheel': {
        title: 'Super Wheel: 94% RTP, 48x Max Win | {brand}',
        description: 'Super Wheel runs at 94% RTP at {brand}, with a 48x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sweet_27': {
        title: 'Sweet 27: 94% RTP, 1,758x Max Win | {brand}',
        description: 'Sweet 27 runs at 94% RTP at {brand}, with a 1,758x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sweet_alchemy': {
        title: 'Sweet Alchemy: 94% RTP, 3,000x Max Win | {brand}',
        description: 'Sweet Alchemy runs at 94% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sweet_alchemy_100': {
        title: 'Sweet Alchemy 100: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Sweet Alchemy 100 runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sweet_alchemy_2': {
        title: 'Sweet Alchemy 2: 94% RTP, 1,000,000x Max Win | {brand}',
        description: 'Sweet Alchemy 2 runs at 94% RTP at {brand}, with a 1,000,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/sweet_alchemy_bingo': {
        title: 'Sweet Alchemy Bingo: 94% RTP, 104,469x Max Win | {brand}',
        description: 'Sweet Alchemy Bingo runs at 94% RTP at {brand}, with a 104,469x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/tale_of_kyubiko': {
        title: 'Tale Of Kyubiko: 94% RTP, 2,250x Max Win | {brand}',
        description: 'Tale Of Kyubiko runs at 94% RTP at {brand}, with a 2,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/tales_of_asgard_freyas_wedding': {
        title: "Tales of Asgard: Freya's Wedding: 94% RTP | {brand}",
        description: "Tales of Asgard: Freya's Wedding runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/tales_of_asgard_lokis_fortune': {
        title: "Tales of Asgard: Loki's Fortune: 94% RTP | {brand}",
        description: "Tales of Asgard: Loki's Fortune runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/tales_of_mithrune_syns_fortune': {
        title: "Tales of Mithrune Syn's Fortune: 94% RTP | {brand}",
        description: "Tales of Mithrune Syn's Fortune runs at 94% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/temple_of_prosperity': {
        title: 'Temple of Prosperity: 94% RTP, 100,000x Max Win | {brand}',
        description: 'Temple of Prosperity runs at 94% RTP at {brand}, with a 100,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/temple_of_tollan': {
        title: 'Temple of Tollan: 94% RTP | {brand}',
        description: 'Temple of Tollan runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/temple_of_wealth': {
        title: 'Temple Of Wealth Slot | 10,000x Max Win | {brand}',
        description: "Play Temple Of Wealth by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/ternion': {
        title: 'Ternion: 94% RTP, 11,111x Max Win | {brand}',
        description: 'Ternion runs at 94% RTP at {brand}, with a 11,111x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/testament': {
        title: 'Testament: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Testament runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/thats_rich': {
        title: "That's Rich: 94% RTP, 10,000x Max Win | {brand}",
        description: "That's Rich runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/play-n-go/the_faces_of_freya': {
        title: 'The Faces of Freya: 94% RTP, 5,000x Max Win | {brand}',
        description: 'The Faces of Freya runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/the_green_knight': {
        title: 'The Green Knight: 94% RTP, 10,000x Max Win | {brand}',
        description: 'The Green Knight runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/the_green_knight_oath_of_thorns': {
        title: 'The Green Knight: 94% RTP, 14,000x Max Win',
        description: 'The Green Knight Oath of Thorns runs at 94% RTP at {brand}, with a 14,000x max win and medium volatility. Crypto deposits, instant withdrawals, no.'
    },
    '/p/play-n-go/the_last_sundown': {
        title: 'The Last Sundown: 94% RTP, 18,000x Max Win | {brand}',
        description: 'The Last Sundown runs at 94% RTP at {brand}, with a 18,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/the_paying_piano_club': {
        title: 'The Paying Piano Club: 94% RTP, 5,000x Max Win | {brand}',
        description: 'The Paying Piano Club runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/the_return_of_the_green_knight': {
        title: 'The Return of the Green Knight: 94% RTP | {brand}',
        description: 'The Return of the Green Knight runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/the_sword_and_the_grail': {
        title: 'The Sword and The Grail: 94% RTP, 10,000x Max Win | {brand}',
        description: 'The Sword and The Grail runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/the_sword_and_the_grail_excalibur': {
        title: 'The Sword and the Grail Excalibur: 94% RTP | {brand}',
        description: 'The Sword and the Grail Excalibur runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/the_wild_class': {
        title: 'The Wild Class: 94% RTP, 6,666x Max Win | {brand}',
        description: 'The Wild Class runs at 94% RTP at {brand}, with a 6,666x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/thunderscreech': {
        title: 'Thunderscreech: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Thunderscreech runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/tomb_of_gold': {
        title: 'Tomb of Gold: 94% RTP | {brand}',
        description: 'Tomb of Gold runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/tomb_of_gold_ii': {
        title: 'Tomb of Gold II: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Tomb of Gold II runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/tome_of_madness_bingo': {
        title: 'Tome Of Madness Bingo: 94% RTP, 4,250x Max Win | {brand}',
        description: 'Tome Of Madness Bingo runs at 94% RTP at {brand}, with a 4,250x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/treasures_of_kongar': {
        title: 'Treasures of Kongar: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Treasures of Kongar runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/treats_of_terror': {
        title: 'Treats of Terror: 96.2% RTP, 10,000x Max Win | {brand}',
        description: 'Treats of Terror runs at 96.2% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/trinity_impact': {
        title: 'Trinity Impact: 94% RTP, 1,600x Max Win | {brand}',
        description: 'Trinity Impact runs at 94% RTP at {brand}, with a 1,600x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/troll_hunters': {
        title: 'Troll Hunters: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Troll Hunters runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/troll_hunters_2': {
        title: 'Troll Hunters 2: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Troll Hunters 2 runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/undefeated_xerxes': {
        title: 'Undefeated Xerxes: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Undefeated Xerxes runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/usa_flip': {
        title: 'USA Flip: 94% RTP, 1,000x Max Win | {brand}',
        description: 'USA Flip runs at 94% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/viking_apocalypse': {
        title: 'Viking Apocalypse: 94% RTP, 1,000,000x Max Win | {brand}',
        description: 'Viking Apocalypse runs at 94% RTP at {brand}, with a 1,000,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/viking_runecraft': {
        title: 'Viking Runecraft: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Viking Runecraft runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/viking_runecraft_100': {
        title: 'Viking Runecraft 100: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Viking Runecraft 100 runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/viking_runecraft_bingo': {
        title: 'Viking Runecraft Bingo Slot | 10,000x Win | {brand}',
        description: "Viking Runecraft Bingo slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/viper_city_heist': {
        title: 'Viper City Heist: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Viper City Heist runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wheel_of_mictlan': {
        title: 'Wheel of Mictlan: 96.2% RTP, 40,000x Max Win | {brand}',
        description: 'Wheel of Mictlan runs at 96.2% RTP at {brand}, with a 40,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/whispering_winds': {
        title: 'Whispering Winds: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Whispering Winds runs at 94% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_bandolier': {
        title: 'Wild Bandolier: 94% RTP, 900,000x Max Win | {brand}',
        description: 'Wild Bandolier runs at 94% RTP at {brand}, with a 900,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_blood': {
        title: 'Wild Blood: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Wild Blood runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_blood_2': {
        title: 'Wild Blood 2: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Blood 2 runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_falls': {
        title: 'Wild Falls: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Wild Falls runs at 94% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_falls_2': {
        title: 'Wild Falls 2: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Wild Falls 2 runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_frames': {
        title: 'Wild Frames: 94% RTP, 7,000x Max Win | {brand}',
        description: 'Wild Frames runs at 94% RTP at {brand}, with a 7,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_melon': {
        title: 'Wild Melon: 94% RTP, 3,333x Max Win | {brand}',
        description: 'Wild Melon runs at 94% RTP at {brand}, with a 3,333x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_north': {
        title: 'Wild North: 94% RTP, 2,500x Max Win | {brand}',
        description: 'Wild North runs at 94% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_rails': {
        title: 'Wild Rails: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Rails runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_survivor': {
        title: 'Wild Survivor: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Wild Survivor runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wild_trigger': {
        title: 'Wild Trigger: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Wild Trigger runs at 94% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wildest_gambit': {
        title: 'Wildest Gambit: 94% RTP | {brand}',
        description: 'Wildest Gambit runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wildhound_derby': {
        title: 'Wildhound Derby: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Wildhound Derby runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/winabeest': {
        title: 'Win-A-Beest: 94% RTP, 10,240x Max Win | {brand}',
        description: 'Win-A-Beest runs at 94% RTP at {brand}, with a 10,240x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/wizard_of_gems': {
        title: 'Wizard of Gems: 94% RTP, 12,500x Max Win | {brand}',
        description: 'Wizard of Gems runs at 94% RTP at {brand}, with a 12,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/play-n-go/xmas_joker': {
        title: 'Xmas Joker: 94% RTP, 6,480x Max Win | {brand}',
        description: 'Xmas Joker runs at 94% RTP at {brand}, with a 6,480x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/hawaiian_tiki': {
        title: 'Hawaiian Tiki: 96.76% RTP, 1,274x Max Win | {brand}',
        description: 'Hawaiian Tiki runs at 96.76% RTP, with a 1,274x max win and medium volatility. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/pragmatic-play-live/big_small_baccarat': {
        title: 'Big Small Baccarat: up to 98.94% RTP | {brand}',
        description: 'Live Big Small Baccarat at {brand} returns up to 98.94%, with Big and Small side bets on the card count. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play-live/amazing_baccarat': {
        title: 'Amazing Baccarat: Lucky Cards up to 200x | {brand}',
        description: 'Live speed baccarat at {brand} with Lucky Card multipliers up to 200x and the Amazing 8s side bet. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play-live/baccarat_lobby': {
        title: 'Baccarat Lobby: 18 Live Tables | {brand}',
        description: 'Every Pragmatic Play Live baccarat table open at {brand}, with the RTP of each. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/roulette_lobby': {
        title: 'Roulette Lobby: 32 Live Tables at 97.30% | {brand}',
        description: 'Every Pragmatic Play Live roulette table open at {brand}, with the RTP of each. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/dragon_tiger_lobby': {
        title: 'Dragon Tiger Lobby: 96.27% RTP | {brand}',
        description: 'The Pragmatic Play Live Dragon Tiger table open at {brand}, returning 96.27%. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pragmatic-play-live/game_show_lobby': {
        title: 'Game Show Lobby: 10 Live Shows | {brand}',
        description: 'Every Pragmatic Play Live game show open at {brand}, with the RTP of each. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/baccarat_deluxe': {
        title: 'Baccarat Deluxe: PG Soft RNG Baccarat | {brand}',
        description: "PG Soft's RNG baccarat table at {brand}. No RTP is published by the catalogue or the studio - alternatives that do publish one."
    },
    '/p/relax-gaming/agroculture': {
        title: 'AgroCulture: 94% RTP, 10,000x Max Win | {brand}',
        description: 'AgroCulture runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/ancient_tumble': {
        title: 'Ancient Tumble: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Ancient Tumble runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/atlantis_crush': {
        title: 'Atlantis Crush: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Atlantis Crush runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/attila_the_hun': {
        title: 'Attila The Hun: 96.38% RTP, 1,048x Max Win | {brand}',
        description: 'Attila The Hun runs at 96.38% RTP at {brand}, with a 1,048x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/aura_god': {
        title: 'Aura God: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Aura God runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/aussies_vs_emus': {
        title: 'Aussies vs Emus: 93.69% RTP | {brand}',
        description: 'Aussies vs Emus runs at 93.69% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/bacon_bankroll': {
        title: 'Bacon Bankroll: 94% RTP, 5,106x Max Win | {brand}',
        description: 'Bacon Bankroll runs at 94% RTP at {brand}, with a 5,106x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/banana_town': {
        title: 'Banana Town: 96% RTP | {brand}',
        description: 'Banana Town runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/beast_gains': {
        title: 'Beast Gains: 94% RTP, 25,000x Max Win | {brand}',
        description: 'Beast Gains runs at 94% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/beast_mode': {
        title: 'Beast Mode: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Beast Mode runs at 96% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/beellionaires': {
        title: 'Beellionaires: 94% RTP | {brand}',
        description: 'Beellionaires runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/bill_and_coin': {
        title: 'Bill & Coin: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Bill & Coin runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/bill_and_coin_2': {
        title: 'Bill and Coin 2: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Bill and Coin 2 runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/blender_blitz': {
        title: 'Blender Blitz: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Blender Blitz runs at 96% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/bone_raiders': {
        title: 'Bone Raiders: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Bone Raiders runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/bonsai_dragon_blitz': {
        title: 'Bonsai Dragon Blitz: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Bonsai Dragon Blitz runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/book_of': {
        title: 'Book of: 96% RTP | {brand}',
        description: 'Book of runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/book_of_power': {
        title: 'Book of Power: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Book of Power runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/bounty_county': {
        title: 'Bounty County: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Bounty County runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/camelot_cash': {
        title: 'Camelot Cash: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Camelot Cash runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/cash_in_transit': {
        title: 'Cash in Transit: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Cash in Transit runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/caveman_bob': {
        title: 'Caveman Bob: 96% RTP, 500x Max Win | {brand}',
        description: 'Caveman Bob runs at 96% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/chip_spin': {
        title: 'Chip Spin: 96% RTP, 25,102x Max Win | {brand}',
        description: 'Chip Spin runs at 96% RTP at {brand}, with a 25,102x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/cluster_tumble': {
        title: 'Cluster Tumble: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Cluster Tumble runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/cod_of_thunder': {
        title: 'Cod of Thunder: 94% RTP | {brand}',
        description: 'Cod of Thunder runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/conquer_babylon': {
        title: 'Conquer Babylon: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Conquer Babylon runs at 94% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/cowabunga': {
        title: 'Cowabunga: 94% RTP | {brand}',
        description: 'Cowabunga runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/dead_mans_trail': {
        title: "Dead Man's Trail: 96% RTP, 50,000x Max Win | {brand}",
        description: "Dead Man's Trail runs at 96% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/dead_riders_trail': {
        title: 'Dead Riders Trail: 94% RTP, 50,561x Max Win | {brand}',
        description: 'Dead Riders Trail runs at 94% RTP at {brand}, with a 50,561x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/deep_descent': {
        title: 'Deep Descent: 96% RTP, 18,814x Max Win | {brand}',
        description: 'Deep Descent runs at 96% RTP at {brand}, with a 18,814x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/diamonds': {
        title: 'Diamonds: 94% RTP | {brand}',
        description: 'Diamonds runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/dragons_awakening': {
        title: "Dragons' Awakening: 96% RTP, 4,573x Max Win | {brand}",
        description: "Dragons' Awakening runs at 96% RTP at {brand}, with a 4,573x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/emeralds_infinity_reels': {
        title: "Emerald's Infinity Reels: 96% RTP, 24,056x Max Win | {brand}",
        description: "Emerald's Infinity Reels runs at 96% RTP at {brand}, with a 24,056x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/epic_dreams': {
        title: 'Epic Dreams: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Epic Dreams runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/epic_joker': {
        title: 'Epic Joker: 96% RTP, 1,254x Max Win | {brand}',
        description: 'Epic Joker runs at 96% RTP at {brand}, with a 1,254x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/erik_the_red': {
        title: 'Erik the Red: 96% RTP, 959x Max Win | {brand}',
        description: 'Erik the Red runs at 96% RTP at {brand}, with a 959x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/fangs_inferno': {
        title: "Fang's Inferno: 94% RTP, 5,000x Max Win | {brand}",
        description: "Fang's Inferno runs at 94% RTP at {brand}, with a 5,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/feather_fury': {
        title: 'Feather Fury: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Feather Fury runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/firewins_factory': {
        title: 'FireWins Factory: 94% RTP, 9,344x Max Win | {brand}',
        description: 'FireWins Factory runs at 94% RTP at {brand}, with a 9,344x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/fly_cat': {
        title: 'Fly Cat$: 94% RTP | {brand}',
        description: 'Fly Cat$ runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/franks_diner': {
        title: "Frank's Diner: 94% RTP, 10,000x Max Win | {brand}",
        description: "Frank's Diner runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/freaked_out_fish': {
        title: 'Freaked Out Fish: 94% RTP | {brand}',
        description: 'Freaked Out Fish runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/frequent_flyer': {
        title: 'Frequent Flyer: 96% RTP, 5,426x Max Win | {brand}',
        description: 'Frequent Flyer runs at 96% RTP at {brand}, with a 5,426x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/galactic_racers': {
        title: 'Galactic Racers: 94% RTP | {brand}',
        description: 'Galactic Racers runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/giants_and_sheep': {
        title: 'Giants and Sheep: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Giants and Sheep runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/glyph_of_gods': {
        title: 'Glyph of Gods: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Glyph of Gods runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/grim_the_splitter': {
        title: 'Grim The Splitter: 94% RTP | {brand}',
        description: 'Grim The Splitter runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/groovy_knights': {
        title: 'Groovy Knights: 94% RTP | {brand}',
        description: 'Groovy Knights runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/guitar_quest': {
        title: 'Guitar Quest: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Guitar Quest runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/hazakura_ways': {
        title: 'Hazakura Ways: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Hazakura Ways runs at 96% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/helios_fury': {
        title: "Helios' Fury: 96% RTP, 50,000x Max Win | {brand}",
        description: "Helios' Fury runs at 96% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/hellcatraz': {
        title: 'Hellcatraz: 96% RTP | {brand}',
        description: 'Hellcatraz runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/hellcatraz_2': {
        title: 'Hellcatraz 2: 94% RTP | {brand}',
        description: 'Hellcatraz 2 runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/heroes_gathering': {
        title: "Heroes' Gathering: 96% RTP, 29,794x Max Win | {brand}",
        description: "Heroes' Gathering runs at 96% RTP at {brand}, with a 29,794x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/hex': {
        title: 'Hex: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Hex runs at 96% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/horror_hotel': {
        title: 'Horror Hotel: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Horror Hotel runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/hot_rod_racers': {
        title: 'Hot Rod Racers: 94% RTP, 25,000x Max Win | {brand}',
        description: 'Hot Rod Racers runs at 94% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/ignite_the_night': {
        title: 'Ignite the Night: 96% RTP, 5,734x Max Win | {brand}',
        description: 'Ignite the Night runs at 96% RTP at {brand}, with a 5,734x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/immortal_5': {
        title: 'Immortal 5: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Immortal 5 runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/iron_bank': {
        title: 'Iron Bank: 96% RTP, 49,998x Max Win | {brand}',
        description: 'Iron Bank runs at 96% RTP at {brand}, with a 49,998x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/iron_bank_2': {
        title: 'Iron Bank 2: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Iron Bank 2 runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/its_time': {
        title: "It's Time!!: 96% RTP, 2,500x Max Win | {brand}",
        description: "It's Time!! runs at 96% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/joker_split': {
        title: 'Joker Split: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Joker Split runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/jumbo_juicy': {
        title: 'Jumbo Juicy: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Jumbo Juicy runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/jupiters_choice': {
        title: 'Jupiters Choice: 96% RTP | {brand}',
        description: 'Jupiters Choice runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/jurassic_party': {
        title: 'Jurassic Party: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Jurassic Party runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/king_of_kings': {
        title: 'King of Kings: 96% RTP, 10,509x Max Win | {brand}',
        description: 'King of Kings runs at 96% RTP at {brand}, with a 10,509x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/kluster_krystals_megaclusters': {
        title: 'Kluster Krystals Megaclusters: 96% RTP, 9,921x Max Win | {brand}',
        description: 'Kluster Krystals Megaclusters runs at 96% RTP at {brand}, with a 9,921x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/krakens_cove': {
        title: "Kraken's Cove: 94% RTP, 10,000x Max Win | {brand}",
        description: "Kraken's Cove runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/la_fiesta': {
        title: 'La Fiesta: 96% RTP, 14,778x Max Win | {brand}',
        description: 'La Fiesta runs at 96% RTP at {brand}, with a 14,778x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/legend_of_odysseus': {
        title: 'Legend of Odysseus: 94.09% RTP | {brand}',
        description: 'Legend of Odysseus runs at 94.09% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/lets_get_ready_to_rumble': {
        title: "Let's get ready to Rumble: 96% RTP, 2,389x Max Win | {brand}",
        description: "Let's get ready to Rumble runs at 96% RTP at {brand}, with a 2,389x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/lure_of_fortune': {
        title: 'Lure of Fortune: 94% RTP | {brand}',
        description: 'Lure of Fortune runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/magawa_vs_mines': {
        title: 'Magawa vs Mines: 94% RTP | {brand}',
        description: 'Magawa vs Mines runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/marching_legions': {
        title: 'Marching Legions: 96% RTP, 7,458x Max Win | {brand}',
        description: 'Marching Legions runs at 96% RTP at {brand}, with a 7,458x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/masked_treasures': {
        title: 'Masked Treasures: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Masked Treasures runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/mega_flip': {
        title: 'Mega Flip: 96% RTP, 5,493x Max Win | {brand}',
        description: 'Mega Flip runs at 96% RTP at {brand}, with a 5,493x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/mega_heist': {
        title: 'Mega Heist: 94% RTP, 16,591x Max Win | {brand}',
        description: 'Mega Heist runs at 94% RTP at {brand}, with a 16,591x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/mega_masks': {
        title: 'Mega Masks: 96% RTP, 2,451x Max Win | {brand}',
        description: 'Mega Masks runs at 96% RTP at {brand}, with a 2,451x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/mega_mine': {
        title: 'Mega Mine: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Mega Mine runs at 96% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/midnight_marauder': {
        title: 'Midnight Marauder: 96% RTP, 31,605x Max Win | {brand}',
        description: 'Midnight Marauder runs at 96% RTP at {brand}, with a 31,605x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/midnight_marauder_clusterbreaker': {
        title: 'Midnight Marauder ClusterBreaker: 94% RTP | {brand}',
        description: 'Midnight Marauder ClusterBreaker runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_cart': {
        title: 'Money Cart: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Money Cart runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_cart_2': {
        title: 'Money Cart 2: 98% RTP, 5,000x Max Win | {brand}',
        description: 'Money Cart 2 runs at 98% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_cart_3': {
        title: 'Money Cart 3: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Money Cart 3 runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_cart_4': {
        title: 'Money Cart 4: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Money Cart 4 runs at 94% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_plane': {
        title: 'Money Plane: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Money Plane runs at 94% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_sleigh': {
        title: 'Money Sleigh: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Money Sleigh runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_train': {
        title: 'Money Train: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Money Train runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_train_2': {
        title: 'Money Train 2: 96% RTP | {brand}',
        description: 'Money Train 2 runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_train_3': {
        title: 'Money Train 3: 96% RTP | {brand}',
        description: 'Money Train 3 runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_train_5': {
        title: 'Money Train 5: 94% RTP | {brand}',
        description: 'Money Train 5 runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/money_train_origins': {
        title: 'Money Train Origins: 94% RTP | {brand}',
        description: 'Money Train Origins runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/monkey_gods_of_the_inca': {
        title: 'Monkey Gods of the Inca: 94% RTP | {brand}',
        description: 'Monkey Gods of the Inca runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/multiplier_odyssey': {
        title: 'Multiplier Odyssey: 96% RTP, 50,895x Max Win | {brand}',
        description: 'Multiplier Odyssey runs at 96% RTP at {brand}, with a 50,895x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/mystic_multipliers': {
        title: 'Mystic Multipliers: 94.09% RTP | {brand}',
        description: 'Mystic Multipliers runs at 94.09% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/napoleon_vs_rabbits': {
        title: 'Napoleon vs Rabbits: 94% RTP | {brand}',
        description: 'Napoleon vs Rabbits runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/necromancers_gate': {
        title: "Necromancer's Gate: 94% RTP, 25,000x Max Win | {brand}",
        description: "Necromancer's Gate runs at 94% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/neko_night': {
        title: 'Neko Night: 94% RTP | {brand}',
        description: 'Neko Night runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/net_gains': {
        title: 'Net Gains: 94% RTP, 15,000x Max Win | {brand}',
        description: 'Net Gains runs at 94% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/olympus_7s': {
        title: 'Olympus 7s: 94% RTP | {brand}',
        description: 'Olympus 7s runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/pharaohs_last_wish': {
        title: "Pharaoh's Last Wish: 94% RTP, 10,000x Max Win | {brand}",
        description: "Pharaoh's Last Wish runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/pinata_popper': {
        title: 'Pinata Popper: 94% RTP | {brand}',
        description: 'Pinata Popper runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/plunderland': {
        title: 'Plunderland: 96% RTP, 10,266x Max Win | {brand}',
        description: 'Plunderland runs at 96% RTP at {brand}, with a 10,266x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/powerspin': {
        title: 'Powerspin: 96% RTP, 300x Max Win | {brand}',
        description: 'Powerspin runs at 96% RTP at {brand}, with a 300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/purrrminator': {
        title: 'Purrrminator: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Purrrminator runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/quackin_reels': {
        title: "Quackin' Reels: 94% RTP, 8,850x Max Win | {brand}",
        description: "Quackin' Reels runs at 94% RTP at {brand}, with a 8,850x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/ramses_revenge': {
        title: 'Ramses Revenge: 96% RTP, 49,996x Max Win | {brand}',
        description: 'Ramses Revenge runs at 96% RTP at {brand}, with a 49,996x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/sails_of_fortune': {
        title: 'Sails of Fortune: 96% RTP, 36,383x Max Win | {brand}',
        description: 'Sails of Fortune runs at 96% RTP at {brand}, with a 36,383x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/santas_stack': {
        title: "Santa's Stack: 96.27% RTP, 20,000x Max Win | {brand}",
        description: "Santa's Stack runs at 96.27% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/shark_wash': {
        title: 'Shark Wash: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Shark Wash runs at 96% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/sloth_tumble': {
        title: 'Sloth Tumble: 94% RTP | {brand}',
        description: 'Sloth Tumble runs at 94% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/snake_arena': {
        title: 'Snake Arena: 96% RTP, 2,758x Max Win | {brand}',
        description: 'Snake Arena runs at 96% RTP at {brand}, with a 2,758x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/snake_arena_2': {
        title: 'Snake Arena 2: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Snake Arena 2 runs at 94% RTP at {brand}, with a 50,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/snakes_gold': {
        title: 'Snakes Gold: 94.19% RTP | {brand}',
        description: 'Snakes Gold runs at 94.19% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/space_miners': {
        title: 'Space Miners: 96% RTP, 50,000x Max Win | {brand}',
        description: 'Space Miners runs at 96% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/spirit_of_the_beast': {
        title: 'Spirit of the Beast: 96% RTP, 11,531x Max Win | {brand}',
        description: 'Spirit of the Beast runs at 96% RTP at {brand}, with a 11,531x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/st_louis_1904': {
        title: 'St Louis 1904: 93.99% RTP | {brand}',
        description: 'St Louis 1904 runs at 93.99% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/sultan_spins': {
        title: 'Sultan Spins: 94% RTP, 5,015x Max Win | {brand}',
        description: 'Sultan Spins runs at 94% RTP at {brand}, with a 5,015x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/sweetopia_royale': {
        title: 'Sweetopia Royale: 94% RTP, 5,000x Max Win | {brand}',
        description: 'Sweetopia Royale runs at 94% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/templar_tumble': {
        title: 'Templar Tumble: 96% RTP, 17,371x Max Win | {brand}',
        description: 'Templar Tumble runs at 96% RTP at {brand}, with a 17,371x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/templar_tumble_2': {
        title: 'Templar Tumble 2: 94% RTP | {brand}',
        description: 'Templar Tumble 2 runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/temple_tumble_megaways': {
        title: 'Temple Tumble MegaWays: 96% RTP, 7,767x Max Win | {brand}',
        description: 'Temple Tumble MegaWays runs at 96% RTP at {brand}, with a 7,767x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/the_great_pigsby': {
        title: 'The Great Pigsby: 96% RTP, 810x Max Win | {brand}',
        description: 'The Great Pigsby runs at 96% RTP at {brand}, with a 810x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/the_great_pigsby_megapays': {
        title: 'The Great Pigsby Megapays: 96.19% RTP, 20,000x Max Win | {brand}',
        description: 'The Great Pigsby Megapays runs at 96.19% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/the_great_pigsby_megaways': {
        title: 'The Great Pigsby MegaWays: 94% RTP, 20,000x Max Win | {brand}',
        description: 'The Great Pigsby MegaWays runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/the_tumbles': {
        title: 'The Tumbles: 94% RTP, 5,000x Max Win | {brand}',
        description: 'The Tumbles runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/tiger_kingdom': {
        title: 'Tiger Kingdom: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Tiger Kingdom runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/tiger_shrine': {
        title: 'Tiger Shrine: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Tiger Shrine runs at 94% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/titan_strike': {
        title: 'Titan Strike: 94% RTP, 2,000x Max Win | {brand}',
        description: 'Titan Strike runs at 94% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/tnt_tumble': {
        title: 'TNT Tumble: 96% RTP, 12,278x Max Win | {brand}',
        description: 'TNT Tumble runs at 96% RTP at {brand}, with a 12,278x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/top_dawg': {
        title: 'Top Dawg$: 96% RTP, 25,014x Max Win | {brand}',
        description: 'Top Dawg$ runs at 96% RTP at {brand}, with a 25,014x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/torii_tumble': {
        title: 'Torii Tumble: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Torii Tumble runs at 94% RTP at {brand}, with a 20,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/totem_guardians': {
        title: 'Totem Guardians: 94% RTP | {brand}',
        description: 'Totem Guardians runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/tower_tumble': {
        title: 'Tower Tumble: 96% RTP, 5,150x Max Win | {brand}',
        description: 'Tower Tumble runs at 96% RTP at {brand}, with a 5,150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/treasure_tumble': {
        title: 'Treasure Tumble: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Treasure Tumble runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/trolls_gold': {
        title: "Troll's Gold: 96% RTP, 12,500x Max Win | {brand}",
        description: "Troll's Gold runs at 96% RTP at {brand}, with a 12,500x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/relax-gaming/volatile_vikings': {
        title: 'Volatile Vikings: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Volatile Vikings runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/volatile_vikings_2': {
        title: 'Volatile Vikings 2: 96.3% RTP, 10,000x Max Win | {brand}',
        description: 'Volatile Vikings 2 runs at 96.3% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/wild_chapo': {
        title: 'Wild Chapo: 96% RTP, 10,044x Max Win | {brand}',
        description: 'Wild Chapo runs at 96% RTP at {brand}, with a 10,044x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/wild_chapo_2': {
        title: 'Wild Chapo 2: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Wild Chapo 2 runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/wild_hike': {
        title: 'Wild Hike: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Wild Hike runs at 94% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/wild_yield': {
        title: 'Wild Yield: 94% RTP, 50,000x Max Win | {brand}',
        description: 'Wild Yield runs at 94% RTP at {brand}, with a 50,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/wildchemy': {
        title: 'Wildchemy: 96% RTP, 697x Max Win | {brand}',
        description: 'Wildchemy runs at 96% RTP at {brand}, with a 697x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/winter_champions': {
        title: 'Winter Champions: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Winter Champions runs at 94% RTP at {brand}, with a 6,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/world_class_kick_off': {
        title: 'World Class Kick Off: 94% RTP | {brand}',
        description: 'World Class Kick Off runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/relax-gaming/zombie_circus': {
        title: 'Zombie Circus: 96% RTP, 10,587x Max Win | {brand}',
        description: 'Zombie Circus runs at 96% RTP at {brand}, with a 10,587x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/black_friday': {
        title: 'Black Friday: 96.35% RTP, 20,000x Max Win | {brand}',
        description: 'Black Friday runs at 96.35% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/brainwashed': {
        title: 'Brainwashed: 96.28% RTP, 20,000x Max Win | {brand}',
        description: 'Brainwashed runs at 96.28% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/devils_finger': {
        title: 'Devils Finger: 96.4% RTP, 20,000x Max Win | {brand}',
        description: 'Devils Finger runs at 96.4% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/laced': {
        title: 'Laced: 96.12% RTP, 20,000x Max Win | {brand}',
        description: 'Laced runs at 96.12% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/mortal_bromance': {
        title: 'Mortal Bromance: 96.28% RTP | {brand}',
        description: 'Mortal Bromance runs at 96.28% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/office_party': {
        title: 'Office Party: 96.51% RTP, 20,000x Max Win | {brand}',
        description: 'Office Party runs at 96.51% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/oops': {
        title: 'Oops: 96.28% RTP, 20,000x Max Win | {brand}',
        description: 'Oops runs at 96.28% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/orphan_organ': {
        title: 'Orphan Organ: 96.17% RTP, 20,000x Max Win | {brand}',
        description: 'Orphan Organ runs at 96.17% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/preach_tv': {
        title: 'Preach TV: 94.45% RTP, 20,000x Max Win | {brand}',
        description: 'Preach TV runs at 94.45% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/sew': {
        title: 'Sew: 96.33% RTP, 20,000x Max Win | {brand}',
        description: 'Sew runs at 96.33% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/sheeple': {
        title: 'Sheeple: 96.31% RTP, 20,000x Max Win | {brand}',
        description: 'Sheeple runs at 96.31% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/suck': {
        title: 'Suck: 96.06% RTP, 20,000x Max Win | {brand}',
        description: 'Suck runs at 96.06% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/swoll': {
        title: 'Swoll: 96.21% RTP, 20,000x Max Win | {brand}',
        description: 'Swoll runs at 96.21% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/trap_tower': {
        title: 'Trap Tower: 96.26% RTP, 20,000x Max Win | {brand}',
        description: 'Trap Tower runs at 96.26% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/shadylady/truth': {
        title: 'Truth: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Truth runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/3021_ad_the_bounty_hunter_gigablox': {
        title: '3021 AD The Bounty Hunter Gigablox: 96% RTP | {brand}',
        description: '3021 AD The Bounty Hunter Gigablox runs at 96% RTP at {brand}, with a 9,052x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/3_gladiators_vs_caesar': {
        title: '3 Gladiators Vs Caesar: 94% RTP, 2,930x Max Win | {brand}',
        description: '3 Gladiators Vs Caesar runs at 94% RTP at {brand}, with a 2,930x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/4_foxx_crew_wild_energy_multimax': {
        title: '4 Foxx Crew Wild Energy Multimax: 94% RTP | {brand}',
        description: '4 Foxx Crew Wild Energy Multimax runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/777_volt_gigablox': {
        title: '777 Volt GigaBlox: 94% RTP, 5,000x Max Win | {brand}',
        description: '777 Volt GigaBlox runs at 94% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/age_of_asgard': {
        title: 'Age of Asgard: 96% RTP, 2,444x Max Win | {brand}',
        description: 'Age of Asgard runs at 96% RTP at {brand}, with a 2,444x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/alchymedes': {
        title: 'Alchymedes: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Alchymedes runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/aldos_journey': {
        title: "Aldo's Journey: 96% RTP, 4,205x Max Win | {brand}",
        description: "Aldo's Journey runs at 96% RTP at {brand}, with a 4,205x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/yggdrasil-gaming/aphrodite_goes_wild_rushingwilds': {
        title: 'Aphrodite Goes Wild RushingWilds: 94% RTP | {brand}',
        description: 'Aphrodite Goes Wild RushingWilds runs at 94% RTP at {brand}, with a 82,982x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/arthurs_fortune': {
        title: "Arthur's Fortune: 96% RTP, 10,857x Max Win | {brand}",
        description: "Arthur's Fortune runs at 96% RTP at {brand}, with a 10,857x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/yggdrasil-gaming/atlantean_gigarise': {
        title: 'Atlantean Gigarise: 96% RTP, 4,017x Max Win | {brand}',
        description: 'Atlantean Gigarise runs at 96% RTP at {brand}, with a 4,017x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/avatars_gateway_guardians': {
        title: 'Avatars: Gateway Guardians: 96% RTP, 2,900x Max Win | {brand}',
        description: 'Avatars: Gateway Guardians runs at 96% RTP at {brand}, with a 2,900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/badger_miners': {
        title: 'Badger Miners: 96.2% RTP | {brand}',
        description: 'Badger Miners runs at 96.2% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/baron_samedi': {
        title: 'Baron Samedi: 96% RTP, 2,179x Max Win | {brand}',
        description: 'Baron Samedi runs at 96% RTP at {brand}, with a 2,179x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/beasty_blox_gigablox': {
        title: 'Beasty Blox GigaBlox: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Beasty Blox GigaBlox runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/beauty_and_the_beast': {
        title: 'Beauty and the Beast: 96% RTP, 400x Max Win | {brand}',
        description: 'Beauty and the Beast runs at 96% RTP at {brand}, with a 400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/bicicleta': {
        title: 'Bicicleta: 96% RTP, 1,900x Max Win | {brand}',
        description: 'Bicicleta runs at 96% RTP at {brand}, with a 1,900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/big_blox': {
        title: 'Big Blox: 96% RTP, 3,888x Max Win | {brand}',
        description: 'Big Blox runs at 96% RTP at {brand}, with a 3,888x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/blood_moon_wilds': {
        title: 'Blood Moon Wilds: 96% RTP, 2,130x Max Win | {brand}',
        description: 'Blood Moon Wilds runs at 96% RTP at {brand}, with a 2,130x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/bloody_pesos': {
        title: 'Bloody Pesos: 96% RTP, 90,000x Max Win | {brand}',
        description: 'Bloody Pesos runs at 96% RTP at {brand}, with a 90,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/bob_marlin_goes_deep': {
        title: 'Bob Marlin Goes Deep: 96.8% RTP, 19,996x Max Win | {brand}',
        description: 'Bob Marlin Goes Deep runs at 96.8% RTP at {brand}, with a 19,996x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/boilin_pots': {
        title: "Boilin' Pots: 96% RTP, 10,114x Max Win | {brand}",
        description: "Boilin' Pots runs at 96% RTP at {brand}, with a 10,114x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/yggdrasil-gaming/brazil_bomba_mobile': {
        title: 'Brazil Bomba Mobile: 96% RTP, 6,218x Max Win | {brand}',
        description: 'Brazil Bomba Mobile runs at 96% RTP at {brand}, with a 6,218x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/buffalo_freedom_doublemax': {
        title: 'Buffalo Freedom Doublemax: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Buffalo Freedom Doublemax runs at 96% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/calavera_crush': {
        title: 'Calavera Crush: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Calavera Crush runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/candyfinity': {
        title: 'Candyfinity: 96.2% RTP | {brand}',
        description: 'Candyfinity runs at 96.2% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/cannonade': {
        title: 'Cannonade!: 96% RTP, 17,001x Max Win | {brand}',
        description: 'Cannonade! runs at 96% RTP at {brand}, with a 17,001x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/carol_of_the_elves': {
        title: 'Carol of the Elves: 96% RTP, 5,800x Max Win | {brand}',
        description: 'Carol of the Elves runs at 96% RTP at {brand}, with a 5,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/casino_zeppelin_reloaded': {
        title: 'Casino Zeppelin Reloaded: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Casino Zeppelin Reloaded runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/cazino_cosmos': {
        title: 'Cazino Cosmos: 96% RTP, 11,821x Max Win | {brand}',
        description: 'Cazino Cosmos runs at 96% RTP at {brand}, with a 11,821x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/cazino_zeppelin': {
        title: 'Cazino Zeppelin: 96% RTP, 6,700x Max Win | {brand}',
        description: 'Cazino Zeppelin runs at 96% RTP at {brand}, with a 6,700x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/champion_of_the_underworld': {
        title: 'Champion of the Underworld: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Champion of the Underworld runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/champions_of_rome': {
        title: 'Champions of Rome: 96% RTP, 2,683x Max Win | {brand}',
        description: 'Champions of Rome runs at 96% RTP at {brand}, with a 2,683x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/chibeasties': {
        title: 'Chibeasties: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Chibeasties runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/christmas_plaza_doublemax': {
        title: 'Christmas Plaza Doublemax: 96% RTP, 19,978x Max Win | {brand}',
        description: 'Christmas Plaza Doublemax runs at 96% RTP at {brand}, with a 19,978x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/coocoo_cashoo': {
        title: 'CooCoo Cashoo: 96% RTP, 5,154x Max Win | {brand}',
        description: 'CooCoo Cashoo runs at 96% RTP at {brand}, with a 5,154x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/dark_vortex': {
        title: 'Dark Vortex: 96% RTP, 2,683x Max Win | {brand}',
        description: 'Dark Vortex runs at 96% RTP at {brand}, with a 2,683x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/defenders_of_mystica': {
        title: 'Defenders of Mystica: 96% RTP | {brand}',
        description: 'Defenders of Mystica runs at 96% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/devour_the_weak': {
        title: 'Devour the Weak: 96.2% RTP | {brand}',
        description: 'Devour the Weak runs at 96.2% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/dick_the_farmer': {
        title: 'Dick the Farmer: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Dick the Farmer runs at 96% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/double_dragons': {
        title: 'Double Dragons: 96% RTP, 800x Max Win | {brand}',
        description: 'Double Dragons runs at 96% RTP at {brand}, with a 800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/dr_fortuno': {
        title: 'Dr Fortuno: 96% RTP, 4,000x Max Win | {brand}',
        description: 'Dr Fortuno runs at 96% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/dwarf_mine': {
        title: 'Dwarf Mine: 96% RTP, 3,904x Max Win | {brand}',
        description: 'Dwarf Mine runs at 96% RTP at {brand}, with a 3,904x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/easter_island': {
        title: 'Easter Island: 96% RTP, 1,880x Max Win | {brand}',
        description: 'Easter Island runs at 96% RTP at {brand}, with a 1,880x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/easter_island_2': {
        title: 'Easter Island 2: 96% RTP, 2,500x Max Win | {brand}',
        description: 'Easter Island 2 runs at 96% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/eforce': {
        title: 'E-Force: 96% RTP, 10,000x Max Win | {brand}',
        description: 'E-Force runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/elysian_jackpots': {
        title: 'Elysian Jackpots: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Elysian Jackpots runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/fatzs_diner': {
        title: "Fatz's Diner: 96% RTP, 9,052x Max Win | {brand}",
        description: "Fatz's Diner runs at 96% RTP at {brand}, with a 9,052x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/yggdrasil-gaming/firekick_multimax': {
        title: 'Firekick! Multimax: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Firekick! Multimax runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/florageddon': {
        title: 'Florageddon: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Florageddon runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/football_glory': {
        title: 'Football Glory: 96% RTP, 4,000x Max Win | {brand}',
        description: 'Football Glory runs at 96% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/frost_queen_jackpots': {
        title: 'Frost Queen Jackpots: 96% RTP, 1,265x Max Win | {brand}',
        description: 'Frost Queen Jackpots runs at 96% RTP at {brand}, with a 1,265x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/fruitoids': {
        title: 'Fruitoids: 96% RTP, 2,500x Max Win | {brand}',
        description: 'Fruitoids runs at 96% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/gator_gold_deluxe_gigablox': {
        title: 'Gator Gold Deluxe Gigablox: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Gator Gold Deluxe Gigablox runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/gator_gold_gigablox': {
        title: 'Gator Gold Gigablox: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Gator Gold Gigablox runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/gem_rocks': {
        title: 'Gem Rocks: 96% RTP, 9,217x Max Win | {brand}',
        description: 'Gem Rocks runs at 96% RTP at {brand}, with a 9,217x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/gemstone_jam': {
        title: 'Gemstone Jam: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Gemstone Jam runs at 96% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/giga_zombies_giga_blox': {
        title: 'Giga Zombies Giga Blox: 96% RTP, 6,260x Max Win | {brand}',
        description: 'Giga Zombies Giga Blox runs at 96% RTP at {brand}, with a 6,260x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/giganimals_gigablox': {
        title: 'Giganimals Gigablox: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Giganimals Gigablox runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/gold_frontier_jackpots_fastpot5': {
        title: 'Gold frontier Jackpots FastPot5: 94% RTP | {brand}',
        description: 'Gold frontier Jackpots FastPot5 runs at 94% RTP at {brand}, with a 1,265x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/golden_fish_tank_2_gigablox': {
        title: 'Golden Fish Tank 2 Gigablox: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Golden Fish Tank 2 Gigablox runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/golden_fish_tank_party': {
        title: 'Golden Fish Tank Party: 94% RTP, 6,000x Max Win | {brand}',
        description: 'Golden Fish Tank Party runs at 94% RTP at {brand}, with a 6,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/golden_fishtank': {
        title: 'Golden Fishtank: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Golden Fishtank runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/golden_gorgon': {
        title: 'Golden Gorgon: 96% RTP, 2,502x Max Win | {brand}',
        description: 'Golden Gorgon runs at 96% RTP at {brand}, with a 2,502x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/hades': {
        title: 'Hades: 96% RTP, 11,129x Max Win | {brand}',
        description: 'Hades runs at 96% RTP at {brand}, with a 11,129x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/holmes_and_the_stolen_stones': {
        title: 'Holmes and the Stolen Stones: 96% RTP, 600x Max Win | {brand}',
        description: 'Holmes and the Stolen Stones runs at 96% RTP at {brand}, with a 600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/hyperburst': {
        title: 'Hyperburst: 96% RTP, 12,800x Max Win | {brand}',
        description: 'Hyperburst runs at 96% RTP at {brand}, with a 12,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/incinerator': {
        title: 'Incinerator: 96% RTP, 300x Max Win | {brand}',
        description: 'Incinerator runs at 96% RTP at {brand}, with a 300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/jackpot_express': {
        title: 'Jackpot Express: 96% RTP, 2,175x Max Win | {brand}',
        description: 'Jackpot Express runs at 96% RTP at {brand}, with a 2,175x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/jackpot_raiders': {
        title: 'Jackpot Raiders: 96% RTP, 4,110x Max Win | {brand}',
        description: 'Jackpot Raiders runs at 96% RTP at {brand}, with a 4,110x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/jellycious_doublemax': {
        title: 'Jellycious DoubleMax: 94% RTP, 25,000x Max Win | {brand}',
        description: 'Jellycious DoubleMax runs at 94% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/jungle_books': {
        title: 'Jungle Books: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Jungle Books runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/legend_of_the_golden_monkey': {
        title: 'Legend of the Golden Monkey: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Legend of the Golden Monkey runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/lightning_joker': {
        title: 'Lightning Joker: 96% RTP, 10,011x Max Win | {brand}',
        description: 'Lightning Joker runs at 96% RTP at {brand}, with a 10,011x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/lucha_maniacs': {
        title: 'Lucha Maniacs: 96% RTP, 3,600x Max Win | {brand}',
        description: 'Lucha Maniacs runs at 96% RTP at {brand}, with a 3,600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/lucky_apocalypse_gigablox': {
        title: 'Lucky Apocalypse Gigablox: 96% RTP, 6,260x Max Win | {brand}',
        description: 'Lucky Apocalypse Gigablox runs at 96% RTP at {brand}, with a 6,260x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/lucky_neko': {
        title: 'Lucky Neko: 96% RTP, 6,953x Max Win | {brand}',
        description: 'Lucky Neko runs at 96% RTP at {brand}, with a 6,953x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/lucky_ryan_gigablox': {
        title: 'Lucky Ryan Gigablox: 96% RTP, 40,000x Max Win | {brand}',
        description: 'Lucky Ryan Gigablox runs at 96% RTP at {brand}, with a 40,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/max_elements_gigablox': {
        title: 'Max Elements Gigablox: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Max Elements Gigablox runs at 96% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/mexomax_multimax': {
        title: 'MexoMax! Multimax: 96% RTP, 10,000x Max Win | {brand}',
        description: 'MexoMax! Multimax runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/monkeys_go_bananas': {
        title: 'Monkeys Go Bananas: 94% RTP, 10,000x Max Win | {brand}',
        description: 'Monkeys Go Bananas runs at 94% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/multifly': {
        title: 'Multifly!: 96% RTP, 10,513x Max Win | {brand}',
        description: 'Multifly! runs at 96% RTP at {brand}, with a 10,513x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/multifly_2_multimax': {
        title: 'Multifly! 2 Multimax: 96% RTP, 10,311x Max Win | {brand}',
        description: 'Multifly! 2 Multimax runs at 96% RTP at {brand}, with a 10,311x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/neon_rush_splitz': {
        title: 'Neon Rush - Splitz: 96% RTP, 25,676x Max Win | {brand}',
        description: 'Neon Rush - Splitz runs at 96% RTP at {brand}, with a 25,676x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/neon_villains_doublemax': {
        title: 'Neon Villains Doublemax: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Neon Villains Doublemax runs at 96% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/nice_catch_2': {
        title: 'Nice Catch 2: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Nice Catch 2 runs at 96% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/nice_catch_doublemax': {
        title: 'Nice Catch DoubleMax: 96.2% RTP | {brand}',
        description: 'Nice Catch DoubleMax runs at 96.2% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/nirvana': {
        title: 'Nirvana: 96% RTP, 800x Max Win | {brand}',
        description: 'Nirvana runs at 96% RTP at {brand}, with a 800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/notredame_tales_gigablox': {
        title: 'Notre-Dame Tales GigaBlox™: 96.2% RTP | {brand}',
        description: 'Notre-Dame Tales GigaBlox™ runs at 96.2% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/of_sabers_and_monsters_wildfight': {
        title: 'Of Sabers and Monsters WildFight: 96% RTP | {brand}',
        description: 'Of Sabers and Monsters WildFight runs at 96% RTP at {brand}, with a 14,755x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/orient_express': {
        title: 'Orient Express: 96% RTP, 1,150x Max Win | {brand}',
        description: 'Orient Express runs at 96% RTP at {brand}, with a 1,150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/ozwins_jackpots': {
        title: 'Ozwins Jackpots: 96% RTP, 600x Max Win | {brand}',
        description: 'Ozwins Jackpots runs at 96% RTP at {brand}, with a 600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/penguin_city': {
        title: 'Penguin City: 96% RTP, 1,647x Max Win | {brand}',
        description: 'Penguin City runs at 96% RTP at {brand}, with a 1,647x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/pirates_2_mutiny': {
        title: 'Pirates 2: Mutiny: 96% RTP, 4,900x Max Win | {brand}',
        description: 'Pirates 2: Mutiny runs at 96% RTP at {brand}, with a 4,900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/pirates_smugglers_paradise': {
        title: 'Pirates: Smugglers Paradise: 96% RTP, 1,243x Max Win | {brand}',
        description: 'Pirates: Smugglers Paradise runs at 96% RTP at {brand}, with a 1,243x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/pumpkin_smash': {
        title: 'Pumpkin Smash: 96% RTP, 1,800x Max Win | {brand}',
        description: 'Pumpkin Smash runs at 96% RTP at {brand}, with a 1,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/pushy_cats': {
        title: 'Pushy Cats: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Pushy Cats runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/ragnaravens_wildenergy': {
        title: 'Ragnaravens WildEnergy: 96% RTP | {brand}',
        description: 'Ragnaravens WildEnergy runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/ragnawolves_wildenergy': {
        title: 'Ragnawolves WildEnergy: 96% RTP | {brand}',
        description: 'Ragnawolves WildEnergy runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/rainbow_ryan': {
        title: 'Rainbow Ryan: 96% RTP, 5,100x Max Win | {brand}',
        description: 'Rainbow Ryan runs at 96% RTP at {brand}, with a 5,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/rainbow_ryan_2': {
        title: 'Rainbow Ryan 2: 94% RTP, 20,000x Max Win | {brand}',
        description: 'Rainbow Ryan 2 runs at 94% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/raptor_2': {
        title: 'Raptor 2: 94% RTP, 9,493x Max Win | {brand}',
        description: 'Raptor 2 runs at 94% RTP at {brand}, with a 9,493x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/raptor_doublemax': {
        title: 'Raptor Doublemax: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Raptor Doublemax runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/reel_desire': {
        title: 'Reel Desire: 96% RTP, 20,480x Max Win | {brand}',
        description: 'Reel Desire runs at 96% RTP at {brand}, with a 20,480x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/rock_star_santa_multimax': {
        title: 'Rock Star Santa MultiMax: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Rock Star Santa MultiMax runs at 96% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/sahara_nights': {
        title: 'Sahara Nights: 96% RTP, 3,068x Max Win | {brand}',
        description: 'Sahara Nights runs at 96% RTP at {brand}, with a 3,068x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/seasons': {
        title: 'Seasons: 96% RTP, 1,400x Max Win | {brand}',
        description: 'Seasons runs at 96% RTP at {brand}, with a 1,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/spina_colada': {
        title: 'Spina Colada: 96% RTP, 3,200x Max Win | {brand}',
        description: 'Spina Colada runs at 96% RTP at {brand}, with a 3,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/starfire_fortunes_tophit': {
        title: 'Starfire Fortunes TopHit: 96.2% RTP, 25,000x Max Win | {brand}',
        description: 'Starfire Fortunes TopHit runs at 96.2% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/suncatcher_gigablox': {
        title: 'Suncatcher Gigablox: 96% RTP, 1,430x Max Win | {brand}',
        description: 'Suncatcher Gigablox runs at 96% RTP at {brand}, with a 1,430x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/sunny_shores': {
        title: 'Sunny Shores: 96% RTP, 324x Max Win | {brand}',
        description: 'Sunny Shores runs at 96% RTP at {brand}, with a 324x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/syncronite': {
        title: 'Syncronite: 96% RTP, 64,800x Max Win | {brand}',
        description: 'Syncronite runs at 96% RTP at {brand}, with a 64,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/temple_stacks_splitz': {
        title: 'Temple Stacks: Splitz: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Temple Stacks: Splitz runs at 96% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/the_one_armed_bandit': {
        title: 'The One Armed Bandit: 96% RTP, 11,863x Max Win | {brand}',
        description: 'The One Armed Bandit runs at 96% RTP at {brand}, with a 11,863x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/the_royal_family': {
        title: 'The Royal Family: 96% RTP, 3,500x Max Win | {brand}',
        description: 'The Royal Family runs at 96% RTP at {brand}, with a 3,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/thunder_of_thor': {
        title: 'Thunder Of Thor: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Thunder Of Thor runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/time_travel_tigers': {
        title: 'Time Travel Tigers: 96% RTP, 3,104x Max Win | {brand}',
        description: 'Time Travel Tigers runs at 96% RTP at {brand}, with a 3,104x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/trickstar_spins': {
        title: 'Trickstar Spins: 94% RTP, 800x Max Win | {brand}',
        description: 'Trickstar Spins runs at 94% RTP at {brand}, with a 800x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/trolls_bridge': {
        title: 'Trolls Bridge: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Trolls Bridge runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/tutstwister': {
        title: 'TutsTwister: 96% RTP, 966x Max Win | {brand}',
        description: 'TutsTwister runs at 96% RTP at {brand}, with a 966x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/valley_of_the_dead_only_wins_boltlock': {
        title: 'Valley of the Dead Only Wins BoltLock: 94% RTP | {brand}',
        description: 'Valley of the Dead Only Wins BoltLock runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/yggdrasil-gaming/valley_of_the_gods': {
        title: 'Valley of the Gods: 96% RTP, 5,800x Max Win | {brand}',
        description: 'Valley of the Gods runs at 96% RTP at {brand}, with a 5,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/valley_of_the_gods_2': {
        title: 'Valley of the Gods 2: 96% RTP, 5,481x Max Win | {brand}',
        description: 'Valley of the Gods 2 runs at 96% RTP at {brand}, with a 5,481x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vampire_riches': {
        title: 'Vampire Riches: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Vampire Riches runs at 96% RTP at {brand}, with a 25,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vault_of_fortune': {
        title: 'Vault of Fortune: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Vault of Fortune runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vikings_go_berzerk': {
        title: 'Vikings go Berzerk: 96% RTP, 4,000x Max Win | {brand}',
        description: 'Vikings go Berzerk runs at 96% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vikings_go_berzerk_reloaded': {
        title: 'Vikings Go Berzerk: Reloaded: 96% RTP, 25,000x Max Win | {brand}',
        description: 'Vikings Go Berzerk: Reloaded runs at 96% RTP at {brand}, with a 25,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vikings_go_to_egypt_wild_fight': {
        title: 'Vikings Go To Egypt Wild Fight: 94% RTP | {brand}',
        description: 'Vikings Go To Egypt Wild Fight runs at 94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vikings_go_to_hell': {
        title: 'Vikings Go To Hell: 96% RTP, 5,500x Max Win | {brand}',
        description: 'Vikings Go To Hell runs at 96% RTP at {brand}, with a 5,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vikings_go_to_valhalla': {
        title: 'Vikings go to Valhalla: 96% RTP, 23,634x Max Win | {brand}',
        description: 'Vikings go to Valhalla runs at 96% RTP at {brand}, with a 23,634x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vikings_go_to_vegas_wild_fight': {
        title: 'Vikings go to Vegas Wild Fight: 94% RTP | {brand}',
        description: 'Vikings go to Vegas Wild Fight runs at 94% RTP at {brand}, with a 4,375x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/vikings_go_wild': {
        title: 'Vikings go Wild: 96% RTP, 1,900x Max Win | {brand}',
        description: 'Vikings go Wild runs at 96% RTP at {brand}, with a 1,900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/wild_robo_factory': {
        title: 'Wild Robo Factory: 96% RTP, 2,878x Max Win | {brand}',
        description: 'Wild Robo Factory runs at 96% RTP at {brand}, with a 2,878x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/wild_stack_frenzy': {
        title: 'Wild Stack Frenzy: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Wild Stack Frenzy runs at 96% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/wilhelm_tell': {
        title: 'Wilhelm Tell: 96% RTP, 7,500x Max Win | {brand}',
        description: 'Wilhelm Tell runs at 96% RTP at {brand}, with a 7,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/winterberries': {
        title: 'Winterberries: 96% RTP, 2,500x Max Win | {brand}',
        description: 'Winterberries runs at 96% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/winterberries_2': {
        title: 'Winterberries 2: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Winterberries 2 runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/wolf_hunters': {
        title: 'Wolf Hunters: 96% RTP, 2,324x Max Win | {brand}',
        description: 'Wolf Hunters runs at 96% RTP at {brand}, with a 2,324x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/yokozuna_clash': {
        title: 'Yokozuna Clash: 96% RTP, 3,449x Max Win | {brand}',
        description: 'Yokozuna Clash runs at 96% RTP at {brand}, with a 3,449x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/yggdrasil-gaming/your_own_island': {
        title: 'Your Own Island: 96% RTP, 6,000x Max Win | {brand}',
        description: 'Your Own Island runs at 96% RTP at {brand}, with a 6,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/100_flaring_fruits': {
        title: '100 Flaring Fruits: 96% RTP, 5,000x Max Win | {brand}',
        description: '100 Flaring Fruits runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/20_flaring_fruits': {
        title: '20 Flaring Fruits: 96% RTP, 5,000x Max Win | {brand}',
        description: '20 Flaring Fruits runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/40_finest_xxl': {
        title: '40 Finest XXL: 96% RTP, 5,000x Max Win | {brand}',
        description: '40 Finest XXL runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/40_finest_xxl_flaming_link': {
        title: '40 Finest XXL Flaming Link: 94.11% RTP, 3,000x Max Win | {brand}',
        description: '40 Finest XXL Flaming Link runs at 94.11% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/50_flaring_fruit': {
        title: '50 Flaring Fruit: 94% RTP, 5,000x Max Win | {brand}',
        description: '50 Flaring Fruit runs at 94% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/50_flaring_fruits': {
        title: '50 Flaring Fruits: 96% RTP, 5,000x Max Win | {brand}',
        description: '50 Flaring Fruits runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/5_ember_wilds': {
        title: '5 Ember Wilds: 96% RTP, 1,105x Max Win | {brand}',
        description: '5 Ember Wilds runs at 96% RTP at {brand}, with a 1,105x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/5_flaring_fruits': {
        title: '5 Flaring Fruits: 96% RTP, 5,000x Max Win | {brand}',
        description: '5 Flaring Fruits runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/alexandria_fire': {
        title: 'Alexandria Fire: 96% RTP, 3,550x Max Win | {brand}',
        description: 'Alexandria Fire runs at 96% RTP at {brand}, with a 3,550x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/ancient_magic': {
        title: 'Ancient Magic: 96% RTP, 6,800x Max Win | {brand}',
        description: 'Ancient Magic runs at 96% RTP at {brand}, with a 6,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/ancient_riches': {
        title: 'Ancient Riches: 96% RTP, 1,100x Max Win | {brand}',
        description: 'Ancient Riches runs at 96% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/atlantic_wilds': {
        title: 'Atlantic Wilds: 96% RTP, 1,300x Max Win | {brand}',
        description: 'Atlantic Wilds runs at 96% RTP at {brand}, with a 1,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/aura_of_jupiter': {
        title: 'Aura of Jupiter: 96% RTP, 1,100x Max Win | {brand}',
        description: 'Aura of Jupiter runs at 96% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/back_to_the_fruits': {
        title: 'Back to the Fruits: 96% RTP, 1,600x Max Win | {brand}',
        description: 'Back to the Fruits runs at 96% RTP at {brand}, with a 1,600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/back_to_the_fruits_respins_of_amunre': {
        title: 'Back to the Fruits Respins of Amun-Re: 96% RTP | {brand}',
        description: 'Back to the Fruits Respins of Amun-Re runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/beautiful_nature': {
        title: 'Beautiful Nature: 96% RTP, 1,400x Max Win | {brand}',
        description: 'Beautiful Nature runs at 96% RTP at {brand}, with a 1,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/beer_party': {
        title: 'Beer Party: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Beer Party runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/black_beauty': {
        title: 'Black Beauty: 96% RTP, 1,100x Max Win | {brand}',
        description: 'Black Beauty runs at 96% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_ages': {
        title: 'Book of Ages: 96% RTP, 6,100x Max Win | {brand}',
        description: 'Book of Ages runs at 96% RTP at {brand}, with a 6,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_crazy_chicken': {
        title: 'Book of Crazy Chicken: 96% RTP | {brand}',
        description: 'Book of Crazy Chicken runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_elements': {
        title: 'Book of Elements: 96.13% RTP, 7,800x Max Win | {brand}',
        description: 'Book of Elements runs at 96.13% RTP at {brand}, with a 7,800x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_juno': {
        title: 'Book of Juno: 96% RTP, 6,100x Max Win | {brand}',
        description: 'Book of Juno runs at 96% RTP at {brand}, with a 6,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_madness': {
        title: 'Book of Madness: 96% RTP, 6,100x Max Win | {brand}',
        description: 'Book of Madness runs at 96% RTP at {brand}, with a 6,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_madness_2': {
        title: 'Book of Madness 2: 94.11% RTP, 11,800x Max Win | {brand}',
        description: 'Book of Madness 2 runs at 94.11% RTP at {brand}, with a 11,800x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_madness_deluxe': {
        title: 'Book Of Madness Deluxe: 94.09% RTP, 10,800x Max Win | {brand}',
        description: 'Book Of Madness Deluxe runs at 94.09% RTP at {brand}, with a 10,800x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_madness_flaming_link': {
        title: 'Book of Madness Flaming Link: 94.14% RTP | {brand}',
        description: 'Book of Madness Flaming Link runs at 94.14% RTP at {brand}, with a 12,176x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_madness_respins_of_amunre': {
        title: 'Book of Madness Respins of Amun-Re: 96% RTP | {brand}',
        description: 'Book of Madness Respins of Amun-Re runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_oasis': {
        title: 'Book of Oasis: 96% RTP, 6,360x Max Win | {brand}',
        description: 'Book of Oasis runs at 96% RTP at {brand}, with a 6,360x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/book_of_romeo_and_julia': {
        title: 'Book of Romeo and Julia: 96% RTP, 6,300x Max Win | {brand}',
        description: 'Book of Romeo and Julia runs at 96% RTP at {brand}, with a 6,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/books_and_bounties': {
        title: 'Books & Bounties: 96% RTP, 2,250x Max Win | {brand}',
        description: 'Books & Bounties runs at 96% RTP at {brand}, with a 2,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/books_and_bulls': {
        title: 'Books & Bulls: 96% RTP, 4,800x Max Win | {brand}',
        description: 'Books & Bulls runs at 96% RTP at {brand}, with a 4,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/books_and_pearls': {
        title: 'Books & Pearls: 96% RTP, 6,300x Max Win | {brand}',
        description: 'Books & Pearls runs at 96% RTP at {brand}, with a 6,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/books_and_pearls_respins_of_amunre': {
        title: 'Books & Pearls Respins of Amun-Re: 96% RTP | {brand}',
        description: 'Books & Pearls Respins of Amun-Re runs at 96% RTP at {brand}, with a 9,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/books_and_temples': {
        title: 'Books & Temples: 96% RTP, 2,400x Max Win | {brand}',
        description: 'Books & Temples runs at 96% RTP at {brand}, with a 2,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/crystal_ball': {
        title: 'Crystal Ball: 96% RTP, 6,800x Max Win | {brand}',
        description: 'Crystal Ball runs at 96% RTP at {brand}, with a 6,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/crystal_ball_deluxe': {
        title: 'Crystal Ball Deluxe: 96.16% RTP, 10,200x Max Win | {brand}',
        description: 'Crystal Ball Deluxe runs at 96.16% RTP at {brand}, with a 10,200x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/crystal_ball_flaming_link': {
        title: 'Crystal Ball Flaming Link: 94.13% RTP, 5,400x Max Win | {brand}',
        description: 'Crystal Ball Flaming Link runs at 94.13% RTP at {brand}, with a 5,400x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/crystal_ball_multi_symbols': {
        title: 'Crystal Ball Multi Symbols: 96.11% RTP | {brand}',
        description: 'Crystal Ball Multi Symbols runs at 96.11% RTP at {brand}, with a 10,100x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/crystal_burst_xxl': {
        title: 'Crystal Burst XXL: 96% RTP, 4,000x Max Win | {brand}',
        description: 'Crystal Burst XXL runs at 96% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/crystal_strike': {
        title: 'Crystal Strike: 96% RTP, 580x Max Win | {brand}',
        description: 'Crystal Strike runs at 96% RTP at {brand}, with a 580x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/cutie_cat': {
        title: 'Cutie Cat: 96% RTP, 1,100x Max Win | {brand}',
        description: 'Cutie Cat runs at 96% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/dead_legion': {
        title: 'Dead Legion: 94.12% RTP, 10,400x Max Win | {brand}',
        description: 'Dead Legion runs at 94.12% RTP at {brand}, with a 10,400x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/disc_of_athena': {
        title: 'Disc of Athena: 96% RTP, 12,000x Max Win | {brand}',
        description: 'Disc of Athena runs at 96% RTP at {brand}, with a 12,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/divine_fire': {
        title: 'Divine Fire: 96% RTP, 3,550x Max Win | {brand}',
        description: 'Divine Fire runs at 96% RTP at {brand}, with a 3,550x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/dragon_of_the_princess': {
        title: 'Dragon of the Princess: 96% RTP, 2,200x Max Win | {brand}',
        description: 'Dragon of the Princess runs at 96% RTP at {brand}, with a 2,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/duck_shooter': {
        title: 'Duck Shooter: 96% RTP, 550x Max Win | {brand}',
        description: 'Duck Shooter runs at 96% RTP at {brand}, with a 550x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/expanding_fireworks': {
        title: 'Expanding Fireworks: 96% RTP, 1,200x Max Win | {brand}',
        description: 'Expanding Fireworks runs at 96% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/explodiac': {
        title: 'Explodiac: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Explodiac runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fancy_fruits': {
        title: 'Fancy Fruits: 96% RTP, 1,100x Max Win | {brand}',
        description: 'Fancy Fruits runs at 96% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fancy_fruits_deluxe': {
        title: 'Fancy Fruits Deluxe: 96.09% RTP, 1,100x Max Win | {brand}',
        description: 'Fancy Fruits Deluxe runs at 96.09% RTP at {brand}, with a 1,100x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fancy_fruits_flaming_link': {
        title: 'Fancy Fruits Flaming Link: 96.12% RTP, 12,200x Max Win | {brand}',
        description: 'Fancy Fruits Flaming Link runs at 96.12% RTP at {brand}, with a 12,200x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fancy_fruits_respins_of_amunre': {
        title: 'Fancy Fruits Respins of Amun-Re: 96% RTP | {brand}',
        description: 'Fancy Fruits Respins of Amun-Re runs at 96% RTP at {brand}, with a 9,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fengs_fortune': {
        title: "Feng's Fortune: 96% RTP | {brand}",
        description: "Feng's Fortune runs at 96% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/gamomat-games/football_super_spins': {
        title: 'Football Super Spins: 96% RTP, 550x Max Win | {brand}',
        description: 'Football Super Spins runs at 96% RTP at {brand}, with a 550x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fort_brave': {
        title: 'Fort Brave: 96% RTP, 16,500x Max Win | {brand}',
        description: 'Fort Brave runs at 96% RTP at {brand}, with a 16,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/frooty_troupe_game_on_94': {
        title: 'Frooty Troupe Game On 94: 94.13% RTP, 230x Max Win | {brand}',
        description: 'Frooty Troupe Game On 94 runs at 94.13% RTP at {brand}, with a 230x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/frooty_troupe_gold_club': {
        title: 'Frooty Troupe Gold Club: 94.13% RTP, 600x Max Win | {brand}',
        description: 'Frooty Troupe Gold Club runs at 94.13% RTP at {brand}, with a 600x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/frooty_troupe_sun_splash': {
        title: 'Frooty Troupe Sun Splash: 94.15% RTP, 5,100x Max Win | {brand}',
        description: 'Frooty Troupe Sun Splash runs at 94.15% RTP at {brand}, with a 5,100x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fruit_love': {
        title: 'Fruit Love: 96% RTP, 4,020x Max Win | {brand}',
        description: 'Fruit Love runs at 96% RTP at {brand}, with a 4,020x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fruit_mania': {
        title: 'Fruit Mania: 96% RTP, 1,500x Max Win | {brand}',
        description: 'Fruit Mania runs at 96% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fruit_mania_deluxe': {
        title: 'Fruit Mania Deluxe: 96.12% RTP, 1,500x Max Win | {brand}',
        description: 'Fruit Mania Deluxe runs at 96.12% RTP at {brand}, with a 1,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fruit_mania_flaming_link': {
        title: 'Fruit Mania Flaming Link: 94.14% RTP, 2,700x Max Win | {brand}',
        description: 'Fruit Mania Flaming Link runs at 94.14% RTP at {brand}, with a 2,700x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/fruit_rush': {
        title: 'Fruit Rush: 96% RTP, 1,810x Max Win | {brand}',
        description: 'Fruit Rush runs at 96% RTP at {brand}, with a 1,810x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/gates_of_persia': {
        title: 'Gates of Persia: 96% RTP, 600x Max Win | {brand}',
        description: 'Gates of Persia runs at 96% RTP at {brand}, with a 600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/glamorous_times': {
        title: 'Glamorous Times: 96% RTP, 900x Max Win | {brand}',
        description: 'Glamorous Times runs at 96% RTP at {brand}, with a 900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/golden_egg_of_crazy_chicken': {
        title: 'Golden Egg of Crazy Chicken: 96% RTP | {brand}',
        description: 'Golden Egg of Crazy Chicken runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/golden_touch': {
        title: 'Golden Touch: 96% RTP, 1,800x Max Win | {brand}',
        description: 'Golden Touch runs at 96% RTP at {brand}, with a 1,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/great_grizzly': {
        title: 'Great Grizzly: 96.12% RTP, 17,820x Max Win | {brand}',
        description: 'Great Grizzly runs at 96.12% RTP at {brand}, with a 17,820x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/great_warrior': {
        title: 'Great Warrior: 96% RTP, 8,200x Max Win | {brand}',
        description: 'Great Warrior runs at 96% RTP at {brand}, with a 8,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/hellfire': {
        title: 'Hellfire: 96% RTP, 910x Max Win | {brand}',
        description: 'Hellfire runs at 96% RTP at {brand}, with a 910x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/juicy_jester': {
        title: 'Juicy Jester: 96.14% RTP, 900x Max Win | {brand}',
        description: 'Juicy Jester runs at 96.14% RTP at {brand}, with a 900x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/king_and_queen': {
        title: 'King & Queen: 96% RTP, 900x Max Win | {brand}',
        description: 'King & Queen runs at 96% RTP at {brand}, with a 900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/king_of_the_jungle': {
        title: 'King of the Jungle: 96% RTP, 1,300x Max Win | {brand}',
        description: 'King of the Jungle runs at 96% RTP at {brand}, with a 1,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/la_dolce_vita': {
        title: 'La Dolce Vita: 96% RTP, 4,005x Max Win | {brand}',
        description: 'La Dolce Vita runs at 96% RTP at {brand}, with a 4,005x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/la_dolce_vita_2': {
        title: 'La Dolce Vita 2: 94.15% RTP, 2,100x Max Win | {brand}',
        description: 'La Dolce Vita 2 runs at 94.15% RTP at {brand}, with a 2,100x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/la_dolce_vita_deluxe': {
        title: 'La Dolce Vita Deluxe: 96.03% RTP, 552x Max Win | {brand}',
        description: 'La Dolce Vita Deluxe runs at 96.03% RTP at {brand}, with a 552x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/la_dolce_vita_flaming_link': {
        title: 'La Dolce Vita Flaming Link: 94.11% RTP, 2,900x Max Win | {brand}',
        description: 'La Dolce Vita Flaming Link runs at 94.11% RTP at {brand}, with a 2,900x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/land_of_heroes': {
        title: 'Land of Heroes: 96% RTP, 1,900x Max Win | {brand}',
        description: 'Land of Heroes runs at 96% RTP at {brand}, with a 1,900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/lava_lions': {
        title: 'Lava Lions: 96% RTP, 1,600x Max Win | {brand}',
        description: 'Lava Lions runs at 96% RTP at {brand}, with a 1,600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/legacy_of_ramses_book': {
        title: 'Legacy of Ramses Book: 94.13% RTP, 12,000x Max Win | {brand}',
        description: 'Legacy of Ramses Book runs at 94.13% RTP at {brand}, with a 12,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/maaax_diamonds': {
        title: 'Maaax Diamonds: 96% RTP, 1,100x Max Win | {brand}',
        description: 'Maaax Diamonds runs at 96% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/maaax_diamonds_christmas_edition': {
        title: 'Maaax Diamonds Christmas Edition: 96% RTP | {brand}',
        description: 'Maaax Diamonds Christmas Edition runs at 96% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/maaax_diamonds_deluxe': {
        title: 'Maaax Diamonds Deluxe: 96.07% RTP, 1,060x Max Win | {brand}',
        description: 'Maaax Diamonds Deluxe runs at 96.07% RTP at {brand}, with a 1,060x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/magic_stone': {
        title: 'Magic Stone: 96% RTP, 1,400x Max Win | {brand}',
        description: 'Magic Stone runs at 96% RTP at {brand}, with a 1,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/mayan_fire': {
        title: 'Mayan Fire: 96% RTP, 3,650x Max Win | {brand}',
        description: 'Mayan Fire runs at 96% RTP at {brand}, with a 3,650x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/mighty_dragon': {
        title: 'Mighty Dragon: 96% RTP, 1,800x Max Win | {brand}',
        description: 'Mighty Dragon runs at 96% RTP at {brand}, with a 1,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/monkey_mania': {
        title: 'Monkey Mania: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Monkey Mania runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/multi_machine': {
        title: 'Multi Machine: 94.13% RTP, 2,400x Max Win | {brand}',
        description: 'Multi Machine runs at 94.13% RTP at {brand}, with a 2,400x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/night_wolves': {
        title: 'Night Wolves: 96% RTP, 1,400x Max Win | {brand}',
        description: 'Night Wolves runs at 96% RTP at {brand}, with a 1,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/nordic_fire': {
        title: 'Nordic Fire: 96% RTP, 3,525x Max Win | {brand}',
        description: 'Nordic Fire runs at 96% RTP at {brand}, with a 3,525x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/old_fisherman': {
        title: 'Old Fisherman: 96% RTP, 2,400x Max Win | {brand}',
        description: 'Old Fisherman runs at 96% RTP at {brand}, with a 2,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/phantoms_mirror': {
        title: "Phantom's Mirror: 96% RTP, 700x Max Win | {brand}",
        description: "Phantom's Mirror runs at 96% RTP at {brand}, with a 700x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/gamomat-games/pharaos_riches': {
        title: "Pharao's Riches: 96% RTP, 2,000x Max Win | {brand}",
        description: "Pharao's Riches runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/gamomat-games/ramses_book': {
        title: 'Ramses Book: 96% RTP, 6,300x Max Win | {brand}',
        description: 'Ramses Book runs at 96% RTP at {brand}, with a 6,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/ramses_book_christmas_edition': {
        title: 'Ramses Book Christmas Edition: 96% RTP, 6,300x Max Win | {brand}',
        description: 'Ramses Book Christmas Edition runs at 96% RTP at {brand}, with a 6,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/ramses_book_deluxe': {
        title: 'Ramses Book Deluxe: 96.15% RTP | {brand}',
        description: 'Ramses Book Deluxe runs at 96.15% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/ramses_book_easter_edition': {
        title: 'Ramses Book Easter Edition: 96% RTP | {brand}',
        description: 'Ramses Book Easter Edition runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/ramses_book_flaming_link': {
        title: 'Ramses Book Flaming Link: 96.12% RTP, 12,176x Max Win | {brand}',
        description: 'Ramses Book Flaming Link runs at 96.12% RTP at {brand}, with a 12,176x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/ramses_book_respins_of_amunre': {
        title: 'Ramses Book Respins of Amun-Re: 96% RTP | {brand}',
        description: 'Ramses Book Respins of Amun-Re runs at 96% RTP at {brand}, with a 9,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/ramses_book_rock_edition': {
        title: 'Ramses Book Rock Edition: 94.09% RTP, 10,800x Max Win | {brand}',
        description: 'Ramses Book Rock Edition runs at 94.09% RTP at {brand}, with a 10,800x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/roman_legion': {
        title: 'Roman Legion: 96% RTP, 7,600x Max Win | {brand}',
        description: 'Roman Legion runs at 96% RTP at {brand}, with a 7,600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/roman_legion_deluxe': {
        title: 'Roman Legion Deluxe: 96.16% RTP, 10,400x Max Win | {brand}',
        description: 'Roman Legion Deluxe runs at 96.16% RTP at {brand}, with a 10,400x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/roman_legion_extreme': {
        title: 'Roman Legion Extreme: 96% RTP | {brand}',
        description: 'Roman Legion Extreme runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/roman_legion_flaming_link': {
        title: 'Roman Legion Flaming Link: 94.12% RTP, 12,150x Max Win | {brand}',
        description: 'Roman Legion Flaming Link runs at 94.12% RTP at {brand}, with a 12,150x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_7_xxl': {
        title: 'Royal 7 XXL: 96% RTP | {brand}',
        description: 'Royal 7 XXL runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_seven': {
        title: 'Royal Seven: 96% RTP, 550x Max Win | {brand}',
        description: 'Royal Seven runs at 96% RTP at {brand}, with a 550x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_seven_deluxe': {
        title: 'Royal Seven Deluxe: 96.1% RTP, 510x Max Win | {brand}',
        description: 'Royal Seven Deluxe runs at 96.1% RTP at {brand}, with a 510x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_seven_flaming_link': {
        title: 'Royal Seven Flaming Link: 94.11% RTP, 2,800x Max Win | {brand}',
        description: 'Royal Seven Flaming Link runs at 94.11% RTP at {brand}, with a 2,800x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_seven_ultra': {
        title: 'Royal Seven Ultra: 96% RTP, 10,000x Max Win | {brand}',
        description: 'Royal Seven Ultra runs at 96% RTP at {brand}, with a 10,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_seven_ultra_flaming_link': {
        title: 'Royal Seven Ultra Flaming Link: 94.12% RTP | {brand}',
        description: 'Royal Seven Ultra Flaming Link runs at 94.12% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_seven_xxl': {
        title: 'Royal Seven XXL: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Royal Seven XXL runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_seven_xxl_easter_edition': {
        title: 'Royal Seven XXL Easter Edition: 96% RTP | {brand}',
        description: 'Royal Seven XXL Easter Edition runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royal_seven_xxl_flaming_link': {
        title: 'Royal Seven XXL Flaming Link: 94.13% RTP | {brand}',
        description: 'Royal Seven XXL Flaming Link runs at 94.13% RTP at {brand}, with a 12,150x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/royale_seven_deluxe_xxl_deluxe': {
        title: 'Royale Seven Deluxe XXL Deluxe: 96.11% RTP | {brand}',
        description: 'Royale Seven Deluxe XXL Deluxe runs at 96.11% RTP at {brand} and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/savanna_moon': {
        title: 'Savanna Moon: 96% RTP, 6,500x Max Win | {brand}',
        description: 'Savanna Moon runs at 96% RTP at {brand}, with a 6,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/sevens_and_books': {
        title: 'Sevens & Books: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Sevens & Books runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/sevens_fire': {
        title: 'Sevens Fire: 96% RTP, 3,550x Max Win | {brand}',
        description: 'Sevens Fire runs at 96% RTP at {brand}, with a 3,550x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/shoguns_secret': {
        title: "Shogun's Secret: 96% RTP, 1,200x Max Win | {brand}",
        description: "Shogun's Secret runs at 96% RTP at {brand}, with a 1,200x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/gamomat-games/simply_the_best': {
        title: 'Simply the Best: 96% RTP, 1,100x Max Win | {brand}',
        description: 'Simply the Best runs at 96% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/sticky_diamonds': {
        title: 'Sticky Diamonds: 96% RTP, 1,500x Max Win | {brand}',
        description: 'Sticky Diamonds runs at 96% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/sticky_diamonds_easter_egg': {
        title: 'Sticky Diamonds Easter Egg: 96% RTP | {brand}',
        description: 'Sticky Diamonds Easter Egg runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/sunny_sevens': {
        title: 'Sunny Sevens: 96% RTP, 1,500x Max Win | {brand}',
        description: 'Sunny Sevens runs at 96% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/super_duper_cherry': {
        title: 'Super Duper Cherry: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Super Duper Cherry runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/take_5': {
        title: 'Take 5: 96% RTP, 200x Max Win | {brand}',
        description: 'Take 5 runs at 96% RTP at {brand}, with a 200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/take_5_christmas_edition': {
        title: 'Take 5 Christmas Edition: 96% RTP, 200x Max Win | {brand}',
        description: 'Take 5 Christmas Edition runs at 96% RTP at {brand}, with a 200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/the_book_beyond': {
        title: 'The Book Beyond: 96% RTP, 7,200x Max Win | {brand}',
        description: 'The Book Beyond runs at 96% RTP at {brand}, with a 7,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/the_book_beyond_2': {
        title: 'The Book Beyond 2: 96.13% RTP, 35,700x Max Win | {brand}',
        description: 'The Book Beyond 2 runs at 96.13% RTP at {brand}, with a 35,700x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/the_expandable': {
        title: 'The Expandable: 96% RTP, 1,500x Max Win | {brand}',
        description: 'The Expandable runs at 96% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/the_mighty_king': {
        title: 'The Mighty King: 96% RTP, 1,300x Max Win | {brand}',
        description: 'The Mighty King runs at 96% RTP at {brand}, with a 1,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/tower_of_power': {
        title: 'Tower of Power: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Tower of Power runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/vegas_joker': {
        title: 'Vegas Joker: 96.14% RTP, 900x Max Win | {brand}',
        description: 'Vegas Joker runs at 96.14% RTP at {brand}, with a 900x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/western_jack': {
        title: 'Western Jack: 96% RTP, 3,000x Max Win | {brand}',
        description: 'Western Jack runs at 96% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/wild_rubies': {
        title: 'Wild Rubies: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Wild Rubies runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/wild_rubies_christmas_edition': {
        title: 'Wild Rubies Christmas Edition: 96% RTP, 2,000x Max Win | {brand}',
        description: 'Wild Rubies Christmas Edition runs at 96% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/win_blaster': {
        title: 'Win Blaster: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Win Blaster runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/win_blaster_christmas_edition': {
        title: 'Win Blaster Christmas Edition: 96% RTP | {brand}',
        description: 'Win Blaster Christmas Edition runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/win_shooter': {
        title: 'Win Shooter: 96% RTP, 500x Max Win | {brand}',
        description: 'Win Shooter runs at 96% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/gamomat-games/xploding_pumpkins': {
        title: 'Xploding Pumpkins: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Xploding Pumpkins runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/100_joker_staxx': {
        title: '100 Joker Staxx: 96.48% RTP, 3,825x Max Win | {brand}',
        description: '100 Joker Staxx runs at 96.48% RTP at {brand}, with a 3,825x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/25_cookies_hit_the_bonus': {
        title: '25 Cookies: Hit the Bonus: 95.7% RTP, 10,000x Max Win | {brand}',
        description: '25 Cookies: Hit the Bonus runs at 95.7% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/3_carts_of_gold_hold_and_win': {
        title: '3 Carts of Gold: Hold and Win: 95.76% RTP | {brand}',
        description: '3 Carts of Gold: Hold and Win runs at 95.76% RTP at {brand}, with a 6,591x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/3_chillies_and_joker_hold_and_win': {
        title: '3 Chillies and Joker Hold and Win: 95.5% RTP | {brand}',
        description: '3 Chillies and Joker Hold and Win runs at 95.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/playson/3_luxor_pots_hold_and_win': {
        title: '3 Luxor Pots Hold and Win: 95.76% RTP, 10,033x Max Win | {brand}',
        description: '3 Luxor Pots Hold and Win runs at 95.76% RTP at {brand}, with a 10,033x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/3_magic_lamps_hold_and_win': {
        title: '3 Magic Lamps: Hold and Win: 95.76% RTP | {brand}',
        description: '3 Magic Lamps: Hold and Win runs at 95.76% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/3_pirate_barrels_hold_and_win': {
        title: '3 Pirate Barrels: Hold and Win: 95.76% RTP | {brand}',
        description: '3 Pirate Barrels: Hold and Win runs at 95.76% RTP at {brand}, with a 14,373x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/3_pots_riches_hold_and_win': {
        title: '3 Pots Riches: Hold and Win: 95.76% RTP | {brand}',
        description: '3 Pots Riches: Hold and Win runs at 95.76% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/3_royal_coins_hold_and_win': {
        title: '3 Royal Coins Hold and Win: 95.36% RTP | {brand}',
        description: '3 Royal Coins Hold and Win runs at 95.36% RTP at {brand}, with a 10,050x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/3_supercharged_diamonds_hold_and_win': {
        title: '3 Supercharged Diamonds Hold and Win: 95.5% RTP | {brand}',
        description: '3 Supercharged Diamonds Hold and Win runs at 95.5% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/playson/3_thunder_coins_hold_and_win': {
        title: '3 Thunder Coins: Hold and Win: 95.49% RTP | {brand}',
        description: '3 Thunder Coins: Hold and Win runs at 95.49% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/3x_catch': {
        title: '3x Catch: 95.6% RTP, 4,546x Max Win | {brand}',
        description: '3x Catch runs at 95.6% RTP at {brand}, with a 4,546x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/4_chili_amigos_hold_and_win': {
        title: '4 Chili Amigos Hold and Win: 95.7% RTP | {brand}',
        description: '4 Chili Amigos Hold and Win runs at 95.7% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/4_chili_pots_hold_and_win': {
        title: '4 Chili Pots: Hold and Win: 95.7% RTP, 15,000x Max Win | {brand}',
        description: '4 Chili Pots: Hold and Win runs at 95.7% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/4_pots_riches_super_wheel': {
        title: '4 Pots Riches: Super Wheel: 95.7% RTP, 15,000x Max Win | {brand}',
        description: '4 Pots Riches: Super Wheel runs at 95.7% RTP at {brand}, with a 15,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/4_supercharged_clovers': {
        title: '4 Supercharged Clovers: 95.7% RTP, 15,000x Max Win | {brand}',
        description: '4 Supercharged Clovers runs at 95.7% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/4_supershiny_diamonds_hold_and_win': {
        title: '4 Supershiny Diamonds: Hold and Win: 94.69% RTP | {brand}',
        description: '4 Supershiny Diamonds: Hold and Win runs at 94.69% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/playson/5_fortunator': {
        title: '5 Fortunator: 96.25% RTP, 820x Max Win | {brand}',
        description: '5 Fortunator runs at 96.25% RTP at {brand}, with a 820x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/5_super_sevens_and_fruits': {
        title: '5 Super Sevens & Fruits: 95.89% RTP, 1,100x Max Win | {brand}',
        description: '5 Super Sevens & Fruits runs at 95.89% RTP at {brand}, with a 1,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/777_sizzling_wins_5_line': {
        title: '777 Sizzling Wins: 5 Line: 96.21% RTP | {brand}',
        description: '777 Sizzling Wins: 5 Line runs at 96.21% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/arizona_heist_hold_and_win': {
        title: 'Arizona Heist: Hold and Win: 95.6% RTP | {brand}',
        description: 'Arizona Heist: Hold and Win runs at 95.6% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/blazing_wins_5_lines': {
        title: 'Blazing Wins: 5 Lines: 96.31% RTP | {brand}',
        description: 'Blazing Wins: 5 Lines runs at 96.31% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/book_del_sol': {
        title: 'Book Del Sol: 95.76% RTP, 12,330x Max Win | {brand}',
        description: 'Book Del Sol runs at 95.76% RTP at {brand}, with a 12,330x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/book_of_gold_classic': {
        title: 'Book of Gold: Classic: 95.94% RTP, 6,156x Max Win | {brand}',
        description: 'Book of Gold: Classic runs at 95.94% RTP at {brand}, with a 6,156x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/book_of_gold_double_chance': {
        title: 'Book of Gold: Double Chance: 95.04% RTP | {brand}',
        description: 'Book of Gold: Double Chance runs at 95.04% RTP at {brand}, with a 4,067x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/book_of_gold_multichance': {
        title: 'Book of Gold: Multichance: 95.4% RTP, 6,550x Max Win | {brand}',
        description: 'Book of Gold: Multichance runs at 95.4% RTP at {brand}, with a 6,550x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/buffalo_power_2': {
        title: 'Buffalo Power 2: 95.44% RTP | {brand}',
        description: 'Buffalo Power 2 runs at 95.44% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/buffalo_power_christmas': {
        title: 'Buffalo Power: Christmas: 95.04% RTP, 1,187x Max Win | {brand}',
        description: 'Buffalo Power: Christmas runs at 95.04% RTP at {brand}, with a 1,187x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/buffalo_power_hold_and_win': {
        title: 'Buffalo Power: Hold and Win: 95.04% RTP | {brand}',
        description: 'Buffalo Power: Hold and Win runs at 95.04% RTP at {brand}, with a 1,187x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/buffalo_power_megaways': {
        title: 'Buffalo Power Megaways: 95.84% RTP, 4,806x Max Win | {brand}',
        description: 'Buffalo Power Megaways runs at 95.84% RTP at {brand}, with a 4,806x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/burning_fortunator': {
        title: 'Burning Fortunator: 96.16% RTP, 60x Max Win | {brand}',
        description: 'Burning Fortunator runs at 96.16% RTP at {brand}, with a 60x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/burning_wins': {
        title: 'Burning Wins: 96.21% RTP, 60x Max Win | {brand}',
        description: 'Burning Wins runs at 96.21% RTP at {brand}, with a 60x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/burning_wins_x2': {
        title: 'Burning Wins x2: 95.98% RTP, 15x Max Win | {brand}',
        description: 'Burning Wins x2 runs at 95.98% RTP at {brand}, with a 15x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/charge_the_clovers_hit_the_bonus': {
        title: 'Charge the Clovers Hit the Bonus: 95.68% RTP | {brand}',
        description: 'Charge the Clovers Hit the Bonus runs at 95.68% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/playson/classic_fruit_hold_and_win': {
        title: 'Classic Fruit Hold and Win: 95.17% RTP, 5,000x Max Win | {brand}',
        description: 'Classic Fruit Hold and Win runs at 95.17% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/clover_charm_hit_the_bonus': {
        title: 'Clover Charm: Hit the Bonus: 95.66% RTP | {brand}',
        description: 'Clover Charm: Hit the Bonus runs at 95.66% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/clover_smash': {
        title: 'Clover Smash: 95.68% RTP, 1,086x Max Win | {brand}',
        description: 'Clover Smash runs at 95.68% RTP at {brand}, with a 1,086x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/clover_strike_hold_and_win': {
        title: 'Clover Strike Hold and Win: 95.65% RTP | {brand}',
        description: 'Clover Strike Hold and Win runs at 95.65% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/coin_strike_2_hold_and_win': {
        title: 'Coin Strike 2: Hold and Win: 95.65% RTP | {brand}',
        description: 'Coin Strike 2: Hold and Win runs at 95.65% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/coin_strike_xxl': {
        title: 'Coin Strike XXL: 95.6% RTP, 5,405x Max Win | {brand}',
        description: 'Coin Strike XXL runs at 95.6% RTP at {brand}, with a 5,405x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/crown_and_diamonds_hold_and_win': {
        title: 'Crown and Diamonds: Hold and Win: 95.64% RTP | {brand}',
        description: 'Crown and Diamonds: Hold and Win runs at 95.64% RTP at {brand}, with a 4,030x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/crown_strike_hold_and_win': {
        title: 'Crown Strike: Hold and Win: 95.7% RTP | {brand}',
        description: 'Crown Strike: Hold and Win runs at 95.7% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/diamond_fortunator': {
        title: 'Diamond Fortunator: 95.6% RTP, 2,620x Max Win | {brand}',
        description: 'Diamond Fortunator runs at 95.6% RTP at {brand}, with a 2,620x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/diamond_power_hold_and_win': {
        title: 'Diamond Power: Hold and Win: 95.66% RTP | {brand}',
        description: 'Diamond Power: Hold and Win runs at 95.66% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/diamond_power_xxl_hold_and_win': {
        title: 'Diamond Power XXL Hold and Win: 95.6% RTP | {brand}',
        description: 'Diamond Power XXL Hold and Win runs at 95.6% RTP at {brand}, with a 5,405x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/diamond_wins': {
        title: 'Diamond Wins: 95.52% RTP, 1,201x Max Win | {brand}',
        description: 'Diamond Wins runs at 95.52% RTP at {brand}, with a 1,201x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/divine_dragon_hold_and_win': {
        title: 'Divine Dragon: Hold and Win: 95.56% RTP | {brand}',
        description: 'Divine Dragon: Hold and Win runs at 95.56% RTP at {brand}, with a 1,248x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/eagle_power_hold_and_win': {
        title: 'Eagle Power: Hold and Win: 95.06% RTP, 2,105x Max Win | {brand}',
        description: 'Eagle Power: Hold and Win runs at 95.06% RTP at {brand}, with a 2,105x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/empire_gold_hold_and_win': {
        title: 'Empire Gold: Hold and Win: 95.76% RTP, 5,000x Max Win | {brand}',
        description: 'Empire Gold: Hold and Win runs at 95.76% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/energy_coins_hold_and_win': {
        title: 'Energy Coins: Hold and Win: 95.74% RTP | {brand}',
        description: 'Energy Coins: Hold and Win runs at 95.74% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/energy_joker_hold_and_win': {
        title: 'Energy Joker: Hold and Win: 95% RTP | {brand}',
        description: 'Energy Joker: Hold and Win runs at 95% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/fruits_and_jokers_100_lines': {
        title: 'Fruits & Jokers: 100 lines: 96.47% RTP, 2,545x Max Win | {brand}',
        description: 'Fruits & Jokers: 100 lines runs at 96.47% RTP at {brand}, with a 2,545x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/fruits_and_jokers_20_lines': {
        title: 'Fruits & Jokers: 20 lines: 96.5% RTP, 819x Max Win | {brand}',
        description: 'Fruits & Jokers: 20 lines runs at 96.5% RTP at {brand}, with a 819x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/fruits_and_jokers_40_lines': {
        title: 'Fruits & Jokers: 40 lines: 96.45% RTP, 1,500x Max Win | {brand}',
        description: 'Fruits & Jokers: 40 lines runs at 96.45% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/giza_nights_hold_and_win': {
        title: 'Giza Nights: Hold and Win: 95.96% RTP, 5,000x Max Win | {brand}',
        description: 'Giza Nights: Hold and Win runs at 95.96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/golden_penny_x1000': {
        title: 'Golden Penny x1000: 95.68% RTP | {brand}',
        description: 'Golden Penny x1000 runs at 95.68% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/hit_the_bank_hold_and_win': {
        title: 'Hit the Bank: Hold and Win: 95.21% RTP | {brand}',
        description: 'Hit the Bank: Hold and Win runs at 95.21% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/hot_burning_wins': {
        title: 'Hot Burning Wins: 96% RTP, 150x Max Win | {brand}',
        description: 'Hot Burning Wins runs at 96% RTP at {brand}, with a 150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/hot_coins_hold_and_win': {
        title: 'Hot Coins: Hold and Win: 95.61% RTP, 1,387x Max Win | {brand}',
        description: 'Hot Coins: Hold and Win runs at 95.61% RTP at {brand}, with a 1,387x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/imperial_fruits_100_lines': {
        title: 'Imperial Fruits: 100 Lines: 96.42% RTP, 1,057x Max Win | {brand}',
        description: 'Imperial Fruits: 100 Lines runs at 96.42% RTP at {brand}, with a 1,057x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/imperial_fruits_5_lines': {
        title: 'Imperial Fruits: 5 lines: 96.71% RTP, 820x Max Win | {brand}',
        description: 'Imperial Fruits: 5 lines runs at 96.71% RTP at {brand}, with a 820x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/jingle_coins_hold_and_win': {
        title: 'Jingle Coins: Hold and Win: 95.66% RTP, 5,150x Max Win | {brand}',
        description: 'Jingle Coins: Hold and Win runs at 95.66% RTP at {brand}, with a 5,150x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/joker_expand_5_lines': {
        title: 'Joker Expand: 5 lines: 96.5% RTP, 1,050x Max Win | {brand}',
        description: 'Joker Expand: 5 lines runs at 96.5% RTP at {brand}, with a 1,050x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/jokers_coins_hold_and_win': {
        title: "Joker's Coins: Hold and Win: 95.71% RTP | {brand}",
        description: "Joker's Coins: Hold and Win runs at 95.71% RTP at {brand}, with a 3,255x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/playson/king_of_the_sky_hit_the_bonus': {
        title: 'King of the Sky Hit the Bonus: 95.5% RTP | {brand}',
        description: 'King of the Sky Hit the Bonus runs at 95.5% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/legend_of_cleopatra': {
        title: 'Legend of Cleopatra: 95.05% RTP, 657x Max Win | {brand}',
        description: 'Legend of Cleopatra runs at 95.05% RTP at {brand}, with a 657x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/legend_of_cleopatra_megaways': {
        title: 'Legend of Cleopatra Megaways: 95.84% RTP | {brand}',
        description: 'Legend of Cleopatra Megaways runs at 95.84% RTP at {brand}, with a 6,584x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/lightning_clovers_hit_the_bonus': {
        title: 'Lightning Clovers - Hit the Bonus™: 95.49% RTP | {brand}',
        description: 'Lightning Clovers - Hit the Bonus™ runs at 95.49% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/lion_gems_3_pot_hold_and_win': {
        title: 'Lion Gems 3 Pot Hold and Win: 95.76% RTP | {brand}',
        description: 'Lion Gems 3 Pot Hold and Win runs at 95.76% RTP at {brand}, with a 12,186x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/lion_gems_hold_and_win': {
        title: 'Lion Gems: Hold and Win: 95.55% RTP, 3,504x Max Win | {brand}',
        description: 'Lion Gems: Hold and Win runs at 95.55% RTP at {brand}, with a 3,504x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/merry_giftmas_hold_and_win': {
        title: 'Merry Giftmas: Hold and Win: 95.74% RTP | {brand}',
        description: 'Merry Giftmas: Hold and Win runs at 95.74% RTP at {brand}, with a 10,256x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/pearl_beauty_hold_and_win': {
        title: 'Pearl Beauty: Hold and Win: 95.05% RTP, 1,192x Max Win | {brand}',
        description: 'Pearl Beauty: Hold and Win runs at 95.05% RTP at {brand}, with a 1,192x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/pearl_ocean_hold_and_win': {
        title: 'Pearl Ocean: Hold and Win: 95.95% RTP | {brand}',
        description: 'Pearl Ocean: Hold and Win runs at 95.95% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/piggy_power_hit_the_bonus': {
        title: 'Piggy Power: Hit the Bonus: 95.7% RTP, 4,505x Max Win | {brand}',
        description: 'Piggy Power: Hit the Bonus runs at 95.7% RTP at {brand}, with a 4,505x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/pink_clovers_xxxl_hold_and_win': {
        title: 'Pink Clovers XXXL: Hold and Win: 95.64% RTP | {brand}',
        description: 'Pink Clovers XXXL: Hold and Win runs at 95.64% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/playson/pink_joker_hold_and_win': {
        title: 'Pink Joker: Hold and Win: 95.87% RTP | {brand}',
        description: 'Pink Joker: Hold and Win runs at 95.87% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/pirate_chest_hold_and_win': {
        title: 'Pirate Chest: Hold and Win: 95.66% RTP, 3,589x Max Win | {brand}',
        description: 'Pirate Chest: Hold and Win runs at 95.66% RTP at {brand}, with a 3,589x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/power_crown_hold_and_win': {
        title: 'Power Crown: Hold and Win: 95.74% RTP | {brand}',
        description: 'Power Crown: Hold and Win runs at 95.74% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/rhino_coins_hit_the_bonus': {
        title: 'Rhino Coins Hit the Bonus: 95.5% RTP, 15,000x Max Win | {brand}',
        description: 'Rhino Coins Hit the Bonus runs at 95.5% RTP at {brand}, with a 15,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/rich_diamonds_hold_and_win': {
        title: 'Rich Diamonds: Hold and Win: 95.59% RTP | {brand}',
        description: 'Rich Diamonds: Hold and Win runs at 95.59% RTP at {brand}, with a 2,095x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/rise_of_egypt': {
        title: 'Rise of Egypt: 95.82% RTP, 944x Max Win | {brand}',
        description: 'Rise of Egypt runs at 95.82% RTP at {brand}, with a 944x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/rockin_joker_hold_and_win': {
        title: 'Rockin Joker Hold and Win: 95.5% RTP, 10,000x Max Win | {brand}',
        description: 'Rockin Joker Hold and Win runs at 95.5% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/royal_coins_2_hold_and_win': {
        title: 'Royal Coins 2: Hold and Win: 95.64% RTP | {brand}',
        description: 'Royal Coins 2: Hold and Win runs at 95.64% RTP at {brand}, with a 4,030x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/royal_coins_hold_and_win': {
        title: 'Royal Coins: Hold and Win: 95.64% RTP, 4,259x Max Win | {brand}',
        description: 'Royal Coins: Hold and Win runs at 95.64% RTP at {brand}, with a 4,259x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/royal_express_hold_and_win': {
        title: 'Royal Express Hold and Win: 95.62% RTP, 9,585x Max Win | {brand}',
        description: 'Royal Express Hold and Win runs at 95.62% RTP at {brand}, with a 9,585x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/royal_fortunator_hold_and_win': {
        title: 'Royal Fortunator: Hold and Win: 95.64% RTP | {brand}',
        description: 'Royal Fortunator: Hold and Win runs at 95.64% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/sevens_and_fruits': {
        title: 'Sevens & Fruits: 96.31% RTP, 1,010x Max Win | {brand}',
        description: 'Sevens & Fruits runs at 96.31% RTP at {brand}, with a 1,010x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/sevens_and_fruits_20_lines': {
        title: 'Sevens and Fruits: 20 lines: 96.31% RTP, 273x Max Win | {brand}',
        description: 'Sevens and Fruits: 20 lines runs at 96.31% RTP at {brand}, with a 273x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/solar_king': {
        title: 'Solar King: 95.45% RTP, 2,221x Max Win | {brand}',
        description: 'Solar King runs at 95.45% RTP at {brand}, with a 2,221x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/solar_queen': {
        title: 'Solar Queen: 95.78% RTP, 2,668x Max Win | {brand}',
        description: 'Solar Queen runs at 95.78% RTP at {brand}, with a 2,668x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/solar_temple': {
        title: 'Solar Temple: 95.22% RTP, 20,000x Max Win | {brand}',
        description: 'Solar Temple runs at 95.22% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/sugar_teddy': {
        title: 'Sugar Teddy: 95.5% RTP, 20,000x Max Win | {brand}',
        description: 'Sugar Teddy runs at 95.5% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/sunny_fruits_2_hold_and_win': {
        title: 'Sunny Fruits 2: Hold and Win: 95.74% RTP | {brand}',
        description: 'Sunny Fruits 2: Hold and Win runs at 95.74% RTP at {brand}, with a 10,016x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/sunny_fruits_hold_and_win': {
        title: 'Sunny Fruits: Hold and Win: 95.05% RTP, 1,193x Max Win | {brand}',
        description: 'Sunny Fruits: Hold and Win runs at 95.05% RTP at {brand}, with a 1,193x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/super_pink_joker_hold_and_win': {
        title: 'Super Pink Joker: Hold and Win: 95.74% RTP | {brand}',
        description: 'Super Pink Joker: Hold and Win runs at 95.74% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/supercharged_clovers_hold_and_win': {
        title: 'Supercharged Clovers: Hold and Win: 95.78% RTP | {brand}',
        description: 'Supercharged Clovers: Hold and Win runs at 95.78% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/playson/thunder_coins_hold_and_win': {
        title: 'Thunder Coins: Hold and Win: 95.66% RTP | {brand}',
        description: 'Thunder Coins: Hold and Win runs at 95.66% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/thunder_coins_xxl_hold_and_win': {
        title: 'Thunder Coins XXL: Hold and Win: 95.6% RTP | {brand}',
        description: 'Thunder Coins XXL: Hold and Win runs at 95.6% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/thunder_coins_xxl_multicoin': {
        title: 'Thunder Coins XXL Multicoin: 95.65% RTP | {brand}',
        description: 'Thunder Coins XXL Multicoin runs at 95.65% RTP at {brand}, with a 7,426x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/tornado_power_hold_and_win': {
        title: 'Tornado Power Hold and Win: 95.65% RTP, 4,816x Max Win | {brand}',
        description: 'Tornado Power Hold and Win runs at 95.65% RTP at {brand}, with a 4,816x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/treasures_of_fire': {
        title: 'Treasures of Fire: 95.51% RTP, 20,000x Max Win | {brand}',
        description: 'Treasures of Fire runs at 95.51% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/wolf_power_hold_and_win': {
        title: 'Wolf Power: Hold and Win: 95.04% RTP, 1,272x Max Win | {brand}',
        description: 'Wolf Power: Hold and Win runs at 95.04% RTP at {brand}, with a 1,272x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/wolf_power_megaways': {
        title: 'Wolf Power Megaways: 96% RTP, 20,000x Max Win | {brand}',
        description: 'Wolf Power Megaways runs at 96% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/playson/x1000_golden_penny_2': {
        title: 'x1000 Golden Penny 2: 95.67% RTP, 20,000x Max Win | {brand}',
        description: 'x1000 Golden Penny 2 runs at 95.67% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/adventures_beyond_wonderland_magical_maze': {
        title: 'Adventures Beyond Wonderland Magical Maze: 96.15% RTP | {brand}',
        description: 'Adventures Beyond Wonderland Magical Maze runs at 96.15% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/arcane_gems': {
        title: 'Arcane Gems: 96.05% RTP | {brand}',
        description: 'Arcane Gems runs at 96.05% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/ark_of_mystery': {
        title: 'Ark of Mystery: 96.53% RTP | {brand}',
        description: 'Ark of Mystery runs at 96.53% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/artemis_vs_medusa': {
        title: 'Artemis vs Medusa: 96.17% RTP | {brand}',
        description: 'Artemis vs Medusa runs at 96.17% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/azticons_chaos_clusters': {
        title: 'Azticons Chaos Clusters: 96.26% RTP | {brand}',
        description: 'Azticons Chaos Clusters runs at 96.26% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/big_bad_wolf': {
        title: 'Big Bad Wolf: 97.34% RTP | {brand}',
        description: 'Big Bad Wolf runs at 97.34% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/big_bad_wolf_christmas_special': {
        title: 'Big Bad Wolf Christmas Special: 97.34% RTP | {brand}',
        description: 'Big Bad Wolf Christmas Special runs at 97.34% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/big_bad_wolf_megaways': {
        title: 'Big Bad Wolf Megaways: 96.05% RTP | {brand}',
        description: 'Big Bad Wolf Megaways runs at 96.05% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/big_bad_wolf_pigs_of_steel': {
        title: 'Big Bad Wolf: Pigs of Steel: 96.14% RTP | {brand}',
        description: 'Big Bad Wolf: Pigs of Steel runs at 96.14% RTP at {brand}, with a 18,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/big_bot_crew': {
        title: 'Big Bot Crew: 96.51% RTP | {brand}',
        description: 'Big Bot Crew runs at 96.51% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/blue_fortune': {
        title: 'Blue Fortune: 96.57% RTP | {brand}',
        description: 'Blue Fortune runs at 96.57% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/book_of_duat': {
        title: 'Book of Duat: 96.27% RTP | {brand}',
        description: 'Book of Duat runs at 96.27% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/book_of_yuletide': {
        title: 'Book of Yuletide: 96.27% RTP, 32,760x Max Win | {brand}',
        description: 'Book of Yuletide runs at 96.27% RTP at {brand}, with a 32,760x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/brawlers_bar_cash_collect': {
        title: 'Brawlers Bar Cash Collect™: 96.02% RTP | {brand}',
        description: 'Brawlers Bar Cash Collect™ runs at 96.02% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/brawlers_brew': {
        title: 'Brawlers Brew: 94.19% RTP, 7,620x Max Win | {brand}',
        description: 'Brawlers Brew runs at 94.19% RTP at {brand}, with a 7,620x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/brooklyn_bootleggers': {
        title: 'Brooklyn Bootleggers: 96.25% RTP | {brand}',
        description: 'Brooklyn Bootleggers runs at 96.25% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/cabin_crashers': {
        title: 'Cabin Crashers: 96.18% RTP | {brand}',
        description: 'Cabin Crashers runs at 96.18% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/candy_glyph': {
        title: 'Candy Glyph: 96.19% RTP | {brand}',
        description: 'Candy Glyph runs at 96.19% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/cash_truck': {
        title: 'Cash Truck: 96% RTP | {brand}',
        description: 'Cash Truck runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/cash_truck_2': {
        title: 'Cash Truck 2: 96.1% RTP | {brand}',
        description: 'Cash Truck 2 runs at 96.1% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/cash_truck_3_turbo': {
        title: 'Cash Truck 3 Turbo: 96.06% RTP | {brand}',
        description: 'Cash Truck 3 Turbo runs at 96.06% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/cash_truck_begins': {
        title: 'Cash Truck Begins: 94.19% RTP, 20,000x Max Win | {brand}',
        description: 'Cash Truck Begins runs at 94.19% RTP at {brand}, with a 20,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/cash_truck_xmas_delivery': {
        title: 'Cash Truck Xmas Delivery: 94.19% RTP | {brand}',
        description: 'Cash Truck Xmas Delivery runs at 94.19% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/crown_of_valor': {
        title: 'Crown of Valor: 96.16% RTP | {brand}',
        description: 'Crown of Valor runs at 96.16% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/crystal_prince': {
        title: 'Crystal Prince: 96.04% RTP | {brand}',
        description: 'Crystal Prince runs at 96.04% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/crystal_queen': {
        title: 'Crystal Queen: 96.16% RTP | {brand}',
        description: 'Crystal Queen runs at 96.16% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/crystal_queen_coins': {
        title: 'Crystal Queen Coins: 96.06% RTP, 10,150x Max Win | {brand}',
        description: 'Crystal Queen Coins runs at 96.06% RTP at {brand}, with a 10,150x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/diamond_duke': {
        title: 'Diamond Duke: 96.23% RTP | {brand}',
        description: 'Diamond Duke runs at 96.23% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/dinosaur_rage': {
        title: 'Dinosaur Rage: 96.11% RTP, 17,000x Max Win | {brand}',
        description: 'Dinosaur Rage runs at 96.11% RTP at {brand}, with a 17,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/divine_dreams': {
        title: 'Divine Dreams: 96.12% RTP | {brand}',
        description: 'Divine Dreams runs at 96.12% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/dragon_chase': {
        title: 'Dragon Chase: 96.39% RTP | {brand}',
        description: 'Dragon Chase runs at 96.39% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/dragon_shrine': {
        title: 'Dragon Shrine: 96.55% RTP | {brand}',
        description: 'Dragon Shrine runs at 96.55% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/durian_dynamite': {
        title: 'Durian Dynamite: 96.22% RTP | {brand}',
        description: 'Durian Dynamite runs at 96.22% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/dwarfs_gone_wild': {
        title: 'Dwarfs Gone Wild: 96.38% RTP | {brand}',
        description: 'Dwarfs Gone Wild runs at 96.38% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/eastern_emeralds': {
        title: 'Eastern Emeralds: 96.58% RTP, 1,680x Max Win | {brand}',
        description: 'Eastern Emeralds runs at 96.58% RTP at {brand}, with a 1,680x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/epic_fish_adventure': {
        title: 'Epic Fish Adventure: 96.07% RTP, 5,190x Max Win | {brand}',
        description: 'Epic Fish Adventure runs at 96.07% RTP at {brand}, with a 5,190x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/epic_fish_marlin_madness': {
        title: 'Epic Fish Marlin Madness: 94.19% RTP, 7,673x Max Win | {brand}',
        description: 'Epic Fish Marlin Madness runs at 94.19% RTP at {brand}, with a 7,673x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/epic_fish_net_of_fortune': {
        title: 'Epic Fish Net of Fortune: 96.1% RTP, 5,360x Max Win | {brand}',
        description: 'Epic Fish Net of Fortune runs at 96.1% RTP at {brand}, with a 5,360x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/fairy_gate': {
        title: 'Fairy Gate: 96.66% RTP | {brand}',
        description: 'Fairy Gate runs at 96.66% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/feasting_fox': {
        title: 'Feasting Fox: 96.29% RTP | {brand}',
        description: 'Feasting Fox runs at 96.29% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/fire_tale': {
        title: 'Fire Tale: 96% RTP | {brand}',
        description: 'Fire Tale runs at 96% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/genies_touch': {
        title: 'Genies Touch: 96.9% RTP | {brand}',
        description: 'Genies Touch runs at 96.9% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/ghost_glyph': {
        title: 'Ghost Glyph: 96.18% RTP | {brand}',
        description: 'Ghost Glyph runs at 96.18% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/gloria_invicta': {
        title: 'Gloria Invicta: 94.19% RTP, 18,143x Max Win | {brand}',
        description: 'Gloria Invicta runs at 94.19% RTP at {brand}, with a 18,143x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/golden_glyph': {
        title: 'Golden Glyph: 96.19% RTP | {brand}',
        description: 'Golden Glyph runs at 96.19% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/golden_glyph_2': {
        title: 'Golden Glyph 2: 96.09% RTP | {brand}',
        description: 'Golden Glyph 2 runs at 96.09% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/golden_glyph_3': {
        title: 'Golden Glyph 3: 96.11% RTP | {brand}',
        description: 'Golden Glyph 3 runs at 96.11% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/goldilocks': {
        title: 'Goldilocks: 96.84% RTP | {brand}',
        description: 'Goldilocks runs at 96.84% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/guardian_of_athens': {
        title: 'Guardian Of Athens: 96.58% RTP | {brand}',
        description: 'Guardian Of Athens runs at 96.58% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/hall_of_the_mountain_king': {
        title: 'Hall of the Mountain King: 96.29% RTP, 7,000x Max Win | {brand}',
        description: 'Hall of the Mountain King runs at 96.29% RTP at {brand}, with a 7,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/hammer_of_vulcan': {
        title: 'Hammer of Vulcan: 95.81% RTP, 20,000x Max Win | {brand}',
        description: 'Hammer of Vulcan runs at 95.81% RTP at {brand}, with a 20,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/hidden_valley_120': {
        title: 'Hidden Valley 120: 95.69% RTP | {brand}',
        description: 'Hidden Valley 120 runs at 95.69% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/high_street_heist': {
        title: 'High Street Heist: 96.29% RTP | {brand}',
        description: 'High Street Heist runs at 96.29% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/honeylocks_pots': {
        title: 'Honeylocks Pots: 94.18% RTP, 2,500x Max Win | {brand}',
        description: 'Honeylocks Pots runs at 94.18% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/ivan_and_the_immortal_king': {
        title: 'Ivan and the Immortal King: 96.29% RTP | {brand}',
        description: 'Ivan and the Immortal King runs at 96.29% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/joker_strike': {
        title: 'Joker Strike: 96.46% RTP | {brand}',
        description: 'Joker Strike runs at 96.46% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/king_colossus': {
        title: 'King Colossus: 96.57% RTP | {brand}',
        description: 'King Colossus runs at 96.57% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/leprechaun_hills': {
        title: 'Leprechaun Hills: 96.49% RTP | {brand}',
        description: 'Leprechaun Hills runs at 96.49% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/loco_the_monkey': {
        title: 'Loco the Monkey: 96.15% RTP | {brand}',
        description: 'Loco the Monkey runs at 96.15% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/mayana': {
        title: 'Mayana: 96.63% RTP | {brand}',
        description: 'Mayana runs at 96.63% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/midas_coins': {
        title: 'Midas Coins: 96.02% RTP, 5,000x Max Win | {brand}',
        description: 'Midas Coins runs at 96.02% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/mighty_arthur': {
        title: 'Mighty Arthur: 96.94% RTP | {brand}',
        description: 'Mighty Arthur runs at 96.94% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/neros_fortune': {
        title: "Nero's Fortune: 96.24% RTP | {brand}",
        description: "Nero's Fortune runs at 96.24% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/quickspin/northern_sky': {
        title: 'Northern Sky: 96.57% RTP | {brand}',
        description: 'Northern Sky runs at 96.57% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/panthers_reign': {
        title: "Panther's Reign: 96.25% RTP | {brand}",
        description: "Panther's Reign runs at 96.25% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/quickspin/pearl_o_plinko': {
        title: 'Pearl O Plinko: 94.19% RTP | {brand}',
        description: 'Pearl O Plinko runs at 94.19% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/pearl_o_plinko_mermaid': {
        title: 'Pearl O Plinko Mermaid: 98.1% RTP | {brand}',
        description: 'Pearl O Plinko Mermaid runs at 98.1% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/phoenix_sun': {
        title: 'Phoenix Sun: 96.08% RTP | {brand}',
        description: 'Phoenix Sun runs at 96.08% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/pied_piper': {
        title: 'Pied Piper: 96.32% RTP | {brand}',
        description: 'Pied Piper runs at 96.32% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/pineapple_crush': {
        title: 'Pineapple Crush: 96.01% RTP, 7,333x Max Win | {brand}',
        description: 'Pineapple Crush runs at 96.01% RTP at {brand}, with a 7,333x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/pirates_charm': {
        title: "Pirate's Charm: 96.49% RTP | {brand}",
        description: "Pirate's Charm runs at 96.49% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/quickspin/polar_paws': {
        title: 'Polar Paws: 96.84% RTP | {brand}',
        description: 'Polar Paws runs at 96.84% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/prime_zone': {
        title: 'Prime Zone: 96.28% RTP | {brand}',
        description: 'Prime Zone runs at 96.28% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/rapunzels_tower': {
        title: "Rapunzel's Tower: 96.25% RTP | {brand}",
        description: "Rapunzel's Tower runs at 96.25% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/quickspin/razortooth': {
        title: 'Razortooth: 96.6% RTP | {brand}',
        description: 'Razortooth runs at 96.6% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/reel_nightmare': {
        title: 'Reel Nightmare: 96.23% RTP, 17,279x Max Win | {brand}',
        description: 'Reel Nightmare runs at 96.23% RTP at {brand}, with a 17,279x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/reno_7s': {
        title: "Reno 7's: 95.98% RTP | {brand}",
        description: "Reno 7's runs at 95.98% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/quickspin/robbits_94': {
        title: 'Robbits 94: 94.19% RTP, 4,236x Max Win | {brand}',
        description: 'Robbits 94 runs at 94.19% RTP at {brand}, with a 4,236x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sakura_fortune': {
        title: 'Sakura Fortune: 96.58% RTP | {brand}',
        description: 'Sakura Fortune runs at 96.58% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sakura_fortune_2': {
        title: 'Sakura Fortune 2: 96.03% RTP | {brand}',
        description: 'Sakura Fortune 2 runs at 96.03% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sakura_fortune_epic_bloom': {
        title: 'Sakura Fortune Epic Bloom: 96.06% RTP, 10,000x Max Win | {brand}',
        description: 'Sakura Fortune Epic Bloom runs at 96.06% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/scepter_of_anubis': {
        title: 'Scepter of Anubis: 94.19% RTP, 10,000x Max Win | {brand}',
        description: 'Scepter of Anubis runs at 94.19% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/second_strike': {
        title: 'Second Strike: 96.22% RTP | {brand}',
        description: 'Second Strike runs at 96.22% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sevens_high': {
        title: 'Sevens High: 96.54% RTP | {brand}',
        description: 'Sevens High runs at 96.54% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sevens_high_ultra': {
        title: 'Sevens High Ultra: 96.06% RTP | {brand}',
        description: 'Sevens High Ultra runs at 96.06% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/shields_of_lambda': {
        title: 'Shields of Lambda: 96.13% RTP | {brand}',
        description: 'Shields of Lambda runs at 96.13% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sinbad': {
        title: 'Sinbad: 97.06% RTP | {brand}',
        description: 'Sinbad runs at 97.06% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/skulls_up': {
        title: 'Skulls UP!: 96.26% RTP | {brand}',
        description: 'Skulls UP! runs at 96.26% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/slugger_time': {
        title: 'Slugger Time: 96.18% RTP | {brand}',
        description: 'Slugger Time runs at 96.18% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/spinions': {
        title: 'Spinions: 96.05% RTP | {brand}',
        description: 'Spinions runs at 96.05% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/spinions_xmas_party': {
        title: 'Spinions X-mas Party: 96.05% RTP | {brand}',
        description: 'Spinions X-mas Party runs at 96.05% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sticky_bandits': {
        title: 'Sticky Bandits: 96.58% RTP | {brand}',
        description: 'Sticky Bandits runs at 96.58% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sticky_bandits_3_most_wanted': {
        title: 'Sticky Bandits 3: Most Wanted: 96.25% RTP | {brand}',
        description: 'Sticky Bandits 3: Most Wanted runs at 96.25% RTP at {brand}, with a 22,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sticky_bandits_thunder_rail': {
        title: 'Sticky Bandits Thunder Rail: 94.19% RTP | {brand}',
        description: 'Sticky Bandits Thunder Rail runs at 94.19% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sticky_bandits_trail_of_blood': {
        title: 'Sticky Bandits Trail of Blood: 96.23% RTP | {brand}',
        description: 'Sticky Bandits Trail of Blood runs at 96.23% RTP at {brand}, with a 17,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sticky_bandits_unchained': {
        title: 'Sticky Bandits Unchained: 96.09% RTP | {brand}',
        description: 'Sticky Bandits Unchained runs at 96.09% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/sticky_bandits_wild_return': {
        title: 'Sticky Bandits: Wild Return: 96.22% RTP | {brand}',
        description: 'Sticky Bandits: Wild Return runs at 96.22% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/tales_of_dr_dolittle': {
        title: 'Tales of Dr. Dolittle: 96.73% RTP | {brand}',
        description: 'Tales of Dr. Dolittle runs at 96.73% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/temple_of_paw': {
        title: 'Temple of Paw: 96.01% RTP, 7,333x Max Win | {brand}',
        description: 'Temple of Paw runs at 96.01% RTP at {brand}, with a 7,333x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/the_grand': {
        title: 'The Grand: 96.58% RTP | {brand}',
        description: 'The Grand runs at 96.58% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/the_grim_reaper': {
        title: 'The Grim Reaper: 94.19% RTP, 5,360x Max Win | {brand}',
        description: 'The Grim Reaper runs at 94.19% RTP at {brand}, with a 5,360x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/the_wild_chase': {
        title: 'The Wild Chase: 96.72% RTP | {brand}',
        description: 'The Wild Chase runs at 96.72% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/ticket_to_the_stars': {
        title: 'Ticket to the Stars: 96.52% RTP | {brand}',
        description: 'Ticket to the Stars runs at 96.52% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/tigers_glory': {
        title: "Tiger's Glory: 96.51% RTP, 12,000x Max Win | {brand}",
        description: "Tiger's Glory runs at 96.51% RTP at {brand}, with a 12,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/quickspin/tigers_glory_ultra': {
        title: "Tiger's Glory Ultra: 96.72% RTP, 32,000x Max Win | {brand}",
        description: "Tiger's Glory Ultra runs at 96.72% RTP at {brand}, with a 32,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/quickspin/treasure_island': {
        title: 'Treasure Island: 97.07% RTP | {brand}',
        description: 'Treasure Island runs at 97.07% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/vampire_senpai': {
        title: 'Vampire Senpai: 96.19% RTP, 8,800x Max Win | {brand}',
        description: 'Vampire Senpai runs at 96.19% RTP at {brand}, with a 8,800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/volcano_riches': {
        title: 'Volcano Riches: 96.43% RTP | {brand}',
        description: 'Volcano Riches runs at 96.43% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/warp_wreckers_power_glyph': {
        title: 'Warp Wreckers Power Glyph: 96.29% RTP, 4,500x Max Win | {brand}',
        description: 'Warp Wreckers Power Glyph runs at 96.29% RTP at {brand}, with a 4,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/wild_beans': {
        title: 'Wild Beans: 94.19% RTP | {brand}',
        description: 'Wild Beans runs at 94.19% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/wild_cauldron': {
        title: 'Wild Cauldron: 96.09% RTP | {brand}',
        description: 'Wild Cauldron runs at 96.09% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/wild_chase_tokyo_go': {
        title: 'Wild Chase: Tokyo Go: 96.54% RTP | {brand}',
        description: 'Wild Chase: Tokyo Go runs at 96.54% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/wild_harlequin': {
        title: 'Wild Harlequin: 96.27% RTP | {brand}',
        description: 'Wild Harlequin runs at 96.27% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/wild_luchador': {
        title: 'Wild Luchador: 96% RTP, 40,500x Max Win | {brand}',
        description: 'Wild Luchador runs at 96% RTP at {brand}, with a 40,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/wild_tome_of_the_woods': {
        title: 'Wild Tome of the Woods: 96.28% RTP | {brand}',
        description: 'Wild Tome of the Woods runs at 96.28% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/quickspin/wins_of_fortune': {
        title: 'Wins of Fortune: 96.54% RTP | {brand}',
        description: 'Wins of Fortune runs at 96.54% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/12_bells': {
        title: '12 Bells: 94.16% RTP | {brand}',
        description: '12 Bells runs at 94.16% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/12_coins': {
        title: '12 Coins™: 94.1% RTP | {brand}',
        description: '12 Coins™ runs at 94.1% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/12_coins_grand_diamond_edition': {
        title: '12 Coins Grand Diamond Edition: 94.15% RTP | {brand}',
        description: '12 Coins Grand Diamond Edition runs at 94.15% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/12_coins_grand_gold_edition': {
        title: '12 Coins™ Grand Gold Edition: 94.17% RTP | {brand}',
        description: '12 Coins™ Grand Gold Edition runs at 94.17% RTP at {brand}, with a 150,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/12_coins_grand_platinum_edition': {
        title: '12 Coins™: Grand Platinum Edition: 94.15% RTP | {brand}',
        description: '12 Coins™: Grand Platinum Edition runs at 94.15% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/15_coins': {
        title: '15 Coins: 94.18% RTP, 100,000x Max Win | {brand}',
        description: '15 Coins runs at 94.18% RTP at {brand}, with a 100,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/15_coins_grand_gold_edition': {
        title: '15 Coins Grand Gold Edition: 94.17% RTP | {brand}',
        description: '15 Coins Grand Gold Edition runs at 94.17% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/15_coins_grand_platinum_edition': {
        title: '15 Coins™: Grand Platinum Edition: 94.16% RTP | {brand}',
        description: '15 Coins™: Grand Platinum Edition runs at 94.16% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/16_coins': {
        title: '16 Coins: 94.13% RTP | {brand}',
        description: '16 Coins runs at 94.13% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/16_coins_grand_gold_edition': {
        title: '16 Coins™ Grand Gold Edition: 94.15% RTP | {brand}',
        description: '16 Coins™ Grand Gold Edition runs at 94.15% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/16_coins_grand_platinum_edition': {
        title: '16 Coins Grand Platinum Edition: 94.15% RTP | {brand}',
        description: '16 Coins Grand Platinum Edition runs at 94.15% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/16_coins_x5000': {
        title: '16 Coins x5000: 94.16% RTP, 5,000x Max Win | {brand}',
        description: '16 Coins x5000 runs at 94.16% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/20_coins': {
        title: '20 Coins™: 94.16% RTP, 1,500x Max Win | {brand}',
        description: '20 Coins™ runs at 94.16% RTP at {brand}, with a 1,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/20_coins_grand_gold_edition': {
        title: '20 Coins™ Grand Gold Edition: 94.16% RTP | {brand}',
        description: '20 Coins™ Grand Gold Edition runs at 94.16% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/24_coins': {
        title: '24 Coins™: 94.14% RTP, 1,200x Max Win | {brand}',
        description: '24 Coins™ runs at 94.14% RTP at {brand}, with a 1,200x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/25_coins': {
        title: '25 Coins: 94.15% RTP, 2,000x Max Win | {brand}',
        description: '25 Coins runs at 94.15% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/25_coins_grand_gold_edition': {
        title: '25 Coins Grand Gold Edition: 94.11% RTP | {brand}',
        description: '25 Coins Grand Gold Edition runs at 94.11% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/30_coins': {
        title: '30 Coins™: 94.15% RTP, 1,500x Max Win | {brand}',
        description: '30 Coins™ runs at 94.15% RTP at {brand}, with a 1,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/30_coins_grand_gold_edition': {
        title: '30 Coins Grand Gold Edition: 94.14% RTP | {brand}',
        description: '30 Coins Grand Gold Edition runs at 94.14% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/36_coins': {
        title: '36 Coins™: 94.17% RTP | {brand}',
        description: '36 Coins™ runs at 94.17% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/36_coins_grand_gold_edition': {
        title: '36 Coins Grand Gold Edition: 94.18% RTP | {brand}',
        description: '36 Coins Grand Gold Edition runs at 94.18% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_balls': {
        title: '9 Balls: 94.14% RTP, 2,500x Max Win | {brand}',
        description: '9 Balls runs at 94.14% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_bells': {
        title: '9 Bells: 94.14% RTP | {brand}',
        description: '9 Bells runs at 94.14% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_burning_dragons': {
        title: '9 Burning Dragons: 94.23% RTP, 2,187x Max Win | {brand}',
        description: '9 Burning Dragons runs at 94.23% RTP at {brand}, with a 2,187x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_burning_stars': {
        title: '9 Burning Stars: 94.06% RTP, 1,500x Max Win | {brand}',
        description: '9 Burning Stars runs at 94.06% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_coins': {
        title: '9 Coins: 94.13% RTP, 500x Max Win | {brand}',
        description: '9 Coins runs at 94.13% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_coins_1000_edition': {
        title: '9 Coins 1000 Edition: 94.11% RTP, 1,000x Max Win | {brand}',
        description: '9 Coins 1000 Edition runs at 94.11% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_coins_extremely_light': {
        title: '9 Coins™ Extremely Light: 94.13% RTP, 500x Max Win | {brand}',
        description: '9 Coins™ Extremely Light runs at 94.13% RTP at {brand}, with a 500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_coins_grand_diamond_edition': {
        title: '9 Coins Grand Diamond Edition: 94.16% RTP | {brand}',
        description: '9 Coins Grand Diamond Edition runs at 94.16% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_coins_grand_gold_edition': {
        title: '9 Coins: Grand Gold Edition: 94.13% RTP | {brand}',
        description: '9 Coins: Grand Gold Edition runs at 94.13% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_coins_grand_platinum_edition': {
        title: '9 Coins Grand Platinum Edition: 94.14% RTP | {brand}',
        description: '9 Coins Grand Platinum Edition runs at 94.14% RTP at {brand} and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_lions': {
        title: '9 Lions: 96% RTP, 1,000x Max Win | {brand}',
        description: '9 Lions runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_lions_hold_the_jackpot': {
        title: '9 Lions™ Hold The Jackpot™: 94.1% RTP | {brand}',
        description: '9 Lions™ Hold The Jackpot™ runs at 94.1% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/9_tigers': {
        title: '9 Tigers™: 94.25% RTP, 1,000x Max Win | {brand}',
        description: '9 Tigers™ runs at 94.25% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/american_gold_poker': {
        title: 'American Gold Poker: 94.38% RTP | {brand}',
        description: 'American Gold Poker runs at 94.38% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/arcade': {
        title: 'Arcade: 93.85% RTP, 1,400x Max Win | {brand}',
        description: 'Arcade runs at 93.85% RTP at {brand}, with a 1,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/back_to_70s': {
        title: "Back to 70's: 96% RTP, 5,150x Max Win | {brand}",
        description: "Back to 70's runs at 96% RTP at {brand}, with a 5,150x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/wazdan/back_to_the_70s': {
        title: "Back to the 70's: 94.18% RTP | {brand}",
        description: "Back to the 70's runs at 94.18% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/wazdan/bars_and_7s': {
        title: 'Bars & 7s: 96% RTP, 40x Max Win | {brand}',
        description: 'Bars & 7s runs at 96% RTP at {brand}, with a 40x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/barsand7s': {
        title: 'BARsand7s: 94.2% RTP | {brand}',
        description: 'BARsand7s runs at 94.2% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/beach_party': {
        title: 'Beach Party: 94.68% RTP, 36x Max Win | {brand}',
        description: 'Beach Party runs at 94.68% RTP at {brand}, with a 36x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/beach_party_hot': {
        title: 'Beach Party Hot: 93.79% RTP, 305x Max Win | {brand}',
        description: 'Beach Party Hot runs at 93.79% RTP at {brand}, with a 305x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/beauty_fruity': {
        title: 'Beauty Fruity: 94.3% RTP, 2,500x Max Win | {brand}',
        description: 'Beauty Fruity runs at 94.3% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/bell_wizard': {
        title: 'Bell Wizard: 93.86% RTP, 2,300x Max Win | {brand}',
        description: 'Bell Wizard runs at 93.86% RTP at {brand}, with a 2,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/bells_of_fortune': {
        title: 'Bells of Fortune: 94.15% RTP | {brand}',
        description: 'Bells of Fortune runs at 94.15% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/black_hawk': {
        title: 'Black Hawk: 94.07% RTP, 75x Max Win | {brand}',
        description: 'Black Hawk runs at 94.07% RTP at {brand}, with a 75x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/black_hawk_deluxe': {
        title: 'Black Hawk Deluxe: 94.07% RTP, 600x Max Win | {brand}',
        description: 'Black Hawk Deluxe runs at 94.07% RTP at {brand}, with a 600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/black_horse': {
        title: 'Black Horse: 94.04% RTP, 2,500x Max Win | {brand}',
        description: 'Black Horse runs at 94.04% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/black_horse_cash_out': {
        title: 'Black Horse Cash Out: 94.17% RTP | {brand}',
        description: 'Black Horse Cash Out runs at 94.17% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/black_horse_deluxe': {
        title: 'Black Horse Deluxe: 94.26% RTP, 950x Max Win | {brand}',
        description: 'Black Horse Deluxe runs at 94.26% RTP at {brand}, with a 950x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/book_of_faith': {
        title: 'Book of Faith™: 94.1% RTP, 500,000x Max Win | {brand}',
        description: 'Book of Faith™ runs at 94.1% RTP at {brand}, with a 500,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/bumba_meu_boi_coin': {
        title: 'Bumba Meu Boi Coin: 94.14% RTP | {brand}',
        description: 'Bumba Meu Boi Coin runs at 94.14% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/burning_reels': {
        title: 'Burning Reels: 95.5% RTP, 1,250x Max Win | {brand}',
        description: 'Burning Reels runs at 95.5% RTP at {brand}, with a 1,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/burning_stars': {
        title: 'Burning Stars: 93.8% RTP, 4,650x Max Win | {brand}',
        description: 'Burning Stars runs at 93.8% RTP at {brand}, with a 4,650x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/burning_stars_3': {
        title: 'Burning Stars 3: 94.23% RTP, 2,187x Max Win | {brand}',
        description: 'Burning Stars 3 runs at 94.23% RTP at {brand}, with a 2,187x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/burning_sun': {
        title: 'Burning Sun™: 94.1% RTP, 5,000x Max Win | {brand}',
        description: 'Burning Sun™ runs at 94.1% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/burning_sun_extremely_light': {
        title: 'Burning Sun™ Extremely Light: 94.1% RTP | {brand}',
        description: 'Burning Sun™ Extremely Light runs at 94.1% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/butterfly_lovers': {
        title: 'Butterfly Lovers: 94.06% RTP, 1,600x Max Win | {brand}',
        description: 'Butterfly Lovers runs at 94.06% RTP at {brand}, with a 1,600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/captain_shark': {
        title: 'Captain Shark: 93.92% RTP, 748x Max Win | {brand}',
        description: 'Captain Shark runs at 93.92% RTP at {brand}, with a 748x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/carribean_beach_poker': {
        title: 'Carribean Beach Poker: 96% RTP, 1,000x Max Win | {brand}',
        description: 'Carribean Beach Poker runs at 96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/cash_grotto': {
        title: 'Cash Grotto: 94.14% RTP, 1,500x Max Win | {brand}',
        description: 'Cash Grotto runs at 94.14% RTP at {brand}, with a 1,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/choco_reels': {
        title: 'Choco Reels: 94.35% RTP, 9,500x Max Win | {brand}',
        description: 'Choco Reels runs at 94.35% RTP at {brand}, with a 9,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/clover_lady': {
        title: 'Clover Lady: 94.32% RTP, 3,500x Max Win | {brand}',
        description: 'Clover Lady runs at 94.32% RTP at {brand}, with a 3,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/colin_the_cat': {
        title: 'Colin the Cat: 94.28% RTP, 260x Max Win | {brand}',
        description: 'Colin the Cat runs at 94.28% RTP at {brand}, with a 260x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/corrida_romance': {
        title: 'Corrida Romance: 94.72% RTP, 5,150x Max Win | {brand}',
        description: 'Corrida Romance runs at 94.72% RTP at {brand}, with a 5,150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/corrida_romance_deluxe': {
        title: 'Corrida Romance Deluxe: 94.73% RTP, 4,650x Max Win | {brand}',
        description: 'Corrida Romance Deluxe runs at 94.73% RTP at {brand}, with a 4,650x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/crazy_cars': {
        title: 'Crazy Cars: 93.92% RTP, 1,750x Max Win | {brand}',
        description: 'Crazy Cars runs at 93.92% RTP at {brand}, with a 1,750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/criss_cross_81': {
        title: 'Criss Cross 81: 94.1% RTP, 300x Max Win | {brand}',
        description: 'Criss Cross 81 runs at 94.1% RTP at {brand}, with a 300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/cube_mania': {
        title: 'Cube Mania™: 94.04% RTP, 1,000x Max Win | {brand}',
        description: 'Cube Mania™ runs at 94.04% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/cube_mania_deluxe': {
        title: 'Cube Mania Deluxe™: 93.93% RTP, 570x Max Win | {brand}',
        description: 'Cube Mania Deluxe™ runs at 93.93% RTP at {brand}, with a 570x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/demon_jack_27': {
        title: 'Demon Jack 27: 93.98% RTP, 1,104x Max Win | {brand}',
        description: 'Demon Jack 27 runs at 93.98% RTP at {brand}, with a 1,104x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/dino_reels_81': {
        title: 'Dino Reels 81: 94.13% RTP, 691x Max Win | {brand}',
        description: 'Dino Reels 81 runs at 94.13% RTP at {brand}, with a 691x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/double_tigers': {
        title: 'Double Tigers: 94.2% RTP, 40x Max Win | {brand}',
        description: 'Double Tigers runs at 94.2% RTP at {brand}, with a 40x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/draculas_castle': {
        title: "Dracula's Castle: 93.92% RTP, 1,000x Max Win | {brand}",
        description: "Dracula's Castle runs at 93.92% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/wazdan/dragons_lucky_8': {
        title: 'Dragons Lucky 8™: 94.48% RTP, 1,150x Max Win | {brand}',
        description: 'Dragons Lucky 8™ runs at 94.48% RTP at {brand}, with a 1,150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/dwarfs_fortune': {
        title: 'Dwarfs Fortune: 94.11% RTP, 2,500x Max Win | {brand}',
        description: 'Dwarfs Fortune runs at 94.11% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/easter_coins': {
        title: 'Easter Coins: 94.15% RTP | {brand}',
        description: 'Easter Coins runs at 94.15% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/eggs_of_fortune': {
        title: 'Eggs of Fortune: 94.17% RTP, 5,000x Max Win | {brand}',
        description: 'Eggs of Fortune runs at 94.17% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/extra_bingo': {
        title: 'Extra Bingo: 94.09% RTP, 1,000x Max Win | {brand}',
        description: 'Extra Bingo runs at 94.09% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fenix_play': {
        title: 'Fenix Play: 94.29% RTP, 748x Max Win | {brand}',
        description: 'Fenix Play runs at 94.29% RTP at {brand}, with a 748x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fenix_play_27': {
        title: 'Fenix Play 27: 93.98% RTP, 72x Max Win | {brand}',
        description: 'Fenix Play 27 runs at 93.98% RTP at {brand}, with a 72x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fenix_play_27_deluxe': {
        title: 'Fenix Play 27 Deluxe: 93.98% RTP, 748x Max Win | {brand}',
        description: 'Fenix Play 27 Deluxe runs at 93.98% RTP at {brand}, with a 748x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fenix_play_deluxe': {
        title: 'Fenix Play Deluxe: 94.29% RTP, 75x Max Win | {brand}',
        description: 'Fenix Play Deluxe runs at 94.29% RTP at {brand}, with a 75x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fire_bird': {
        title: 'Fire Bird: 93.96% RTP, 1,000x Max Win | {brand}',
        description: 'Fire Bird runs at 93.96% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fishermans_luck': {
        title: "Fisherman's Luck: 94.16% RTP, 2,500x Max Win | {brand}",
        description: "Fisherman's Luck runs at 94.16% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/wazdan/football_mania': {
        title: 'Football Mania: 94.26% RTP, 1,000x Max Win | {brand}',
        description: 'Football Mania runs at 94.26% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/football_mania_deluxe': {
        title: 'Football Mania Deluxe: 94.26% RTP, 1,000x Max Win | {brand}',
        description: 'Football Mania Deluxe runs at 94.26% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fortune_reels': {
        title: 'Fortune Reels: 94.14% RTP, 2,100x Max Win | {brand}',
        description: 'Fortune Reels runs at 94.14% RTP at {brand}, with a 2,100x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fruit_fiesta': {
        title: 'Fruit Fiesta: 93.89% RTP, 730x Max Win | {brand}',
        description: 'Fruit Fiesta runs at 93.89% RTP at {brand}, with a 730x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fruit_mania': {
        title: 'Fruit Mania: 94.26% RTP | {brand}',
        description: 'Fruit Mania runs at 94.26% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fruit_mania_deluxe': {
        title: 'Fruit Mania Deluxe: 94.26% RTP, 1,000x Max Win | {brand}',
        description: 'Fruit Mania Deluxe runs at 94.26% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/fruits_go_bananas': {
        title: 'Fruits Go Bananas: 94.11% RTP, 850x Max Win | {brand}',
        description: 'Fruits Go Bananas runs at 94.11% RTP at {brand}, with a 850x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/gem_splitter': {
        title: 'Gem Splitter: 94.27% RTP, 9,000x Max Win | {brand}',
        description: 'Gem Splitter runs at 94.27% RTP at {brand}, with a 9,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/golden_sphinx': {
        title: 'Golden Sphinx: 94.51% RTP, 2,000x Max Win | {brand}',
        description: 'Golden Sphinx runs at 94.51% RTP at {brand}, with a 2,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/good_luck_40': {
        title: 'Good Luck 40: 94.14% RTP, 2,350x Max Win | {brand}',
        description: 'Good Luck 40 runs at 94.14% RTP at {brand}, with a 2,350x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/great_book_of_magic': {
        title: 'Great Book Of Magic: 94.18% RTP, 5,150x Max Win | {brand}',
        description: 'Great Book Of Magic runs at 94.18% RTP at {brand}, with a 5,150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/great_book_of_magic_deluxe': {
        title: 'Great Book Of Magic Deluxe: 94.18% RTP, 5,150x Max Win | {brand}',
        description: 'Great Book Of Magic Deluxe runs at 94.18% RTP at {brand}, with a 5,150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/haunted_coins_x1000': {
        title: 'Haunted Coins x1000: 94.13% RTP, 1,000x Max Win | {brand}',
        description: 'Haunted Coins x1000 runs at 94.13% RTP at {brand}, with a 1,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/haunted_hospital': {
        title: 'Haunted Hospital: 94.03% RTP, 820x Max Win | {brand}',
        description: 'Haunted Hospital runs at 94.03% RTP at {brand}, with a 820x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/highschool_manga': {
        title: 'Highschool Manga: 93.96% RTP, 320x Max Win | {brand}',
        description: 'Highschool Manga runs at 93.96% RTP at {brand}, with a 320x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/highway_to_hell': {
        title: 'Highway to Hell: 94.35% RTP, 2,144x Max Win | {brand}',
        description: 'Highway to Hell runs at 94.35% RTP at {brand}, with a 2,144x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/highway_to_hell_deluxe': {
        title: 'Highway to Hell Deluxe: 93.92% RTP, 1,000x Max Win | {brand}',
        description: 'Highway to Hell Deluxe runs at 93.92% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_777': {
        title: 'Hot 777: 94.11% RTP, 305x Max Win | {brand}',
        description: 'Hot 777 runs at 94.11% RTP at {brand}, with a 305x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_777_deluxe': {
        title: 'Hot 777 Deluxe: 94.62% RTP, 200x Max Win | {brand}',
        description: 'Hot 777 Deluxe runs at 94.62% RTP at {brand}, with a 200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_party': {
        title: 'Hot Party: 94.15% RTP, 4,650x Max Win | {brand}',
        description: 'Hot Party runs at 94.15% RTP at {brand}, with a 4,650x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_party_deluxe': {
        title: 'Hot Party Deluxe: 94.15% RTP, 305x Max Win | {brand}',
        description: 'Hot Party Deluxe runs at 94.15% RTP at {brand}, with a 305x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot777_hold_the_jackpot': {
        title: 'Hot Slot:777 Hold the Jackpot: 94.09% RTP | {brand}',
        description: 'Hot Slot:777 Hold the Jackpot runs at 94.09% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_cash_out': {
        title: 'Hot Slot™: 777 Cash Out: 94.13% RTP, 1,500x Max Win | {brand}',
        description: 'Hot Slot™: 777 Cash Out runs at 94.13% RTP at {brand}, with a 1,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_cash_out_extremely_light': {
        title: 'Hot Slot™: 777 Cash Out Extremely Light: 94.13% RTP | {brand}',
        description: 'Hot Slot™: 777 Cash Out Extremely Light runs at 94.13% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/wazdan/hot_slot_777_cash_out_grand_gold_edition': {
        title: 'Hot Slot™: 777 Cash Out Grand Gold Edition: 94.17% RTP | {brand}',
        description: 'Hot Slot™: 777 Cash Out Grand Gold Edition runs at 94.17% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/wazdan/hot_slot_777_coins': {
        title: 'Hot Slot: 777 Coins: 94.11% RTP | {brand}',
        description: 'Hot Slot: 777 Coins runs at 94.11% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_coins_extremely_light': {
        title: 'Hot Slot™: 777 Coins Extremely Light: 94.11% RTP | {brand}',
        description: 'Hot Slot™: 777 Coins Extremely Light runs at 94.11% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/wazdan/hot_slot_777_crown': {
        title: 'Hot Slot: 777 Crown: 96% RTP, 305x Max Win | {brand}',
        description: 'Hot Slot: 777 Crown runs at 96% RTP at {brand}, with a 305x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_crown_extremely_light': {
        title: 'Hot Slot™: 777 Crown Extremely Light: 94.18% RTP | {brand}',
        description: 'Hot Slot™: 777 Crown Extremely Light runs at 94.18% RTP at {brand}, with a 305x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_diamond_crown': {
        title: 'Hot Slot 777 Diamond Crown: 94.16% RTP, 5,000x Max Win | {brand}',
        description: 'Hot Slot 777 Diamond Crown runs at 94.16% RTP at {brand}, with a 5,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_gold_crown': {
        title: 'Hot Slot 777 Gold Crown: 94.12% RTP, 1,500x Max Win | {brand}',
        description: 'Hot Slot 777 Gold Crown runs at 94.12% RTP at {brand}, with a 1,500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_hold_the_jackpot': {
        title: 'Hot Slot 777 Hold the Jackpot: 96.14% RTP | {brand}',
        description: 'Hot Slot 777 Hold the Jackpot runs at 96.14% RTP at {brand}, with a 1,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_platinum_crown': {
        title: 'Hot Slot 777 Platinum Crown: 94.15% RTP | {brand}',
        description: 'Hot Slot 777 Platinum Crown runs at 94.15% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_rubies': {
        title: 'Hot Slot: 777 Rubies: 94.14% RTP, 5,000x Max Win | {brand}',
        description: 'Hot Slot: 777 Rubies runs at 94.14% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_rubies_extremely_light': {
        title: 'Hot Slot™: 777 Rubies Extremely Light: 94.14% RTP | {brand}',
        description: 'Hot Slot™: 777 Rubies Extremely Light runs at 94.14% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/wazdan/hot_slot_777_stars': {
        title: 'Hot Slot: 777 Stars: 94.15% RTP, 5,000x Max Win | {brand}',
        description: 'Hot Slot: 777 Stars runs at 94.15% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_777_stars_extremely_light': {
        title: 'Hot Slot: 777 Stars Extremely Light: 94.15% RTP | {brand}',
        description: 'Hot Slot: 777 Stars Extremely Light runs at 94.15% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_diamond_coins': {
        title: 'Hot Slot Diamond Coins: 94.16% RTP, 3,000x Max Win | {brand}',
        description: 'Hot Slot Diamond Coins runs at 94.16% RTP at {brand}, with a 3,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_gold_coins': {
        title: 'Hot Slot Gold Coins: 94.16% RTP, 750x Max Win | {brand}',
        description: 'Hot Slot Gold Coins runs at 94.16% RTP at {brand}, with a 750x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_great_book_of_magic': {
        title: 'Hot Slot™: Great Book Of Magic: 94.14% RTP | {brand}',
        description: 'Hot Slot™: Great Book Of Magic runs at 94.14% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_magic_bombs': {
        title: 'Hot Slot™: Magic Bombs: 94.16% RTP, 6,000x Max Win | {brand}',
        description: 'Hot Slot™: Magic Bombs runs at 94.16% RTP at {brand}, with a 6,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_magic_pearls': {
        title: 'Hot Slot: Magic Pearls: 94.18% RTP, 2,500x Max Win | {brand}',
        description: 'Hot Slot: Magic Pearls runs at 94.18% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_mystery_jackpot_joker': {
        title: 'Hot Slot™: Mystery Jackpot Joker: 94.16% RTP | {brand}',
        description: 'Hot Slot™: Mystery Jackpot Joker runs at 94.16% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hot_slot_platinum_coins': {
        title: 'Hot Slot Platinum Coins: 94.18% RTP, 2,500x Max Win | {brand}',
        description: 'Hot Slot Platinum Coins runs at 94.18% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/hungry_shark': {
        title: 'Hungry Shark: 94.18% RTP, 5,150x Max Win | {brand}',
        description: 'Hungry Shark runs at 94.18% RTP at {brand}, with a 5,150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/in_the_forest': {
        title: 'In The Forest: 95.5% RTP, 1,250x Max Win | {brand}',
        description: 'In The Forest runs at 95.5% RTP at {brand}, with a 1,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/infinity_hero': {
        title: 'Infinity Hero: 94.18% RTP, 13,000x Max Win | {brand}',
        description: 'Infinity Hero runs at 94.18% RTP at {brand}, with a 13,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/jack_on_hold': {
        title: 'Jack on Hold: 94.65% RTP, 500x Max Win | {brand}',
        description: 'Jack on Hold runs at 94.65% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/jackpot_builders': {
        title: 'Jackpot Builders: 93.93% RTP, 570x Max Win | {brand}',
        description: 'Jackpot Builders runs at 93.93% RTP at {brand}, with a 570x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/jacks_ride': {
        title: "Jack's Ride: 94.29% RTP, 81x Max Win | {brand}",
        description: "Jack's Ride runs at 94.29% RTP at {brand}, with a 81x max win. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/wazdan/jelly_reels': {
        title: 'Jelly Reels: 94.19% RTP, 2,500x Max Win | {brand}',
        description: 'Jelly Reels runs at 94.19% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/joker_explosion': {
        title: 'Joker Explosion: 93.8% RTP, 1,000x Max Win | {brand}',
        description: 'Joker Explosion runs at 93.8% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/juicy_reels': {
        title: 'Juicy Reels: 94.17% RTP, 750x Max Win | {brand}',
        description: 'Juicy Reels runs at 94.17% RTP at {brand}, with a 750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/jumping_fruits': {
        title: 'Jumping Fruits: 94.29% RTP, 81x Max Win | {brand}',
        description: 'Jumping Fruits runs at 94.29% RTP at {brand}, with a 81x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/kickoff': {
        title: 'KickOff: 94.51% RTP, 440x Max Win | {brand}',
        description: 'KickOff runs at 94.51% RTP at {brand}, with a 440x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/larry_the_leprechaun': {
        title: 'Larry the Leprechaun: 94.25% RTP, 350x Max Win | {brand}',
        description: 'Larry the Leprechaun runs at 94.25% RTP at {brand}, with a 350x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/los_muertos': {
        title: 'Los Muertos: 94.33% RTP, 850x Max Win | {brand}',
        description: 'Los Muertos runs at 94.33% RTP at {brand}, with a 850x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/los_muertos_ii': {
        title: 'Los Muertos II: 94.16% RTP, 4,000x Max Win | {brand}',
        description: 'Los Muertos II runs at 94.16% RTP at {brand}, with a 4,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/lost_treasure': {
        title: 'Lost Treasure: 93.89% RTP, 3,500x Max Win | {brand}',
        description: 'Lost Treasure runs at 93.89% RTP at {brand}, with a 3,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/lucky_9': {
        title: 'Lucky 9: 94.24% RTP, 1,300x Max Win | {brand}',
        description: 'Lucky 9 runs at 94.24% RTP at {brand}, with a 1,300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/lucky_fish': {
        title: 'Lucky Fish: 94.44% RTP, 350x Max Win | {brand}',
        description: 'Lucky Fish runs at 94.44% RTP at {brand}, with a 350x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/lucky_fortune': {
        title: 'Lucky Fortune: 94.19% RTP, 1,104x Max Win | {brand}',
        description: 'Lucky Fortune runs at 94.19% RTP at {brand}, with a 1,104x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/lucky_queen': {
        title: 'Lucky Queen: 94.06% RTP, 4,500x Max Win | {brand}',
        description: 'Lucky Queen runs at 94.06% RTP at {brand}, with a 4,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/lucky_reels': {
        title: 'Lucky Reels™: 94.25% RTP, 900x Max Win | {brand}',
        description: 'Lucky Reels™ runs at 94.25% RTP at {brand}, with a 900x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_eggs': {
        title: 'Magic Eggs: 94.16% RTP, 40x Max Win | {brand}',
        description: 'Magic Eggs runs at 94.16% RTP at {brand}, with a 40x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruit_cherries': {
        title: 'Magic Fruit: Cherries: 94.14% RTP, 500x Max Win | {brand}',
        description: 'Magic Fruit: Cherries runs at 94.14% RTP at {brand}, with a 500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruit_dice': {
        title: 'Magic Fruit Dice: 96.41% RTP, 4,000x Max Win | {brand}',
        description: 'Magic Fruit Dice runs at 96.41% RTP at {brand}, with a 4,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruit_oranges': {
        title: 'Magic Fruit$: Oranges: 94.16% RTP | {brand}',
        description: 'Magic Fruit$: Oranges runs at 94.16% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruits': {
        title: 'Magic Fruits: 94.16% RTP, 260x Max Win | {brand}',
        description: 'Magic Fruits runs at 94.16% RTP at {brand}, with a 260x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruits_27': {
        title: 'Magic Fruits 27: 94.56% RTP, 2,240x Max Win | {brand}',
        description: 'Magic Fruits 27 runs at 94.56% RTP at {brand}, with a 2,240x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruits_4': {
        title: 'Magic Fruits 4: 94.28% RTP, 1,000x Max Win | {brand}',
        description: 'Magic Fruits 4 runs at 94.28% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruits_4_deluxe': {
        title: 'Magic Fruits 4 Deluxe: 94.28% RTP, 260x Max Win | {brand}',
        description: 'Magic Fruits 4 Deluxe runs at 94.28% RTP at {brand}, with a 260x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruits_81': {
        title: 'Magic Fruits 81: 94% RTP, 260x Max Win | {brand}',
        description: 'Magic Fruits 81 runs at 94% RTP at {brand}, with a 260x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruits_deluxe': {
        title: 'Magic Fruits Deluxe: 94.16% RTP, 40x Max Win | {brand}',
        description: 'Magic Fruits Deluxe runs at 94.16% RTP at {brand}, with a 40x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruits_dice': {
        title: 'Magic Fruits Dice: 94.16% RTP | {brand}',
        description: 'Magic Fruits Dice runs at 94.16% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_fruits_oranges': {
        title: 'Magic Fruits Oranges: 96.14% RTP, 10,000x Max Win | {brand}',
        description: 'Magic Fruits Oranges runs at 96.14% RTP at {brand}, with a 10,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_hot': {
        title: 'Magic Hot: 94.28% RTP, 800x Max Win | {brand}',
        description: 'Magic Hot runs at 94.28% RTP at {brand}, with a 800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_hot_4': {
        title: 'Magic Hot 4: 94.28% RTP, 1,250x Max Win | {brand}',
        description: 'Magic Hot 4 runs at 94.28% RTP at {brand}, with a 1,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_hot_4_deluxe': {
        title: 'Magic Hot 4 Deluxe: 94.28% RTP, 260x Max Win | {brand}',
        description: 'Magic Hot 4 Deluxe runs at 94.28% RTP at {brand}, with a 260x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_of_the_ring': {
        title: 'Magic Of The Ring: 94.18% RTP, 800x Max Win | {brand}',
        description: 'Magic Of The Ring runs at 94.18% RTP at {brand}, with a 800x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_of_the_ring_deluxe': {
        title: 'Magic Of The Ring Deluxe: 94.18% RTP, 5,150x Max Win | {brand}',
        description: 'Magic Of The Ring Deluxe runs at 94.18% RTP at {brand}, with a 5,150x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_spins': {
        title: 'Magic Spins: 94.1% RTP, 2,500x Max Win | {brand}',
        description: 'Magic Spins runs at 94.1% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_stars': {
        title: 'Magic Stars: 94.32% RTP, 40x Max Win | {brand}',
        description: 'Magic Stars runs at 94.32% RTP at {brand}, with a 40x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_stars_3': {
        title: 'Magic Stars 3: 94.32% RTP, 200x Max Win | {brand}',
        description: 'Magic Stars 3 runs at 94.32% RTP at {brand}, with a 200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_stars_5': {
        title: 'Magic Stars 5: 94.15% RTP, 305x Max Win | {brand}',
        description: 'Magic Stars 5 runs at 94.15% RTP at {brand}, with a 305x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_stars_6': {
        title: 'Magic Stars 6: 94.17% RTP, 750x Max Win | {brand}',
        description: 'Magic Stars 6 runs at 94.17% RTP at {brand}, with a 750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_stars_9': {
        title: 'Magic Stars 9: 94.33% RTP, 10,500x Max Win | {brand}',
        description: 'Magic Stars 9 runs at 94.33% RTP at {brand}, with a 10,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_target': {
        title: 'Magic Target: 95.5% RTP, 1,000x Max Win | {brand}',
        description: 'Magic Target runs at 95.5% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/magic_target_deluxe': {
        title: 'Magic Target Deluxe: 95.5% RTP, 1,250x Max Win | {brand}',
        description: 'Magic Target Deluxe runs at 95.5% RTP at {brand}, with a 1,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mayan_ritual': {
        title: 'Mayan Ritual: 94.33% RTP, 850x Max Win | {brand}',
        description: 'Mayan Ritual runs at 94.33% RTP at {brand}, with a 850x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/miami_beach': {
        title: 'Miami Beach: 94.8% RTP, 7,200x Max Win | {brand}',
        description: 'Miami Beach runs at 94.8% RTP at {brand}, with a 7,200x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/midnight_in_tokyo': {
        title: 'Midnight in Tokyo: 94.27% RTP, 3,000x Max Win | {brand}',
        description: 'Midnight in Tokyo runs at 94.27% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_crown_empire_of_gold': {
        title: 'Mighty Crown: Empire of Gold: 94.14% RTP | {brand}',
        description: 'Mighty Crown: Empire of Gold runs at 94.14% RTP at {brand}, with a 1,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_crown_legacy_of_mars': {
        title: 'Mighty Crown Legacy of Mars: 94.15% RTP | {brand}',
        description: 'Mighty Crown Legacy of Mars runs at 94.15% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_fish_blue_marlin': {
        title: 'Mighty Fish™: Blue Marlin: 94.17% RTP, 2,500x Max Win | {brand}',
        description: 'Mighty Fish™: Blue Marlin runs at 94.17% RTP at {brand}, with a 2,500x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_hot_777': {
        title: 'Mighty Hot 777: 94.16% RTP, 2,500x Max Win | {brand}',
        description: 'Mighty Hot 777 runs at 94.16% RTP at {brand}, with a 2,500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_hot_amazonia': {
        title: 'Mighty Hot: Amazonia: 94.17% RTP, 1,500x Max Win | {brand}',
        description: 'Mighty Hot: Amazonia runs at 94.17% RTP at {brand}, with a 1,500x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_symbols_crowns': {
        title: 'Mighty Symbols: Crowns: 94.12% RTP | {brand}',
        description: 'Mighty Symbols: Crowns runs at 94.12% RTP at {brand} and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_symbols_diamonds': {
        title: 'Mighty Symbols™: Diamonds: 94.13% RTP | {brand}',
        description: 'Mighty Symbols™: Diamonds runs at 94.13% RTP at {brand}, with a 250,000x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_symbols_jokers': {
        title: 'Mighty Symbols™: Jokers: 94.13% RTP, 750x Max Win | {brand}',
        description: 'Mighty Symbols™: Jokers runs at 94.13% RTP at {brand}, with a 750x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_symbols_sevens': {
        title: 'Mighty Symbols: Sevens: 94.13% RTP, 2,000x Max Win | {brand}',
        description: 'Mighty Symbols: Sevens runs at 94.13% RTP at {brand}, with a 2,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_wild_gorilla': {
        title: 'Mighty Wild Gorilla: 94.18% RTP | {brand}',
        description: 'Mighty Wild Gorilla runs at 94.18% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_wild_jaguar': {
        title: 'Mighty Wild™: Jaguar: 94.13% RTP, 750x Max Win | {brand}',
        description: 'Mighty Wild™: Jaguar runs at 94.13% RTP at {brand}, with a 750x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_wild_panther': {
        title: 'Mighty Wild™: Panther: 94.15% RTP, 750x Max Win | {brand}',
        description: 'Mighty Wild™: Panther runs at 94.15% RTP at {brand}, with a 750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mighty_wild_panther_grand_gold_edition': {
        title: 'Mighty Wild™: Panther Grand Gold Edition: 94.11% RTP | {brand}',
        description: 'Mighty Wild™: Panther Grand Gold Edition runs at 94.11% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/wazdan/moon_of_fortune': {
        title: 'Moon Of Fortune: 94.18% RTP | {brand}',
        description: 'Moon Of Fortune runs at 94.18% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mystery_jack': {
        title: 'Mystery Jack: 94.22% RTP, 532x Max Win | {brand}',
        description: 'Mystery Jack runs at 94.22% RTP at {brand}, with a 532x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mystery_jack_deluxe': {
        title: 'Mystery Jack Deluxe: 94.03% RTP, 820x Max Win | {brand}',
        description: 'Mystery Jack Deluxe runs at 94.03% RTP at {brand}, with a 820x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mystery_kindom_mystery_bells': {
        title: 'Mystery Kindom: Mystery Bells: 96% RTP, 750x Max Win | {brand}',
        description: 'Mystery Kindom: Mystery Bells runs at 96% RTP at {brand}, with a 750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/mystery_kingdom_mystery_bells': {
        title: 'Mystery Kingdom Mystery Bells: 94.15% RTP | {brand}',
        description: 'Mystery Kingdom Mystery Bells runs at 94.15% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/neon_city': {
        title: 'Neon City: 94.02% RTP, 1,250x Max Win | {brand}',
        description: 'Neon City runs at 94.02% RTP at {brand}, with a 1,250x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/night_club_81': {
        title: 'Night Club 81: 93.54% RTP, 2,240x Max Win | {brand}',
        description: 'Night Club 81 runs at 93.54% RTP at {brand}, with a 2,240x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/one_coin': {
        title: 'One Coin: 94.14% RTP | {brand}',
        description: 'One Coin runs at 94.14% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/one_coins': {
        title: 'One Coins: 96.17% RTP, 500x Max Win | {brand}',
        description: 'One Coins runs at 96.17% RTP at {brand}, with a 500x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/ox_coin': {
        title: 'Ox Coin: 94.2% RTP, 250,000x Max Win | {brand}',
        description: 'Ox Coin runs at 94.2% RTP at {brand}, with a 250,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/power_of_god_medusa_extremely_light': {
        title: 'Power of God: Medusa Extremely Light: 96.18% RTP | {brand}',
        description: 'Power of God: Medusa Extremely Light runs at 96.18% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/wazdan/power_of_gods_egypt': {
        title: 'Power of Gods: Egypt: 94.02% RTP, 8,000x Max Win | {brand}',
        description: 'Power of Gods: Egypt runs at 94.02% RTP at {brand}, with a 8,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/power_of_gods_hades': {
        title: 'Power of Gods: Hades: 94.37% RTP, 5,000x Max Win | {brand}',
        description: 'Power of Gods: Hades runs at 94.37% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/power_of_gods_medusa': {
        title: 'Power of Gods™: Medusa: 94.38% RTP, 2,500x Max Win | {brand}',
        description: 'Power of Gods™: Medusa runs at 94.38% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/power_of_gods_medusa_extremely_light': {
        title: 'Power of Gods: Medusa Extremely Light: 94.38% RTP | {brand}',
        description: 'Power of Gods: Medusa Extremely Light runs at 94.38% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/power_of_gods_the_pantheon': {
        title: 'Power of Gods: The Pantheon: 94.05% RTP | {brand}',
        description: 'Power of Gods: The Pantheon runs at 94.05% RTP at {brand}, with a 1,450x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/power_of_gods_valhalla': {
        title: 'Power of Gods™: Valhalla: 94.13% RTP, 2,145x Max Win | {brand}',
        description: 'Power of Gods™: Valhalla runs at 94.13% RTP at {brand}, with a 2,145x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/power_of_gods_valhalla_extremely_light': {
        title: 'Power of Gods™: Valhalla Extremely Light: 94.13% RTP | {brand}',
        description: 'Power of Gods™: Valhalla Extremely Light runs at 94.13% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/power_of_sun_svarog': {
        title: 'Power of Sun™: Svarog: 94.12% RTP, 5,000x Max Win | {brand}',
        description: 'Power of Sun™: Svarog runs at 94.12% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/prosperity_pearls': {
        title: 'Prosperity Pearls: 94.23% RTP, 4,000x Max Win | {brand}',
        description: 'Prosperity Pearls runs at 94.23% RTP at {brand}, with a 4,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/prosperity_reels': {
        title: 'Prosperity Reels: 94.14% RTP, 2,100x Max Win | {brand}',
        description: 'Prosperity Reels runs at 94.14% RTP at {brand}, with a 2,100x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/reel_hero': {
        title: 'Reel Hero: 94.29% RTP, 1,050x Max Win | {brand}',
        description: 'Reel Hero runs at 94.29% RTP at {brand}, with a 1,050x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/reel_joke': {
        title: 'Reel Joke: 94.28% RTP, 9,500x Max Win | {brand}',
        description: 'Reel Joke runs at 94.28% RTP at {brand}, with a 9,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/relic_hunters_and_the_book_of_faith': {
        title: 'Relic Hunters and the Book of Faith: 94.34% RTP | {brand}',
        description: 'Relic Hunters and the Book of Faith runs at 94.34% RTP at {brand}, with a 750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/santas_gift_frenzy': {
        title: "Santa's Gift Frenzy: 96.12% RTP, 10,000x Max Win | {brand}",
        description: "Santa's Gift Frenzy runs at 96.12% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/wazdan/santas_gifts_frenzy': {
        title: "Santa's Gifts Frenzy: 94.13% RTP | {brand}",
        description: "Santa's Gifts Frenzy runs at 94.13% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/wazdan/sizzling_777': {
        title: 'Sizzling 777: 94.15% RTP, 305x Max Win | {brand}',
        description: 'Sizzling 777 runs at 94.15% RTP at {brand}, with a 305x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sizzling_777_deluxe': {
        title: 'Sizzling 777 Deluxe: 94.15% RTP, 305x Max Win | {brand}',
        description: 'Sizzling 777 Deluxe runs at 94.15% RTP at {brand}, with a 305x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sizzling_bells': {
        title: 'Sizzling Bells: 94.29% RTP, 15,000x Max Win | {brand}',
        description: 'Sizzling Bells runs at 94.29% RTP at {brand}, with a 15,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sizzling_eggs': {
        title: 'Sizzling Eggs: 94.03% RTP, 2,500x Max Win | {brand}',
        description: 'Sizzling Eggs runs at 94.03% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sizzling_eggs_extremely_light': {
        title: 'Sizzling Eggs Extremely Light: 94.03% RTP | {brand}',
        description: 'Sizzling Eggs Extremely Light runs at 94.03% RTP at {brand} and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sizzling_eggs_grand_gold_edition': {
        title: 'Sizzling Eggs Grand Gold Edition: 94.16% RTP | {brand}',
        description: 'Sizzling Eggs Grand Gold Edition runs at 94.16% RTP at {brand}, with a 3,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sizzling_eggs_grand_platinum_edition': {
        title: 'Sizzling Eggs Grand Platinum Edition: 94.16% RTP | {brand}',
        description: 'Sizzling Eggs Grand Platinum Edition runs at 94.16% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    },
    '/p/wazdan/sizzling_kindom_bison': {
        title: 'Sizzling Kindom: Bison: 96% RTP, 5,000x Max Win | {brand}',
        description: 'Sizzling Kindom: Bison runs at 96% RTP at {brand}, with a 5,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sizzling_kingdom_bison': {
        title: 'Sizzling Kingdom Bison: 94.03% RTP | {brand}',
        description: 'Sizzling Kingdom Bison runs at 94.03% RTP at {brand}. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sizzling_moon': {
        title: 'Sizzling Moon: 94.06% RTP, 2,500x Max Win | {brand}',
        description: 'Sizzling Moon runs at 94.06% RTP at {brand}, with a 2,500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/slot_jam': {
        title: 'Slot Jam: 93.93% RTP, 570x Max Win | {brand}',
        description: 'Slot Jam runs at 93.93% RTP at {brand}, with a 570x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sonic_reels': {
        title: 'Sonic Reels: 94.3% RTP, 5,400x Max Win | {brand}',
        description: 'Sonic Reels runs at 94.3% RTP at {brand}, with a 5,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/space_gem': {
        title: 'Space Gem: 94.27% RTP, 1,000x Max Win | {brand}',
        description: 'Space Gem runs at 94.27% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/space_spins': {
        title: 'Space Spins: 94.4% RTP, 1,650x Max Win | {brand}',
        description: 'Space Spins runs at 94.4% RTP at {brand}, with a 1,650x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/spectrum': {
        title: 'Spectrum: 94.34% RTP, 500x Max Win | {brand}',
        description: 'Spectrum runs at 94.34% RTP at {brand}, with a 500x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/sun_of_fortune': {
        title: 'Sun of Fortune: 94.31% RTP, 1,450x Max Win | {brand}',
        description: 'Sun of Fortune runs at 94.31% RTP at {brand}, with a 1,450x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/super_hot': {
        title: 'Super Hot: 94.63% RTP, 340x Max Win | {brand}',
        description: 'Super Hot runs at 94.63% RTP at {brand}, with a 340x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/telly_reels': {
        title: 'Telly Reels: 94.23% RTP, 1,400x Max Win | {brand}',
        description: 'Telly Reels runs at 94.23% RTP at {brand}, with a 1,400x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/three_cards': {
        title: 'Three Cards: 94.03% RTP, 1,000x Max Win | {brand}',
        description: 'Three Cards runs at 94.03% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/triple_star': {
        title: 'Triple Star: 93.99% RTP, 300x Max Win | {brand}',
        description: 'Triple Star runs at 93.99% RTP at {brand}, with a 300x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/turbo_play': {
        title: 'Turbo Play: 94.49% RTP, 409x Max Win | {brand}',
        description: 'Turbo Play runs at 94.49% RTP at {brand}, with a 409x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/unicorn_reels': {
        title: 'Unicorn Reels: 94.32% RTP, 1,000x Max Win | {brand}',
        description: 'Unicorn Reels runs at 94.32% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/valentines_coins': {
        title: "Valentine's Coins: 94.13% RTP, 50,000x Max Win | {brand}",
        description: "Valentine's Coins runs at 94.13% RTP at {brand}, with a 50,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/wazdan/valhalla': {
        title: 'Valhalla: 94.07% RTP, 600x Max Win | {brand}',
        description: 'Valhalla runs at 94.07% RTP at {brand}, with a 600x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/vegas_hot': {
        title: 'Vegas Hot: 94.5% RTP, 340x Max Win | {brand}',
        description: 'Vegas Hot runs at 94.5% RTP at {brand}, with a 340x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/vegas_hot_81': {
        title: 'Vegas Hot 81: 94.19% RTP, 5,850x Max Win | {brand}',
        description: 'Vegas Hot 81 runs at 94.19% RTP at {brand}, with a 5,850x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/vegas_reels_ii': {
        title: 'Vegas Reels II: 94.36% RTP, 710x Max Win | {brand}',
        description: 'Vegas Reels II runs at 94.36% RTP at {brand}, with a 710x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/welcome_to_hell_81': {
        title: 'Welcome To Hell 81: 94.19% RTP, 5,850x Max Win | {brand}',
        description: 'Welcome To Hell 81 runs at 94.19% RTP at {brand}, with a 5,850x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/wild_girls': {
        title: 'Wild Girls: 94.13% RTP, 750x Max Win | {brand}',
        description: 'Wild Girls runs at 94.13% RTP at {brand}, with a 750x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/wild_guns': {
        title: 'Wild Guns: 94.11% RTP, 850x Max Win | {brand}',
        description: 'Wild Guns runs at 94.11% RTP at {brand}, with a 850x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/wild_jack': {
        title: 'Wild Jack: 93.98% RTP, 3,000x Max Win | {brand}',
        description: 'Wild Jack runs at 93.98% RTP at {brand}, with a 3,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/wild_jack_81': {
        title: 'Wild Jack 81: 94.16% RTP, 2,240x Max Win | {brand}',
        description: 'Wild Jack 81 runs at 94.16% RTP at {brand}, with a 2,240x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/wazdan/win_and_replay': {
        title: 'Win And Replay: 94.46% RTP, 1,000x Max Win | {brand}',
        description: 'Win And Replay runs at 94.46% RTP at {brand}, with a 1,000x max win. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/avatarux/7_lucky_gods': {
        title: '7 Lucky Gods: 94% RTP, 1,200x Max Win | {brand}',
        description: '7 Lucky Gods runs at 94% RTP at {brand}, with a 1,200x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/book_of_hidden_tombs': {
        title: 'Book of Hidden Tombs: 97% RTP, 10,000x Max Win | {brand}',
        description: 'Book of Hidden Tombs runs at 97% RTP at {brand}, with a 10,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/fortune_trio_minions_of_fu': {
        title: 'Fortune Trio: Minions of Fu: 95.05% RTP | {brand}',
        description: 'Fortune Trio: Minions of Fu runs at 95.05% RTP at {brand}, with a 2,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/lucky_pinball': {
        title: 'Lucky Pinball: 97.07% RTP, 777x Max Win | {brand}',
        description: 'Lucky Pinball runs at 97.07% RTP at {brand}, with a 777x max win and low volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/bgaming/st_patricks_pots_hold_and_win': {
        title: "St. Patrick's Pots Hold and Win: 97.75% RTP | {brand}",
        description: "St. Patrick's Pots Hold and Win runs at 97.75% RTP at {brand}, with a 3,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee."
    },
    '/p/pragmatic-play/super_serge': {
        title: 'Super Serge: 96.5% RTP, 10,000x Max Win | {brand}',
        description: 'Super Serge runs at 96.5% RTP at {brand}, with a 10,000x max win and medium volatility. Crypto deposits, instant withdrawals, no platform fee.'
    },
    '/p/pgsoft/farmstead_fortune': {
        title: 'Farmstead Fortune: 96.76% RTP, 5,000x Max Win | {brand}',
        description: 'Farmstead Fortune runs at 96.76% RTP at {brand}, with a 5,000x max win and high volatility. Crypto deposits, instant withdrawals, no platform fee on payouts.'
    }
};
export const gameSeo = {
    ...gameSeoBase
};
export function normalizeGameSeoPath(pathname) {
    const clean = pathname.replace(/\/$/, '').split('?')[0] || '';
    const pIdx = clean.indexOf('/p/');
    if (pIdx < 0)
        return null;
    const parts = clean.slice(pIdx).split('/').filter(Boolean);
    if (parts.length < 3 || parts[0] !== 'p')
        return null;
    if (parts.length > 3)
        return null;
    const [, providerSlug, gameSlug] = parts;
    return `/p/${providerSlug}/${gameSlug}`;
}
export function getGameSeo(pathname) {
    const key = normalizeGameSeoPath(pathname);
    if (!key)
        return undefined;
    return gameSeo[key];
}
export function applyGameSeoBrandSubstitution(title, description, companyName) {
    const withBrand = (s) => s.replace(/\{brand\}/g, companyName);
    return {
        title: withBrand(title),
        description: withBrand(description)
    };
}
